import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: any; output: any; }
  JSON: { input: any; output: any; }
  MongoID: { input: any; output: any; }
  RegExpAsString: { input: any; output: any; }
};

export type AccommodationOperatorMetadata = {
  __typename?: 'AccommodationOperatorMetadata';
  guestRoomQty?: Maybe<Scalars['Float']['output']>;
  shortTermAccommodationLicense?: Maybe<Scalars['String']['output']>;
};

export type AccommodationOperatorMetadataInput = {
  guestRoomQty?: InputMaybe<Scalars['Float']['input']>;
  shortTermAccommodationLicense?: InputMaybe<Scalars['String']['input']>;
};

export type AccommodationProductMetadata = {
  __typename?: 'AccommodationProductMetadata';
  amenities: Array<Tag>;
  calendarLinks?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  checkIn?: Maybe<Scalars['String']['output']>;
  checkOut?: Maybe<Scalars['String']['output']>;
  closures: Array<Maybe<Closure>>;
  guestMetadata?: Maybe<GuestMetadata>;
  rooms: Array<Maybe<Room>>;
};

export type AccommodationProductMetadataInput = {
  amenities?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  calendarLinks?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  checkIn?: InputMaybe<Scalars['String']['input']>;
  checkOut?: InputMaybe<Scalars['String']['input']>;
  closures: Array<InputMaybe<ClosureInput>>;
  guestMetadata?: InputMaybe<GuestMetadataInput>;
  rooms: Array<InputMaybe<RoomInput>>;
};

export type Address = {
  __typename?: 'Address';
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  line1?: Maybe<Scalars['String']['output']>;
  line2?: Maybe<Scalars['String']['output']>;
  location?: Maybe<AddressLocation>;
  postalCode?: Maybe<Scalars['String']['output']>;
  subdivision?: Maybe<Scalars['String']['output']>;
};

export type AddressInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  line1?: InputMaybe<Scalars['String']['input']>;
  line2?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<AddressLocationInput>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  subdivision?: InputMaybe<Scalars['String']['input']>;
};

export type AddressLocation = {
  __typename?: 'AddressLocation';
  coordinates: Array<Maybe<Scalars['Float']['output']>>;
  type: EnumAddressLocationType;
};

export type AddressLocationInput = {
  coordinates: Array<InputMaybe<Scalars['Float']['input']>>;
  type: EnumAddressLocationType;
};

export type ApiAccess = {
  __typename?: 'ApiAccess';
  _id: Scalars['MongoID']['output'];
  createdDateISO?: Maybe<Scalars['Date']['output']>;
  token: Scalars['String']['output'];
  updatedDateISO?: Maybe<Scalars['Date']['output']>;
  user?: Maybe<UserWithPictureTc>;
};

export type Asset = AssetInterface & {
  __typename?: 'Asset';
  _id: Scalars['String']['output'];
  blurhash: Scalars['String']['output'];
  caption: Multilingual;
  createdDateISO?: Maybe<Scalars['Date']['output']>;
  originalUrl?: Maybe<Scalars['String']['output']>;
  parentEntity: EntityReference;
  type?: Maybe<EnumDKeyAssetType>;
  updatedDateISO?: Maybe<Scalars['Date']['output']>;
};

export type AssetFile = AssetInterface & {
  __typename?: 'AssetFile';
  _id: Scalars['String']['output'];
  blurhash: Scalars['String']['output'];
  caption: Multilingual;
  createdDateISO?: Maybe<Scalars['Date']['output']>;
  originalUrl?: Maybe<Scalars['String']['output']>;
  parentEntity: EntityReference;
  type?: Maybe<EnumDKeyAssetType>;
  updatedDateISO?: Maybe<Scalars['Date']['output']>;
};

export type AssetImage = AssetInterface & {
  __typename?: 'AssetImage';
  _id: Scalars['String']['output'];
  assetUrls?: Maybe<AssetImageUrls>;
  blurhash: Scalars['String']['output'];
  caption: Multilingual;
  colors?: Maybe<Array<Maybe<Color>>>;
  createdDateISO?: Maybe<Scalars['Date']['output']>;
  detectedObjects?: Maybe<DetectedObjects>;
  height: Scalars['Float']['output'];
  originalUrl?: Maybe<Scalars['String']['output']>;
  parentEntity: EntityReference;
  qualityAnalysis?: Maybe<ImageQualityAnalysis>;
  qualityScore?: Maybe<ImageQualityRating>;
  type?: Maybe<EnumDKeyAssetType>;
  updatedDateISO?: Maybe<Scalars['Date']['output']>;
  width: Scalars['Float']['output'];
};

export type AssetImageUrls = {
  __typename?: 'AssetImageUrls';
  large?: Maybe<Scalars['String']['output']>;
  medium?: Maybe<Scalars['String']['output']>;
  thumbnail?: Maybe<Scalars['String']['output']>;
};

export type AssetInterface = {
  _id: Scalars['String']['output'];
  blurhash: Scalars['String']['output'];
  caption: Multilingual;
  createdDateISO?: Maybe<Scalars['Date']['output']>;
  originalUrl?: Maybe<Scalars['String']['output']>;
  parentEntity: EntityReference;
  type?: Maybe<EnumDKeyAssetType>;
  updatedDateISO?: Maybe<Scalars['Date']['output']>;
};

export type Booker = {
  __typename?: 'Booker';
  _id: Scalars['MongoID']['output'];
  bundles: Array<Maybe<BookerBundles>>;
  createdDateISO?: Maybe<Scalars['Date']['output']>;
  customizations?: Maybe<BookerCustomizations>;
  discounts: Array<Discount>;
  name: Multilingual;
  paymentMetadata?: Maybe<BookerPaymentMetadata>;
  policies: Array<Policy>;
  rules: Array<Rule>;
  status: EnumBookerStatus;
  statusNotification?: Maybe<Multilingual>;
  storefront: Scalars['MongoID']['output'];
  updatedDateISO?: Maybe<Scalars['Date']['output']>;
  waivers: Array<AssetFile>;
};


export type BookerDiscountsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsDiscountInput>;
};


export type BookerPoliciesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsPolicyInput>;
};


export type BookerRulesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsRuleInput>;
};


export type BookerWaiversArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsAssetFileInput>;
};

export type BookerBundles = {
  __typename?: 'BookerBundles';
  _id?: Maybe<Scalars['MongoID']['output']>;
  product?: Maybe<Product>;
  upsells: Array<Product>;
};

export type BookerBundlesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  product: Scalars['MongoID']['input'];
  upsells?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type BookerCustomizations = {
  __typename?: 'BookerCustomizations';
  featuredImage?: Maybe<AssetImage>;
  logo?: Maybe<AssetImage>;
};

export type BookerCustomizationsInput = {
  featuredImage?: InputMaybe<Scalars['MongoID']['input']>;
  logo?: InputMaybe<Scalars['MongoID']['input']>;
};

export type BookerPaymentMetadata = {
  __typename?: 'BookerPaymentMetadata';
  applicationPercentage?: Maybe<Scalars['Float']['output']>;
  connectedAccountId?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  depositSettings?: Maybe<DepositSettings>;
  securityDepositSettings?: Maybe<SecurityDepositSettings>;
  tax?: Maybe<Tax>;
};

export type BookerPaymentMetadataInput = {
  applicationPercentage?: InputMaybe<Scalars['Float']['input']>;
  connectedAccountId?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  depositSettings?: InputMaybe<DepositSettingsInput>;
  securityDepositSettings?: InputMaybe<SecurityDepositSettingsInput>;
  tax?: InputMaybe<Scalars['String']['input']>;
};

export type BooleanHoursOfOperation = {
  fri?: InputMaybe<Scalars['Boolean']['input']>;
  mon?: InputMaybe<Scalars['Boolean']['input']>;
  sat?: InputMaybe<Scalars['Boolean']['input']>;
  sun?: InputMaybe<Scalars['Boolean']['input']>;
  thu?: InputMaybe<Scalars['Boolean']['input']>;
  tue?: InputMaybe<Scalars['Boolean']['input']>;
  wed?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BooleanLinks = {
  bookNow?: InputMaybe<Scalars['Boolean']['input']>;
  facebook?: InputMaybe<Scalars['Boolean']['input']>;
  googleMyBusiness?: InputMaybe<Scalars['Boolean']['input']>;
  instagram?: InputMaybe<Scalars['Boolean']['input']>;
  pinterest?: InputMaybe<Scalars['Boolean']['input']>;
  tiktok?: InputMaybe<Scalars['Boolean']['input']>;
  tripAdvisor?: InputMaybe<Scalars['Boolean']['input']>;
  website?: InputMaybe<Scalars['Boolean']['input']>;
  x?: InputMaybe<Scalars['Boolean']['input']>;
  youtube?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BooleanSeasonality = {
  apr?: InputMaybe<Scalars['Boolean']['input']>;
  aug?: InputMaybe<Scalars['Boolean']['input']>;
  dec?: InputMaybe<Scalars['Boolean']['input']>;
  feb?: InputMaybe<Scalars['Boolean']['input']>;
  jan?: InputMaybe<Scalars['Boolean']['input']>;
  jul?: InputMaybe<Scalars['Boolean']['input']>;
  jun?: InputMaybe<Scalars['Boolean']['input']>;
  mar?: InputMaybe<Scalars['Boolean']['input']>;
  may?: InputMaybe<Scalars['Boolean']['input']>;
  nov?: InputMaybe<Scalars['Boolean']['input']>;
  oct?: InputMaybe<Scalars['Boolean']['input']>;
  sep?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CalendarLinksByProductId = {
  links: Array<Scalars['String']['input']>;
  productId: Scalars['String']['input'];
};

export type Campaign = {
  __typename?: 'Campaign';
  _entityId: Scalars['MongoID']['output'];
  _id: Scalars['MongoID']['output'];
  _versionId: Scalars['MongoID']['output'];
  assets: Array<AssetImage>;
  createdDateISO?: Maybe<Scalars['Date']['output']>;
  dateRangeISO: DateRangeIso;
  description: Multilingual;
  list: Scalars['MongoID']['output'];
  name: Multilingual;
  owner: Owner;
  updatedDateISO?: Maybe<Scalars['Date']['output']>;
};

export type CartPrices = {
  __typename?: 'CartPrices';
  depositTotal: Scalars['Int']['output'];
  discountTotal: Scalars['Int']['output'];
  discountTotals: Array<DiscountTotalPerDiscount>;
  grandTotal: Scalars['Int']['output'];
  productPrices: Array<PricePerProduct>;
  subTotal: Scalars['Int']['output'];
  taxTotal: Scalars['Int']['output'];
};

export type Changelog = {
  __typename?: 'Changelog';
  _id: Scalars['MongoID']['output'];
  createdDateISO?: Maybe<Scalars['Date']['output']>;
  entity: VersionedEntityReference;
  initiatedByUser?: Maybe<UserWithPictureTc>;
  message: Multilingual;
  owner: Owner;
  updatedDateISO?: Maybe<Scalars['Date']['output']>;
};

export type Closure = {
  __typename?: 'Closure';
  _id?: Maybe<Scalars['MongoID']['output']>;
  dateRangeISO: DateRangeIso;
  name: Scalars['String']['output'];
};

export type ClosureData = {
  __typename?: 'ClosureData';
  closure: Closure;
  productIds: Array<Scalars['String']['output']>;
};

export type ClosureInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  dateRangeISO: DateRangeIsoInput;
  name: Scalars['String']['input'];
};

export type Color = {
  __typename?: 'Color';
  _id: Scalars['MongoID']['output'];
  predominance: Scalars['Float']['output'];
  value: Scalars['String']['output'];
};

export type Contact = {
  __typename?: 'Contact';
  address?: Maybe<Address>;
  email?: Maybe<Scalars['String']['output']>;
  links?: Maybe<Links>;
  phone?: Maybe<Scalars['String']['output']>;
  tollFreePublicPhone?: Maybe<Scalars['String']['output']>;
};

export type ContactInput = {
  address?: InputMaybe<AddressInput>;
  email?: InputMaybe<Scalars['String']['input']>;
  links?: InputMaybe<LinksInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  tollFreePublicPhone?: InputMaybe<Scalars['String']['input']>;
};

export type ContactUsEmailDetails = {
  email: Scalars['String']['input'];
  message: Scalars['String']['input'];
  name: Scalars['String']['input'];
  phone: Scalars['String']['input'];
};

export type ContactWithBooleanLinks = {
  address?: InputMaybe<AddressInput>;
  email?: InputMaybe<Scalars['String']['input']>;
  links?: InputMaybe<BooleanLinks>;
  phone?: InputMaybe<Scalars['String']['input']>;
  tollFreePublicPhone?: InputMaybe<Scalars['String']['input']>;
};

export type CreateManyRuleInput = {
  activePeriod?: InputMaybe<DateRangeIsoInput>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  storefront: Scalars['MongoID']['input'];
  type: EnumRuleType;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
  value: Scalars['JSON']['input'];
};

export type CreateManyRulePayload = {
  __typename?: 'CreateManyRulePayload';
  /** Number of created documents */
  createdCount: Scalars['Int']['output'];
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Documents IDs */
  recordIds: Array<Scalars['MongoID']['output']>;
  /** Created documents */
  records?: Maybe<Array<Rule>>;
};

export type CreateManyTagGroupInput = {
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  key: EnumTagGroupKey;
  name: MultilingualInput;
  type: EnumTagGroupType;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

export type CreateManyTagGroupPayload = {
  __typename?: 'CreateManyTagGroupPayload';
  /** Number of created documents */
  createdCount: Scalars['Int']['output'];
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Documents IDs */
  recordIds: Array<Scalars['MongoID']['output']>;
  /** Created documents */
  records?: Maybe<Array<TagGroup>>;
};

export type CreateManyTagInput = {
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  entityType?: InputMaybe<EnumTagEntityType>;
  entityTypes: Array<InputMaybe<EnumTagEntityTypes>>;
  name: MultilingualInput;
  owner?: InputMaybe<OwnerInput>;
  tagGroup: Scalars['MongoID']['input'];
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

export type CreateManyTagPayload = {
  __typename?: 'CreateManyTagPayload';
  /** Number of created documents */
  createdCount: Scalars['Int']['output'];
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Documents IDs */
  recordIds: Array<Scalars['MongoID']['output']>;
  /** Created documents */
  records?: Maybe<Array<Tag>>;
};

export type CreateOneBookerInput = {
  bundles?: InputMaybe<Array<InputMaybe<BookerBundlesInput>>>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  customizations?: InputMaybe<BookerCustomizationsInput>;
  discounts?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  name: MultilingualInput;
  paymentMetadata?: InputMaybe<BookerPaymentMetadataInput>;
  policies?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  rules?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  status?: InputMaybe<EnumBookerStatus>;
  statusNotification?: InputMaybe<MultilingualInput>;
  storefront: Scalars['MongoID']['input'];
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
  waivers?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CreateOneBookerPayload = {
  __typename?: 'CreateOneBookerPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<Booker>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneCustomerInput = {
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
  orders?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  phone?: InputMaybe<Scalars['String']['input']>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

export type CreateOneCustomerPayload = {
  __typename?: 'CreateOneCustomerPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<Customer>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneDiscountInput = {
  amount: Scalars['Float']['input'];
  canCombine?: InputMaybe<Scalars['Boolean']['input']>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  currentUsageCount?: InputMaybe<Scalars['Float']['input']>;
  daysInAdvance?: InputMaybe<Scalars['Float']['input']>;
  description?: InputMaybe<MultilingualInput>;
  discountActivePeriod?: InputMaybe<DateRangeIsoInput>;
  excludeUpsells?: InputMaybe<Scalars['Boolean']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  maxNights?: InputMaybe<Scalars['Float']['input']>;
  maxUsageCount?: InputMaybe<Scalars['Float']['input']>;
  minGuestCount?: InputMaybe<Scalars['Float']['input']>;
  minNights?: InputMaybe<Scalars['Float']['input']>;
  name: MultilingualInput;
  promoCode?: InputMaybe<Scalars['String']['input']>;
  storefront: Scalars['MongoID']['input'];
  type: EnumDiscountType;
  unit: EnumDiscountUnit;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

export type CreateOneDiscountPayload = {
  __typename?: 'CreateOneDiscountPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<Discount>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneEventInput = {
  access: EventAccessInput;
  contact?: InputMaybe<ContactInput>;
  createdBy?: InputMaybe<Scalars['MongoID']['input']>;
  createdByEmail: Scalars['String']['input'];
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  description: MultilingualInput;
  /** The end date of the event. The string will be formatted as yyyy-mm-dd. To have it make sense to humans, the month will start at 01, so Jan 20, 2025 would be 2025-01-20. */
  endDate?: InputMaybe<Scalars['String']['input']>;
  eventLocation: EventEventLocationInput;
  images?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  locationType?: InputMaybe<EnumEventLocationType>;
  otherLocations?: InputMaybe<Array<InputMaybe<EventEventLocationInput>>>;
  presentedBy?: InputMaybe<MultilingualInput>;
  price?: InputMaybe<Scalars['String']['input']>;
  recurrencePattern: EventRecurrencePatternInput;
  schedules: Array<InputMaybe<EventSchedulesInput>>;
  /** The start date of the event. The string will be formatted as yyyy-mm-dd. To have it make sense to humans, the month will start at 01, so Jan 20, 2025 would be 2025-01-20. */
  startDate: Scalars['String']['input'];
  tags?: InputMaybe<EventTagsInput>;
  tempTags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ticketUrl?: InputMaybe<Scalars['String']['input']>;
  title: MultilingualInput;
  type: EnumEventType;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
  venue?: InputMaybe<MultilingualInput>;
};

export type CreateOneEventPayload = {
  __typename?: 'CreateOneEventPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<Event>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneInventoryItemInput = {
  claimedDateRangesISO?: InputMaybe<Array<InputMaybe<DateRangeIsoInput>>>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  product: Scalars['MongoID']['input'];
  type: EnumInventoryItemType;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

export type CreateOneInventoryItemPayload = {
  __typename?: 'CreateOneInventoryItemPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<InventoryItem>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneListInput = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  description: MultilingualInput;
  entityReferences: Array<InputMaybe<VersionedEntityReferenceInput>>;
  externallyAvailableEntityReferences?: InputMaybe<Array<InputMaybe<VersionedEntityReferenceInput>>>;
  favorited?: InputMaybe<Scalars['Boolean']['input']>;
  name: MultilingualInput;
  owner: OwnerInput;
  selections: Scalars['JSON']['input'];
  type: EnumListType;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

export type CreateOneListPayload = {
  __typename?: 'CreateOneListPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<List>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneNoteInput = {
  author: Scalars['MongoID']['input'];
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  entity: EntityReferenceInput;
  mentions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  message: Scalars['String']['input'];
  owner: OwnerInput;
  resolvedBy?: InputMaybe<Scalars['MongoID']['input']>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

export type CreateOneNotePayload = {
  __typename?: 'CreateOneNotePayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<Note>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneOperatorInput = {
  _entityId?: InputMaybe<Scalars['MongoID']['input']>;
  _versionId?: InputMaybe<Scalars['MongoID']['input']>;
  accommodationMetadata?: InputMaybe<AccommodationOperatorMetadataInput>;
  avgImageQuality?: InputMaybe<EnumOperatorAvgImageQuality>;
  claimed: Scalars['Boolean']['input'];
  contact: ContactInput;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<MultilingualInput>;
  enrollments: Array<InputMaybe<OperatorEnrollmentsInput>>;
  experienceMetadata?: InputMaybe<ExperienceOperatorMetadataInput>;
  hoursOfOperation?: InputMaybe<OperatorHoursOfOperationInput>;
  images?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name: MultilingualInput;
  operationalStatus?: InputMaybe<EnumOperatorOperationalStatus>;
  pricing?: InputMaybe<EnumOperatorPricing>;
  restaurantMetadata?: InputMaybe<RestaurantOperatorMetadataInput>;
  seasonality?: InputMaybe<SeasonalityInput>;
  selectedTagGroups?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  serviceMetadata?: InputMaybe<ServiceOperatorMetadataInput>;
  shortDescription?: InputMaybe<MultilingualInput>;
  tags?: InputMaybe<OperatorTagsInput>;
  toursMetadata?: InputMaybe<ToursOperatorMetadataInput>;
  type: EnumOperatorType;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

export type CreateOneOperatorPayload = {
  __typename?: 'CreateOneOperatorPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<Operator>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneOrderPayload = {
  __typename?: 'CreateOneOrderPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<Order>;
  /** Document ID */
  recordId?: Maybe<Scalars['String']['output']>;
};

export type CreateOneOrganizationInput = {
  contact?: InputMaybe<ContactInput>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  description: MultilingualInput;
  domains?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  images?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  logo: Scalars['String']['input'];
  metadata?: InputMaybe<OrganizationMetadataInput>;
  name: MultilingualInput;
  onboardingMetadata: OrganizationOnboardingMetadataInput;
  shortDescription: MultilingualInput;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

export type CreateOneOrganizationPayload = {
  __typename?: 'CreateOneOrganizationPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<Organization>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOnePolicyInput = {
  content: MultilingualInput;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name: MultilingualInput;
  storefront: Scalars['MongoID']['input'];
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

export type CreateOnePolicyPayload = {
  __typename?: 'CreateOnePolicyPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<Policy>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneProductInput = {
  accommodationMetadata?: InputMaybe<AccommodationProductMetadataInput>;
  contact?: InputMaybe<ProductContactInput>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<MultilingualInput>;
  externalBookingUrl?: InputMaybe<Scalars['String']['input']>;
  images?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isUpsellOnly: Scalars['Boolean']['input'];
  name: MultilingualInput;
  owner: OwnerInput;
  pricing?: InputMaybe<PricingInput>;
  publicationStatus: EnumProductPublicationStatus;
  quantitySettings?: InputMaybe<ProductQuantitySettingsInput>;
  rules?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  shortDescription?: InputMaybe<MultilingualInput>;
  storefront: Scalars['MongoID']['input'];
  tags?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  type: EnumProductType;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

export type CreateOneProductPayload = {
  __typename?: 'CreateOneProductPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<Product>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOnePublicationStatusInput = {
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  entity: VersionedEntityReferenceInput;
  organization: Scalars['MongoID']['input'];
  status: EnumPublicationStatusStatus;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

export type CreateOnePublicationStatusPayload = {
  __typename?: 'CreateOnePublicationStatusPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<PublicationStatus>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneRefundPayload = {
  __typename?: 'CreateOneRefundPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<Refund>;
  /** Document ID */
  recordId?: Maybe<Scalars['String']['output']>;
};

export type CreateOneRuleInput = {
  activePeriod?: InputMaybe<DateRangeIsoInput>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  storefront: Scalars['MongoID']['input'];
  type: EnumRuleType;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
  value: Scalars['JSON']['input'];
};

export type CreateOneRulePayload = {
  __typename?: 'CreateOneRulePayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<Rule>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneStorefrontInput = {
  connectedAccountIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  name: MultilingualInput;
  siteMetadata?: InputMaybe<StorefrontSiteMetadataInput>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

export type CreateOneStorefrontPayload = {
  __typename?: 'CreateOneStorefrontPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<Storefront>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneTagGroupInput = {
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  key: EnumTagGroupKey;
  name: MultilingualInput;
  type: EnumTagGroupType;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

export type CreateOneTagGroupPayload = {
  __typename?: 'CreateOneTagGroupPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<TagGroup>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneTagInput = {
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  entityType?: InputMaybe<EnumTagEntityType>;
  entityTypes: Array<InputMaybe<EnumTagEntityTypes>>;
  name: MultilingualInput;
  owner?: InputMaybe<OwnerInput>;
  tagGroup: Scalars['MongoID']['input'];
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

export type CreateOneTagPayload = {
  __typename?: 'CreateOneTagPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<Tag>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneTaxInput = {
  country: Scalars['String']['input'];
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  owner?: InputMaybe<OwnerInput>;
  percentage: Scalars['Float']['input'];
  subdivision: Scalars['String']['input'];
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

export type CreateOneTaxPayload = {
  __typename?: 'CreateOneTaxPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<Tax>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneUserInput = {
  access: UserAccessInput;
  auth0Id?: InputMaybe<Scalars['String']['input']>;
  confirmationCodes?: InputMaybe<Array<InputMaybe<UserConfirmationCodesInput>>>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  email: Scalars['String']['input'];
  emailPreferences?: InputMaybe<Array<InputMaybe<UserEmailPreferencesInput>>>;
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  onboardingMetadata?: InputMaybe<UserOnboardingMetadataInput>;
  signupToken?: InputMaybe<Scalars['String']['input']>;
  status: EnumUserStatus;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
  userType: EnumUserUserType;
};

export type CreateOneWidgetInput = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  description: MultilingualInput;
  entityOverrides?: InputMaybe<Array<InputMaybe<WidgetEntityOverridesInput>>>;
  eventSettings?: InputMaybe<WidgetEventSettingsInput>;
  favorited?: InputMaybe<Scalars['Boolean']['input']>;
  filterableTags?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  list?: InputMaybe<Scalars['MongoID']['input']>;
  name: MultilingualInput;
  owner: OwnerInput;
  type: EnumWidgetType;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

export type CreateOneWidgetPayload = {
  __typename?: 'CreateOneWidgetPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<Widget>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CustomOrderFilter = {
  /** Filter by an array of _ids to match specific orders */
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  createdEndDate?: InputMaybe<Scalars['String']['input']>;
  createdStartDate?: InputMaybe<Scalars['String']['input']>;
  /** Filter by search term to filter by _id, customerContact.name, or customerContact.email */
  search?: InputMaybe<Scalars['String']['input']>;
};

export type Customer = {
  __typename?: 'Customer';
  _id: Scalars['MongoID']['output'];
  createdDateISO?: Maybe<Scalars['Date']['output']>;
  email: Scalars['String']['output'];
  name: Scalars['String']['output'];
  orders: Array<Maybe<Scalars['String']['output']>>;
  phone?: Maybe<Scalars['String']['output']>;
  updatedDateISO?: Maybe<Scalars['Date']['output']>;
};

export type CustomerInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
  orders?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  phone?: InputMaybe<Scalars['String']['input']>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

export type DateInput = {
  _eq?: InputMaybe<Scalars['Date']['input']>;
  _gt?: InputMaybe<Scalars['Date']['input']>;
  _gte?: InputMaybe<Scalars['Date']['input']>;
  _lt?: InputMaybe<Scalars['Date']['input']>;
  _lte?: InputMaybe<Scalars['Date']['input']>;
  _ne?: InputMaybe<Scalars['Date']['input']>;
};

export type DateRangeIso = {
  __typename?: 'DateRangeISO';
  _id: Scalars['MongoID']['output'];
  end: Scalars['String']['output'];
  metadata?: Maybe<Scalars['String']['output']>;
  start: Scalars['String']['output'];
};

export type DateRangeIsoInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  end: Scalars['String']['input'];
  metadata?: InputMaybe<Scalars['String']['input']>;
  start: Scalars['String']['input'];
};

export type DepositSettings = {
  __typename?: 'DepositSettings';
  chargeBalanceDaysBeforeCheckIn: Scalars['Float']['output'];
  enabled: Scalars['Boolean']['output'];
  rate?: Maybe<Scalars['Float']['output']>;
  rateType?: Maybe<EnumDepositSettingsRateType>;
};

export type DepositSettingsInput = {
  chargeBalanceDaysBeforeCheckIn?: InputMaybe<Scalars['Float']['input']>;
  enabled: Scalars['Boolean']['input'];
  rate?: InputMaybe<Scalars['Float']['input']>;
  rateType?: InputMaybe<EnumDepositSettingsRateType>;
};

export type DetectedObjects = {
  __typename?: 'DetectedObjects';
  hasFace?: Maybe<Scalars['Boolean']['output']>;
  hasText?: Maybe<Scalars['Boolean']['output']>;
};

export type Discount = {
  __typename?: 'Discount';
  _id: Scalars['MongoID']['output'];
  amount: Scalars['Float']['output'];
  canCombine: Scalars['Boolean']['output'];
  createdDateISO?: Maybe<Scalars['Date']['output']>;
  currentUsageCount: Scalars['Float']['output'];
  daysInAdvance?: Maybe<Scalars['Float']['output']>;
  description?: Maybe<Multilingual>;
  discountActivePeriod?: Maybe<DateRangeIso>;
  excludeUpsells: Scalars['Boolean']['output'];
  isActive: Scalars['Boolean']['output'];
  maxNights?: Maybe<Scalars['Float']['output']>;
  maxUsageCount?: Maybe<Scalars['Float']['output']>;
  minGuestCount?: Maybe<Scalars['Float']['output']>;
  minNights?: Maybe<Scalars['Float']['output']>;
  name: Multilingual;
  promoCode?: Maybe<Scalars['String']['output']>;
  storefront: Scalars['MongoID']['output'];
  type: EnumDiscountType;
  unit: EnumDiscountUnit;
  updatedDateISO?: Maybe<Scalars['Date']['output']>;
};

export type DiscountTotalPerDiscount = {
  __typename?: 'DiscountTotalPerDiscount';
  discountId: Scalars['ID']['output'];
  total: Scalars['Int']['output'];
};

export type EmailResponse = {
  __typename?: 'EmailResponse';
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type EntityReference = {
  __typename?: 'EntityReference';
  _entityId: Scalars['MongoID']['output'];
  type: EnumEntityReferenceType;
};

export type EntityReferenceInput = {
  _entityId: Scalars['MongoID']['input'];
  type: EnumEntityReferenceType;
};

export enum EnumAddressLocationType {
  Point = 'Point'
}

export enum EnumBookerStatus {
  Archived = 'ARCHIVED',
  Closed = 'CLOSED',
  Draft = 'DRAFT',
  Open = 'OPEN'
}

export enum EnumConfirmationCodeType {
  OperatorOwnershipConfirmation = 'OPERATOR_OWNERSHIP_CONFIRMATION'
}

export enum EnumDKeyAssetType {
  AssetFile = 'AssetFile',
  AssetImage = 'AssetImage'
}

export enum EnumDepositSettingsRateType {
  Fixed = 'FIXED',
  Percentage = 'PERCENTAGE'
}

export enum EnumDiscountType {
  EarlyBird = 'EARLY_BIRD',
  GuestCount = 'GUEST_COUNT',
  LengthOfStay = 'LENGTH_OF_STAY',
  PromoCode = 'PROMO_CODE'
}

export enum EnumDiscountUnit {
  Fixed = 'FIXED',
  Percentage = 'PERCENTAGE'
}

export enum EnumEntityReferenceType {
  Event = 'EVENT',
  List = 'LIST',
  Note = 'NOTE',
  Operator = 'OPERATOR',
  Organization = 'ORGANIZATION',
  Storefront = 'STOREFRONT',
  Widget = 'WIDGET'
}

export enum EnumEventAccessOperatorStatus {
  Approved = 'APPROVED',
  Cancelled = 'CANCELLED',
  Declined = 'DECLINED',
  Draft = 'DRAFT',
  ForReview = 'FOR_REVIEW'
}

export enum EnumEventEventLocationLocationInfoType {
  Operator = 'OPERATOR',
  Organization = 'ORGANIZATION'
}

export enum EnumEventLocationType {
  InPerson = 'IN_PERSON',
  Virtual = 'VIRTUAL'
}

/** For monthly frequency, the weekday the event should occur on (used in conjuction with dayOfMonthOccurrence) (e.g. WE) */
export enum EnumEventRecurrencePatternDayOfMonth {
  Fr = 'FR',
  Mo = 'MO',
  Sa = 'SA',
  Su = 'SU',
  Th = 'TH',
  Tu = 'TU',
  We = 'WE'
}

export enum EnumEventRecurrencePatternDaysOfWeek {
  Fr = 'FR',
  Mo = 'MO',
  Sa = 'SA',
  Su = 'SU',
  Th = 'TH',
  Tu = 'TU',
  We = 'WE'
}

export enum EnumEventRecurrencePatternFrequency {
  Daily = 'DAILY',
  Monthly = 'MONTHLY',
  Once = 'ONCE',
  Weekly = 'WEEKLY',
  Yearly = 'YEARLY'
}

export enum EnumEventType {
  Multi = 'MULTI',
  Recurring = 'RECURRING',
  Single = 'SINGLE'
}

export enum EnumInventoryItemType {
  Accommodation = 'ACCOMMODATION',
  Event = 'EVENT'
}

export enum EnumListType {
  Manual = 'MANUAL',
  Smart = 'SMART'
}

export enum EnumOperatorAvgImageQuality {
  Average = 'AVERAGE',
  High = 'HIGH',
  Low = 'LOW'
}

export enum EnumOperatorEnrollmentsOnboardingStatus {
  CompletedOnboarding = 'COMPLETED_ONBOARDING',
  CompletedSurvey = 'COMPLETED_SURVEY',
  Incomplete = 'INCOMPLETE'
}

export enum EnumOperatorOperationalStatus {
  Open = 'OPEN',
  PermanentlyClosed = 'PERMANENTLY_CLOSED',
  TemporarilyClosed = 'TEMPORARILY_CLOSED'
}

export enum EnumOperatorPricing {
  Expensive = 'EXPENSIVE',
  Inexpensive = 'INEXPENSIVE',
  ModeratelyExpensive = 'MODERATELY_EXPENSIVE',
  VeryExpensive = 'VERY_EXPENSIVE'
}

export enum EnumOperatorType {
  Accommodation = 'ACCOMMODATION',
  Attraction = 'ATTRACTION',
  FestivalsAndEvents = 'FESTIVALS_AND_EVENTS',
  FoodAndBeverageBusinessType = 'FOOD_AND_BEVERAGE_BUSINESS_TYPE',
  Government = 'GOVERNMENT',
  OtherBusinessType = 'OTHER_BUSINESS_TYPE',
  OutdoorRecreation = 'OUTDOOR_RECREATION',
  Retail = 'RETAIL',
  Service = 'SERVICE',
  TourismOrganization = 'TOURISM_ORGANIZATION',
  TourismSupportOrAdjacent = 'TOURISM_SUPPORT_OR_ADJACENT',
  Tours = 'TOURS',
  Transportation = 'TRANSPORTATION',
  Venue = 'VENUE'
}

export enum EnumOwnerType {
  Operator = 'OPERATOR',
  Organization = 'ORGANIZATION'
}

export enum EnumPostHogDataMetadataAppContext {
  WhereaboutsNext = 'whereabouts_next',
  WidgetBooker = 'widget_booker',
  WidgetEventSubmit = 'widget_event_submit',
  WidgetEvents = 'widget_events',
  WidgetOperator = 'widget_operator'
}

export enum EnumPostHogDataMetadataEventName {
  AmenitiesViewed = 'amenities_viewed',
  BookerLoaded = 'booker_loaded',
  CloseOperatorDetails = 'close_operator_details',
  CustomerDetailsAdded = 'customer_details_added',
  DatesSelected = 'dates_selected',
  DetailsClick = 'details_click',
  EntityImpression = 'entity_impression',
  ExpandedDetailsClick = 'expanded_details_click',
  ExpandedDetailsPageview = 'expanded_details_pageview',
  FilterTagAdded = 'filter_tag_added',
  FilterTagRemoved = 'filter_tag_removed',
  GuestsSelected = 'guests_selected',
  OpenBookNowLink = 'open_book_now_link',
  OutboundClick = 'outbound_click',
  PaymentMethodAdded = 'payment_method_added',
  PoliciesAccepted = 'policies_accepted',
  ProductAddedToCart = 'product_added_to_cart',
  ProductRemovedFromCart = 'product_removed_from_cart',
  ProductUpdatedInCart = 'product_updated_in_cart',
  PromoCodeApplied = 'promo_code_applied',
  PurchaseCompleted = 'purchase_completed',
  ScrollEventsLeft = 'scroll_events_left',
  ScrollEventsRight = 'scroll_events_right',
  ScrollOperatorsLeft = 'scroll_operators_left',
  ScrollOperatorsRight = 'scroll_operators_right',
  ScrollRecurringEventsDown = 'scroll_recurring_events_down',
  ScrollRecurringEventsUp = 'scroll_recurring_events_up',
  ScrollViewMoreTags = 'scroll_view_more_tags',
  ScrollViewPreviousTags = 'scroll_view_previous_tags'
}

export enum EnumPriceTierType {
  Adult = 'ADULT',
  Child = 'CHILD',
  General = 'GENERAL',
  Infant = 'INFANT',
  Pet = 'PET',
  Senior = 'SENIOR'
}

export enum EnumProductPublicationStatus {
  Approved = 'APPROVED',
  Deleted = 'DELETED',
  Draft = 'DRAFT',
  NeedsApproval = 'NEEDS_APPROVAL',
  Unpublished = 'UNPUBLISHED'
}

export enum EnumProductType {
  Accommodation = 'ACCOMMODATION',
  Fee = 'FEE'
}

export enum EnumPublicationStatusStatus {
  Approved = 'APPROVED',
  Deleted = 'DELETED',
  Draft = 'DRAFT',
  NeedsApproval = 'NEEDS_APPROVAL',
  Unpublished = 'UNPUBLISHED'
}

export enum EnumRefundStatus {
  Failed = 'failed',
  Pending = 'pending',
  Succeeded = 'succeeded'
}

export enum EnumRoomType {
  Bath = 'BATH',
  Bed = 'BED'
}

export enum EnumRuleType {
  MaxBookableDate = 'MAX_BOOKABLE_DATE',
  MaxNights = 'MAX_NIGHTS',
  MinBookableDate = 'MIN_BOOKABLE_DATE',
  MinNights = 'MIN_NIGHTS',
  UnavailableCheckInDays = 'UNAVAILABLE_CHECK_IN_DAYS',
  UnavailableCheckOutDays = 'UNAVAILABLE_CHECK_OUT_DAYS'
}

export enum EnumSecurityDepositSettingsRateType {
  Fixed = 'FIXED',
  Percentage = 'PERCENTAGE'
}

export enum EnumStripeMetadataSecurityHoldStatus {
  ChargeFailed = 'CHARGE_FAILED',
  ChargeSuccess = 'CHARGE_SUCCESS',
  HoldPlaced = 'HOLD_PLACED'
}

export enum EnumTagEntityType {
  Event = 'EVENT',
  List = 'LIST',
  Note = 'NOTE',
  Operator = 'OPERATOR',
  Organization = 'ORGANIZATION',
  Storefront = 'STOREFRONT',
  Widget = 'WIDGET'
}

export enum EnumTagEntityTypes {
  Event = 'EVENT',
  List = 'LIST',
  Note = 'NOTE',
  Operator = 'OPERATOR',
  Organization = 'ORGANIZATION',
  Storefront = 'STOREFRONT',
  Widget = 'WIDGET'
}

export enum EnumTagGroupKey {
  Accommodation = 'ACCOMMODATION',
  Accreditations = 'ACCREDITATIONS',
  AdventureAndOutdoorActivities = 'ADVENTURE_AND_OUTDOOR_ACTIVITIES',
  AdventureExtreme = 'ADVENTURE_EXTREME',
  ArtsAndCulture = 'ARTS_AND_CULTURE',
  ArtsCulture = 'ARTS_CULTURE',
  Attraction = 'ATTRACTION',
  BackOffice = 'BACK_OFFICE',
  BedroomSpecific = 'BEDROOM_SPECIFIC',
  BusinessNetworking = 'BUSINESS_NETWORKING',
  CampingRving = 'CAMPING_RVING',
  CommunitySocial = 'COMMUNITY_SOCIAL',
  CorporateTravel = 'CORPORATE_TRAVEL',
  EventExperience = 'EVENT_EXPERIENCE',
  ExperientialTourism = 'EXPERIENTIAL_TOURISM',
  FamilyEvents = 'FAMILY_EVENTS',
  FestivalsAndEvents = 'FESTIVALS_AND_EVENTS',
  Fishing = 'FISHING',
  FoodAndBeverageBusinessType = 'FOOD_AND_BEVERAGE_BUSINESS_TYPE',
  FoodAndBeverageGlobal = 'FOOD_AND_BEVERAGE_GLOBAL',
  FoodDrink = 'FOOD_DRINK',
  Government = 'GOVERNMENT',
  HealthWellness = 'HEALTH_WELLNESS',
  Heritage = 'HERITAGE',
  Hunting = 'HUNTING',
  MembershipTiers = 'MEMBERSHIP_TIERS',
  NatureGardens = 'NATURE_GARDENS',
  OtherBusinessType = 'OTHER_BUSINESS_TYPE',
  OtherGlobal = 'OTHER_GLOBAL',
  OutdoorRecreation = 'OUTDOOR_RECREATION',
  Recreation = 'RECREATION',
  Region = 'REGION',
  Retail = 'RETAIL',
  RoofedAccommodation = 'ROOFED_ACCOMMODATION',
  ScienceDiscovery = 'SCIENCE_DISCOVERY',
  SeasonalOrThemes = 'SEASONAL_OR_THEMES',
  Service = 'SERVICE',
  Shopping = 'SHOPPING',
  Specializations = 'SPECIALIZATIONS',
  SportsOutdoor = 'SPORTS_OUTDOOR',
  StyleExperience = 'STYLE_EXPERIENCE',
  TechnologyInnovation = 'TECHNOLOGY_INNOVATION',
  TourismEnabler = 'TOURISM_ENABLER',
  TourismOrganization = 'TOURISM_ORGANIZATION',
  TourismSupportOrAdjacent = 'TOURISM_SUPPORT_OR_ADJACENT',
  Tours = 'TOURS',
  Transportation = 'TRANSPORTATION',
  Venue = 'VENUE',
  WellnessAndSpa = 'WELLNESS_AND_SPA',
  WellnessAndSpaAmenity = 'WELLNESS_AND_SPA_AMENITY'
}

export enum EnumTagGroupType {
  Amenity = 'AMENITY',
  BusinessType = 'BUSINESS_TYPE',
  Global = 'GLOBAL',
  GlobalEvent = 'GLOBAL_EVENT',
  OrganizationSpecific = 'ORGANIZATION_SPECIFIC'
}

export enum EnumUserAccessOperatorsRole {
  Owner = 'OWNER',
  Staff = 'STAFF'
}

export enum EnumUserAccessOperatorsStatus {
  Accepted = 'ACCEPTED',
  Invited = 'INVITED',
  NotInvited = 'NOT_INVITED',
  Requested = 'REQUESTED'
}

export enum EnumUserConfirmationCodesType {
  OperatorOwnershipConfirmation = 'OPERATOR_OWNERSHIP_CONFIRMATION'
}

export enum EnumUserEmailPreferencesFrequency {
  Always = 'ALWAYS',
  Daily = 'DAILY',
  Never = 'NEVER',
  Weekly = 'WEEKLY'
}

export enum EnumUserEmailPreferencesTemplateName {
  Digest = 'DIGEST',
  StorefrontTransaction = 'STOREFRONT_TRANSACTION',
  Transaction = 'TRANSACTION'
}

export enum EnumUserStatus {
  Enrolled = 'ENROLLED',
  NotProvisioned = 'NOT_PROVISIONED',
  Provisioned = 'PROVISIONED'
}

export enum EnumUserUserType {
  PrivateApi = 'PRIVATE_API',
  PublicApi = 'PUBLIC_API',
  TnbInternal = 'TNB_INTERNAL',
  Whereabouts = 'WHEREABOUTS'
}

export enum EnumVersionedEntityReferenceType {
  Event = 'EVENT',
  List = 'LIST',
  Note = 'NOTE',
  Operator = 'OPERATOR',
  Organization = 'ORGANIZATION',
  Storefront = 'STOREFRONT',
  Widget = 'WIDGET'
}

export enum EnumWidgetEventSettingsDisplayType {
  Carousel = 'CAROUSEL',
  Grid = 'GRID'
}

export enum EnumWidgetType {
  Event = 'EVENT',
  Operator = 'OPERATOR'
}

export type ErrorInterface = {
  /** Generic error message */
  message?: Maybe<Scalars['String']['output']>;
};

export type Event = {
  __typename?: 'Event';
  _id: Scalars['MongoID']['output'];
  access: EventAccess;
  contact?: Maybe<Contact>;
  createdBy?: Maybe<Scalars['MongoID']['output']>;
  createdByEmail: Scalars['String']['output'];
  createdDateISO?: Maybe<Scalars['Date']['output']>;
  description: Multilingual;
  /** The end date of the event. The string will be formatted as yyyy-mm-dd. To have it make sense to humans, the month will start at 01, so Jan 20, 2025 would be 2025-01-20. */
  endDate?: Maybe<Scalars['String']['output']>;
  eventLocation: EventEventLocation;
  images: Array<AssetImage>;
  locationType: EnumEventLocationType;
  otherLocations: Array<Maybe<EventEventLocation>>;
  presentedBy?: Maybe<Multilingual>;
  price?: Maybe<Scalars['String']['output']>;
  recurrencePattern: EventRecurrencePattern;
  schedules: Array<Maybe<EventSchedules>>;
  /** The start date of the event. The string will be formatted as yyyy-mm-dd. To have it make sense to humans, the month will start at 01, so Jan 20, 2025 would be 2025-01-20. */
  startDate: Scalars['String']['output'];
  tags?: Maybe<EventTags>;
  tempTags: Array<Maybe<Scalars['String']['output']>>;
  ticketUrl?: Maybe<Scalars['String']['output']>;
  title: Multilingual;
  type: EnumEventType;
  updatedDateISO?: Maybe<Scalars['Date']['output']>;
  venue?: Maybe<Multilingual>;
};

export type EventAccess = {
  __typename?: 'EventAccess';
  operator?: Maybe<EventAccessOperator>;
  organizations: Array<Maybe<EventAccessOperator>>;
};

export type EventAccessInput = {
  operator?: InputMaybe<EventAccessOperatorInput>;
  organizations: Array<InputMaybe<EventAccessOperatorInput>>;
};

export type EventAccessOperator = {
  __typename?: 'EventAccessOperator';
  _entityId: Scalars['MongoID']['output'];
  status?: Maybe<EnumEventAccessOperatorStatus>;
};

export type EventAccessOperatorInput = {
  _entityId: Scalars['MongoID']['input'];
  status?: InputMaybe<EnumEventAccessOperatorStatus>;
};

export type EventEventLocation = {
  __typename?: 'EventEventLocation';
  contact?: Maybe<Contact>;
  locationInfo?: Maybe<EventEventLocationLocationInfo>;
  venue: Multilingual;
};

export type EventEventLocationInput = {
  contact?: InputMaybe<ContactInput>;
  locationInfo?: InputMaybe<EventEventLocationLocationInfoInput>;
  venue: MultilingualInput;
};

export type EventEventLocationLocationInfo = {
  __typename?: 'EventEventLocationLocationInfo';
  _entityId?: Maybe<Scalars['MongoID']['output']>;
  _id?: Maybe<Scalars['MongoID']['output']>;
  type?: Maybe<EnumEventEventLocationLocationInfoType>;
};

export type EventEventLocationLocationInfoInput = {
  _entityId?: InputMaybe<Scalars['MongoID']['input']>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  type?: InputMaybe<EnumEventEventLocationLocationInfoType>;
};

export type EventRecurrencePattern = {
  __typename?: 'EventRecurrencePattern';
  /** For monthly frequency, the extact date each month (e.g. the 15th) */
  dateOfMonth?: Maybe<Scalars['Float']['output']>;
  /** For monthly frequency, the weekday the event should occur on (used in conjuction with dayOfMonthOccurrence) (e.g. WE) */
  dayOfMonth?: Maybe<EnumEventRecurrencePatternDayOfMonth>;
  /** For monthly frequency, the weekday occurrence the event should occur on (used in conjuction with dayOfMonth) (e.g. 3). If this value is 5, it is treated as the 'last occurrence in the month' */
  dayOfMonthOccurrence?: Maybe<Scalars['Float']['output']>;
  /** For daily or weekly frequency, the weekday(s) to recur (e.g. Thursdays and Saturdays) */
  daysOfWeek?: Maybe<Array<Maybe<EnumEventRecurrencePatternDaysOfWeek>>>;
  /** The end date of the recurrence */
  endDate?: Maybe<Scalars['String']['output']>;
  frequency: EnumEventRecurrencePatternFrequency;
  interval?: Maybe<Scalars['Float']['output']>;
  /** For yearly frequency, the MM-dd of the year that the event should occur on */
  monthAndDateOfYear?: Maybe<Scalars['String']['output']>;
  /** A list of dates (yyyy-MM-dd) for the MULTI type event */
  multiDates?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** A list of dates (yyyy-MM-dd) that should be skipped in the recurrence */
  skipDates?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type EventRecurrencePatternInput = {
  /** For monthly frequency, the extact date each month (e.g. the 15th) */
  dateOfMonth?: InputMaybe<Scalars['Float']['input']>;
  /** For monthly frequency, the weekday the event should occur on (used in conjuction with dayOfMonthOccurrence) (e.g. WE) */
  dayOfMonth?: InputMaybe<EnumEventRecurrencePatternDayOfMonth>;
  /** For monthly frequency, the weekday occurrence the event should occur on (used in conjuction with dayOfMonth) (e.g. 3). If this value is 5, it is treated as the 'last occurrence in the month' */
  dayOfMonthOccurrence?: InputMaybe<Scalars['Float']['input']>;
  /** For daily or weekly frequency, the weekday(s) to recur (e.g. Thursdays and Saturdays) */
  daysOfWeek?: InputMaybe<Array<InputMaybe<EnumEventRecurrencePatternDaysOfWeek>>>;
  /** The end date of the recurrence */
  endDate?: InputMaybe<Scalars['String']['input']>;
  frequency: EnumEventRecurrencePatternFrequency;
  interval?: InputMaybe<Scalars['Float']['input']>;
  /** For yearly frequency, the MM-dd of the year that the event should occur on */
  monthAndDateOfYear?: InputMaybe<Scalars['String']['input']>;
  /** A list of dates (yyyy-MM-dd) for the MULTI type event */
  multiDates?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** A list of dates (yyyy-MM-dd) that should be skipped in the recurrence */
  skipDates?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type EventSchedules = {
  __typename?: 'EventSchedules';
  allDay: Scalars['Boolean']['output'];
  timeSlots?: Maybe<Array<Maybe<EventSchedulesTimeSlots>>>;
};

export type EventSchedulesInput = {
  allDay: Scalars['Boolean']['input'];
  timeSlots?: InputMaybe<Array<InputMaybe<EventSchedulesTimeSlotsInput>>>;
};

export type EventSchedulesTimeSlots = {
  __typename?: 'EventSchedulesTimeSlots';
  _id?: Maybe<Scalars['MongoID']['output']>;
  endsNextDay?: Maybe<Scalars['Boolean']['output']>;
  from?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  to?: Maybe<Scalars['String']['output']>;
};

export type EventSchedulesTimeSlotsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  endsNextDay?: InputMaybe<Scalars['Boolean']['input']>;
  from?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  to?: InputMaybe<Scalars['String']['input']>;
};

export enum EventStatus {
  Approved = 'APPROVED',
  Cancelled = 'CANCELLED',
  Declined = 'DECLINED',
  Draft = 'DRAFT',
  ForReview = 'FOR_REVIEW'
}

export type EventTags = {
  __typename?: 'EventTags';
  global: Array<Tag>;
  organizationSpecific: Array<Tag>;
};

export type EventTagsInput = {
  global?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  organizationSpecific?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type EventWithOccurrences = {
  __typename?: 'EventWithOccurrences';
  _id: Scalars['MongoID']['output'];
  access: EventAccess;
  contact?: Maybe<Contact>;
  createdBy?: Maybe<Scalars['MongoID']['output']>;
  createdByEmail: Scalars['String']['output'];
  createdDateISO?: Maybe<Scalars['Date']['output']>;
  description: Multilingual;
  /** The end date of the event. The string will be formatted as yyyy-mm-dd. To have it make sense to humans, the month will start at 01, so Jan 20, 2025 would be 2025-01-20. */
  endDate?: Maybe<Scalars['String']['output']>;
  eventLocation: EventEventLocation;
  images: Array<AssetImage>;
  locationType: EnumEventLocationType;
  occurrences?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  otherLocations: Array<Maybe<EventEventLocation>>;
  presentedBy?: Maybe<Multilingual>;
  price?: Maybe<Scalars['String']['output']>;
  recurrencePattern: EventRecurrencePattern;
  schedules: Array<Maybe<EventSchedules>>;
  /** The start date of the event. The string will be formatted as yyyy-mm-dd. To have it make sense to humans, the month will start at 01, so Jan 20, 2025 would be 2025-01-20. */
  startDate: Scalars['String']['output'];
  tags?: Maybe<EventTags>;
  tempTags: Array<Maybe<Scalars['String']['output']>>;
  ticketUrl?: Maybe<Scalars['String']['output']>;
  title: Multilingual;
  type: EnumEventType;
  updatedDateISO?: Maybe<Scalars['Date']['output']>;
  venue?: Maybe<Multilingual>;
};

export type ExperienceOperatorMetadata = {
  __typename?: 'ExperienceOperatorMetadata';
  _id?: Maybe<Scalars['MongoID']['output']>;
};

export type ExperienceOperatorMetadataInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterFindManyAccommodationOperatorMetadataInput = {
  guestRoomQty?: InputMaybe<Scalars['Float']['input']>;
  shortTermAccommodationLicense?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyAccommodationProductMetadataInput = {
  amenities?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  calendarLinks?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  checkIn?: InputMaybe<Scalars['String']['input']>;
  checkOut?: InputMaybe<Scalars['String']['input']>;
  closures?: InputMaybe<Array<InputMaybe<FilterFindManyClosureInput>>>;
  guestMetadata?: InputMaybe<FilterFindManyGuestMetadataInput>;
  rooms?: InputMaybe<Array<InputMaybe<FilterFindManyRoomInput>>>;
};

export type FilterFindManyAddressInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  line1?: InputMaybe<Scalars['String']['input']>;
  line2?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<FilterFindManyAddressLocationInput>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  subdivision?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyAddressLocationInput = {
  coordinates?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  type?: InputMaybe<EnumAddressLocationType>;
};

export type FilterFindManyAssetFileInput = {
  AND?: InputMaybe<Array<FilterFindManyAssetInput>>;
  OR?: InputMaybe<Array<FilterFindManyAssetInput>>;
  _id?: InputMaybe<Scalars['String']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyAssetOperatorsInput>;
  blurhash?: InputMaybe<Scalars['String']['input']>;
  caption?: InputMaybe<FilterFindManyMultilingualInput>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  originalUrl?: InputMaybe<Scalars['String']['input']>;
  parentEntity?: InputMaybe<FilterFindManyEntityReferenceInput>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

export type FilterFindManyAssetImageInput = {
  AND?: InputMaybe<Array<FilterFindManyAssetInput>>;
  OR?: InputMaybe<Array<FilterFindManyAssetInput>>;
  _id?: InputMaybe<Scalars['String']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyAssetOperatorsInput>;
  blurhash?: InputMaybe<Scalars['String']['input']>;
  caption?: InputMaybe<FilterFindManyMultilingualInput>;
  colors?: InputMaybe<Array<InputMaybe<FilterFindManyColorInput>>>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  /**
   * Currently, our schema only supports facial and text detection, using the built-in Cloudinary AI Content Analysis face detection, and the `cld-text` model. Therefore, the fields returned in `detectedObjects` will be limited to *optional* `humanFace` and `text` fields which are of `IDetectedObject[]` type.
   *
   * &nbsp;
   *
   * `IDetectedObject` contains a `boundingBox` array of `numbers`, a `categories` array of `string`s, and a `number` `confidence` value.
   *
   * &nbsp;
   *
   * ```json
   * interface IDetectedObject extends Document {
   *   boundingBox: number[];
   *   categories: string[];
   *   confidence: number;
   * }
   * ```
   */
  detectedObjects?: InputMaybe<Scalars['JSON']['input']>;
  height?: InputMaybe<Scalars['Float']['input']>;
  originalUrl?: InputMaybe<Scalars['String']['input']>;
  parentEntity?: InputMaybe<FilterFindManyEntityReferenceInput>;
  qualityAnalysis?: InputMaybe<FilterFindManyImageQualityAnalysisInput>;
  qualityScore?: InputMaybe<Scalars['Float']['input']>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
  width?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyAssetInput = {
  AND?: InputMaybe<Array<FilterFindManyAssetInput>>;
  OR?: InputMaybe<Array<FilterFindManyAssetInput>>;
  _id?: InputMaybe<Scalars['String']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyAssetOperatorsInput>;
  blurhash?: InputMaybe<Scalars['String']['input']>;
  caption?: InputMaybe<FilterFindManyMultilingualInput>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  originalUrl?: InputMaybe<Scalars['String']['input']>;
  parentEntity?: InputMaybe<FilterFindManyEntityReferenceInput>;
  type?: InputMaybe<EnumDKeyAssetType>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyAssetOperatorsInput = {
  _id?: InputMaybe<FilterFindManyAsset_IdOperatorsInput>;
};

export type FilterFindManyAsset_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyBookerBundlesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  product?: InputMaybe<Scalars['MongoID']['input']>;
  upsells?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyBookerCustomizationsInput = {
  featuredImage?: InputMaybe<Scalars['MongoID']['input']>;
  logo?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterFindManyBookerInput = {
  AND?: InputMaybe<Array<FilterFindManyBookerInput>>;
  OR?: InputMaybe<Array<FilterFindManyBookerInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyBookerOperatorsInput>;
  bundles?: InputMaybe<Array<InputMaybe<FilterFindManyBookerBundlesInput>>>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  customizations?: InputMaybe<FilterFindManyBookerCustomizationsInput>;
  discounts?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  name?: InputMaybe<FilterFindManyMultilingualInput>;
  paymentMetadata?: InputMaybe<FilterFindManyBookerPaymentMetadataInput>;
  policies?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  rules?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  status?: InputMaybe<EnumBookerStatus>;
  statusNotification?: InputMaybe<FilterFindManyMultilingualInput>;
  storefront?: InputMaybe<Scalars['MongoID']['input']>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
  waivers?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyBookerOperatorsInput = {
  _id?: InputMaybe<FilterFindManyBooker_IdOperatorsInput>;
};

export type FilterFindManyBookerPaymentMetadataInput = {
  applicationPercentage?: InputMaybe<Scalars['Float']['input']>;
  connectedAccountId?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  depositSettings?: InputMaybe<FilterFindManyDepositSettingsInput>;
  securityDepositSettings?: InputMaybe<FilterFindManySecurityDepositSettingsInput>;
  tax?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyBooker_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyChangelogInput = {
  AND?: InputMaybe<Array<FilterFindManyChangelogInput>>;
  OR?: InputMaybe<Array<FilterFindManyChangelogInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyChangelogOperatorsInput>;
  /** Filter by createDateISO either _eq, _gt, _lt, _gte, or _lte */
  createdDateISO?: InputMaybe<CreatedDateIso>;
  entity?: InputMaybe<FilterFindManyVersionedEntityReferenceInput>;
  initiatedByUser?: InputMaybe<Scalars['MongoID']['input']>;
  /** Filter by message.en either _eq, _startsWith, or _notStartsWith */
  message?: InputMaybe<Message>;
  owner?: InputMaybe<FilterFindManyOwnerInput>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyChangelogOperatorsInput = {
  _id?: InputMaybe<FilterFindManyChangelog_IdOperatorsInput>;
};

export type FilterFindManyChangelog_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyClosureInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  dateRangeISO?: InputMaybe<FilterFindManyDateRangeIsoInput>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyColorInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  predominance?: InputMaybe<Scalars['Float']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyContactInput = {
  address?: InputMaybe<FilterFindManyAddressInput>;
  email?: InputMaybe<Scalars['String']['input']>;
  links?: InputMaybe<FilterFindManyLinksInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  tollFreePublicPhone?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyCustomerInput = {
  AND?: InputMaybe<Array<FilterFindManyCustomerInput>>;
  OR?: InputMaybe<Array<FilterFindManyCustomerInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyCustomerOperatorsInput>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  orders?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  phone?: InputMaybe<Scalars['String']['input']>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyCustomerOperatorsInput = {
  _id?: InputMaybe<FilterFindManyCustomer_IdOperatorsInput>;
};

export type FilterFindManyCustomer_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyDateRangeIsoInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  end: Scalars['String']['input'];
  metadata?: InputMaybe<Scalars['String']['input']>;
  start: Scalars['String']['input'];
};

export type FilterFindManyDepositSettingsInput = {
  chargeBalanceDaysBeforeCheckIn?: InputMaybe<Scalars['Float']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  rate?: InputMaybe<Scalars['Float']['input']>;
  rateType?: InputMaybe<EnumDepositSettingsRateType>;
};

export type FilterFindManyDiscountInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  amount?: InputMaybe<Scalars['Float']['input']>;
  canCombine?: InputMaybe<Scalars['Boolean']['input']>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  currentUsageCount?: InputMaybe<Scalars['Float']['input']>;
  daysInAdvance?: InputMaybe<Scalars['Float']['input']>;
  description?: InputMaybe<FilterFindManyMultilingualInput>;
  discountActivePeriod?: InputMaybe<FilterFindManyDateRangeIsoInput>;
  excludeUpsells?: InputMaybe<Scalars['Boolean']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  maxNights?: InputMaybe<Scalars['Float']['input']>;
  maxUsageCount?: InputMaybe<Scalars['Float']['input']>;
  minGuestCount?: InputMaybe<Scalars['Float']['input']>;
  minNights?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<FilterFindManyMultilingualInput>;
  promoCode?: InputMaybe<Scalars['String']['input']>;
  storefront?: InputMaybe<Scalars['MongoID']['input']>;
  type?: InputMaybe<EnumDiscountType>;
  unit?: InputMaybe<EnumDiscountUnit>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

export type FilterFindManyEntityReferenceInput = {
  _entityId?: InputMaybe<Scalars['MongoID']['input']>;
  type?: InputMaybe<EnumEntityReferenceType>;
};

export type FilterFindManyExperienceOperatorMetadataInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterFindManyGuestMetadataInput = {
  maximumNumber?: InputMaybe<Scalars['Float']['input']>;
  minimumNumber?: InputMaybe<Scalars['Float']['input']>;
  nameEntryAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  nameEntryRequired?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FilterFindManyImageQualityAnalysisInput = {
  blockiness?: InputMaybe<Scalars['Float']['input']>;
  chroma_subsampling?: InputMaybe<Scalars['Float']['input']>;
  color_score?: InputMaybe<Scalars['Float']['input']>;
  contrast?: InputMaybe<Scalars['Float']['input']>;
  dct?: InputMaybe<Scalars['Float']['input']>;
  exposure?: InputMaybe<Scalars['Float']['input']>;
  focus?: InputMaybe<Scalars['Float']['input']>;
  jpeg_chroma?: InputMaybe<Scalars['Float']['input']>;
  jpeg_quality?: InputMaybe<Scalars['Float']['input']>;
  lighting?: InputMaybe<Scalars['Float']['input']>;
  noise?: InputMaybe<Scalars['Float']['input']>;
  pixel_score?: InputMaybe<Scalars['Float']['input']>;
  resolution?: InputMaybe<Scalars['Float']['input']>;
  saturation?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyInventoryItemInput = {
  AND?: InputMaybe<Array<FilterFindManyInventoryItemInput>>;
  OR?: InputMaybe<Array<FilterFindManyInventoryItemInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyInventoryItemOperatorsInput>;
  claimedDateRangesISO?: InputMaybe<Array<InputMaybe<FilterFindManyDateRangeIsoInput>>>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  product?: InputMaybe<Scalars['MongoID']['input']>;
  type?: InputMaybe<EnumInventoryItemType>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyInventoryItemOperatorsInput = {
  _id?: InputMaybe<FilterFindManyInventoryItem_IdOperatorsInput>;
};

export type FilterFindManyInventoryItem_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyLinksInput = {
  bookNow?: InputMaybe<Scalars['String']['input']>;
  facebook?: InputMaybe<Scalars['String']['input']>;
  googleMyBusiness?: InputMaybe<Scalars['String']['input']>;
  instagram?: InputMaybe<Scalars['String']['input']>;
  pinterest?: InputMaybe<Scalars['String']['input']>;
  tiktok?: InputMaybe<Scalars['String']['input']>;
  tripAdvisor?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
  x?: InputMaybe<Scalars['String']['input']>;
  youtube?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyListInput = {
  AND?: InputMaybe<Array<FilterFindManyListInput>>;
  OR?: InputMaybe<Array<FilterFindManyListInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyListOperatorsInput>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<FilterFindManyMultilingualInput>;
  entityReferences?: InputMaybe<Array<InputMaybe<FilterFindManyVersionedEntityReferenceInput>>>;
  externallyAvailableEntityReferences?: InputMaybe<Array<InputMaybe<FilterFindManyVersionedEntityReferenceInput>>>;
  favorited?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<FilterFindManyMultilingualInput>;
  owner?: InputMaybe<FilterFindManyOwnerInput>;
  selections?: InputMaybe<Scalars['JSON']['input']>;
  type?: InputMaybe<EnumListType>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyListOperatorsInput = {
  _id?: InputMaybe<FilterFindManyList_IdOperatorsInput>;
};

export type FilterFindManyList_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyMultilingualInput = {
  en?: InputMaybe<Scalars['String']['input']>;
  es?: InputMaybe<Scalars['String']['input']>;
  fr?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyNoteInput = {
  AND?: InputMaybe<Array<FilterFindManyNoteInput>>;
  OR?: InputMaybe<Array<FilterFindManyNoteInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyNoteOperatorsInput>;
  author?: InputMaybe<Scalars['MongoID']['input']>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  entity?: InputMaybe<FilterFindManyEntityReferenceInput>;
  mentions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  message?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<FilterFindManyOwnerInput>;
  resolvedBy?: InputMaybe<Scalars['MongoID']['input']>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyNoteOperatorsInput = {
  _id?: InputMaybe<FilterFindManyNote_IdOperatorsInput>;
};

export type FilterFindManyNote_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyOperatorEnrollmentsInput = {
  onboardingStatus?: InputMaybe<EnumOperatorEnrollmentsOnboardingStatus>;
  organization?: InputMaybe<Scalars['MongoID']['input']>;
  organizationControlled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FilterFindManyOperatorInput = {
  AND?: InputMaybe<Array<FilterFindManyOperatorInput>>;
  OR?: InputMaybe<Array<FilterFindManyOperatorInput>>;
  /** Filter operators by _entityId. Accepts an array of _entityId. */
  _entityId?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyOperatorOperatorsInput>;
  _versionId?: InputMaybe<Scalars['MongoID']['input']>;
  accommodationMetadata?: InputMaybe<FilterFindManyAccommodationOperatorMetadataInput>;
  avgImageQuality?: InputMaybe<EnumOperatorAvgImageQuality>;
  claimed?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter operators by contact details. You may check if certain links exist or not by passing a boolean value */
  contact?: InputMaybe<ContactWithBooleanLinks>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<FilterFindManyMultilingualInput>;
  enrollments?: InputMaybe<Array<InputMaybe<FilterFindManyOperatorEnrollmentsInput>>>;
  experienceMetadata?: InputMaybe<FilterFindManyExperienceOperatorMetadataInput>;
  /** Filter operators by which days of the week they're open or closed. */
  hoursOfOperation?: InputMaybe<BooleanHoursOfOperation>;
  images?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Filter operators by location using a point and radius. Accepts a value of [longitude, latitude, radius] */
  location?: InputMaybe<Array<Scalars['Float']['input']>>;
  name?: InputMaybe<FilterFindManyMultilingualInput>;
  /** Filter operators by operationalStatus. Accepts an array of operationalStatus values. */
  operationalStatus?: InputMaybe<Array<InputMaybe<EnumOperatorOperationalStatus>>>;
  /** Filter operators by organization ids */
  organizations?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter operators by pricing. Accepts an array of pricing values. */
  pricing?: InputMaybe<Array<InputMaybe<EnumOperatorPricing>>>;
  restaurantMetadata?: InputMaybe<FilterFindManyRestaurantOperatorMetadataInput>;
  /** Filter operators by a search string that filters by operator name */
  search?: InputMaybe<Scalars['String']['input']>;
  /** Filter operators by which months of the year they're open or closed. */
  seasonality?: InputMaybe<BooleanSeasonality>;
  /** Search all operators that have selected tag groups that are included */
  selectedTagGroups?: InputMaybe<Array<Scalars['String']['input']>>;
  serviceMetadata?: InputMaybe<FilterFindManyServiceOperatorMetadataInput>;
  shortDescription?: InputMaybe<FilterFindManyMultilingualInput>;
  /** Search all operator tags by $in operator */
  tags?: InputMaybe<OperatorTagsInput>;
  toursMetadata?: InputMaybe<FilterFindManyToursOperatorMetadataInput>;
  type?: InputMaybe<EnumOperatorType>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyOperatorOperatorsInput = {
  _entityId?: InputMaybe<FilterFindManyOperator_EntityIdOperatorsInput>;
  _id?: InputMaybe<FilterFindManyOperator_IdOperatorsInput>;
  _versionId?: InputMaybe<FilterFindManyOperator_VersionIdOperatorsInput>;
};

export type FilterFindManyOperator_EntityIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyOperator_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyOperator_VersionIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyOrderGuestsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyOrderInput = {
  AND?: InputMaybe<Array<FilterFindManyOrderInput>>;
  OR?: InputMaybe<Array<FilterFindManyOrderInput>>;
  _custom?: InputMaybe<CustomOrderFilter>;
  _id?: InputMaybe<Scalars['String']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyOrderOperatorsInput>;
  cancelled?: InputMaybe<Scalars['Boolean']['input']>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  customer?: InputMaybe<Scalars['MongoID']['input']>;
  discounts?: InputMaybe<Array<InputMaybe<FilterFindManyDiscountInput>>>;
  guests?: InputMaybe<Array<InputMaybe<FilterFindManyOrderGuestsInput>>>;
  purchasedProducts?: InputMaybe<Array<InputMaybe<FilterFindManyPurchasedProductInput>>>;
  source?: InputMaybe<FilterFindManyOrderSourceInput>;
  stripeMetadata?: InputMaybe<FilterFindManyStripeMetadataInput>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyOrderOperatorsInput = {
  _id?: InputMaybe<FilterFindManyOrder_IdOperatorsInput>;
};

export type FilterFindManyOrderSourceInput = {
  booker?: InputMaybe<Scalars['MongoID']['input']>;
  storefront?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterFindManyOrder_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyOrganizationInput = {
  AND?: InputMaybe<Array<FilterFindManyOrganizationInput>>;
  OR?: InputMaybe<Array<FilterFindManyOrganizationInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyOrganizationOperatorsInput>;
  contact?: InputMaybe<FilterFindManyContactInput>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<FilterFindManyMultilingualInput>;
  domains?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  images?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  logo?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<FilterFindManyOrganizationMetadataInput>;
  name?: InputMaybe<FilterFindManyMultilingualInput>;
  onboardingMetadata?: InputMaybe<FilterFindManyOrganizationOnboardingMetadataInput>;
  shortDescription?: InputMaybe<FilterFindManyMultilingualInput>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

export type FilterFindManyOrganizationMetadataInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  eventLookaheadMonths?: InputMaybe<Scalars['Float']['input']>;
  inviteWhenAddingStaff?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FilterFindManyOrganizationOnboardingMetadataInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  allowColdSignup?: InputMaybe<Scalars['Boolean']['input']>;
  introMessage?: InputMaybe<Scalars['String']['input']>;
  typeformSurveyId?: InputMaybe<Scalars['String']['input']>;
  videoId?: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyOrganizationOperatorsInput = {
  _id?: InputMaybe<FilterFindManyOrganization_IdOperatorsInput>;
};

export type FilterFindManyOrganization_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyOwnerInput = {
  entityId?: InputMaybe<Scalars['MongoID']['input']>;
  type?: InputMaybe<EnumOwnerType>;
};

export type FilterFindManyPolicyInput = {
  AND?: InputMaybe<Array<FilterFindManyPolicyInput>>;
  OR?: InputMaybe<Array<FilterFindManyPolicyInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyPolicyOperatorsInput>;
  content?: InputMaybe<FilterFindManyMultilingualInput>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<FilterFindManyMultilingualInput>;
  storefront?: InputMaybe<Scalars['MongoID']['input']>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyPolicyOperatorsInput = {
  _id?: InputMaybe<FilterFindManyPolicy_IdOperatorsInput>;
};

export type FilterFindManyPolicy_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyPostHogDataInput = {
  AND?: InputMaybe<Array<FilterFindManyPostHogDataInput>>;
  OR?: InputMaybe<Array<FilterFindManyPostHogDataInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyPostHogDataOperatorsInput>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  metadata?: InputMaybe<FilterFindManyPostHogDataMetadataInput>;
  timestamp?: InputMaybe<Scalars['Date']['input']>;
  /** Filter by timestamp range (use _gte with _lt) */
  timestampRange?: InputMaybe<DateInput>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

export type FilterFindManyPostHogDataMetadataInput = {
  appContext?: InputMaybe<EnumPostHogDataMetadataAppContext>;
  booker?: InputMaybe<Scalars['MongoID']['input']>;
  event?: InputMaybe<Scalars['MongoID']['input']>;
  eventName?: InputMaybe<EnumPostHogDataMetadataEventName>;
  instanceId?: InputMaybe<Scalars['String']['input']>;
  list?: InputMaybe<Scalars['MongoID']['input']>;
  operator?: InputMaybe<Scalars['MongoID']['input']>;
  orderId?: InputMaybe<Scalars['String']['input']>;
  organization?: InputMaybe<Scalars['MongoID']['input']>;
  product?: InputMaybe<Scalars['MongoID']['input']>;
  promoCode?: InputMaybe<Scalars['String']['input']>;
  widget?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyPostHogDataOperatorsInput = {
  _id?: InputMaybe<FilterFindManyPostHogData_IdOperatorsInput>;
};

export type FilterFindManyPostHogData_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyPriceTierInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  label?: InputMaybe<FilterFindManyMultilingualInput>;
  price?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<EnumPriceTierType>;
};

export type FilterFindManyPricingInput = {
  description?: InputMaybe<FilterFindManyMultilingualInput>;
  tiers?: InputMaybe<Array<InputMaybe<FilterFindManyPriceTierInput>>>;
};

export type FilterFindManyProductContactInput = {
  address?: InputMaybe<FilterFindManyAddressInput>;
  email?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  tollFreePublicPhone?: InputMaybe<Scalars['String']['input']>;
  useOwnerContact?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FilterFindManyProductInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  accommodationMetadata?: InputMaybe<FilterFindManyAccommodationProductMetadataInput>;
  contact?: InputMaybe<FilterFindManyProductContactInput>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<FilterFindManyMultilingualInput>;
  externalBookingUrl?: InputMaybe<Scalars['String']['input']>;
  images?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isUpsellOnly?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<FilterFindManyMultilingualInput>;
  owner?: InputMaybe<FilterFindManyOwnerInput>;
  pricing?: InputMaybe<FilterFindManyPricingInput>;
  publicationStatus?: InputMaybe<EnumProductPublicationStatus>;
  quantitySettings?: InputMaybe<FilterFindManyProductQuantitySettingsInput>;
  rules?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  shortDescription?: InputMaybe<FilterFindManyMultilingualInput>;
  storefront?: InputMaybe<Scalars['MongoID']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  type?: InputMaybe<EnumProductType>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

export type FilterFindManyProductQuantitySettingsInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  maxQuantity?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyPurchasedProductGuestsPerTierInput = {
  count?: InputMaybe<Scalars['Float']['input']>;
  tierId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterFindManyPurchasedProductInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  guestsPerTier?: InputMaybe<Array<InputMaybe<FilterFindManyPurchasedProductGuestsPerTierInput>>>;
  inventoryClaims?: InputMaybe<Array<InputMaybe<FilterFindManyPurchasedProductInventoryClaimsInput>>>;
  product?: InputMaybe<FilterFindManyProductInput>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyPurchasedProductInventoryClaimsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  claimedDateRangeISO?: InputMaybe<FilterFindManyDateRangeIsoInput>;
  inventory?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterFindManyRefundInput = {
  AND?: InputMaybe<Array<FilterFindManyRefundInput>>;
  OR?: InputMaybe<Array<FilterFindManyRefundInput>>;
  _id?: InputMaybe<Scalars['String']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyRefundOperatorsInput>;
  amount?: InputMaybe<Scalars['Float']['input']>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  orderId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<EnumRefundStatus>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyRefundOperatorsInput = {
  _id?: InputMaybe<FilterFindManyRefund_IdOperatorsInput>;
};

export type FilterFindManyRefund_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyRestaurantOperatorMetadataInput = {
  seatingCapacity?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyRoomInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  amenities?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  type?: InputMaybe<EnumRoomType>;
};

export type FilterFindManyRuleInput = {
  AND?: InputMaybe<Array<FilterFindManyRuleInput>>;
  OR?: InputMaybe<Array<FilterFindManyRuleInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyRuleOperatorsInput>;
  activePeriod?: InputMaybe<FilterFindManyDateRangeIsoInput>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  storefront?: InputMaybe<Scalars['MongoID']['input']>;
  type?: InputMaybe<EnumRuleType>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
  value?: InputMaybe<Scalars['JSON']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyRuleOperatorsInput = {
  _id?: InputMaybe<FilterFindManyRule_IdOperatorsInput>;
};

export type FilterFindManyRule_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManySecurityDepositSettingsInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  placeHoldDaysBeforeCheckOut?: InputMaybe<Scalars['Float']['input']>;
  rate?: InputMaybe<Scalars['Float']['input']>;
  rateType?: InputMaybe<EnumSecurityDepositSettingsRateType>;
};

export type FilterFindManyServiceOperatorMetadataInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterFindManyStorefrontInput = {
  AND?: InputMaybe<Array<FilterFindManyStorefrontInput>>;
  OR?: InputMaybe<Array<FilterFindManyStorefrontInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyStorefrontOperatorsInput>;
  connectedAccountIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  name?: InputMaybe<FilterFindManyMultilingualInput>;
  siteMetadata?: InputMaybe<FilterFindManyStorefrontSiteMetadataInput>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyStorefrontOperatorsInput = {
  _id?: InputMaybe<FilterFindManyStorefront_IdOperatorsInput>;
};

export type FilterFindManyStorefrontSiteMetadataInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  bookers?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  description?: InputMaybe<FilterFindManyMultilingualInput>;
  email?: InputMaybe<Scalars['String']['input']>;
  featuredImage?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  logo?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyStorefront_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyStripeMetadataInput = {
  chargeId?: InputMaybe<Scalars['String']['input']>;
  customerId?: InputMaybe<Scalars['String']['input']>;
  invoiceId?: InputMaybe<Scalars['String']['input']>;
  paymentMethodId?: InputMaybe<Scalars['String']['input']>;
  securityHoldPaymentIntentId?: InputMaybe<Scalars['String']['input']>;
  securityHoldStatus?: InputMaybe<EnumStripeMetadataSecurityHoldStatus>;
};

export type FilterFindManySurveyResponseInput = {
  AND?: InputMaybe<Array<FilterFindManySurveyResponseInput>>;
  OR?: InputMaybe<Array<FilterFindManySurveyResponseInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManySurveyResponseOperatorsInput>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  operator?: InputMaybe<Scalars['MongoID']['input']>;
  organization?: InputMaybe<Scalars['MongoID']['input']>;
  responses?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  surveyId?: InputMaybe<Scalars['String']['input']>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
  user?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManySurveyResponseOperatorsInput = {
  _id?: InputMaybe<FilterFindManySurveyResponse_IdOperatorsInput>;
};

export type FilterFindManySurveyResponse_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyTagGroupInput = {
  AND?: InputMaybe<Array<FilterFindManyTagGroupInput>>;
  OR?: InputMaybe<Array<FilterFindManyTagGroupInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyTagGroupOperatorsInput>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  key?: InputMaybe<EnumTagGroupKey>;
  name?: InputMaybe<FilterFindManyMultilingualInput>;
  /** Filter tagGroup by an array of tagGroup types */
  type?: InputMaybe<Array<EnumTagGroupType>>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyTagGroupOperatorsInput = {
  _id?: InputMaybe<FilterFindManyTagGroup_IdOperatorsInput>;
};

export type FilterFindManyTagGroup_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyTagInput = {
  AND?: InputMaybe<Array<FilterFindManyTagInput>>;
  OR?: InputMaybe<Array<FilterFindManyTagInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyTagOperatorsInput>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  entityType?: InputMaybe<EnumTagEntityType>;
  /** Filter tags by entityTypes. Accepts an array of entityTypes. */
  entityTypes: Array<InputMaybe<EnumTagEntityTypes>>;
  name?: InputMaybe<FilterFindManyMultilingualInput>;
  owner?: InputMaybe<FilterFindManyOwnerInput>;
  /** Filter tags by tagGroup. Accepts an array of tagGroup _ids. */
  tagGroup?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyTagOperatorsInput = {
  _id?: InputMaybe<FilterFindManyTag_IdOperatorsInput>;
};

export type FilterFindManyTag_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyTaxInput = {
  AND?: InputMaybe<Array<FilterFindManyTaxInput>>;
  OR?: InputMaybe<Array<FilterFindManyTaxInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyTaxOperatorsInput>;
  country?: InputMaybe<Scalars['String']['input']>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  owner?: InputMaybe<FilterFindManyOwnerInput>;
  percentage?: InputMaybe<Scalars['Float']['input']>;
  subdivision?: InputMaybe<Scalars['String']['input']>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyTaxOperatorsInput = {
  _id?: InputMaybe<FilterFindManyTax_IdOperatorsInput>;
};

export type FilterFindManyTax_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyToursOperatorMetadataInput = {
  maxGroupSize?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyUserAccessInput = {
  operators?: InputMaybe<Array<InputMaybe<FilterFindManyUserAccessOperatorsInput>>>;
  organizations?: InputMaybe<Array<InputMaybe<FilterFindManyUserAccessOperatorsInput>>>;
  storefronts?: InputMaybe<Array<InputMaybe<FilterFindManyUserAccessOperatorsInput>>>;
};

export type FilterFindManyUserAccessOperatorsInput = {
  entityId: Scalars['MongoID']['input'];
  role: EnumUserAccessOperatorsRole;
  status: EnumUserAccessOperatorsStatus;
};

export type FilterFindManyUserAuth0IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyUserConfirmationCodesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  sentToEmail?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<EnumUserConfirmationCodesType>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
  validated?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FilterFindManyUserEmailOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyUserEmailPreferencesInput = {
  frequency?: InputMaybe<EnumUserEmailPreferencesFrequency>;
  templateName?: InputMaybe<EnumUserEmailPreferencesTemplateName>;
};

export type FilterFindManyUserInput = {
  AND?: InputMaybe<Array<FilterFindManyUserInput>>;
  OR?: InputMaybe<Array<FilterFindManyUserInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyUserOperatorsInput>;
  access?: InputMaybe<FilterFindManyUserAccessInput>;
  auth0Id?: InputMaybe<Scalars['String']['input']>;
  confirmationCodes?: InputMaybe<Array<InputMaybe<FilterFindManyUserConfirmationCodesInput>>>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailPreferences?: InputMaybe<Array<InputMaybe<FilterFindManyUserEmailPreferencesInput>>>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  onboardingMetadata?: InputMaybe<FilterFindManyUserOnboardingMetadataInput>;
  signupToken?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<EnumUserStatus>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
  userType?: InputMaybe<EnumUserUserType>;
};

export type FilterFindManyUserOnboardingMetadataInput = {
  isPostOnboarding?: InputMaybe<Scalars['Boolean']['input']>;
  onboardingOrganization?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyUserOperatorsInput = {
  _id?: InputMaybe<FilterFindManyUser_IdOperatorsInput>;
  auth0Id?: InputMaybe<FilterFindManyUserAuth0IdOperatorsInput>;
  email?: InputMaybe<FilterFindManyUserEmailOperatorsInput>;
  signupToken?: InputMaybe<FilterFindManyUserSignupTokenOperatorsInput>;
};

export type FilterFindManyUserSignupTokenOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyUser_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyVersionedEntityReferenceInput = {
  _entityId?: InputMaybe<Scalars['MongoID']['input']>;
  _versionId?: InputMaybe<Scalars['MongoID']['input']>;
  type?: InputMaybe<EnumVersionedEntityReferenceType>;
};

export type FilterFindManyWidgetEntityOverridesInput = {
  _entityId?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<FilterFindManyMultilingualInput>;
  images?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  shortDescription?: InputMaybe<FilterFindManyMultilingualInput>;
};

export type FilterFindManyWidgetEventSettingsInput = {
  displayType?: InputMaybe<EnumWidgetEventSettingsDisplayType>;
  eventTags?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lookAheadMonths?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyWidgetInput = {
  AND?: InputMaybe<Array<FilterFindManyWidgetInput>>;
  OR?: InputMaybe<Array<FilterFindManyWidgetInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyWidgetOperatorsInput>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<FilterFindManyMultilingualInput>;
  entityOverrides?: InputMaybe<Array<InputMaybe<FilterFindManyWidgetEntityOverridesInput>>>;
  eventSettings?: InputMaybe<FilterFindManyWidgetEventSettingsInput>;
  favorited?: InputMaybe<Scalars['Boolean']['input']>;
  filterableTags?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  list?: InputMaybe<Scalars['MongoID']['input']>;
  name?: InputMaybe<FilterFindManyMultilingualInput>;
  owner?: InputMaybe<FilterFindManyOwnerInput>;
  type?: InputMaybe<EnumWidgetType>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyWidgetOperatorsInput = {
  _id?: InputMaybe<FilterFindManyWidget_IdOperatorsInput>;
};

export type FilterFindManyWidget_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneApiAccessInput = {
  AND?: InputMaybe<Array<FilterFindOneApiAccessInput>>;
  OR?: InputMaybe<Array<FilterFindOneApiAccessInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneApiAccessOperatorsInput>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
  user?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneApiAccessOperatorsInput = {
  _id?: InputMaybe<FilterFindOneApiAccess_IdOperatorsInput>;
  token?: InputMaybe<FilterFindOneApiAccessTokenOperatorsInput>;
};

export type FilterFindOneApiAccessTokenOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindOneApiAccess_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneCampaignInput = {
  AND?: InputMaybe<Array<FilterFindOneCampaignInput>>;
  OR?: InputMaybe<Array<FilterFindOneCampaignInput>>;
  _entityId?: InputMaybe<Scalars['MongoID']['input']>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneCampaignOperatorsInput>;
  _versionId?: InputMaybe<Scalars['MongoID']['input']>;
  assets?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  dateRangeISO?: InputMaybe<FilterFindOneDateRangeIsoInput>;
  description?: InputMaybe<FilterFindOneMultilingualInput>;
  list?: InputMaybe<Scalars['MongoID']['input']>;
  name?: InputMaybe<FilterFindOneMultilingualInput>;
  owner?: InputMaybe<FilterFindOneOwnerInput>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneCampaignOperatorsInput = {
  _entityId?: InputMaybe<FilterFindOneCampaign_EntityIdOperatorsInput>;
  _id?: InputMaybe<FilterFindOneCampaign_IdOperatorsInput>;
  _versionId?: InputMaybe<FilterFindOneCampaign_VersionIdOperatorsInput>;
};

export type FilterFindOneCampaign_EntityIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneCampaign_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneCampaign_VersionIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneDateRangeIsoInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  end?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindOneMaintenanceDoorstopInput = {
  isLive: Scalars['Boolean']['input'];
  message: MultilingualInput;
};

export type FilterFindOneMaintenanceInput = {
  AND?: InputMaybe<Array<FilterFindOneMaintenanceInput>>;
  OR?: InputMaybe<Array<FilterFindOneMaintenanceInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneMaintenanceOperatorsInput>;
  banner?: InputMaybe<FilterFindOneMaintenanceDoorstopInput>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  doorstop?: InputMaybe<FilterFindOneMaintenanceDoorstopInput>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneMaintenanceOperatorsInput = {
  _id?: InputMaybe<FilterFindOneMaintenance_IdOperatorsInput>;
};

export type FilterFindOneMaintenance_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneMultilingualInput = {
  en?: InputMaybe<Scalars['String']['input']>;
  es?: InputMaybe<Scalars['String']['input']>;
  fr?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindOneOwnerInput = {
  entityId?: InputMaybe<Scalars['MongoID']['input']>;
  type?: InputMaybe<EnumOwnerType>;
};

export type FilterFindOnePublicationStatusInput = {
  AND?: InputMaybe<Array<FilterFindOnePublicationStatusInput>>;
  OR?: InputMaybe<Array<FilterFindOnePublicationStatusInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOnePublicationStatusOperatorsInput>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  entity?: InputMaybe<FilterFindOneVersionedEntityReferenceInput>;
  organization?: InputMaybe<Scalars['MongoID']['input']>;
  status?: InputMaybe<EnumPublicationStatusStatus>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOnePublicationStatusOperatorsInput = {
  _id?: InputMaybe<FilterFindOnePublicationStatus_IdOperatorsInput>;
};

export type FilterFindOnePublicationStatus_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneSurveyResponseInput = {
  AND?: InputMaybe<Array<FilterFindOneSurveyResponseInput>>;
  OR?: InputMaybe<Array<FilterFindOneSurveyResponseInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneSurveyResponseOperatorsInput>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  operator?: InputMaybe<Scalars['MongoID']['input']>;
  organization?: InputMaybe<Scalars['MongoID']['input']>;
  responses?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  surveyId?: InputMaybe<Scalars['String']['input']>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
  user?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneSurveyResponseOperatorsInput = {
  _id?: InputMaybe<FilterFindOneSurveyResponse_IdOperatorsInput>;
};

export type FilterFindOneSurveyResponse_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneTagGroupInput = {
  AND?: InputMaybe<Array<FilterFindOneTagGroupInput>>;
  OR?: InputMaybe<Array<FilterFindOneTagGroupInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneTagGroupOperatorsInput>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  key?: InputMaybe<EnumTagGroupKey>;
  name?: InputMaybe<FilterFindOneMultilingualInput>;
  type?: InputMaybe<EnumTagGroupType>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneTagGroupOperatorsInput = {
  _id?: InputMaybe<FilterFindOneTagGroup_IdOperatorsInput>;
};

export type FilterFindOneTagGroup_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneUserAccessInput = {
  operators?: InputMaybe<Array<InputMaybe<FilterFindOneUserAccessOperatorsInput>>>;
  organizations?: InputMaybe<Array<InputMaybe<FilterFindOneUserAccessOperatorsInput>>>;
  storefronts?: InputMaybe<Array<InputMaybe<FilterFindOneUserAccessOperatorsInput>>>;
};

export type FilterFindOneUserAccessOperatorsInput = {
  entityId: Scalars['MongoID']['input'];
  role: EnumUserAccessOperatorsRole;
  status: EnumUserAccessOperatorsStatus;
};

export type FilterFindOneUserAuth0IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindOneUserConfirmationCodesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  sentToEmail?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<EnumUserConfirmationCodesType>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
  validated?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FilterFindOneUserEmailOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindOneUserEmailPreferencesInput = {
  frequency?: InputMaybe<EnumUserEmailPreferencesFrequency>;
  templateName?: InputMaybe<EnumUserEmailPreferencesTemplateName>;
};

export type FilterFindOneUserInput = {
  AND?: InputMaybe<Array<FilterFindOneUserInput>>;
  OR?: InputMaybe<Array<FilterFindOneUserInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneUserOperatorsInput>;
  access?: InputMaybe<FilterFindOneUserAccessInput>;
  auth0Id?: InputMaybe<Scalars['String']['input']>;
  confirmationCodes?: InputMaybe<Array<InputMaybe<FilterFindOneUserConfirmationCodesInput>>>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailPreferences?: InputMaybe<Array<InputMaybe<FilterFindOneUserEmailPreferencesInput>>>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  onboardingMetadata?: InputMaybe<FilterFindOneUserOnboardingMetadataInput>;
  signupToken?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<EnumUserStatus>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
  userType?: InputMaybe<EnumUserUserType>;
};

export type FilterFindOneUserOnboardingMetadataInput = {
  isPostOnboarding?: InputMaybe<Scalars['Boolean']['input']>;
  onboardingOrganization?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneUserOperatorsInput = {
  _id?: InputMaybe<FilterFindOneUser_IdOperatorsInput>;
  auth0Id?: InputMaybe<FilterFindOneUserAuth0IdOperatorsInput>;
  email?: InputMaybe<FilterFindOneUserEmailOperatorsInput>;
  signupToken?: InputMaybe<FilterFindOneUserSignupTokenOperatorsInput>;
};

export type FilterFindOneUserSignupTokenOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindOneUser_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneVersionedEntityReferenceInput = {
  _entityId?: InputMaybe<Scalars['MongoID']['input']>;
  _versionId?: InputMaybe<Scalars['MongoID']['input']>;
  type?: InputMaybe<EnumVersionedEntityReferenceType>;
};

export type GuestMetadata = {
  __typename?: 'GuestMetadata';
  maximumNumber?: Maybe<Scalars['Float']['output']>;
  minimumNumber?: Maybe<Scalars['Float']['output']>;
  nameEntryAllowed: Scalars['Boolean']['output'];
  nameEntryRequired: Scalars['Boolean']['output'];
};

export type GuestMetadataInput = {
  maximumNumber?: InputMaybe<Scalars['Float']['input']>;
  minimumNumber?: InputMaybe<Scalars['Float']['input']>;
  nameEntryAllowed: Scalars['Boolean']['input'];
  nameEntryRequired: Scalars['Boolean']['input'];
};

export type ImageQualityAnalysis = {
  __typename?: 'ImageQualityAnalysis';
  blockiness?: Maybe<Scalars['Float']['output']>;
  chroma_subsampling?: Maybe<Scalars['Float']['output']>;
  color_score?: Maybe<Scalars['Float']['output']>;
  contrast?: Maybe<Scalars['Float']['output']>;
  dct?: Maybe<Scalars['Float']['output']>;
  exposure?: Maybe<Scalars['Float']['output']>;
  focus?: Maybe<Scalars['Float']['output']>;
  jpeg_chroma?: Maybe<Scalars['Float']['output']>;
  jpeg_quality?: Maybe<Scalars['Float']['output']>;
  lighting?: Maybe<Scalars['Float']['output']>;
  noise?: Maybe<Scalars['Float']['output']>;
  pixel_score?: Maybe<Scalars['Float']['output']>;
  resolution?: Maybe<Scalars['Float']['output']>;
  saturation?: Maybe<Scalars['Float']['output']>;
};

export enum ImageQualityRating {
  Average = 'AVERAGE',
  High = 'HIGH',
  Low = 'LOW'
}

export type IntegrateCalendarLinksByProductIds = {
  __typename?: 'IntegrateCalendarLinksByProductIds';
  products: Array<Product>;
  releasedInventoryClaimItems: Array<InventoryItem>;
  updatedInventoryClaimItems: Array<InventoryItem>;
};

export type InventoryBookedDatesSummary = {
  __typename?: 'InventoryBookedDatesSummary';
  bookedDatesISO: Array<Scalars['String']['output']>;
  checkOutOnlyDatesISO: Array<Scalars['String']['output']>;
};

export type InventoryItem = {
  __typename?: 'InventoryItem';
  _id: Scalars['MongoID']['output'];
  claimedDateRangesISO: Array<Maybe<DateRangeIso>>;
  createdDateISO?: Maybe<Scalars['Date']['output']>;
  product: Scalars['MongoID']['output'];
  type: EnumInventoryItemType;
  updatedDateISO?: Maybe<Scalars['Date']['output']>;
};

export type Links = {
  __typename?: 'Links';
  bookNow?: Maybe<Scalars['String']['output']>;
  facebook?: Maybe<Scalars['String']['output']>;
  googleMyBusiness?: Maybe<Scalars['String']['output']>;
  instagram?: Maybe<Scalars['String']['output']>;
  pinterest?: Maybe<Scalars['String']['output']>;
  tiktok?: Maybe<Scalars['String']['output']>;
  tripAdvisor?: Maybe<Scalars['String']['output']>;
  website?: Maybe<Scalars['String']['output']>;
  x?: Maybe<Scalars['String']['output']>;
  youtube?: Maybe<Scalars['String']['output']>;
};

export type LinksInput = {
  bookNow?: InputMaybe<Scalars['String']['input']>;
  facebook?: InputMaybe<Scalars['String']['input']>;
  googleMyBusiness?: InputMaybe<Scalars['String']['input']>;
  instagram?: InputMaybe<Scalars['String']['input']>;
  pinterest?: InputMaybe<Scalars['String']['input']>;
  tiktok?: InputMaybe<Scalars['String']['input']>;
  tripAdvisor?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
  x?: InputMaybe<Scalars['String']['input']>;
  youtube?: InputMaybe<Scalars['String']['input']>;
};

export type List = {
  __typename?: 'List';
  _id: Scalars['MongoID']['output'];
  archived: Scalars['Boolean']['output'];
  createdDateISO?: Maybe<Scalars['Date']['output']>;
  description: Multilingual;
  entityReferences: Array<Maybe<VersionedEntityReference>>;
  externallyAvailableEntityReferences: Array<Maybe<VersionedEntityReference>>;
  favorited: Scalars['Boolean']['output'];
  name: Multilingual;
  owner: Owner;
  selections: Scalars['JSON']['output'];
  type: EnumListType;
  updatedDateISO?: Maybe<Scalars['Date']['output']>;
};

export type ListWithEntities = {
  __typename?: 'ListWithEntities';
  _id: Scalars['MongoID']['output'];
  archived: Scalars['Boolean']['output'];
  createdDateISO?: Maybe<Scalars['Date']['output']>;
  description: Multilingual;
  entities?: Maybe<Array<OperatorWithStatus>>;
  entityReferences: Array<Maybe<VersionedEntityReference>>;
  externallyAvailableEntityReferences: Array<Maybe<VersionedEntityReference>>;
  favorited: Scalars['Boolean']['output'];
  name: Multilingual;
  owner: Owner;
  selections: Scalars['JSON']['output'];
  type: EnumListType;
  updatedDateISO?: Maybe<Scalars['Date']['output']>;
};

export type ListWithEntitiesAndOverrides = {
  __typename?: 'ListWithEntitiesAndOverrides';
  _id: Scalars['MongoID']['output'];
  archived: Scalars['Boolean']['output'];
  createdDateISO?: Maybe<Scalars['Date']['output']>;
  description: Multilingual;
  entities: Array<OperatorWithOverrides>;
  entityReferences: Array<Maybe<VersionedEntityReference>>;
  externallyAvailableEntityReferences: Array<Maybe<VersionedEntityReference>>;
  favorited: Scalars['Boolean']['output'];
  name: Multilingual;
  owner: Owner;
  selections: Scalars['JSON']['output'];
  type: EnumListType;
  updatedDateISO?: Maybe<Scalars['Date']['output']>;
};

export type Maintenance = {
  __typename?: 'Maintenance';
  _id: Scalars['MongoID']['output'];
  banner: MaintenanceDoorstop;
  createdDateISO?: Maybe<Scalars['Date']['output']>;
  doorstop: MaintenanceDoorstop;
  updatedDateISO?: Maybe<Scalars['Date']['output']>;
};

export type MaintenanceDoorstop = {
  __typename?: 'MaintenanceDoorstop';
  isLive: Scalars['Boolean']['output'];
  message: Multilingual;
};

export type MongoError = ErrorInterface & {
  __typename?: 'MongoError';
  /** MongoDB error code */
  code?: Maybe<Scalars['Int']['output']>;
  /** MongoDB error message */
  message?: Maybe<Scalars['String']['output']>;
};

export type Multilingual = {
  __typename?: 'Multilingual';
  en?: Maybe<Scalars['String']['output']>;
  es?: Maybe<Scalars['String']['output']>;
  fr?: Maybe<Scalars['String']['output']>;
};

export type MultilingualInput = {
  en?: InputMaybe<Scalars['String']['input']>;
  es?: InputMaybe<Scalars['String']['input']>;
  fr?: InputMaybe<Scalars['String']['input']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  /** Create one document with mongoose defaults, setters, hooks and validation */
  bookerCreate?: Maybe<CreateOneBookerPayload>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  bookerRemove?: Maybe<RemoveByIdBookerPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  bookerUpdate?: Maybe<UpdateByIdBookerPayload>;
  createClosuresPerProduct: Array<Scalars['ID']['output']>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  createPublicationStatus?: Maybe<CreateOnePublicationStatusPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  customerCreate?: Maybe<CreateOneCustomerPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  customerUpdate?: Maybe<UpdateByIdCustomerPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  discountCreate?: Maybe<CreateOneDiscountPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  discountUpdate?: Maybe<UpdateByIdDiscountPayload>;
  discountValidatePromocode?: Maybe<Discount>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  eventCreate?: Maybe<CreateOneEventPayload>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  eventDeleteById?: Maybe<RemoveByIdEventPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  eventUpdateById?: Maybe<UpdateByIdEventPayload>;
  fileCreateOne: AssetFile;
  fileDeleteFromCloudinaryOnly: Scalars['Boolean']['output'];
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  fileUpdate?: Maybe<UpdateByIdAssetFilePayload>;
  imageCreateOne: AssetImage;
  imageDeleteFromCloudinaryOnly: Scalars['Boolean']['output'];
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  imageUpdate?: Maybe<UpdateByIdAssetImagePayload>;
  integrateProductCalendarLinksByProductIds: IntegrateCalendarLinksByProductIds;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  inventoryCreate?: Maybe<CreateOneInventoryItemPayload>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  inventoryRemove?: Maybe<RemoveByIdInventoryItemPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  inventoryUpdate?: Maybe<UpdateByIdInventoryItemPayload>;
  inventoryUpdateClaimedDatesByOrder?: Maybe<Order>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  listCreate?: Maybe<CreateOneListPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  listUpdateById: ListWithEntities;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  noteCreateOne?: Maybe<CreateOneNotePayload>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  noteRemoveById?: Maybe<RemoveByIdNotePayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  noteUpdateById?: Maybe<UpdateByIdNotePayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  operatorCreate?: Maybe<CreateOneOperatorPayload>;
  operatorDelete: OperatorWithStatus;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  operatorUpdate: OperatorWithStatus;
  operatorUpdateImages: OperatorWithStatus;
  orderConvertHoldToCharge?: Maybe<Order>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  orderCreate?: Maybe<CreateOneOrderPayload>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  orderRemove?: Maybe<RemoveByIdOrderPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  orderUpdate?: Maybe<UpdateByIdOrderPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  organizationCreate?: Maybe<CreateOneOrganizationPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  organizationUpdate?: Maybe<UpdateByIdOrganizationPayload>;
  organizationUpdateImages: Organization;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  policyCreate?: Maybe<CreateOnePolicyPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  policyUpdate?: Maybe<UpdateByIdPolicyPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  productCreate?: Maybe<CreateOneProductPayload>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  productRemove?: Maybe<RemoveByIdProductPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  productUpdate?: Maybe<UpdateByIdProductPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  refundCreate?: Maybe<CreateOneRefundPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  refundUpdate?: Maybe<UpdateByIdRefundPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  ruleCreate?: Maybe<CreateOneRulePayload>;
  /** Creates Many documents with mongoose defaults, setters, hooks and validation */
  ruleCreateMany?: Maybe<CreateManyRulePayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  ruleUpdate?: Maybe<UpdateByIdRulePayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  storefrontCreate?: Maybe<CreateOneStorefrontPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  storefrontUpdate?: Maybe<UpdateByIdStorefrontPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  tagCreate?: Maybe<CreateOneTagPayload>;
  /** Creates Many documents with mongoose defaults, setters, hooks and validation */
  tagCreateMany?: Maybe<CreateManyTagPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  tagGroupCreate?: Maybe<CreateOneTagGroupPayload>;
  /** Creates Many documents with mongoose defaults, setters, hooks and validation */
  tagGroupCreateMany?: Maybe<CreateManyTagGroupPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  tagUpdate?: Maybe<UpdateByIdTagPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  taxCreate?: Maybe<CreateOneTaxPayload>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  taxRemove?: Maybe<RemoveByIdTaxPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  taxUpdate?: Maybe<UpdateByIdTaxPayload>;
  updateClosuresPerProduct: Array<Scalars['ID']['output']>;
  userApproveAccess?: Maybe<UserWithPictureTc>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  userCreate?: Maybe<UserWithResetPasswordUrlTc>;
  userCreateConfirmationCode: User;
  userCreateInvite?: Maybe<User>;
  userRequestAccess?: Maybe<UserWithPictureTc>;
  userResendConfirmationCode: User;
  userRevokeInvite?: Maybe<User>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  userUpdate?: Maybe<UserWithResetPasswordUrlTc>;
  userValidateConfirmationCode: User;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  widgetCreate?: Maybe<CreateOneWidgetPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  widgetUpdateById?: Maybe<UpdateByIdWidgetPayload>;
};


export type MutationBookerCreateArgs = {
  record: CreateOneBookerInput;
};


export type MutationBookerRemoveArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationBookerUpdateArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdBookerInput;
};


export type MutationCreateClosuresPerProductArgs = {
  endISO: Scalars['String']['input'];
  name: Scalars['String']['input'];
  productIds: Array<Scalars['ID']['input']>;
  startISO: Scalars['String']['input'];
};


export type MutationCreatePublicationStatusArgs = {
  record: CreateOnePublicationStatusInput;
};


export type MutationCustomerCreateArgs = {
  record: CreateOneCustomerInput;
};


export type MutationCustomerUpdateArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdCustomerInput;
};


export type MutationDiscountCreateArgs = {
  record: CreateOneDiscountInput;
};


export type MutationDiscountUpdateArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdDiscountInput;
};


export type MutationDiscountValidatePromocodeArgs = {
  promoCode: Scalars['String']['input'];
  storefrontId: Scalars['ID']['input'];
};


export type MutationEventCreateArgs = {
  record: CreateOneEventInput;
  skipDefaultVenue?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationEventDeleteByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationEventUpdateByIdArgs = {
  _id: Scalars['MongoID']['input'];
  imagesToKeep?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isSubmitting?: InputMaybe<Scalars['Boolean']['input']>;
  record: UpdateByIdEventInput;
  setStatus?: InputMaybe<EnumEventAccessOperatorStatus>;
};


export type MutationFileCreateOneArgs = {
  data: Scalars['JSON']['input'];
};


export type MutationFileDeleteFromCloudinaryOnlyArgs = {
  cloudinaryPublicId: Scalars['String']['input'];
  resourceType: Scalars['String']['input'];
};


export type MutationFileUpdateArgs = {
  _id: Scalars['String']['input'];
  record: UpdateByIdAssetFileInput;
};


export type MutationImageCreateOneArgs = {
  data: Scalars['JSON']['input'];
};


export type MutationImageDeleteFromCloudinaryOnlyArgs = {
  cloudinaryPublicId: Scalars['String']['input'];
  resourceType: Scalars['String']['input'];
};


export type MutationImageUpdateArgs = {
  _id: Scalars['String']['input'];
  record: UpdateByIdAssetImageInput;
};


export type MutationIntegrateProductCalendarLinksByProductIdsArgs = {
  calendarLinksByProductIds: Array<CalendarLinksByProductId>;
};


export type MutationInventoryCreateArgs = {
  record: CreateOneInventoryItemInput;
};


export type MutationInventoryRemoveArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationInventoryUpdateArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdInventoryItemInput;
};


export type MutationInventoryUpdateClaimedDatesByOrderArgs = {
  endISO: Scalars['String']['input'];
  orderId: Scalars['ID']['input'];
  startISO: Scalars['String']['input'];
};


export type MutationListCreateArgs = {
  record: CreateOneListInput;
};


export type MutationListUpdateByIdArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdListInput;
};


export type MutationNoteCreateOneArgs = {
  record: CreateOneNoteInput;
};


export type MutationNoteRemoveByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationNoteUpdateByIdArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdNoteInput;
};


export type MutationOperatorCreateArgs = {
  record: CreateOneOperatorInput;
};


export type MutationOperatorDeleteArgs = {
  _entityId: Scalars['ID']['input'];
};


export type MutationOperatorUpdateArgs = {
  _entityId: Scalars['ID']['input'];
  isApproving?: InputMaybe<Scalars['Boolean']['input']>;
  record: UpdateByIdOperatorInput;
};


export type MutationOperatorUpdateImagesArgs = {
  _entityId: Scalars['ID']['input'];
  imagesToDelete?: InputMaybe<Array<Scalars['String']['input']>>;
  imagesToKeep?: InputMaybe<Array<Scalars['String']['input']>>;
  isApproving?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationOrderConvertHoldToChargeArgs = {
  amount: Scalars['Int']['input'];
  orderId: Scalars['ID']['input'];
};


export type MutationOrderCreateArgs = {
  customer: CustomerInput;
  guests: Array<InputMaybe<OrderGuestsInput>>;
  paymentMethodId: Scalars['String']['input'];
  productPurchaseRequests: Array<InputMaybe<ProductPurchaseRequest>>;
  promoCode?: InputMaybe<Scalars['String']['input']>;
  source: OrderSourceInput;
};


export type MutationOrderRemoveArgs = {
  _id: Scalars['String']['input'];
};


export type MutationOrderUpdateArgs = {
  _id: Scalars['String']['input'];
  cancelled: Scalars['Boolean']['input'];
};


export type MutationOrganizationCreateArgs = {
  record: CreateOneOrganizationInput;
};


export type MutationOrganizationUpdateArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdOrganizationInput;
};


export type MutationOrganizationUpdateImagesArgs = {
  id: Scalars['ID']['input'];
  imagesToDelete?: InputMaybe<Array<Scalars['String']['input']>>;
  imagesToKeep?: InputMaybe<Array<Scalars['String']['input']>>;
  isLogo?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPolicyCreateArgs = {
  record: CreateOnePolicyInput;
};


export type MutationPolicyUpdateArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdPolicyInput;
};


export type MutationProductCreateArgs = {
  inventoryCount: Scalars['Int']['input'];
  record: CreateOneProductInput;
};


export type MutationProductRemoveArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationProductUpdateArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdProductInput;
};


export type MutationRefundCreateArgs = {
  amount: Scalars['Int']['input'];
  orderId: Scalars['String']['input'];
};


export type MutationRefundUpdateArgs = {
  _id: Scalars['String']['input'];
  record: UpdateByIdRefundInput;
};


export type MutationRuleCreateArgs = {
  record: CreateOneRuleInput;
};


export type MutationRuleCreateManyArgs = {
  records: Array<CreateManyRuleInput>;
};


export type MutationRuleUpdateArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdRuleInput;
};


export type MutationStorefrontCreateArgs = {
  record: CreateOneStorefrontInput;
};


export type MutationStorefrontUpdateArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdStorefrontInput;
};


export type MutationTagCreateArgs = {
  record: CreateOneTagInput;
};


export type MutationTagCreateManyArgs = {
  records: Array<CreateManyTagInput>;
};


export type MutationTagGroupCreateArgs = {
  record: CreateOneTagGroupInput;
};


export type MutationTagGroupCreateManyArgs = {
  records: Array<CreateManyTagGroupInput>;
};


export type MutationTagUpdateArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdTagInput;
};


export type MutationTaxCreateArgs = {
  record: CreateOneTaxInput;
};


export type MutationTaxRemoveArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationTaxUpdateArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdTaxInput;
};


export type MutationUpdateClosuresPerProductArgs = {
  closureId: Scalars['ID']['input'];
  deleteClosure: Scalars['Boolean']['input'];
  endISO?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  productIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  startISO?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUserApproveAccessArgs = {
  entity: EntityReferenceInput;
  userId: Scalars['ID']['input'];
};


export type MutationUserCreateArgs = {
  record: CreateOneUserInput;
};


export type MutationUserCreateConfirmationCodeArgs = {
  _id: Scalars['ID']['input'];
  confirmationCodeType: EnumConfirmationCodeType;
  email: Scalars['String']['input'];
};


export type MutationUserCreateInviteArgs = {
  email: Scalars['String']['input'];
  entity: EntityReferenceInput;
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  role?: InputMaybe<RoleType>;
  sendInvitationEmail: Scalars['Boolean']['input'];
};


export type MutationUserRequestAccessArgs = {
  entity: EntityReferenceInput;
};


export type MutationUserResendConfirmationCodeArgs = {
  _id: Scalars['ID']['input'];
  sentToEmail: Scalars['String']['input'];
  type: EnumConfirmationCodeType;
};


export type MutationUserRevokeInviteArgs = {
  entity: EntityReferenceInput;
  userId: Scalars['ID']['input'];
};


export type MutationUserUpdateArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdUserInput;
};


export type MutationUserValidateConfirmationCodeArgs = {
  _id: Scalars['ID']['input'];
  code: Scalars['String']['input'];
};


export type MutationWidgetCreateArgs = {
  record: CreateOneWidgetInput;
};


export type MutationWidgetUpdateByIdArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdWidgetInput;
};

export type Note = {
  __typename?: 'Note';
  _id: Scalars['MongoID']['output'];
  author?: Maybe<UserWithPictureTc>;
  createdDateISO?: Maybe<Scalars['Date']['output']>;
  entity: EntityReference;
  mentions: Array<User>;
  message: Scalars['String']['output'];
  owner: Owner;
  resolvedBy?: Maybe<UserWithPictureTc>;
  updatedDateISO?: Maybe<Scalars['Date']['output']>;
};

export type NumberInput = {
  _eq?: InputMaybe<Scalars['Int']['input']>;
  _gt?: InputMaybe<Scalars['Int']['input']>;
  _gte?: InputMaybe<Scalars['Int']['input']>;
  _lt?: InputMaybe<Scalars['Int']['input']>;
  _lte?: InputMaybe<Scalars['Int']['input']>;
  _ne?: InputMaybe<Scalars['Int']['input']>;
};

export type Operator = {
  __typename?: 'Operator';
  _entityId: Scalars['MongoID']['output'];
  _id: Scalars['MongoID']['output'];
  _versionId: Scalars['MongoID']['output'];
  accommodationMetadata?: Maybe<AccommodationOperatorMetadata>;
  avgImageQuality?: Maybe<EnumOperatorAvgImageQuality>;
  claimed: Scalars['Boolean']['output'];
  contact: Contact;
  createdDateISO?: Maybe<Scalars['Date']['output']>;
  description?: Maybe<Multilingual>;
  enrollments: Array<Maybe<OperatorEnrollments>>;
  experienceMetadata?: Maybe<ExperienceOperatorMetadata>;
  hoursOfOperation?: Maybe<OperatorHoursOfOperation>;
  images: Array<AssetImage>;
  name: Multilingual;
  operationalStatus: EnumOperatorOperationalStatus;
  pricing?: Maybe<EnumOperatorPricing>;
  restaurantMetadata?: Maybe<RestaurantOperatorMetadata>;
  seasonality?: Maybe<Seasonality>;
  selectedTagGroups: Array<Maybe<Scalars['MongoID']['output']>>;
  serviceMetadata?: Maybe<ServiceOperatorMetadata>;
  shortDescription?: Maybe<Multilingual>;
  tags?: Maybe<OperatorTags>;
  toursMetadata?: Maybe<ToursOperatorMetadata>;
  type: EnumOperatorType;
  updatedDateISO?: Maybe<Scalars['Date']['output']>;
};

export type OperatorEnrollments = {
  __typename?: 'OperatorEnrollments';
  onboardingStatus: EnumOperatorEnrollmentsOnboardingStatus;
  organization: Scalars['MongoID']['output'];
  organizationControlled: Scalars['Boolean']['output'];
};

export type OperatorEnrollmentsInput = {
  onboardingStatus: EnumOperatorEnrollmentsOnboardingStatus;
  organization: Scalars['MongoID']['input'];
  organizationControlled: Scalars['Boolean']['input'];
};

export type OperatorHoursOfOperation = {
  __typename?: 'OperatorHoursOfOperation';
  fri?: Maybe<DateRangeIso>;
  mon?: Maybe<DateRangeIso>;
  sat?: Maybe<DateRangeIso>;
  sun?: Maybe<DateRangeIso>;
  thu?: Maybe<DateRangeIso>;
  tue?: Maybe<DateRangeIso>;
  wed?: Maybe<DateRangeIso>;
};

export type OperatorHoursOfOperationInput = {
  fri?: InputMaybe<DateRangeIsoInput>;
  mon?: InputMaybe<DateRangeIsoInput>;
  sat?: InputMaybe<DateRangeIsoInput>;
  sun?: InputMaybe<DateRangeIsoInput>;
  thu?: InputMaybe<DateRangeIsoInput>;
  tue?: InputMaybe<DateRangeIsoInput>;
  wed?: InputMaybe<DateRangeIsoInput>;
};

export enum OperatorManyUseCaseEnum {
  External = 'EXTERNAL',
  Internal = 'INTERNAL'
}

export type OperatorTags = {
  __typename?: 'OperatorTags';
  amenity: Array<Tag>;
  businessType: Array<Tag>;
  global: Array<Tag>;
  organizationSpecific: Array<Tag>;
};

export type OperatorTagsInput = {
  amenity?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  businessType?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  global?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  organizationSpecific?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type OperatorWithOverrides = {
  __typename?: 'OperatorWithOverrides';
  _entityId: Scalars['MongoID']['output'];
  _id: Scalars['MongoID']['output'];
  _versionId: Scalars['MongoID']['output'];
  accommodationMetadata?: Maybe<AccommodationOperatorMetadata>;
  avgImageQuality?: Maybe<EnumOperatorAvgImageQuality>;
  claimed: Scalars['Boolean']['output'];
  contact: Contact;
  createdDateISO?: Maybe<Scalars['Date']['output']>;
  description?: Maybe<Multilingual>;
  enrollments: Array<Maybe<OperatorEnrollments>>;
  experienceMetadata?: Maybe<ExperienceOperatorMetadata>;
  hoursOfOperation?: Maybe<OperatorHoursOfOperation>;
  /** This is the invitedOrAcceptedStaffCount for the operator (shorted to iasc for JSON). A value of -1 means the input includeInvitedOrAcceptedStaffCounts was false. */
  iasc?: Maybe<Scalars['Int']['output']>;
  images: Array<AssetImage>;
  name: Multilingual;
  operationalStatus: EnumOperatorOperationalStatus;
  overrides?: Maybe<OverrideDetails>;
  pricing?: Maybe<EnumOperatorPricing>;
  restaurantMetadata?: Maybe<RestaurantOperatorMetadata>;
  seasonality?: Maybe<Seasonality>;
  serviceMetadata?: Maybe<ServiceOperatorMetadata>;
  shortDescription?: Maybe<Multilingual>;
  status?: Maybe<PublicationStatusType>;
  tags?: Maybe<OperatorTags>;
  toursMetadata?: Maybe<ToursOperatorMetadata>;
  type: EnumOperatorType;
  updatedDateISO?: Maybe<Scalars['Date']['output']>;
};

export type OperatorWithStatus = {
  __typename?: 'OperatorWithStatus';
  _entityId: Scalars['MongoID']['output'];
  _id: Scalars['MongoID']['output'];
  _versionId: Scalars['MongoID']['output'];
  accommodationMetadata?: Maybe<AccommodationOperatorMetadata>;
  avgImageQuality?: Maybe<EnumOperatorAvgImageQuality>;
  claimed: Scalars['Boolean']['output'];
  contact: Contact;
  createdDateISO?: Maybe<Scalars['Date']['output']>;
  description?: Maybe<Multilingual>;
  enrollments: Array<Maybe<OperatorEnrollments>>;
  experienceMetadata?: Maybe<ExperienceOperatorMetadata>;
  hoursOfOperation?: Maybe<OperatorHoursOfOperation>;
  /** This is the invitedOrAcceptedStaffCount for the operator (shorted to iasc for JSON). A value of -1 means the input includeInvitedOrAcceptedStaffCounts was false. */
  iasc?: Maybe<Scalars['Int']['output']>;
  images: Array<AssetImage>;
  name: Multilingual;
  operationalStatus: EnumOperatorOperationalStatus;
  pricing?: Maybe<EnumOperatorPricing>;
  restaurantMetadata?: Maybe<RestaurantOperatorMetadata>;
  seasonality?: Maybe<Seasonality>;
  serviceMetadata?: Maybe<ServiceOperatorMetadata>;
  shortDescription?: Maybe<Multilingual>;
  status?: Maybe<PublicationStatusType>;
  tags?: Maybe<OperatorTags>;
  toursMetadata?: Maybe<ToursOperatorMetadata>;
  type: EnumOperatorType;
  updatedDateISO?: Maybe<Scalars['Date']['output']>;
};

export type OperatorWithStatusAndStaff = {
  __typename?: 'OperatorWithStatusAndStaff';
  _entityId: Scalars['MongoID']['output'];
  _id: Scalars['MongoID']['output'];
  _versionId: Scalars['MongoID']['output'];
  accommodationMetadata?: Maybe<AccommodationOperatorMetadata>;
  avgImageQuality?: Maybe<EnumOperatorAvgImageQuality>;
  claimed: Scalars['Boolean']['output'];
  contact: Contact;
  createdDateISO?: Maybe<Scalars['Date']['output']>;
  description?: Maybe<Multilingual>;
  enrollments: Array<Maybe<OperatorEnrollments>>;
  experienceMetadata?: Maybe<ExperienceOperatorMetadata>;
  hoursOfOperation?: Maybe<OperatorHoursOfOperation>;
  /** This is the invitedOrAcceptedStaffCount for the operator (shorted to iasc for JSON). A value of -1 means the input includeInvitedOrAcceptedStaffCounts was false. */
  iasc?: Maybe<Scalars['Int']['output']>;
  images: Array<AssetImage>;
  name: Multilingual;
  operationalStatus: EnumOperatorOperationalStatus;
  pricing?: Maybe<EnumOperatorPricing>;
  restaurantMetadata?: Maybe<RestaurantOperatorMetadata>;
  seasonality?: Maybe<Seasonality>;
  serviceMetadata?: Maybe<ServiceOperatorMetadata>;
  shortDescription?: Maybe<Multilingual>;
  staff: Array<User>;
  status?: Maybe<PublicationStatusType>;
  tags?: Maybe<OperatorTags>;
  toursMetadata?: Maybe<ToursOperatorMetadata>;
  type: EnumOperatorType;
  updatedDateISO?: Maybe<Scalars['Date']['output']>;
};

export type Order = {
  __typename?: 'Order';
  _id: Scalars['String']['output'];
  cancelled: Scalars['Boolean']['output'];
  createdDateISO?: Maybe<Scalars['Date']['output']>;
  customer?: Maybe<Customer>;
  discounts: Array<Maybe<Discount>>;
  guests: Array<Maybe<OrderGuests>>;
  purchasedProducts: Array<Maybe<PurchasedProduct>>;
  source: OrderSource;
  stripeMetadata: StripeMetadata;
  updatedDateISO?: Maybe<Scalars['Date']['output']>;
};

export type OrderCartPrice = {
  __typename?: 'OrderCartPrice';
  orderId: Scalars['String']['output'];
  prices?: Maybe<CartPrices>;
};

/** List of items with pagination. */
export type OrderFindMany = {
  __typename?: 'OrderFindMany';
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<Order>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type OrderGuests = {
  __typename?: 'OrderGuests';
  _id?: Maybe<Scalars['MongoID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type OrderGuestsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type OrderSource = {
  __typename?: 'OrderSource';
  booker: Scalars['MongoID']['output'];
  storefront: Scalars['MongoID']['output'];
};

export type OrderSourceInput = {
  booker: Scalars['MongoID']['input'];
  storefront: Scalars['MongoID']['input'];
};

export type Organization = {
  __typename?: 'Organization';
  _id: Scalars['MongoID']['output'];
  contact?: Maybe<Contact>;
  createdDateISO?: Maybe<Scalars['Date']['output']>;
  description: Multilingual;
  domains: Array<Maybe<Scalars['String']['output']>>;
  images: Array<AssetImage>;
  logo?: Maybe<AssetImage>;
  metadata?: Maybe<OrganizationMetadata>;
  name: Multilingual;
  onboardingMetadata: OrganizationOnboardingMetadata;
  shortDescription: Multilingual;
  updatedDateISO?: Maybe<Scalars['Date']['output']>;
};

export type OrganizationMetadata = {
  __typename?: 'OrganizationMetadata';
  _id?: Maybe<Scalars['MongoID']['output']>;
  eventLookaheadMonths?: Maybe<Scalars['Float']['output']>;
  inviteWhenAddingStaff?: Maybe<Scalars['Boolean']['output']>;
};

export type OrganizationMetadataInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  eventLookaheadMonths?: InputMaybe<Scalars['Float']['input']>;
  inviteWhenAddingStaff?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OrganizationOnboardingMetadata = {
  __typename?: 'OrganizationOnboardingMetadata';
  _id?: Maybe<Scalars['MongoID']['output']>;
  allowColdSignup?: Maybe<Scalars['Boolean']['output']>;
  introMessage?: Maybe<Scalars['String']['output']>;
  typeformSurveyId?: Maybe<Scalars['String']['output']>;
  videoId?: Maybe<Scalars['String']['output']>;
};

export type OrganizationOnboardingMetadataInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  allowColdSignup?: InputMaybe<Scalars['Boolean']['input']>;
  introMessage?: InputMaybe<Scalars['String']['input']>;
  typeformSurveyId?: InputMaybe<Scalars['String']['input']>;
  videoId?: InputMaybe<Scalars['String']['input']>;
};

export type OverrideDetails = {
  __typename?: 'OverrideDetails';
  description?: Maybe<Multilingual>;
  images: Array<AssetImage>;
  shortDescription?: Maybe<Multilingual>;
};

export type Owner = {
  __typename?: 'Owner';
  entityId: Scalars['MongoID']['output'];
  type: EnumOwnerType;
};

export type OwnerInput = {
  entityId?: InputMaybe<Scalars['MongoID']['input']>;
  type?: InputMaybe<EnumOwnerType>;
};

export type PaginationInfo = {
  __typename?: 'PaginationInfo';
  currentPage: Scalars['Int']['output'];
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  hasPreviousPage?: Maybe<Scalars['Boolean']['output']>;
  itemCount?: Maybe<Scalars['Int']['output']>;
  pageCount?: Maybe<Scalars['Int']['output']>;
  perPage: Scalars['Int']['output'];
};

export type Policy = {
  __typename?: 'Policy';
  _id: Scalars['MongoID']['output'];
  content: Multilingual;
  createdDateISO?: Maybe<Scalars['Date']['output']>;
  isActive: Scalars['Boolean']['output'];
  name: Multilingual;
  storefront: Scalars['MongoID']['output'];
  updatedDateISO?: Maybe<Scalars['Date']['output']>;
};

export enum PostHogAppContext {
  WhereaboutsNext = 'whereabouts_next',
  WidgetBooker = 'widget_booker',
  WidgetEventSubmit = 'widget_event_submit',
  WidgetEvents = 'widget_events',
  WidgetOperator = 'widget_operator'
}

export type PostHogData = {
  __typename?: 'PostHogData';
  _id: Scalars['MongoID']['output'];
  createdDateISO?: Maybe<Scalars['Date']['output']>;
  metadata?: Maybe<PostHogMetadata>;
  timestamp: Scalars['Date']['output'];
  updatedDateISO?: Maybe<Scalars['Date']['output']>;
};

export enum PostHogEventName {
  AmenitiesViewed = 'amenities_viewed',
  BookerLoaded = 'booker_loaded',
  CloseOperatorDetails = 'close_operator_details',
  CustomerDetailsAdded = 'customer_details_added',
  DatesSelected = 'dates_selected',
  DetailsClick = 'details_click',
  EntityImpression = 'entity_impression',
  ExpandedDetailsClick = 'expanded_details_click',
  ExpandedDetailsPageview = 'expanded_details_pageview',
  FilterTagAdded = 'filter_tag_added',
  FilterTagRemoved = 'filter_tag_removed',
  GuestsSelected = 'guests_selected',
  OpenBookNowLink = 'open_book_now_link',
  OutboundClick = 'outbound_click',
  PaymentMethodAdded = 'payment_method_added',
  PoliciesAccepted = 'policies_accepted',
  ProductAddedToCart = 'product_added_to_cart',
  ProductRemovedFromCart = 'product_removed_from_cart',
  ProductUpdatedInCart = 'product_updated_in_cart',
  PromoCodeApplied = 'promo_code_applied',
  PurchaseCompleted = 'purchase_completed',
  ScrollEventsLeft = 'scroll_events_left',
  ScrollEventsRight = 'scroll_events_right',
  ScrollOperatorsLeft = 'scroll_operators_left',
  ScrollOperatorsRight = 'scroll_operators_right',
  ScrollRecurringEventsDown = 'scroll_recurring_events_down',
  ScrollRecurringEventsUp = 'scroll_recurring_events_up',
  ScrollViewMoreTags = 'scroll_view_more_tags',
  ScrollViewPreviousTags = 'scroll_view_previous_tags'
}

export type PostHogEventOrOperatorStats = {
  __typename?: 'PostHogEventOrOperatorStats';
  _id: Scalars['MongoID']['output'];
  createdDateISO?: Maybe<Scalars['Date']['output']>;
  impressions?: Maybe<Scalars['Int']['output']>;
  metadata?: Maybe<PostHogMetadata>;
  outboundClicks?: Maybe<Scalars['Int']['output']>;
  updatedDateISO?: Maybe<Scalars['Date']['output']>;
  views?: Maybe<Scalars['Int']['output']>;
};

export type PostHogMetadata = {
  __typename?: 'PostHogMetadata';
  appContext?: Maybe<Scalars['String']['output']>;
  booker?: Maybe<Booker>;
  event?: Maybe<Event>;
  eventName?: Maybe<Scalars['String']['output']>;
  instanceId?: Maybe<Scalars['String']['output']>;
  list: ListWithEntities;
  operator: OperatorWithStatus;
  orderId?: Maybe<Scalars['String']['output']>;
  organization?: Maybe<Organization>;
  product?: Maybe<Product>;
  promoCode?: Maybe<Scalars['String']['output']>;
  widget: WidgetWithListEntities;
};


export type PostHogMetadataOperatorArgs = {
  loggedInAs?: InputMaybe<OwnerInput>;
};

export type PricePerProduct = {
  __typename?: 'PricePerProduct';
  price: Scalars['Int']['output'];
  productId: Scalars['ID']['output'];
};

export type PriceTier = {
  __typename?: 'PriceTier';
  _id: Scalars['MongoID']['output'];
  label?: Maybe<Multilingual>;
  price: Scalars['Float']['output'];
  type: EnumPriceTierType;
};

export type PriceTierInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  label?: InputMaybe<MultilingualInput>;
  price: Scalars['Float']['input'];
  type: EnumPriceTierType;
};

export type Pricing = {
  __typename?: 'Pricing';
  description?: Maybe<Multilingual>;
  tiers: Array<Maybe<PriceTier>>;
};

export type PricingInput = {
  description?: InputMaybe<MultilingualInput>;
  tiers: Array<InputMaybe<PriceTierInput>>;
};

export type Product = {
  __typename?: 'Product';
  _id: Scalars['MongoID']['output'];
  accommodationMetadata?: Maybe<AccommodationProductMetadata>;
  contact?: Maybe<ProductContact>;
  createdDateISO?: Maybe<Scalars['Date']['output']>;
  description?: Maybe<Multilingual>;
  externalBookingUrl?: Maybe<Scalars['String']['output']>;
  images: Array<AssetImage>;
  isUpsellOnly: Scalars['Boolean']['output'];
  name: Multilingual;
  owner: Owner;
  pricing?: Maybe<Pricing>;
  publicationStatus: EnumProductPublicationStatus;
  quantitySettings?: Maybe<ProductQuantitySettings>;
  rules: Array<Rule>;
  shortDescription?: Maybe<Multilingual>;
  storefront: Scalars['MongoID']['output'];
  tags: Array<Tag>;
  type: EnumProductType;
  updatedDateISO?: Maybe<Scalars['Date']['output']>;
};

export type ProductContact = {
  __typename?: 'ProductContact';
  address?: Maybe<Address>;
  email?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  tollFreePublicPhone?: Maybe<Scalars['String']['output']>;
  useOwnerContact: Scalars['Boolean']['output'];
};

export type ProductContactInput = {
  address?: InputMaybe<AddressInput>;
  email?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  tollFreePublicPhone?: InputMaybe<Scalars['String']['input']>;
  useOwnerContact: Scalars['Boolean']['input'];
};

export type ProductPurchaseRequest = {
  endDateISO: Scalars['String']['input'];
  guestTiers: Array<InputMaybe<PurchasedProductGuestsPerTierInput>>;
  productId: Scalars['MongoID']['input'];
  quantity?: InputMaybe<Scalars['Int']['input']>;
  startDateISO: Scalars['String']['input'];
};

export type ProductQuantitySettings = {
  __typename?: 'ProductQuantitySettings';
  enabled?: Maybe<Scalars['Boolean']['output']>;
  maxQuantity?: Maybe<Scalars['Float']['output']>;
};

export type ProductQuantitySettingsInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  maxQuantity?: InputMaybe<Scalars['Float']['input']>;
};

export type PublicationStatus = {
  __typename?: 'PublicationStatus';
  _id: Scalars['MongoID']['output'];
  createdDateISO?: Maybe<Scalars['Date']['output']>;
  entity: VersionedEntityReference;
  organization?: Maybe<Organization>;
  status?: Maybe<PublicationStatusType>;
  updatedDateISO?: Maybe<Scalars['Date']['output']>;
};

export enum PublicationStatusType {
  Approved = 'APPROVED',
  Deleted = 'DELETED',
  Draft = 'DRAFT',
  NeedsApproval = 'NEEDS_APPROVAL',
  Unpublished = 'UNPUBLISHED'
}

export type PurchasedProduct = {
  __typename?: 'PurchasedProduct';
  _id: Scalars['MongoID']['output'];
  guestsPerTier: Array<Maybe<PurchasedProductGuestsPerTier>>;
  inventoryClaims: Array<Maybe<PurchasedProductInventoryClaims>>;
  product: Product;
  quantity: Scalars['Float']['output'];
};

export type PurchasedProductGuestsPerTier = {
  __typename?: 'PurchasedProductGuestsPerTier';
  count: Scalars['Float']['output'];
  tierId: Scalars['MongoID']['output'];
};

export type PurchasedProductGuestsPerTierInput = {
  count: Scalars['Float']['input'];
  tierId: Scalars['MongoID']['input'];
};

export type PurchasedProductInventoryClaims = {
  __typename?: 'PurchasedProductInventoryClaims';
  _id?: Maybe<Scalars['MongoID']['output']>;
  claimedDateRangeISO?: Maybe<DateRangeIso>;
  inventory?: Maybe<InventoryItem>;
};

export type Query = {
  __typename?: 'Query';
  apiAccessOne?: Maybe<ApiAccess>;
  assetById?: Maybe<AssetInterface>;
  assetByIds?: Maybe<Array<Maybe<AssetInterface>>>;
  assetMany?: Maybe<Array<Maybe<AssetInterface>>>;
  bookerById?: Maybe<Booker>;
  bookerByIds: Array<Booker>;
  bookerByMainProductId?: Maybe<Booker>;
  bookerCartPrice?: Maybe<CartPrices>;
  bookerMany: Array<Booker>;
  bookerSendContactUsEmail?: Maybe<EmailResponse>;
  campaignFindOne?: Maybe<Campaign>;
  changeLogMany: Array<Changelog>;
  customerById?: Maybe<Customer>;
  customerByIds: Array<Customer>;
  customerMany: Array<Customer>;
  discountById?: Maybe<Discount>;
  discountByIds: Array<Discount>;
  discountMany: Array<Discount>;
  eventById?: Maybe<Event>;
  eventLookaheadMonths?: Maybe<Scalars['JSON']['output']>;
  eventMany: Array<EventWithOccurrences>;
  fileById?: Maybe<AssetFile>;
  fileByIds: Array<AssetFile>;
  fileMany: Array<AssetFile>;
  imageById?: Maybe<AssetImage>;
  imageByIds: Array<AssetImage>;
  imageMany: Array<AssetImage>;
  inventoryById?: Maybe<InventoryItem>;
  inventoryByIds: Array<InventoryItem>;
  /** This resolver will return all the fully booked dates & the check-out only dates per product. */
  inventoryDatesByProduct?: Maybe<InventoryBookedDatesSummary>;
  inventoryMany: Array<InventoryItem>;
  listById: ListWithEntities;
  listMany: Array<List>;
  listsByIds?: Maybe<Array<ListWithEntities>>;
  maintenanceFindOne?: Maybe<Maintenance>;
  noteMany: Array<Note>;
  operatorById: OperatorWithStatus;
  operatorMany: Array<OperatorWithStatus>;
  operatorStaff: Array<UserWithPictureTc>;
  operatorsByIds: Array<Maybe<OperatorWithStatusAndStaff>>;
  operatorsByUser: Array<Operator>;
  orderById?: Maybe<Order>;
  orderByIds: Array<Order>;
  orderMany?: Maybe<OrderFindMany>;
  orderPricesById?: Maybe<CartPrices>;
  orderPricesByIds: Array<OrderCartPrice>;
  organizationById?: Maybe<Organization>;
  organizationMany: Array<Organization>;
  organizationStaff: Array<UserWithPictureTc>;
  organizationsByIds: Array<Organization>;
  organizationsByUser: Array<Organization>;
  policyById?: Maybe<Policy>;
  policyByIds: Array<Policy>;
  policyMany: Array<Policy>;
  postHogDataMany: Array<PostHogData>;
  postHogStatsWidgetEvents: Array<PostHogEventOrOperatorStats>;
  postHogStatsWidgetOperators: Array<PostHogEventOrOperatorStats>;
  productById?: Maybe<Product>;
  productCalendarLinkById: Scalars['String']['output'];
  productClosureById?: Maybe<ClosureData>;
  productMany: Array<Product>;
  productTotalSales: Scalars['Float']['output'];
  productsByIds: Array<Product>;
  publicationStatusFindOne?: Maybe<PublicationStatus>;
  refundById?: Maybe<Refund>;
  refundMany: Array<Refund>;
  refundsByOrderIds?: Maybe<Array<Refund>>;
  ruleById?: Maybe<Rule>;
  ruleByIds: Array<Rule>;
  ruleMany: Array<Rule>;
  storefrontById?: Maybe<Storefront>;
  storefrontByIds: Array<Storefront>;
  storefrontMany: Array<Storefront>;
  storefrontStaff: Array<UserWithPictureTc>;
  surveyResponseMany: Array<SurveyResponse>;
  surveyResponseOne?: Maybe<SurveyResponse>;
  tagById?: Maybe<Tag>;
  tagByIds: Array<Tag>;
  tagGroupById?: Maybe<TagGroup>;
  tagGroupByIds: Array<TagGroup>;
  tagGroupMany: Array<TagGroup>;
  tagGroupOne?: Maybe<TagGroup>;
  tagMany: Array<Tag>;
  taxById?: Maybe<Tax>;
  taxMany: Array<Tax>;
  userById?: Maybe<UserWithPictureTc>;
  userByIds: Array<User>;
  userFindOne?: Maybe<UserWithPictureTc>;
  userFindOneByEmail?: Maybe<UserWithResetPasswordUrlTc>;
  userMany: Array<User>;
  userRequestEmailVerification?: Maybe<Scalars['String']['output']>;
  widgetById: WidgetWithListEntities;
  widgetMany: Array<WidgetWithListAndItemCount>;
  widgetsByIds: Array<Widget>;
};


export type QueryApiAccessOneArgs = {
  filter?: InputMaybe<FilterFindOneApiAccessInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOneApiAccessInput>;
};


export type QueryAssetByIdArgs = {
  _id: Scalars['String']['input'];
};


export type QueryAssetByIdsArgs = {
  _ids: Array<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsAssetInput>;
};


export type QueryAssetManyArgs = {
  filter?: InputMaybe<FilterFindManyAssetInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyAssetInput>;
};


export type QueryBookerByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryBookerByIdsArgs = {
  _ids: Array<Scalars['MongoID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsBookerInput>;
};


export type QueryBookerByMainProductIdArgs = {
  operatorId?: InputMaybe<Scalars['ID']['input']>;
  productId: Scalars['ID']['input'];
};


export type QueryBookerCartPriceArgs = {
  bookerId: Scalars['ID']['input'];
  productPurchaseRequests: Array<ProductPurchaseRequest>;
  promoCode?: InputMaybe<Scalars['String']['input']>;
};


export type QueryBookerManyArgs = {
  filter?: InputMaybe<FilterFindManyBookerInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyBookerInput>;
};


export type QueryBookerSendContactUsEmailArgs = {
  bookerId: Scalars['ID']['input'];
  details: ContactUsEmailDetails;
};


export type QueryCampaignFindOneArgs = {
  filter?: InputMaybe<FilterFindOneCampaignInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOneCampaignInput>;
};


export type QueryChangeLogManyArgs = {
  filter?: InputMaybe<FilterFindManyChangelogInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyChangelogInput>;
};


export type QueryCustomerByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryCustomerByIdsArgs = {
  _ids: Array<Scalars['MongoID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsCustomerInput>;
};


export type QueryCustomerManyArgs = {
  filter?: InputMaybe<FilterFindManyCustomerInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyCustomerInput>;
};


export type QueryDiscountByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryDiscountByIdsArgs = {
  _ids: Array<Scalars['MongoID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsDiscountInput>;
};


export type QueryDiscountManyArgs = {
  filter?: InputMaybe<FilterFindManyDiscountInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyDiscountInput>;
  types?: InputMaybe<Array<EnumDiscountType>>;
};


export type QueryEventByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryEventLookaheadMonthsArgs = {
  organizationId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryEventManyArgs = {
  endDate: Scalars['String']['input'];
  keepEventsWithNoFutureOccurrences?: InputMaybe<Scalars['Boolean']['input']>;
  operatorId?: InputMaybe<Scalars['ID']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  skipRecurrences?: InputMaybe<Scalars['Boolean']['input']>;
  startDate: Scalars['String']['input'];
  status?: InputMaybe<EventStatus>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};


export type QueryFileByIdArgs = {
  _id: Scalars['String']['input'];
};


export type QueryFileByIdsArgs = {
  _ids: Array<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsAssetFileInput>;
};


export type QueryFileManyArgs = {
  filter?: InputMaybe<FilterFindManyAssetFileInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyAssetFileInput>;
};


export type QueryImageByIdArgs = {
  _id: Scalars['String']['input'];
};


export type QueryImageByIdsArgs = {
  _ids: Array<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsAssetImageInput>;
};


export type QueryImageManyArgs = {
  filter?: InputMaybe<FilterFindManyAssetImageInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyAssetImageInput>;
};


export type QueryInventoryByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryInventoryByIdsArgs = {
  _ids: Array<Scalars['MongoID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsInventoryItemInput>;
};


export type QueryInventoryDatesByProductArgs = {
  productId: Scalars['ID']['input'];
};


export type QueryInventoryManyArgs = {
  filter?: InputMaybe<FilterFindManyInventoryItemInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyInventoryItemInput>;
};


export type QueryListByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryListManyArgs = {
  filter?: InputMaybe<FilterFindManyListInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyListInput>;
};


export type QueryListsByIdsArgs = {
  _ids: Array<Scalars['MongoID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsListInput>;
};


export type QueryMaintenanceFindOneArgs = {
  filter?: InputMaybe<FilterFindOneMaintenanceInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOneMaintenanceInput>;
};


export type QueryNoteManyArgs = {
  filter?: InputMaybe<FilterFindManyNoteInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyNoteInput>;
};


export type QueryOperatorByIdArgs = {
  loggedInAs?: InputMaybe<OwnerInput>;
  operatorEntityId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatusType>;
};


export type QueryOperatorManyArgs = {
  avgImageQuality?: InputMaybe<Array<ImageQualityRating>>;
  filter?: InputMaybe<FilterFindManyOperatorInput>;
  imageCount?: InputMaybe<NumberInput>;
  includeInvitedOrAcceptedStaffCounts?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  publicationStatus?: InputMaybe<PublicationStatusType>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyOperatorInput>;
  useCase?: InputMaybe<OperatorManyUseCaseEnum>;
};


export type QueryOperatorStaffArgs = {
  operatorId: Scalars['ID']['input'];
};


export type QueryOperatorsByIdsArgs = {
  operatorEntityIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  status?: InputMaybe<PublicationStatusType>;
};


export type QueryOrderByIdArgs = {
  _id: Scalars['String']['input'];
};


export type QueryOrderByIdsArgs = {
  _ids: Array<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsOrderInput>;
};


export type QueryOrderManyArgs = {
  filter?: InputMaybe<FilterFindManyOrderInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyOrderInput>;
};


export type QueryOrderPricesByIdArgs = {
  orderId: Scalars['String']['input'];
};


export type QueryOrderPricesByIdsArgs = {
  orderIds: Array<Scalars['String']['input']>;
};


export type QueryOrganizationByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryOrganizationManyArgs = {
  filter?: InputMaybe<FilterFindManyOrganizationInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyOrganizationInput>;
};


export type QueryOrganizationStaffArgs = {
  organizationId: Scalars['ID']['input'];
};


export type QueryOrganizationsByIdsArgs = {
  _ids: Array<Scalars['MongoID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsOrganizationInput>;
};


export type QueryPolicyByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryPolicyByIdsArgs = {
  _ids: Array<Scalars['MongoID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsPolicyInput>;
};


export type QueryPolicyManyArgs = {
  filter?: InputMaybe<FilterFindManyPolicyInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyPolicyInput>;
};


export type QueryPostHogDataManyArgs = {
  filter?: InputMaybe<FilterFindManyPostHogDataInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyPostHogDataInput>;
};


export type QueryPostHogStatsWidgetEventsArgs = {
  appContext: PostHogAppContext;
  eventId?: InputMaybe<Scalars['ID']['input']>;
  eventName?: InputMaybe<PostHogEventName>;
  organizationId: Scalars['ID']['input'];
  timestampRange: DateInput;
  widgetId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryPostHogStatsWidgetOperatorsArgs = {
  appContext: PostHogAppContext;
  eventName?: InputMaybe<PostHogEventName>;
  listId?: InputMaybe<Scalars['ID']['input']>;
  operatorEntityId?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
  timestampRange: DateInput;
  widgetId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryProductByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryProductCalendarLinkByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryProductClosureByIdArgs = {
  closureId: Scalars['ID']['input'];
};


export type QueryProductManyArgs = {
  filter?: InputMaybe<FilterFindManyProductInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyProductInput>;
};


export type QueryProductTotalSalesArgs = {
  id: Scalars['ID']['input'];
};


export type QueryProductsByIdsArgs = {
  _ids: Array<Scalars['MongoID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsProductInput>;
};


export type QueryPublicationStatusFindOneArgs = {
  filter?: InputMaybe<FilterFindOnePublicationStatusInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOnePublicationStatusInput>;
};


export type QueryRefundByIdArgs = {
  _id: Scalars['String']['input'];
};


export type QueryRefundManyArgs = {
  filter?: InputMaybe<FilterFindManyRefundInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyRefundInput>;
};


export type QueryRefundsByOrderIdsArgs = {
  orderIds: Array<Scalars['ID']['input']>;
};


export type QueryRuleByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryRuleByIdsArgs = {
  _ids: Array<Scalars['MongoID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsRuleInput>;
};


export type QueryRuleManyArgs = {
  filter?: InputMaybe<FilterFindManyRuleInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyRuleInput>;
};


export type QueryStorefrontByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryStorefrontByIdsArgs = {
  _ids: Array<Scalars['MongoID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsStorefrontInput>;
};


export type QueryStorefrontManyArgs = {
  filter?: InputMaybe<FilterFindManyStorefrontInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyStorefrontInput>;
};


export type QueryStorefrontStaffArgs = {
  _id: Scalars['ID']['input'];
};


export type QuerySurveyResponseManyArgs = {
  filter?: InputMaybe<FilterFindManySurveyResponseInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManySurveyResponseInput>;
};


export type QuerySurveyResponseOneArgs = {
  filter?: InputMaybe<FilterFindOneSurveyResponseInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOneSurveyResponseInput>;
};


export type QueryTagByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryTagByIdsArgs = {
  _ids: Array<Scalars['MongoID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsTagInput>;
};


export type QueryTagGroupByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryTagGroupByIdsArgs = {
  _ids: Array<Scalars['MongoID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsTagGroupInput>;
};


export type QueryTagGroupManyArgs = {
  filter?: InputMaybe<FilterFindManyTagGroupInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyTagGroupInput>;
};


export type QueryTagGroupOneArgs = {
  filter?: InputMaybe<FilterFindOneTagGroupInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOneTagGroupInput>;
};


export type QueryTagManyArgs = {
  filter?: InputMaybe<FilterFindManyTagInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyTagInput>;
};


export type QueryTaxByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryTaxManyArgs = {
  filter?: InputMaybe<FilterFindManyTaxInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyTaxInput>;
};


export type QueryUserByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryUserByIdsArgs = {
  _ids: Array<Scalars['MongoID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsUserInput>;
};


export type QueryUserFindOneArgs = {
  filter?: InputMaybe<FilterFindOneUserInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOneUserInput>;
};


export type QueryUserFindOneByEmailArgs = {
  email: Scalars['String']['input'];
};


export type QueryUserManyArgs = {
  filter?: InputMaybe<FilterFindManyUserInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyUserInput>;
};


export type QueryWidgetByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryWidgetManyArgs = {
  filter?: InputMaybe<FilterFindManyWidgetInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyWidgetInput>;
};


export type QueryWidgetsByIdsArgs = {
  _ids: Array<Scalars['MongoID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsWidgetInput>;
};

export type Refund = {
  __typename?: 'Refund';
  _id: Scalars['String']['output'];
  amount: Scalars['Float']['output'];
  createdDateISO?: Maybe<Scalars['Date']['output']>;
  orderId: Scalars['String']['output'];
  status: EnumRefundStatus;
  updatedDateISO?: Maybe<Scalars['Date']['output']>;
};

export type RemoveByIdBookerPayload = {
  __typename?: 'RemoveByIdBookerPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<Booker>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RemoveByIdEventPayload = {
  __typename?: 'RemoveByIdEventPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<Event>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RemoveByIdInventoryItemPayload = {
  __typename?: 'RemoveByIdInventoryItemPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<InventoryItem>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RemoveByIdNotePayload = {
  __typename?: 'RemoveByIdNotePayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<Note>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RemoveByIdOrderPayload = {
  __typename?: 'RemoveByIdOrderPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<Order>;
  /** Document ID */
  recordId?: Maybe<Scalars['String']['output']>;
};

export type RemoveByIdProductPayload = {
  __typename?: 'RemoveByIdProductPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<Product>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RemoveByIdTaxPayload = {
  __typename?: 'RemoveByIdTaxPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<Tax>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RestaurantOperatorMetadata = {
  __typename?: 'RestaurantOperatorMetadata';
  seatingCapacity?: Maybe<Scalars['Float']['output']>;
};

export type RestaurantOperatorMetadataInput = {
  seatingCapacity?: InputMaybe<Scalars['Float']['input']>;
};

export enum RoleType {
  Owner = 'OWNER',
  Staff = 'STAFF'
}

export type Room = {
  __typename?: 'Room';
  _id?: Maybe<Scalars['MongoID']['output']>;
  amenities?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  type: EnumRoomType;
};

export type RoomInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  amenities?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  type: EnumRoomType;
};

export type Rule = {
  __typename?: 'Rule';
  _id: Scalars['MongoID']['output'];
  activePeriod?: Maybe<DateRangeIso>;
  createdDateISO?: Maybe<Scalars['Date']['output']>;
  isActive: Scalars['Boolean']['output'];
  storefront: Scalars['MongoID']['output'];
  type: EnumRuleType;
  updatedDateISO?: Maybe<Scalars['Date']['output']>;
  value: Scalars['JSON']['output'];
};

export type RuntimeError = ErrorInterface & {
  __typename?: 'RuntimeError';
  /** Runtime error message */
  message?: Maybe<Scalars['String']['output']>;
};

export type Seasonality = {
  __typename?: 'Seasonality';
  apr?: Maybe<SeasonalityEnum>;
  aug?: Maybe<SeasonalityEnum>;
  dec?: Maybe<SeasonalityEnum>;
  feb?: Maybe<SeasonalityEnum>;
  jan?: Maybe<SeasonalityEnum>;
  jul?: Maybe<SeasonalityEnum>;
  jun?: Maybe<SeasonalityEnum>;
  mar?: Maybe<SeasonalityEnum>;
  may?: Maybe<SeasonalityEnum>;
  nov?: Maybe<SeasonalityEnum>;
  oct?: Maybe<SeasonalityEnum>;
  sep?: Maybe<SeasonalityEnum>;
};

export enum SeasonalityEnum {
  Closed = 'CLOSED',
  High = 'HIGH',
  Low = 'LOW'
}

export type SeasonalityInput = {
  apr?: InputMaybe<SeasonalityEnum>;
  aug?: InputMaybe<SeasonalityEnum>;
  dec?: InputMaybe<SeasonalityEnum>;
  feb?: InputMaybe<SeasonalityEnum>;
  jan?: InputMaybe<SeasonalityEnum>;
  jul?: InputMaybe<SeasonalityEnum>;
  jun?: InputMaybe<SeasonalityEnum>;
  mar?: InputMaybe<SeasonalityEnum>;
  may?: InputMaybe<SeasonalityEnum>;
  nov?: InputMaybe<SeasonalityEnum>;
  oct?: InputMaybe<SeasonalityEnum>;
  sep?: InputMaybe<SeasonalityEnum>;
};

export type SecurityDepositSettings = {
  __typename?: 'SecurityDepositSettings';
  enabled: Scalars['Boolean']['output'];
  placeHoldDaysBeforeCheckOut: Scalars['Float']['output'];
  rate?: Maybe<Scalars['Float']['output']>;
  rateType?: Maybe<EnumSecurityDepositSettingsRateType>;
};

export type SecurityDepositSettingsInput = {
  enabled: Scalars['Boolean']['input'];
  placeHoldDaysBeforeCheckOut?: InputMaybe<Scalars['Float']['input']>;
  rate?: InputMaybe<Scalars['Float']['input']>;
  rateType?: InputMaybe<EnumSecurityDepositSettingsRateType>;
};

export type ServiceOperatorMetadata = {
  __typename?: 'ServiceOperatorMetadata';
  _id?: Maybe<Scalars['MongoID']['output']>;
};

export type ServiceOperatorMetadataInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
};

export enum SortFindByIdsAssetFileInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindByIdsAssetImageInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindByIdsAssetInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindByIdsBookerInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindByIdsCustomerInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindByIdsDiscountInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindByIdsInventoryItemInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindByIdsListInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindByIdsOrderInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindByIdsOrganizationInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindByIdsPolicyInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindByIdsProductInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindByIdsRuleInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindByIdsStorefrontInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindByIdsTagGroupInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindByIdsTagInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindByIdsUserInput {
  Auth0IdAsc = 'AUTH0ID_ASC',
  Auth0IdDesc = 'AUTH0ID_DESC',
  EmailAsc = 'EMAIL_ASC',
  EmailDesc = 'EMAIL_DESC',
  SignuptokenAsc = 'SIGNUPTOKEN_ASC',
  SignuptokenDesc = 'SIGNUPTOKEN_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindByIdsWidgetInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyAssetFileInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyAssetImageInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyAssetInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyBookerInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyChangelogInput {
  CreatedAsc = '_CREATED_ASC',
  CreatedDesc = '_CREATED_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyCustomerInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyDiscountInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyInventoryItemInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyListInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
  UpdatedAsc = '_UPDATED_ASC',
  UpdatedDesc = '_UPDATED_DESC'
}

export enum SortFindManyNoteInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
  UpdatedAsc = '_UPDATED_ASC',
  UpdatedDesc = '_UPDATED_DESC'
}

export enum SortFindManyOperatorInput {
  EntityidAsc = '_ENTITYID_ASC',
  EntityidDesc = '_ENTITYID_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
  VersionidAsc = '_VERSIONID_ASC',
  VersionidDesc = '_VERSIONID_DESC'
}

export enum SortFindManyOrderInput {
  CreatedAsc = '_CREATED_ASC',
  CreatedDesc = '_CREATED_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyOrganizationInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyPolicyInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyPostHogDataInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyProductInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyRefundInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyRuleInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyStorefrontInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManySurveyResponseInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyTagGroupInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyTagInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyTaxInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyUserInput {
  Auth0IdAsc = 'AUTH0ID_ASC',
  Auth0IdDesc = 'AUTH0ID_DESC',
  EmailAsc = 'EMAIL_ASC',
  EmailDesc = 'EMAIL_DESC',
  SignuptokenAsc = 'SIGNUPTOKEN_ASC',
  SignuptokenDesc = 'SIGNUPTOKEN_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyWidgetInput {
  /** Sort by updatedDateISO ASC */
  UpdatedAsc = '_UPDATED_ASC',
  /** Sort by updatedDateISO DESC */
  UpdatedDesc = '_UPDATED_DESC'
}

export enum SortFindOneApiAccessInput {
  TokenAsc = 'TOKEN_ASC',
  TokenDesc = 'TOKEN_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindOneCampaignInput {
  EntityidAsc = '_ENTITYID_ASC',
  EntityidDesc = '_ENTITYID_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
  VersionidAsc = '_VERSIONID_ASC',
  VersionidDesc = '_VERSIONID_DESC'
}

export enum SortFindOneMaintenanceInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindOnePublicationStatusInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindOneSurveyResponseInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindOneTagGroupInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindOneUserInput {
  Auth0IdAsc = 'AUTH0ID_ASC',
  Auth0IdDesc = 'AUTH0ID_DESC',
  EmailAsc = 'EMAIL_ASC',
  EmailDesc = 'EMAIL_DESC',
  SignuptokenAsc = 'SIGNUPTOKEN_ASC',
  SignuptokenDesc = 'SIGNUPTOKEN_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export type Storefront = {
  __typename?: 'Storefront';
  _id: Scalars['MongoID']['output'];
  connectedAccountIds: Array<Maybe<Scalars['String']['output']>>;
  createdDateISO?: Maybe<Scalars['Date']['output']>;
  name: Multilingual;
  siteMetadata?: Maybe<StorefrontSiteMetadata>;
  updatedDateISO?: Maybe<Scalars['Date']['output']>;
};

export type StorefrontSiteMetadata = {
  __typename?: 'StorefrontSiteMetadata';
  _id?: Maybe<Scalars['MongoID']['output']>;
  bookers: Array<Booker>;
  description?: Maybe<Multilingual>;
  email?: Maybe<Scalars['String']['output']>;
  featuredImage?: Maybe<AssetImage>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  logo?: Maybe<AssetImage>;
  name: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
};


export type StorefrontSiteMetadataBookersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsBookerInput>;
};

export type StorefrontSiteMetadataInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  bookers?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  description?: InputMaybe<MultilingualInput>;
  email?: InputMaybe<Scalars['String']['input']>;
  featuredImage?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  logo?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  slug: Scalars['String']['input'];
};

export type StripeMetadata = {
  __typename?: 'StripeMetadata';
  chargeId: Scalars['String']['output'];
  customerId: Scalars['String']['output'];
  invoiceId?: Maybe<Scalars['String']['output']>;
  paymentMethodId: Scalars['String']['output'];
  securityHoldPaymentIntentId?: Maybe<Scalars['String']['output']>;
  securityHoldStatus?: Maybe<EnumStripeMetadataSecurityHoldStatus>;
};

export type SurveyResponse = {
  __typename?: 'SurveyResponse';
  _id: Scalars['MongoID']['output'];
  createdDateISO?: Maybe<Scalars['Date']['output']>;
  operator: Scalars['MongoID']['output'];
  organization: Scalars['MongoID']['output'];
  responses: Array<Maybe<Scalars['JSON']['output']>>;
  surveyId: Scalars['String']['output'];
  updatedDateISO?: Maybe<Scalars['Date']['output']>;
  user: Scalars['MongoID']['output'];
};

export type Tag = {
  __typename?: 'Tag';
  _id: Scalars['MongoID']['output'];
  createdDateISO?: Maybe<Scalars['Date']['output']>;
  entityType?: Maybe<EnumTagEntityType>;
  entityTypes: Array<Maybe<EnumTagEntityTypes>>;
  name: Multilingual;
  owner?: Maybe<Owner>;
  tagGroup?: Maybe<TagGroup>;
  updatedDateISO?: Maybe<Scalars['Date']['output']>;
};

export type TagGroup = {
  __typename?: 'TagGroup';
  _id: Scalars['MongoID']['output'];
  createdDateISO?: Maybe<Scalars['Date']['output']>;
  key: EnumTagGroupKey;
  name: Multilingual;
  type: EnumTagGroupType;
  updatedDateISO?: Maybe<Scalars['Date']['output']>;
};

export type Tax = {
  __typename?: 'Tax';
  _id: Scalars['MongoID']['output'];
  country: Scalars['String']['output'];
  createdDateISO?: Maybe<Scalars['Date']['output']>;
  owner?: Maybe<Owner>;
  percentage: Scalars['Float']['output'];
  subdivision: Scalars['String']['output'];
  updatedDateISO?: Maybe<Scalars['Date']['output']>;
};

export type ToursOperatorMetadata = {
  __typename?: 'ToursOperatorMetadata';
  maxGroupSize?: Maybe<Scalars['Float']['output']>;
};

export type ToursOperatorMetadataInput = {
  maxGroupSize?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdAccommodationOperatorMetadataInput = {
  guestRoomQty?: InputMaybe<Scalars['Float']['input']>;
  shortTermAccommodationLicense?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdAccommodationProductMetadataInput = {
  amenities?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  calendarLinks?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  checkIn?: InputMaybe<Scalars['String']['input']>;
  checkOut?: InputMaybe<Scalars['String']['input']>;
  closures?: InputMaybe<Array<InputMaybe<UpdateByIdClosureInput>>>;
  guestMetadata?: InputMaybe<UpdateByIdGuestMetadataInput>;
  rooms?: InputMaybe<Array<InputMaybe<UpdateByIdRoomInput>>>;
};

export type UpdateByIdAddressInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  line1?: InputMaybe<Scalars['String']['input']>;
  line2?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<UpdateByIdAddressLocationInput>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  subdivision?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdAddressLocationInput = {
  coordinates?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  type?: InputMaybe<EnumAddressLocationType>;
};

export type UpdateByIdAssetFileInput = {
  blurhash?: InputMaybe<Scalars['String']['input']>;
  caption?: InputMaybe<UpdateByIdMultilingualInput>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  originalUrl?: InputMaybe<Scalars['String']['input']>;
  parentEntity?: InputMaybe<UpdateByIdEntityReferenceInput>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

export type UpdateByIdAssetFilePayload = {
  __typename?: 'UpdateByIdAssetFilePayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<AssetFile>;
  /** Document ID */
  recordId?: Maybe<Scalars['String']['output']>;
};

export type UpdateByIdAssetImageInput = {
  blurhash?: InputMaybe<Scalars['String']['input']>;
  caption?: InputMaybe<UpdateByIdMultilingualInput>;
  colors?: InputMaybe<Array<InputMaybe<UpdateByIdColorInput>>>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  /**
   * Currently, our schema only supports facial and text detection, using the built-in Cloudinary AI Content Analysis face detection, and the `cld-text` model. Therefore, the fields returned in `detectedObjects` will be limited to *optional* `humanFace` and `text` fields which are of `IDetectedObject[]` type.
   *
   * &nbsp;
   *
   * `IDetectedObject` contains a `boundingBox` array of `numbers`, a `categories` array of `string`s, and a `number` `confidence` value.
   *
   * &nbsp;
   *
   * ```json
   * interface IDetectedObject extends Document {
   *   boundingBox: number[];
   *   categories: string[];
   *   confidence: number;
   * }
   * ```
   */
  detectedObjects?: InputMaybe<Scalars['JSON']['input']>;
  height?: InputMaybe<Scalars['Float']['input']>;
  originalUrl?: InputMaybe<Scalars['String']['input']>;
  parentEntity?: InputMaybe<UpdateByIdEntityReferenceInput>;
  qualityAnalysis?: InputMaybe<UpdateByIdImageQualityAnalysisInput>;
  qualityScore?: InputMaybe<Scalars['Float']['input']>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
  width?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdAssetImagePayload = {
  __typename?: 'UpdateByIdAssetImagePayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<AssetImage>;
  /** Document ID */
  recordId?: Maybe<Scalars['String']['output']>;
};

export type UpdateByIdBookerBundlesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  product?: InputMaybe<Scalars['MongoID']['input']>;
  upsells?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type UpdateByIdBookerCustomizationsInput = {
  featuredImage?: InputMaybe<Scalars['MongoID']['input']>;
  logo?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateByIdBookerInput = {
  bundles?: InputMaybe<Array<InputMaybe<UpdateByIdBookerBundlesInput>>>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  customizations?: InputMaybe<UpdateByIdBookerCustomizationsInput>;
  discounts?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  name?: InputMaybe<UpdateByIdMultilingualInput>;
  paymentMetadata?: InputMaybe<UpdateByIdBookerPaymentMetadataInput>;
  policies?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  rules?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  status?: InputMaybe<EnumBookerStatus>;
  statusNotification?: InputMaybe<UpdateByIdMultilingualInput>;
  storefront?: InputMaybe<Scalars['MongoID']['input']>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
  waivers?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UpdateByIdBookerPayload = {
  __typename?: 'UpdateByIdBookerPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<Booker>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdBookerPaymentMetadataInput = {
  applicationPercentage?: InputMaybe<Scalars['Float']['input']>;
  connectedAccountId?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  depositSettings?: InputMaybe<UpdateByIdDepositSettingsInput>;
  securityDepositSettings?: InputMaybe<UpdateByIdSecurityDepositSettingsInput>;
  tax?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdClosureInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  dateRangeISO?: InputMaybe<UpdateByIdDateRangeIsoInput>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdColorInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  predominance?: InputMaybe<Scalars['Float']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdContactInput = {
  address?: InputMaybe<AddressInput>;
  email?: InputMaybe<Scalars['String']['input']>;
  links?: InputMaybe<LinksInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  tollFreePublicPhone?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdCustomerInput = {
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  orders?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  phone?: InputMaybe<Scalars['String']['input']>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

export type UpdateByIdCustomerPayload = {
  __typename?: 'UpdateByIdCustomerPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<Customer>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdDateRangeIsoInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  end: Scalars['String']['input'];
  metadata?: InputMaybe<Scalars['String']['input']>;
  start: Scalars['String']['input'];
};

export type UpdateByIdDepositSettingsInput = {
  chargeBalanceDaysBeforeCheckIn?: InputMaybe<Scalars['Float']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  rate?: InputMaybe<Scalars['Float']['input']>;
  rateType?: InputMaybe<EnumDepositSettingsRateType>;
};

export type UpdateByIdDiscountInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  amount?: InputMaybe<Scalars['Float']['input']>;
  canCombine?: InputMaybe<Scalars['Boolean']['input']>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  currentUsageCount?: InputMaybe<Scalars['Float']['input']>;
  daysInAdvance?: InputMaybe<Scalars['Float']['input']>;
  description?: InputMaybe<UpdateByIdMultilingualInput>;
  discountActivePeriod?: InputMaybe<UpdateByIdDateRangeIsoInput>;
  excludeUpsells?: InputMaybe<Scalars['Boolean']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  maxNights?: InputMaybe<Scalars['Float']['input']>;
  maxUsageCount?: InputMaybe<Scalars['Float']['input']>;
  minGuestCount?: InputMaybe<Scalars['Float']['input']>;
  minNights?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<UpdateByIdMultilingualInput>;
  promoCode?: InputMaybe<Scalars['String']['input']>;
  storefront?: InputMaybe<Scalars['MongoID']['input']>;
  type?: InputMaybe<EnumDiscountType>;
  unit?: InputMaybe<EnumDiscountUnit>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

export type UpdateByIdDiscountPayload = {
  __typename?: 'UpdateByIdDiscountPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<Discount>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdEntityReferenceInput = {
  _entityId?: InputMaybe<Scalars['MongoID']['input']>;
  type?: InputMaybe<EnumEntityReferenceType>;
};

export type UpdateByIdEventAccessInput = {
  operator?: InputMaybe<UpdateByIdEventAccessOperatorInput>;
  organizations?: InputMaybe<Array<InputMaybe<UpdateByIdEventAccessOperatorInput>>>;
};

export type UpdateByIdEventAccessOperatorInput = {
  _entityId: Scalars['MongoID']['input'];
  status?: InputMaybe<EnumEventAccessOperatorStatus>;
};

export type UpdateByIdEventEventLocationInput = {
  contact?: InputMaybe<ContactInput>;
  locationInfo?: InputMaybe<EventEventLocationLocationInfoInput>;
  venue: MultilingualInput;
};

export type UpdateByIdEventInput = {
  access?: InputMaybe<UpdateByIdEventAccessInput>;
  contact?: InputMaybe<UpdateByIdContactInput>;
  createdBy?: InputMaybe<Scalars['MongoID']['input']>;
  createdByEmail?: InputMaybe<Scalars['String']['input']>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<UpdateByIdMultilingualInput>;
  /** The end date of the event. The string will be formatted as yyyy-mm-dd. To have it make sense to humans, the month will start at 01, so Jan 20, 2025 would be 2025-01-20. */
  endDate?: InputMaybe<Scalars['String']['input']>;
  eventLocation?: InputMaybe<UpdateByIdEventEventLocationInput>;
  images?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  locationType?: InputMaybe<EnumEventLocationType>;
  otherLocations?: InputMaybe<Array<InputMaybe<UpdateByIdEventEventLocationInput>>>;
  presentedBy?: InputMaybe<UpdateByIdMultilingualInput>;
  price?: InputMaybe<Scalars['String']['input']>;
  recurrencePattern?: InputMaybe<UpdateByIdEventRecurrencePatternInput>;
  schedules?: InputMaybe<Array<InputMaybe<UpdateByIdEventSchedulesInput>>>;
  /** The start date of the event. The string will be formatted as yyyy-mm-dd. To have it make sense to humans, the month will start at 01, so Jan 20, 2025 would be 2025-01-20. */
  startDate?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<UpdateByIdEventTagsInput>;
  tempTags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ticketUrl?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<UpdateByIdMultilingualInput>;
  type?: InputMaybe<EnumEventType>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
  venue?: InputMaybe<UpdateByIdMultilingualInput>;
};

export type UpdateByIdEventPayload = {
  __typename?: 'UpdateByIdEventPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<Event>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdEventRecurrencePatternInput = {
  /** For monthly frequency, the extact date each month (e.g. the 15th) */
  dateOfMonth?: InputMaybe<Scalars['Float']['input']>;
  /** For monthly frequency, the weekday the event should occur on (used in conjuction with dayOfMonthOccurrence) (e.g. WE) */
  dayOfMonth?: InputMaybe<EnumEventRecurrencePatternDayOfMonth>;
  /** For monthly frequency, the weekday occurrence the event should occur on (used in conjuction with dayOfMonth) (e.g. 3). If this value is 5, it is treated as the 'last occurrence in the month' */
  dayOfMonthOccurrence?: InputMaybe<Scalars['Float']['input']>;
  /** For daily or weekly frequency, the weekday(s) to recur (e.g. Thursdays and Saturdays) */
  daysOfWeek?: InputMaybe<Array<InputMaybe<EnumEventRecurrencePatternDaysOfWeek>>>;
  /** The end date of the recurrence */
  endDate?: InputMaybe<Scalars['String']['input']>;
  frequency?: InputMaybe<EnumEventRecurrencePatternFrequency>;
  interval?: InputMaybe<Scalars['Float']['input']>;
  /** For yearly frequency, the MM-dd of the year that the event should occur on */
  monthAndDateOfYear?: InputMaybe<Scalars['String']['input']>;
  /** A list of dates (yyyy-MM-dd) for the MULTI type event */
  multiDates?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** A list of dates (yyyy-MM-dd) that should be skipped in the recurrence */
  skipDates?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UpdateByIdEventSchedulesInput = {
  allDay?: InputMaybe<Scalars['Boolean']['input']>;
  timeSlots?: InputMaybe<Array<InputMaybe<UpdateByIdEventSchedulesTimeSlotsInput>>>;
};

export type UpdateByIdEventSchedulesTimeSlotsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  endsNextDay?: InputMaybe<Scalars['Boolean']['input']>;
  from?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  to?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdEventTagsInput = {
  global?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  organizationSpecific?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type UpdateByIdExperienceOperatorMetadataInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateByIdGuestMetadataInput = {
  maximumNumber?: InputMaybe<Scalars['Float']['input']>;
  minimumNumber?: InputMaybe<Scalars['Float']['input']>;
  nameEntryAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  nameEntryRequired?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateByIdImageQualityAnalysisInput = {
  blockiness?: InputMaybe<Scalars['Float']['input']>;
  chroma_subsampling?: InputMaybe<Scalars['Float']['input']>;
  color_score?: InputMaybe<Scalars['Float']['input']>;
  contrast?: InputMaybe<Scalars['Float']['input']>;
  dct?: InputMaybe<Scalars['Float']['input']>;
  exposure?: InputMaybe<Scalars['Float']['input']>;
  focus?: InputMaybe<Scalars['Float']['input']>;
  jpeg_chroma?: InputMaybe<Scalars['Float']['input']>;
  jpeg_quality?: InputMaybe<Scalars['Float']['input']>;
  lighting?: InputMaybe<Scalars['Float']['input']>;
  noise?: InputMaybe<Scalars['Float']['input']>;
  pixel_score?: InputMaybe<Scalars['Float']['input']>;
  resolution?: InputMaybe<Scalars['Float']['input']>;
  saturation?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdInventoryItemInput = {
  claimedDateRangesISO?: InputMaybe<Array<InputMaybe<UpdateByIdDateRangeIsoInput>>>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  product?: InputMaybe<Scalars['MongoID']['input']>;
  type?: InputMaybe<EnumInventoryItemType>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

export type UpdateByIdInventoryItemPayload = {
  __typename?: 'UpdateByIdInventoryItemPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<InventoryItem>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdListInput = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<UpdateByIdMultilingualInput>;
  entityReferences?: InputMaybe<Array<InputMaybe<UpdateByIdVersionedEntityReferenceInput>>>;
  externallyAvailableEntityReferences?: InputMaybe<Array<InputMaybe<UpdateByIdVersionedEntityReferenceInput>>>;
  favorited?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<UpdateByIdMultilingualInput>;
  owner?: InputMaybe<UpdateByIdOwnerInput>;
  selections?: InputMaybe<Scalars['JSON']['input']>;
  type?: InputMaybe<EnumListType>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

export type UpdateByIdMultilingualInput = {
  en?: InputMaybe<Scalars['String']['input']>;
  es?: InputMaybe<Scalars['String']['input']>;
  fr?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdNoteInput = {
  author?: InputMaybe<Scalars['MongoID']['input']>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  entity?: InputMaybe<UpdateByIdEntityReferenceInput>;
  mentions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  message?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<UpdateByIdOwnerInput>;
  resolvedBy?: InputMaybe<Scalars['MongoID']['input']>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

export type UpdateByIdNotePayload = {
  __typename?: 'UpdateByIdNotePayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<Note>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdOperatorEnrollmentsInput = {
  onboardingStatus?: InputMaybe<EnumOperatorEnrollmentsOnboardingStatus>;
  organization?: InputMaybe<Scalars['MongoID']['input']>;
  organizationControlled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateByIdOperatorHoursOfOperationInput = {
  fri?: InputMaybe<UpdateByIdDateRangeIsoInput>;
  mon?: InputMaybe<UpdateByIdDateRangeIsoInput>;
  sat?: InputMaybe<UpdateByIdDateRangeIsoInput>;
  sun?: InputMaybe<UpdateByIdDateRangeIsoInput>;
  thu?: InputMaybe<UpdateByIdDateRangeIsoInput>;
  tue?: InputMaybe<UpdateByIdDateRangeIsoInput>;
  wed?: InputMaybe<UpdateByIdDateRangeIsoInput>;
};

export type UpdateByIdOperatorInput = {
  _entityId?: InputMaybe<Scalars['MongoID']['input']>;
  _versionId?: InputMaybe<Scalars['MongoID']['input']>;
  accommodationMetadata?: InputMaybe<UpdateByIdAccommodationOperatorMetadataInput>;
  avgImageQuality?: InputMaybe<EnumOperatorAvgImageQuality>;
  claimed?: InputMaybe<Scalars['Boolean']['input']>;
  contact?: InputMaybe<UpdateByIdContactInput>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<UpdateByIdMultilingualInput>;
  enrollments?: InputMaybe<Array<InputMaybe<UpdateByIdOperatorEnrollmentsInput>>>;
  experienceMetadata?: InputMaybe<UpdateByIdExperienceOperatorMetadataInput>;
  hoursOfOperation?: InputMaybe<UpdateByIdOperatorHoursOfOperationInput>;
  images?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<UpdateByIdMultilingualInput>;
  operationalStatus?: InputMaybe<EnumOperatorOperationalStatus>;
  pricing?: InputMaybe<EnumOperatorPricing>;
  restaurantMetadata?: InputMaybe<UpdateByIdRestaurantOperatorMetadataInput>;
  seasonality?: InputMaybe<UpdateByIdSeasonalityInput>;
  selectedTagGroups?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  serviceMetadata?: InputMaybe<UpdateByIdServiceOperatorMetadataInput>;
  shortDescription?: InputMaybe<UpdateByIdMultilingualInput>;
  tags?: InputMaybe<UpdateByIdOperatorTagsInput>;
  toursMetadata?: InputMaybe<UpdateByIdToursOperatorMetadataInput>;
  type?: InputMaybe<EnumOperatorType>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

export type UpdateByIdOperatorTagsInput = {
  amenity?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  businessType?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  global?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  organizationSpecific?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type UpdateByIdOrderPayload = {
  __typename?: 'UpdateByIdOrderPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<Order>;
  /** Document ID */
  recordId?: Maybe<Scalars['String']['output']>;
};

export type UpdateByIdOrganizationInput = {
  contact?: InputMaybe<UpdateByIdContactInput>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<UpdateByIdMultilingualInput>;
  domains?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  images?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  logo?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<UpdateByIdOrganizationMetadataInput>;
  name?: InputMaybe<UpdateByIdMultilingualInput>;
  onboardingMetadata?: InputMaybe<UpdateByIdOrganizationOnboardingMetadataInput>;
  shortDescription?: InputMaybe<UpdateByIdMultilingualInput>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

export type UpdateByIdOrganizationMetadataInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  eventLookaheadMonths?: InputMaybe<Scalars['Float']['input']>;
  inviteWhenAddingStaff?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateByIdOrganizationOnboardingMetadataInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  allowColdSignup?: InputMaybe<Scalars['Boolean']['input']>;
  introMessage?: InputMaybe<Scalars['String']['input']>;
  typeformSurveyId?: InputMaybe<Scalars['String']['input']>;
  videoId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdOrganizationPayload = {
  __typename?: 'UpdateByIdOrganizationPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<Organization>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdOwnerInput = {
  entityId?: InputMaybe<Scalars['MongoID']['input']>;
  type?: InputMaybe<EnumOwnerType>;
};

export type UpdateByIdPolicyInput = {
  content?: InputMaybe<UpdateByIdMultilingualInput>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<UpdateByIdMultilingualInput>;
  storefront?: InputMaybe<Scalars['MongoID']['input']>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

export type UpdateByIdPolicyPayload = {
  __typename?: 'UpdateByIdPolicyPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<Policy>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdPriceTierInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  label?: InputMaybe<UpdateByIdMultilingualInput>;
  price?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<EnumPriceTierType>;
};

export type UpdateByIdPricingInput = {
  description?: InputMaybe<UpdateByIdMultilingualInput>;
  tiers?: InputMaybe<Array<InputMaybe<UpdateByIdPriceTierInput>>>;
};

export type UpdateByIdProductContactInput = {
  address?: InputMaybe<UpdateByIdAddressInput>;
  email?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  tollFreePublicPhone?: InputMaybe<Scalars['String']['input']>;
  useOwnerContact?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateByIdProductInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  accommodationMetadata?: InputMaybe<UpdateByIdAccommodationProductMetadataInput>;
  contact?: InputMaybe<UpdateByIdProductContactInput>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<UpdateByIdMultilingualInput>;
  externalBookingUrl?: InputMaybe<Scalars['String']['input']>;
  images?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isUpsellOnly?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<UpdateByIdMultilingualInput>;
  owner?: InputMaybe<UpdateByIdOwnerInput>;
  pricing?: InputMaybe<UpdateByIdPricingInput>;
  publicationStatus?: InputMaybe<EnumProductPublicationStatus>;
  quantitySettings?: InputMaybe<UpdateByIdProductQuantitySettingsInput>;
  rules?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  shortDescription?: InputMaybe<UpdateByIdMultilingualInput>;
  storefront?: InputMaybe<Scalars['MongoID']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  type?: InputMaybe<EnumProductType>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

export type UpdateByIdProductPayload = {
  __typename?: 'UpdateByIdProductPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<Product>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdProductQuantitySettingsInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  maxQuantity?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdRefundInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  orderId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<EnumRefundStatus>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

export type UpdateByIdRefundPayload = {
  __typename?: 'UpdateByIdRefundPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<Refund>;
  /** Document ID */
  recordId?: Maybe<Scalars['String']['output']>;
};

export type UpdateByIdRestaurantOperatorMetadataInput = {
  seatingCapacity?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdRoomInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  amenities?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  type?: InputMaybe<EnumRoomType>;
};

export type UpdateByIdRuleInput = {
  activePeriod?: InputMaybe<UpdateByIdDateRangeIsoInput>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  storefront?: InputMaybe<Scalars['MongoID']['input']>;
  type?: InputMaybe<EnumRuleType>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
  value?: InputMaybe<Scalars['JSON']['input']>;
};

export type UpdateByIdRulePayload = {
  __typename?: 'UpdateByIdRulePayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<Rule>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdSeasonalityInput = {
  apr?: InputMaybe<SeasonalityEnum>;
  aug?: InputMaybe<SeasonalityEnum>;
  dec?: InputMaybe<SeasonalityEnum>;
  feb?: InputMaybe<SeasonalityEnum>;
  jan?: InputMaybe<SeasonalityEnum>;
  jul?: InputMaybe<SeasonalityEnum>;
  jun?: InputMaybe<SeasonalityEnum>;
  mar?: InputMaybe<SeasonalityEnum>;
  may?: InputMaybe<SeasonalityEnum>;
  nov?: InputMaybe<SeasonalityEnum>;
  oct?: InputMaybe<SeasonalityEnum>;
  sep?: InputMaybe<SeasonalityEnum>;
};

export type UpdateByIdSecurityDepositSettingsInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  placeHoldDaysBeforeCheckOut?: InputMaybe<Scalars['Float']['input']>;
  rate?: InputMaybe<Scalars['Float']['input']>;
  rateType?: InputMaybe<EnumSecurityDepositSettingsRateType>;
};

export type UpdateByIdServiceOperatorMetadataInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateByIdStorefrontInput = {
  connectedAccountIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  name?: InputMaybe<UpdateByIdMultilingualInput>;
  siteMetadata?: InputMaybe<UpdateByIdStorefrontSiteMetadataInput>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

export type UpdateByIdStorefrontPayload = {
  __typename?: 'UpdateByIdStorefrontPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<Storefront>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdStorefrontSiteMetadataInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  bookers?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  description?: InputMaybe<UpdateByIdMultilingualInput>;
  email?: InputMaybe<Scalars['String']['input']>;
  featuredImage?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  logo?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdTagInput = {
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  entityType?: InputMaybe<EnumTagEntityType>;
  entityTypes?: InputMaybe<Array<InputMaybe<EnumTagEntityTypes>>>;
  name?: InputMaybe<UpdateByIdMultilingualInput>;
  owner?: InputMaybe<UpdateByIdOwnerInput>;
  tagGroup?: InputMaybe<Scalars['MongoID']['input']>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

export type UpdateByIdTagPayload = {
  __typename?: 'UpdateByIdTagPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<Tag>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdTaxInput = {
  country?: InputMaybe<Scalars['String']['input']>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  owner?: InputMaybe<UpdateByIdOwnerInput>;
  percentage?: InputMaybe<Scalars['Float']['input']>;
  subdivision?: InputMaybe<Scalars['String']['input']>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

export type UpdateByIdTaxPayload = {
  __typename?: 'UpdateByIdTaxPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<Tax>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdToursOperatorMetadataInput = {
  maxGroupSize?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdUserAccessInput = {
  operators?: InputMaybe<Array<InputMaybe<UpdateByIdUserAccessOperatorsInput>>>;
  organizations?: InputMaybe<Array<InputMaybe<UpdateByIdUserAccessOperatorsInput>>>;
  storefronts?: InputMaybe<Array<InputMaybe<UpdateByIdUserAccessOperatorsInput>>>;
};

export type UpdateByIdUserAccessOperatorsInput = {
  entityId: Scalars['MongoID']['input'];
  role: EnumUserAccessOperatorsRole;
  status: EnumUserAccessOperatorsStatus;
};

export type UpdateByIdUserConfirmationCodesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  sentToEmail?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<EnumUserConfirmationCodesType>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
  validated?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateByIdUserEmailPreferencesInput = {
  frequency?: InputMaybe<EnumUserEmailPreferencesFrequency>;
  templateName?: InputMaybe<EnumUserEmailPreferencesTemplateName>;
};

export type UpdateByIdUserInput = {
  access?: InputMaybe<UpdateByIdUserAccessInput>;
  auth0Id?: InputMaybe<Scalars['String']['input']>;
  confirmationCodes?: InputMaybe<Array<InputMaybe<UpdateByIdUserConfirmationCodesInput>>>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailPreferences?: InputMaybe<Array<InputMaybe<UpdateByIdUserEmailPreferencesInput>>>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  onboardingMetadata?: InputMaybe<UpdateByIdUserOnboardingMetadataInput>;
  signupToken?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<EnumUserStatus>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
  userType?: InputMaybe<EnumUserUserType>;
};

export type UpdateByIdUserOnboardingMetadataInput = {
  isPostOnboarding?: InputMaybe<Scalars['Boolean']['input']>;
  onboardingOrganization?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateByIdVersionedEntityReferenceInput = {
  _entityId?: InputMaybe<Scalars['MongoID']['input']>;
  _versionId?: InputMaybe<Scalars['MongoID']['input']>;
  type?: InputMaybe<EnumVersionedEntityReferenceType>;
};

export type UpdateByIdWidgetEntityOverridesInput = {
  _entityId?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<UpdateByIdMultilingualInput>;
  images?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  shortDescription?: InputMaybe<UpdateByIdMultilingualInput>;
};

export type UpdateByIdWidgetEventSettingsInput = {
  displayType?: InputMaybe<EnumWidgetEventSettingsDisplayType>;
  eventTags?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lookAheadMonths?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdWidgetInput = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<UpdateByIdMultilingualInput>;
  entityOverrides?: InputMaybe<Array<InputMaybe<UpdateByIdWidgetEntityOverridesInput>>>;
  eventSettings?: InputMaybe<UpdateByIdWidgetEventSettingsInput>;
  favorited?: InputMaybe<Scalars['Boolean']['input']>;
  filterableTags?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  list?: InputMaybe<Scalars['MongoID']['input']>;
  name?: InputMaybe<UpdateByIdMultilingualInput>;
  owner?: InputMaybe<UpdateByIdOwnerInput>;
  type?: InputMaybe<EnumWidgetType>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

export type UpdateByIdWidgetPayload = {
  __typename?: 'UpdateByIdWidgetPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<Widget>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type User = {
  __typename?: 'User';
  _id: Scalars['MongoID']['output'];
  access: UserAccess;
  auth0Id?: Maybe<Scalars['String']['output']>;
  confirmationCodes: Array<Maybe<UserConfirmationCodes>>;
  createdDateISO?: Maybe<Scalars['Date']['output']>;
  email: Scalars['String']['output'];
  emailPreferences: Array<Maybe<UserEmailPreferences>>;
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  onboardingMetadata?: Maybe<UserOnboardingMetadata>;
  signupToken?: Maybe<Scalars['String']['output']>;
  status: EnumUserStatus;
  updatedDateISO?: Maybe<Scalars['Date']['output']>;
  userType: EnumUserUserType;
};

export type UserAccess = {
  __typename?: 'UserAccess';
  operators: Array<Maybe<UserAccessOperators>>;
  organizations: Array<Maybe<UserAccessOperators>>;
  storefronts: Array<Maybe<UserAccessOperators>>;
};

export type UserAccessInput = {
  operators: Array<InputMaybe<UserAccessOperatorsInput>>;
  organizations: Array<InputMaybe<UserAccessOperatorsInput>>;
  storefronts: Array<InputMaybe<UserAccessOperatorsInput>>;
};

export type UserAccessOperators = {
  __typename?: 'UserAccessOperators';
  entityId: Scalars['MongoID']['output'];
  role: EnumUserAccessOperatorsRole;
  status: EnumUserAccessOperatorsStatus;
};

export type UserAccessOperatorsInput = {
  entityId: Scalars['MongoID']['input'];
  role: EnumUserAccessOperatorsRole;
  status: EnumUserAccessOperatorsStatus;
};

export type UserConfirmationCodes = {
  __typename?: 'UserConfirmationCodes';
  _id?: Maybe<Scalars['MongoID']['output']>;
  code: Scalars['String']['output'];
  createdDateISO?: Maybe<Scalars['Date']['output']>;
  sentToEmail: Scalars['String']['output'];
  type: EnumUserConfirmationCodesType;
  updatedDateISO?: Maybe<Scalars['Date']['output']>;
  validated: Scalars['Boolean']['output'];
};

export type UserConfirmationCodesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  code: Scalars['String']['input'];
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  sentToEmail: Scalars['String']['input'];
  type: EnumUserConfirmationCodesType;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
  validated: Scalars['Boolean']['input'];
};

export type UserEmailPreferences = {
  __typename?: 'UserEmailPreferences';
  frequency: EnumUserEmailPreferencesFrequency;
  templateName: EnumUserEmailPreferencesTemplateName;
};

export type UserEmailPreferencesInput = {
  frequency: EnumUserEmailPreferencesFrequency;
  templateName: EnumUserEmailPreferencesTemplateName;
};

export type UserOnboardingMetadata = {
  __typename?: 'UserOnboardingMetadata';
  isPostOnboarding?: Maybe<Scalars['Boolean']['output']>;
  onboardingOrganization?: Maybe<Scalars['MongoID']['output']>;
};

export type UserOnboardingMetadataInput = {
  isPostOnboarding?: InputMaybe<Scalars['Boolean']['input']>;
  onboardingOrganization?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UserWithPictureTc = {
  __typename?: 'UserWithPictureTC';
  _id: Scalars['MongoID']['output'];
  access: UserAccess;
  auth0Id?: Maybe<Scalars['String']['output']>;
  confirmationCodes: Array<Maybe<UserConfirmationCodes>>;
  createdDateISO?: Maybe<Scalars['Date']['output']>;
  email: Scalars['String']['output'];
  emailPreferences: Array<Maybe<UserEmailPreferences>>;
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  onboardingMetadata?: Maybe<UserOnboardingMetadata>;
  picture?: Maybe<Scalars['String']['output']>;
  signupToken?: Maybe<Scalars['String']['output']>;
  status: EnumUserStatus;
  updatedDateISO?: Maybe<Scalars['Date']['output']>;
  userType: EnumUserUserType;
};

export type UserWithResetPasswordUrlTc = {
  __typename?: 'UserWithResetPasswordUrlTC';
  _id: Scalars['MongoID']['output'];
  access: UserAccess;
  auth0Id?: Maybe<Scalars['String']['output']>;
  confirmationCodes: Array<Maybe<UserConfirmationCodes>>;
  createdDateISO?: Maybe<Scalars['Date']['output']>;
  email: Scalars['String']['output'];
  emailPreferences: Array<Maybe<UserEmailPreferences>>;
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  onboardingMetadata?: Maybe<UserOnboardingMetadata>;
  passwordResetUrl?: Maybe<Scalars['String']['output']>;
  signupToken?: Maybe<Scalars['String']['output']>;
  status: EnumUserStatus;
  updatedDateISO?: Maybe<Scalars['Date']['output']>;
  userType: EnumUserUserType;
};

export type ValidationError = ErrorInterface & {
  __typename?: 'ValidationError';
  /** List of validator errors */
  errors?: Maybe<Array<ValidatorError>>;
  /** Combined error message from all validators */
  message?: Maybe<Scalars['String']['output']>;
};

export type ValidatorError = {
  __typename?: 'ValidatorError';
  /** Input record idx in array which occurs the validation error. This `idx` is useful for createMany operation. For singular operations it always be 0. For *Many operations `idx` represents record index in array received from user. */
  idx: Scalars['Int']['output'];
  /** Validation error message */
  message?: Maybe<Scalars['String']['output']>;
  /** Source of the validation error from the model path */
  path?: Maybe<Scalars['String']['output']>;
  /** Field value which occurs the validation error */
  value?: Maybe<Scalars['JSON']['output']>;
};

export type VersionedEntityReference = {
  __typename?: 'VersionedEntityReference';
  _entityId: Scalars['MongoID']['output'];
  _versionId: Scalars['MongoID']['output'];
  type: EnumVersionedEntityReferenceType;
};

export type VersionedEntityReferenceInput = {
  _entityId?: InputMaybe<Scalars['MongoID']['input']>;
  _versionId?: InputMaybe<Scalars['MongoID']['input']>;
  type?: InputMaybe<EnumVersionedEntityReferenceType>;
};

export type Widget = {
  __typename?: 'Widget';
  _id: Scalars['MongoID']['output'];
  archived: Scalars['Boolean']['output'];
  createdDateISO?: Maybe<Scalars['Date']['output']>;
  description: Multilingual;
  entityOverrides: Array<Maybe<WidgetEntityOverrides>>;
  eventSettings?: Maybe<WidgetEventSettings>;
  favorited: Scalars['Boolean']['output'];
  filterableTags: Array<Maybe<Scalars['MongoID']['output']>>;
  list: ListWithEntities;
  name: Multilingual;
  owner: Owner;
  type: EnumWidgetType;
  updatedDateISO?: Maybe<Scalars['Date']['output']>;
};

export type WidgetEntityOverrides = {
  __typename?: 'WidgetEntityOverrides';
  _entityId: Scalars['MongoID']['output'];
  description?: Maybe<Multilingual>;
  images?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  shortDescription?: Maybe<Multilingual>;
};

export type WidgetEntityOverridesInput = {
  _entityId: Scalars['MongoID']['input'];
  description?: InputMaybe<MultilingualInput>;
  images?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  shortDescription?: InputMaybe<MultilingualInput>;
};

export type WidgetEventSettings = {
  __typename?: 'WidgetEventSettings';
  displayType: EnumWidgetEventSettingsDisplayType;
  eventTags: Array<Maybe<Scalars['MongoID']['output']>>;
  lookAheadMonths?: Maybe<Scalars['Float']['output']>;
};

export type WidgetEventSettingsInput = {
  displayType: EnumWidgetEventSettingsDisplayType;
  eventTags: Array<InputMaybe<Scalars['MongoID']['input']>>;
  lookAheadMonths?: InputMaybe<Scalars['Float']['input']>;
};

export type WidgetWithListAndItemCount = {
  __typename?: 'WidgetWithListAndItemCount';
  _id: Scalars['MongoID']['output'];
  archived: Scalars['Boolean']['output'];
  createdDateISO?: Maybe<Scalars['Date']['output']>;
  description: Multilingual;
  entityOverrides: Array<Maybe<WidgetEntityOverrides>>;
  eventSettings?: Maybe<WidgetEventSettings>;
  favorited: Scalars['Boolean']['output'];
  filterableTags: Array<Maybe<Scalars['MongoID']['output']>>;
  itemCount?: Maybe<Scalars['Int']['output']>;
  list?: Maybe<ListWithEntities>;
  name: Multilingual;
  owner: Owner;
  type: EnumWidgetType;
  updatedDateISO?: Maybe<Scalars['Date']['output']>;
};

export type WidgetWithListEntities = {
  __typename?: 'WidgetWithListEntities';
  _id: Scalars['MongoID']['output'];
  archived: Scalars['Boolean']['output'];
  createdDateISO?: Maybe<Scalars['Date']['output']>;
  description: Multilingual;
  eventSettings?: Maybe<WidgetEventSettings>;
  favorited: Scalars['Boolean']['output'];
  filterableTags: Array<Tag>;
  list: ListWithEntitiesAndOverrides;
  name: Multilingual;
  owner: Owner;
  type: EnumWidgetType;
  updatedDateISO?: Maybe<Scalars['Date']['output']>;
};

export type CreatedDateIso = {
  _eq?: InputMaybe<Scalars['Date']['input']>;
  _gt?: InputMaybe<Scalars['Date']['input']>;
  _gte?: InputMaybe<Scalars['Date']['input']>;
  _lt?: InputMaybe<Scalars['Date']['input']>;
  _lte?: InputMaybe<Scalars['Date']['input']>;
};

export type Message = {
  _eq?: InputMaybe<Scalars['String']['input']>;
  _notStartsWith?: InputMaybe<Scalars['String']['input']>;
  _startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type ContactFragmentFragment = { __typename?: 'Contact', email?: string | null, phone?: string | null, tollFreePublicPhone?: string | null, address?: { __typename?: 'Address', line1?: string | null, line2?: string | null, city?: string | null, subdivision?: string | null, postalCode?: string | null, country?: string | null, location?: { __typename?: 'AddressLocation', type: EnumAddressLocationType, coordinates: Array<number | null> } | null } | null, links?: { __typename?: 'Links', bookNow?: string | null, facebook?: string | null, googleMyBusiness?: string | null, instagram?: string | null, pinterest?: string | null, tiktok?: string | null, tripAdvisor?: string | null, website?: string | null, x?: string | null, youtube?: string | null } | null };

export type EventDetailsFragmentFragment = { __typename?: 'Event', _id: any, createdByEmail: string, locationType: EnumEventLocationType, price?: string | null, ticketUrl?: string | null, type: EnumEventType, startDate: string, endDate?: string | null, updatedDateISO?: any | null, title: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, description: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, tags?: { __typename?: 'EventTags', global: Array<{ __typename?: 'Tag', _id: any, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, tagGroup?: { __typename?: 'TagGroup', _id: any, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } | null }>, organizationSpecific: Array<{ __typename?: 'Tag', _id: any, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, tagGroup?: { __typename?: 'TagGroup', _id: any, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } | null }> } | null, venue?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null, contact?: { __typename?: 'Contact', email?: string | null, phone?: string | null, tollFreePublicPhone?: string | null, address?: { __typename?: 'Address', line1?: string | null, line2?: string | null, city?: string | null, subdivision?: string | null, postalCode?: string | null, country?: string | null, location?: { __typename?: 'AddressLocation', type: EnumAddressLocationType, coordinates: Array<number | null> } | null } | null, links?: { __typename?: 'Links', bookNow?: string | null, facebook?: string | null, googleMyBusiness?: string | null, instagram?: string | null, pinterest?: string | null, tiktok?: string | null, tripAdvisor?: string | null, website?: string | null, x?: string | null, youtube?: string | null } | null } | null, eventLocation: { __typename?: 'EventEventLocation', venue: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, contact?: { __typename?: 'Contact', email?: string | null, phone?: string | null, tollFreePublicPhone?: string | null, address?: { __typename?: 'Address', line1?: string | null, line2?: string | null, city?: string | null, subdivision?: string | null, postalCode?: string | null, country?: string | null, location?: { __typename?: 'AddressLocation', type: EnumAddressLocationType, coordinates: Array<number | null> } | null } | null, links?: { __typename?: 'Links', bookNow?: string | null, facebook?: string | null, googleMyBusiness?: string | null, instagram?: string | null, pinterest?: string | null, tiktok?: string | null, tripAdvisor?: string | null, website?: string | null, x?: string | null, youtube?: string | null } | null } | null, locationInfo?: { __typename?: 'EventEventLocationLocationInfo', _entityId?: any | null, type?: EnumEventEventLocationLocationInfoType | null } | null }, otherLocations: Array<{ __typename?: 'EventEventLocation', venue: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, contact?: { __typename?: 'Contact', email?: string | null, phone?: string | null, tollFreePublicPhone?: string | null, address?: { __typename?: 'Address', line1?: string | null, line2?: string | null, city?: string | null, subdivision?: string | null, postalCode?: string | null, country?: string | null, location?: { __typename?: 'AddressLocation', type: EnumAddressLocationType, coordinates: Array<number | null> } | null } | null, links?: { __typename?: 'Links', bookNow?: string | null, facebook?: string | null, googleMyBusiness?: string | null, instagram?: string | null, pinterest?: string | null, tiktok?: string | null, tripAdvisor?: string | null, website?: string | null, x?: string | null, youtube?: string | null } | null } | null, locationInfo?: { __typename?: 'EventEventLocationLocationInfo', _entityId?: any | null, type?: EnumEventEventLocationLocationInfoType | null } | null } | null>, images: Array<{ __typename?: 'AssetImage', _id: string, blurhash: string, qualityScore?: ImageQualityRating | null, width: number, height: number, caption: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, detectedObjects?: { __typename?: 'DetectedObjects', hasText?: boolean | null, hasFace?: boolean | null } | null }>, schedules: Array<{ __typename?: 'EventSchedules', allDay: boolean, timeSlots?: Array<{ __typename?: 'EventSchedulesTimeSlots', _id?: any | null, from?: string | null, to?: string | null, endsNextDay?: boolean | null, note?: string | null } | null> | null } | null>, recurrencePattern: { __typename?: 'EventRecurrencePattern', frequency: EnumEventRecurrencePatternFrequency, interval?: number | null, daysOfWeek?: Array<EnumEventRecurrencePatternDaysOfWeek | null> | null, dateOfMonth?: number | null, dayOfMonth?: EnumEventRecurrencePatternDayOfMonth | null, dayOfMonthOccurrence?: number | null, monthAndDateOfYear?: string | null, multiDates?: Array<string | null> | null, skipDates?: Array<string | null> | null, endDate?: string | null }, access: { __typename?: 'EventAccess', operator?: { __typename?: 'EventAccessOperator', _entityId: any } | null, organizations: Array<{ __typename?: 'EventAccessOperator', _entityId: any, status?: EnumEventAccessOperatorStatus | null } | null> } };

export type EventLocationFragmentFragment = { __typename?: 'EventEventLocation', venue: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, contact?: { __typename?: 'Contact', email?: string | null, phone?: string | null, tollFreePublicPhone?: string | null, address?: { __typename?: 'Address', line1?: string | null, line2?: string | null, city?: string | null, subdivision?: string | null, postalCode?: string | null, country?: string | null, location?: { __typename?: 'AddressLocation', type: EnumAddressLocationType, coordinates: Array<number | null> } | null } | null, links?: { __typename?: 'Links', bookNow?: string | null, facebook?: string | null, googleMyBusiness?: string | null, instagram?: string | null, pinterest?: string | null, tiktok?: string | null, tripAdvisor?: string | null, website?: string | null, x?: string | null, youtube?: string | null } | null } | null, locationInfo?: { __typename?: 'EventEventLocationLocationInfo', _entityId?: any | null, type?: EnumEventEventLocationLocationInfoType | null } | null };

export type ImageFragmentFragment = { __typename?: 'AssetImage', _id: string, blurhash: string, qualityScore?: ImageQualityRating | null, width: number, height: number, caption: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, detectedObjects?: { __typename?: 'DetectedObjects', hasText?: boolean | null, hasFace?: boolean | null } | null };

export type MultilingualFragmentFragment = { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null };

export type NoteFramgmentFragment = { __typename?: 'Note', _id: any, message: string, updatedDateISO?: any | null, author?: { __typename?: 'UserWithPictureTC', _id: any, firstName: string, lastName: string, email: string } | null, entity: { __typename?: 'EntityReference', _entityId: any, type: EnumEntityReferenceType }, owner: { __typename?: 'Owner', entityId: any, type: EnumOwnerType }, resolvedBy?: { __typename?: 'UserWithPictureTC', _id: any, firstName: string, lastName: string } | null };

export type UserFragmentFragment = { __typename?: 'UserWithPictureTC', _id: any, firstName: string, lastName: string, email: string, picture?: string | null, status: EnumUserStatus, access: { __typename?: 'UserAccess', operators: Array<{ __typename?: 'UserAccessOperators', entityId: any, role: EnumUserAccessOperatorsRole, status: EnumUserAccessOperatorsStatus } | null>, organizations: Array<{ __typename?: 'UserAccessOperators', entityId: any, role: EnumUserAccessOperatorsRole, status: EnumUserAccessOperatorsStatus } | null> }, onboardingMetadata?: { __typename?: 'UserOnboardingMetadata', onboardingOrganization?: any | null, isPostOnboarding?: boolean | null } | null };

export type OrderCreateMutationVariables = Exact<{
  source: OrderSourceInput;
  customer: CustomerInput;
  guests: Array<InputMaybe<OrderGuestsInput>> | InputMaybe<OrderGuestsInput>;
  paymentMethodId: Scalars['String']['input'];
  productPurchaseRequests: Array<InputMaybe<ProductPurchaseRequest>> | InputMaybe<ProductPurchaseRequest>;
  promoCode?: InputMaybe<Scalars['String']['input']>;
}>;


export type OrderCreateMutation = { __typename?: 'Mutation', orderCreate?: { __typename?: 'CreateOneOrderPayload', record?: { __typename?: 'Order', _id: string } | null } | null };

export type CreatePublicationStatusMutationVariables = Exact<{
  record: CreateOnePublicationStatusInput;
}>;


export type CreatePublicationStatusMutation = { __typename?: 'Mutation', createPublicationStatus?: { __typename?: 'CreateOnePublicationStatusPayload', record?: { __typename?: 'PublicationStatus', _id: any, status?: PublicationStatusType | null, entity: { __typename?: 'VersionedEntityReference', _entityId: any, _versionId: any, type: EnumVersionedEntityReferenceType } } | null } | null };

export type DiscountValidatePromocodeMutationVariables = Exact<{
  promoCode: Scalars['String']['input'];
  storefrontId: Scalars['ID']['input'];
}>;


export type DiscountValidatePromocodeMutation = { __typename?: 'Mutation', discountValidatePromocode?: { __typename?: 'Discount', promoCode?: string | null } | null };

export type EventCreateMutationVariables = Exact<{
  record: CreateOneEventInput;
  skipDefaultVenue?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type EventCreateMutation = { __typename?: 'Mutation', eventCreate?: { __typename?: 'CreateOneEventPayload', recordId?: any | null, record?: { __typename?: 'Event', _id: any, createdByEmail: string, locationType: EnumEventLocationType, price?: string | null, ticketUrl?: string | null, type: EnumEventType, startDate: string, endDate?: string | null, updatedDateISO?: any | null, title: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, description: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, tags?: { __typename?: 'EventTags', global: Array<{ __typename?: 'Tag', _id: any, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, tagGroup?: { __typename?: 'TagGroup', _id: any, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } | null }>, organizationSpecific: Array<{ __typename?: 'Tag', _id: any, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, tagGroup?: { __typename?: 'TagGroup', _id: any, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } | null }> } | null, venue?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null, contact?: { __typename?: 'Contact', email?: string | null, phone?: string | null, tollFreePublicPhone?: string | null, address?: { __typename?: 'Address', line1?: string | null, line2?: string | null, city?: string | null, subdivision?: string | null, postalCode?: string | null, country?: string | null, location?: { __typename?: 'AddressLocation', type: EnumAddressLocationType, coordinates: Array<number | null> } | null } | null, links?: { __typename?: 'Links', bookNow?: string | null, facebook?: string | null, googleMyBusiness?: string | null, instagram?: string | null, pinterest?: string | null, tiktok?: string | null, tripAdvisor?: string | null, website?: string | null, x?: string | null, youtube?: string | null } | null } | null, eventLocation: { __typename?: 'EventEventLocation', venue: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, contact?: { __typename?: 'Contact', email?: string | null, phone?: string | null, tollFreePublicPhone?: string | null, address?: { __typename?: 'Address', line1?: string | null, line2?: string | null, city?: string | null, subdivision?: string | null, postalCode?: string | null, country?: string | null, location?: { __typename?: 'AddressLocation', type: EnumAddressLocationType, coordinates: Array<number | null> } | null } | null, links?: { __typename?: 'Links', bookNow?: string | null, facebook?: string | null, googleMyBusiness?: string | null, instagram?: string | null, pinterest?: string | null, tiktok?: string | null, tripAdvisor?: string | null, website?: string | null, x?: string | null, youtube?: string | null } | null } | null, locationInfo?: { __typename?: 'EventEventLocationLocationInfo', _entityId?: any | null, type?: EnumEventEventLocationLocationInfoType | null } | null }, otherLocations: Array<{ __typename?: 'EventEventLocation', venue: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, contact?: { __typename?: 'Contact', email?: string | null, phone?: string | null, tollFreePublicPhone?: string | null, address?: { __typename?: 'Address', line1?: string | null, line2?: string | null, city?: string | null, subdivision?: string | null, postalCode?: string | null, country?: string | null, location?: { __typename?: 'AddressLocation', type: EnumAddressLocationType, coordinates: Array<number | null> } | null } | null, links?: { __typename?: 'Links', bookNow?: string | null, facebook?: string | null, googleMyBusiness?: string | null, instagram?: string | null, pinterest?: string | null, tiktok?: string | null, tripAdvisor?: string | null, website?: string | null, x?: string | null, youtube?: string | null } | null } | null, locationInfo?: { __typename?: 'EventEventLocationLocationInfo', _entityId?: any | null, type?: EnumEventEventLocationLocationInfoType | null } | null } | null>, images: Array<{ __typename?: 'AssetImage', _id: string, blurhash: string, qualityScore?: ImageQualityRating | null, width: number, height: number, caption: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, detectedObjects?: { __typename?: 'DetectedObjects', hasText?: boolean | null, hasFace?: boolean | null } | null }>, schedules: Array<{ __typename?: 'EventSchedules', allDay: boolean, timeSlots?: Array<{ __typename?: 'EventSchedulesTimeSlots', _id?: any | null, from?: string | null, to?: string | null, endsNextDay?: boolean | null, note?: string | null } | null> | null } | null>, recurrencePattern: { __typename?: 'EventRecurrencePattern', frequency: EnumEventRecurrencePatternFrequency, interval?: number | null, daysOfWeek?: Array<EnumEventRecurrencePatternDaysOfWeek | null> | null, dateOfMonth?: number | null, dayOfMonth?: EnumEventRecurrencePatternDayOfMonth | null, dayOfMonthOccurrence?: number | null, monthAndDateOfYear?: string | null, multiDates?: Array<string | null> | null, skipDates?: Array<string | null> | null, endDate?: string | null }, access: { __typename?: 'EventAccess', operator?: { __typename?: 'EventAccessOperator', _entityId: any } | null, organizations: Array<{ __typename?: 'EventAccessOperator', _entityId: any, status?: EnumEventAccessOperatorStatus | null } | null> } } | null } | null };

export type EventDeleteByIdMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type EventDeleteByIdMutation = { __typename?: 'Mutation', eventDeleteById?: { __typename?: 'RemoveByIdEventPayload', record?: { __typename?: 'Event', _id: any } | null } | null };

export type EventUpdateByIdMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
  record: UpdateByIdEventInput;
  imagesToKeep?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  setStatus?: InputMaybe<EnumEventAccessOperatorStatus>;
  isSubmitting?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type EventUpdateByIdMutation = { __typename?: 'Mutation', eventUpdateById?: { __typename?: 'UpdateByIdEventPayload', record?: { __typename?: 'Event', _id: any, createdByEmail: string, locationType: EnumEventLocationType, price?: string | null, ticketUrl?: string | null, type: EnumEventType, startDate: string, endDate?: string | null, updatedDateISO?: any | null, title: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, description: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, tags?: { __typename?: 'EventTags', global: Array<{ __typename?: 'Tag', _id: any, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, tagGroup?: { __typename?: 'TagGroup', _id: any, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } | null }>, organizationSpecific: Array<{ __typename?: 'Tag', _id: any, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, tagGroup?: { __typename?: 'TagGroup', _id: any, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } | null }> } | null, venue?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null, contact?: { __typename?: 'Contact', email?: string | null, phone?: string | null, tollFreePublicPhone?: string | null, address?: { __typename?: 'Address', line1?: string | null, line2?: string | null, city?: string | null, subdivision?: string | null, postalCode?: string | null, country?: string | null, location?: { __typename?: 'AddressLocation', type: EnumAddressLocationType, coordinates: Array<number | null> } | null } | null, links?: { __typename?: 'Links', bookNow?: string | null, facebook?: string | null, googleMyBusiness?: string | null, instagram?: string | null, pinterest?: string | null, tiktok?: string | null, tripAdvisor?: string | null, website?: string | null, x?: string | null, youtube?: string | null } | null } | null, eventLocation: { __typename?: 'EventEventLocation', venue: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, contact?: { __typename?: 'Contact', email?: string | null, phone?: string | null, tollFreePublicPhone?: string | null, address?: { __typename?: 'Address', line1?: string | null, line2?: string | null, city?: string | null, subdivision?: string | null, postalCode?: string | null, country?: string | null, location?: { __typename?: 'AddressLocation', type: EnumAddressLocationType, coordinates: Array<number | null> } | null } | null, links?: { __typename?: 'Links', bookNow?: string | null, facebook?: string | null, googleMyBusiness?: string | null, instagram?: string | null, pinterest?: string | null, tiktok?: string | null, tripAdvisor?: string | null, website?: string | null, x?: string | null, youtube?: string | null } | null } | null, locationInfo?: { __typename?: 'EventEventLocationLocationInfo', _entityId?: any | null, type?: EnumEventEventLocationLocationInfoType | null } | null }, otherLocations: Array<{ __typename?: 'EventEventLocation', venue: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, contact?: { __typename?: 'Contact', email?: string | null, phone?: string | null, tollFreePublicPhone?: string | null, address?: { __typename?: 'Address', line1?: string | null, line2?: string | null, city?: string | null, subdivision?: string | null, postalCode?: string | null, country?: string | null, location?: { __typename?: 'AddressLocation', type: EnumAddressLocationType, coordinates: Array<number | null> } | null } | null, links?: { __typename?: 'Links', bookNow?: string | null, facebook?: string | null, googleMyBusiness?: string | null, instagram?: string | null, pinterest?: string | null, tiktok?: string | null, tripAdvisor?: string | null, website?: string | null, x?: string | null, youtube?: string | null } | null } | null, locationInfo?: { __typename?: 'EventEventLocationLocationInfo', _entityId?: any | null, type?: EnumEventEventLocationLocationInfoType | null } | null } | null>, images: Array<{ __typename?: 'AssetImage', _id: string, blurhash: string, qualityScore?: ImageQualityRating | null, width: number, height: number, caption: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, detectedObjects?: { __typename?: 'DetectedObjects', hasText?: boolean | null, hasFace?: boolean | null } | null }>, schedules: Array<{ __typename?: 'EventSchedules', allDay: boolean, timeSlots?: Array<{ __typename?: 'EventSchedulesTimeSlots', _id?: any | null, from?: string | null, to?: string | null, endsNextDay?: boolean | null, note?: string | null } | null> | null } | null>, recurrencePattern: { __typename?: 'EventRecurrencePattern', frequency: EnumEventRecurrencePatternFrequency, interval?: number | null, daysOfWeek?: Array<EnumEventRecurrencePatternDaysOfWeek | null> | null, dateOfMonth?: number | null, dayOfMonth?: EnumEventRecurrencePatternDayOfMonth | null, dayOfMonthOccurrence?: number | null, monthAndDateOfYear?: string | null, multiDates?: Array<string | null> | null, skipDates?: Array<string | null> | null, endDate?: string | null }, access: { __typename?: 'EventAccess', operator?: { __typename?: 'EventAccessOperator', _entityId: any } | null, organizations: Array<{ __typename?: 'EventAccessOperator', _entityId: any, status?: EnumEventAccessOperatorStatus | null } | null> } } | null } | null };

export type FileCreateOneMutationVariables = Exact<{
  data: Scalars['JSON']['input'];
}>;


export type FileCreateOneMutation = { __typename?: 'Mutation', fileCreateOne: { __typename?: 'AssetFile', _id: string, blurhash: string, caption: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } };

export type FileDeleteFromCloudinaryOnlyMutationVariables = Exact<{
  cloudinaryPublicId: Scalars['String']['input'];
  resourceType: Scalars['String']['input'];
}>;


export type FileDeleteFromCloudinaryOnlyMutation = { __typename?: 'Mutation', fileDeleteFromCloudinaryOnly: boolean };

export type FileUpdateMutationVariables = Exact<{
  id: Scalars['String']['input'];
  record: UpdateByIdAssetFileInput;
}>;


export type FileUpdateMutation = { __typename?: 'Mutation', fileUpdate?: { __typename?: 'UpdateByIdAssetFilePayload', record?: { __typename?: 'AssetFile', _id: string, caption: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } | null } | null };

export type ImageCreateOneMutationVariables = Exact<{
  data: Scalars['JSON']['input'];
}>;


export type ImageCreateOneMutation = { __typename?: 'Mutation', imageCreateOne: { __typename?: 'AssetImage', _id: string, blurhash: string, qualityScore?: ImageQualityRating | null, caption: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } };

export type ImageDeleteFromCloudinaryOnlyMutationVariables = Exact<{
  cloudinaryPublicId: Scalars['String']['input'];
  resourceType: Scalars['String']['input'];
}>;


export type ImageDeleteFromCloudinaryOnlyMutation = { __typename?: 'Mutation', imageDeleteFromCloudinaryOnly: boolean };

export type ImageUpdateMutationVariables = Exact<{
  id: Scalars['String']['input'];
  record: UpdateByIdAssetImageInput;
}>;


export type ImageUpdateMutation = { __typename?: 'Mutation', imageUpdate?: { __typename?: 'UpdateByIdAssetImagePayload', record?: { __typename?: 'AssetImage', _id: string, qualityScore?: ImageQualityRating | null, caption: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } | null } | null };

export type ListCreateMutationVariables = Exact<{
  record: CreateOneListInput;
}>;


export type ListCreateMutation = { __typename?: 'Mutation', listCreate?: { __typename?: 'CreateOneListPayload', record?: { __typename?: 'List', _id: any, selections: any, type: EnumListType, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, owner: { __typename?: 'Owner', entityId: any, type: EnumOwnerType }, entityReferences: Array<{ __typename?: 'VersionedEntityReference', _entityId: any, _versionId: any, type: EnumVersionedEntityReferenceType } | null> } | null } | null };

export type ListUpdateByIdMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
  record: UpdateByIdListInput;
}>;


export type ListUpdateByIdMutation = { __typename?: 'Mutation', listUpdateById: { __typename?: 'ListWithEntities', _id: any, type: EnumListType, selections: any, archived: boolean, favorited: boolean, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, description: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } };

export type NoteCreateOneMutationVariables = Exact<{
  record: CreateOneNoteInput;
}>;


export type NoteCreateOneMutation = { __typename?: 'Mutation', noteCreateOne?: { __typename?: 'CreateOneNotePayload', record?: { __typename?: 'Note', _id: any, message: string, updatedDateISO?: any | null, author?: { __typename?: 'UserWithPictureTC', _id: any, firstName: string, lastName: string, email: string } | null, entity: { __typename?: 'EntityReference', _entityId: any, type: EnumEntityReferenceType }, owner: { __typename?: 'Owner', entityId: any, type: EnumOwnerType }, resolvedBy?: { __typename?: 'UserWithPictureTC', _id: any, firstName: string, lastName: string } | null } | null } | null };

export type NoteRemoveByIdMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type NoteRemoveByIdMutation = { __typename?: 'Mutation', noteRemoveById?: { __typename?: 'RemoveByIdNotePayload', record?: { __typename?: 'Note', _id: any, message: string, updatedDateISO?: any | null, author?: { __typename?: 'UserWithPictureTC', _id: any, firstName: string, lastName: string, email: string } | null, entity: { __typename?: 'EntityReference', _entityId: any, type: EnumEntityReferenceType }, owner: { __typename?: 'Owner', entityId: any, type: EnumOwnerType }, resolvedBy?: { __typename?: 'UserWithPictureTC', _id: any, firstName: string, lastName: string } | null } | null } | null };

export type NoteUpdateByIdMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
  record: UpdateByIdNoteInput;
}>;


export type NoteUpdateByIdMutation = { __typename?: 'Mutation', noteUpdateById?: { __typename?: 'UpdateByIdNotePayload', record?: { __typename?: 'Note', _id: any, message: string, updatedDateISO?: any | null, author?: { __typename?: 'UserWithPictureTC', _id: any, firstName: string, lastName: string, email: string } | null, entity: { __typename?: 'EntityReference', _entityId: any, type: EnumEntityReferenceType }, owner: { __typename?: 'Owner', entityId: any, type: EnumOwnerType }, resolvedBy?: { __typename?: 'UserWithPictureTC', _id: any, firstName: string, lastName: string } | null } | null } | null };

export type OperatorCreateMutationVariables = Exact<{
  record: CreateOneOperatorInput;
}>;


export type OperatorCreateMutation = { __typename?: 'Mutation', operatorCreate?: { __typename?: 'CreateOneOperatorPayload', record?: { __typename?: 'Operator', _entityId: any, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } | null } | null };

export type OperatorDeleteMutationVariables = Exact<{
  entityId: Scalars['ID']['input'];
}>;


export type OperatorDeleteMutation = { __typename?: 'Mutation', operatorDelete: { __typename?: 'OperatorWithStatus', _entityId: any, _versionId: any, status?: PublicationStatusType | null, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } };

export type OperatorUpdateMutationVariables = Exact<{
  record: UpdateByIdOperatorInput;
  entityId: Scalars['ID']['input'];
  isApproving?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type OperatorUpdateMutation = { __typename?: 'Mutation', operatorUpdate: { __typename?: 'OperatorWithStatus', _entityId: any, _versionId: any, status?: PublicationStatusType | null, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, enrollments: Array<{ __typename?: 'OperatorEnrollments', organizationControlled: boolean, organization: any, onboardingStatus: EnumOperatorEnrollmentsOnboardingStatus } | null>, tags?: { __typename?: 'OperatorTags', organizationSpecific: Array<{ __typename?: 'Tag', _id: any, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, tagGroup?: { __typename?: 'TagGroup', _id: any, key: EnumTagGroupKey, type: EnumTagGroupType, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } | null }>, global: Array<{ __typename?: 'Tag', _id: any, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, tagGroup?: { __typename?: 'TagGroup', _id: any, key: EnumTagGroupKey, type: EnumTagGroupType, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } | null }>, businessType: Array<{ __typename?: 'Tag', _id: any, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, tagGroup?: { __typename?: 'TagGroup', _id: any, key: EnumTagGroupKey, type: EnumTagGroupType, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } | null }>, amenity: Array<{ __typename?: 'Tag', _id: any, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, tagGroup?: { __typename?: 'TagGroup', _id: any, key: EnumTagGroupKey, type: EnumTagGroupType, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } | null }> } | null } };

export type OperatorUpdateImagesMutationVariables = Exact<{
  entityId: Scalars['ID']['input'];
  imagesToKeep?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  imagesToDelete?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  isApproving?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type OperatorUpdateImagesMutation = { __typename?: 'Mutation', operatorUpdateImages: { __typename?: 'OperatorWithStatus', status?: PublicationStatusType | null } };

export type OrganizationUpdateMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
  record: UpdateByIdOrganizationInput;
}>;


export type OrganizationUpdateMutation = { __typename?: 'Mutation', organizationUpdate?: { __typename?: 'UpdateByIdOrganizationPayload', record?: { __typename?: 'Organization', _id: any, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, contact?: { __typename?: 'Contact', email?: string | null, phone?: string | null, tollFreePublicPhone?: string | null, address?: { __typename?: 'Address', line1?: string | null, line2?: string | null, city?: string | null, subdivision?: string | null, postalCode?: string | null, country?: string | null, location?: { __typename?: 'AddressLocation', type: EnumAddressLocationType, coordinates: Array<number | null> } | null } | null, links?: { __typename?: 'Links', website?: string | null, instagram?: string | null, x?: string | null, bookNow?: string | null, youtube?: string | null, pinterest?: string | null, googleMyBusiness?: string | null, tiktok?: string | null, tripAdvisor?: string | null, facebook?: string | null } | null } | null, description: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, shortDescription: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } | null } | null };

export type OrganizationUpdateImagesMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  imagesToKeep?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  imagesToDelete?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  isLogo?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type OrganizationUpdateImagesMutation = { __typename?: 'Mutation', organizationUpdateImages: { __typename?: 'Organization', _id: any, logo?: { __typename?: 'AssetImage', _id: string, blurhash: string, qualityScore?: ImageQualityRating | null, width: number, height: number, caption: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, detectedObjects?: { __typename?: 'DetectedObjects', hasText?: boolean | null, hasFace?: boolean | null } | null } | null, images: Array<{ __typename?: 'AssetImage', _id: string, blurhash: string, qualityScore?: ImageQualityRating | null, width: number, height: number, caption: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, detectedObjects?: { __typename?: 'DetectedObjects', hasText?: boolean | null, hasFace?: boolean | null } | null }> } };

export type TagCreateMutationVariables = Exact<{
  record: CreateOneTagInput;
}>;


export type TagCreateMutation = { __typename?: 'Mutation', tagCreate?: { __typename?: 'CreateOneTagPayload', record?: { __typename?: 'Tag', _id: any, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } | null } | null };

export type TagGroupManyQueryVariables = Exact<{
  filter?: InputMaybe<FilterFindManyTagGroupInput>;
}>;


export type TagGroupManyQuery = { __typename?: 'Query', tagGroupMany: Array<{ __typename?: 'TagGroup', _id: any, key: EnumTagGroupKey, type: EnumTagGroupType, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } }> };

export type TagUpdateMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
  record: UpdateByIdTagInput;
}>;


export type TagUpdateMutation = { __typename?: 'Mutation', tagUpdate?: { __typename?: 'UpdateByIdTagPayload', record?: { __typename?: 'Tag', _id: any, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } | null } | null };

export type UserApproveAccessMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  entity: EntityReferenceInput;
}>;


export type UserApproveAccessMutation = { __typename?: 'Mutation', userApproveAccess?: { __typename?: 'UserWithPictureTC', _id: any } | null };

export type UserCreateMutationVariables = Exact<{
  record: CreateOneUserInput;
}>;


export type UserCreateMutation = { __typename?: 'Mutation', userCreate?: { __typename?: 'UserWithResetPasswordUrlTC', passwordResetUrl?: string | null } | null };

export type UserCreateConfirmationCodeMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  email: Scalars['String']['input'];
  confirmationCodeType: EnumConfirmationCodeType;
}>;


export type UserCreateConfirmationCodeMutation = { __typename?: 'Mutation', userCreateConfirmationCode: { __typename?: 'User', _id: any } };

export type UserCreateInviteMutationVariables = Exact<{
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  sendInvitationEmail: Scalars['Boolean']['input'];
  entity: EntityReferenceInput;
  role?: InputMaybe<RoleType>;
}>;


export type UserCreateInviteMutation = { __typename?: 'Mutation', userCreateInvite?: { __typename?: 'User', _id: any, email: string, firstName: string, lastName: string } | null };

export type UserRequestAccessMutationVariables = Exact<{
  entity: EntityReferenceInput;
}>;


export type UserRequestAccessMutation = { __typename?: 'Mutation', userRequestAccess?: { __typename?: 'UserWithPictureTC', _id: any, firstName: string, lastName: string, email: string, picture?: string | null, status: EnumUserStatus, access: { __typename?: 'UserAccess', operators: Array<{ __typename?: 'UserAccessOperators', entityId: any, role: EnumUserAccessOperatorsRole, status: EnumUserAccessOperatorsStatus } | null>, organizations: Array<{ __typename?: 'UserAccessOperators', entityId: any, role: EnumUserAccessOperatorsRole, status: EnumUserAccessOperatorsStatus } | null> }, onboardingMetadata?: { __typename?: 'UserOnboardingMetadata', onboardingOrganization?: any | null, isPostOnboarding?: boolean | null } | null } | null };

export type UserResendConfirmationCodeMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  sentToEmail: Scalars['String']['input'];
  type: EnumConfirmationCodeType;
}>;


export type UserResendConfirmationCodeMutation = { __typename?: 'Mutation', userResendConfirmationCode: { __typename?: 'User', _id: any } };

export type UserRevokeInviteMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  entity: EntityReferenceInput;
}>;


export type UserRevokeInviteMutation = { __typename?: 'Mutation', userRevokeInvite?: { __typename?: 'User', _id: any } | null };

export type UserUpdateMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
  record: UpdateByIdUserInput;
}>;


export type UserUpdateMutation = { __typename?: 'Mutation', userUpdate?: { __typename?: 'UserWithResetPasswordUrlTC', _id: any, passwordResetUrl?: string | null } | null };

export type UserValidateConfirmationCodeMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  code: Scalars['String']['input'];
}>;


export type UserValidateConfirmationCodeMutation = { __typename?: 'Mutation', userValidateConfirmationCode: { __typename?: 'User', _id: any } };

export type WidgetCreateMutationVariables = Exact<{
  record: CreateOneWidgetInput;
}>;


export type WidgetCreateMutation = { __typename?: 'Mutation', widgetCreate?: { __typename?: 'CreateOneWidgetPayload', record?: { __typename?: 'Widget', _id: any, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } | null } | null };

export type WidgetUpdateByIdMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
  record: UpdateByIdWidgetInput;
}>;


export type WidgetUpdateByIdMutation = { __typename?: 'Mutation', widgetUpdateById?: { __typename?: 'UpdateByIdWidgetPayload', record?: { __typename?: 'Widget', favorited: boolean, archived: boolean, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, description: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, eventSettings?: { __typename?: 'WidgetEventSettings', displayType: EnumWidgetEventSettingsDisplayType, eventTags: Array<any | null>, lookAheadMonths?: number | null } | null } | null } | null };

export type BookerByIdQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type BookerByIdQuery = { __typename?: 'Query', bookerById?: { __typename?: 'Booker', storefront: any, status: EnumBookerStatus, _id: any, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, bundles: Array<{ __typename?: 'BookerBundles', _id?: any | null, product?: { __typename?: 'Product', storefront: any, type: EnumProductType, publicationStatus: EnumProductPublicationStatus, externalBookingUrl?: string | null, isUpsellOnly: boolean, _id: any, owner: { __typename?: 'Owner', type: EnumOwnerType, entityId: any }, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, description?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null, shortDescription?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null, images: Array<{ __typename?: 'AssetImage', _id: string, blurhash: string, qualityScore?: ImageQualityRating | null, width: number, height: number, caption: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, detectedObjects?: { __typename?: 'DetectedObjects', hasText?: boolean | null, hasFace?: boolean | null } | null }>, tags: Array<{ __typename?: 'Tag', entityType?: EnumTagEntityType | null, entityTypes: Array<EnumTagEntityTypes | null>, _id: any, tagGroup?: { __typename?: 'TagGroup', _id: any, key: EnumTagGroupKey, type: EnumTagGroupType, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } | null, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } }>, rules: Array<{ __typename?: 'Rule', type: EnumRuleType, value: any, isActive: boolean, storefront: any, _id: any, activePeriod?: { __typename?: 'DateRangeISO', _id: any, start: string, end: string, metadata?: string | null } | null }>, pricing?: { __typename?: 'Pricing', tiers: Array<{ __typename?: 'PriceTier', type: EnumPriceTierType, price: number, _id: any, label?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null } | null> } | null, contact?: { __typename?: 'ProductContact', useOwnerContact: boolean, address?: { __typename?: 'Address', line1?: string | null, line2?: string | null, city?: string | null, subdivision?: string | null, postalCode?: string | null, country?: string | null, location?: { __typename?: 'AddressLocation', type: EnumAddressLocationType, coordinates: Array<number | null> } | null } | null } | null, accommodationMetadata?: { __typename?: 'AccommodationProductMetadata', checkIn?: string | null, checkOut?: string | null, guestMetadata?: { __typename?: 'GuestMetadata', minimumNumber?: number | null, maximumNumber?: number | null, nameEntryAllowed: boolean, nameEntryRequired: boolean } | null, amenities: Array<{ __typename?: 'Tag', entityType?: EnumTagEntityType | null, entityTypes: Array<EnumTagEntityTypes | null>, _id: any, tagGroup?: { __typename?: 'TagGroup', _id: any, key: EnumTagGroupKey, type: EnumTagGroupType, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } | null, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } }>, rooms: Array<{ __typename?: 'Room', _id?: any | null, type: EnumRoomType, amenities?: Array<any | null> | null } | null> } | null } | null, upsells: Array<{ __typename?: 'Product', _id: any, isUpsellOnly: boolean, publicationStatus: EnumProductPublicationStatus, type: EnumProductType, description?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, pricing?: { __typename?: 'Pricing', tiers: Array<{ __typename?: 'PriceTier', _id: any, price: number, type: EnumPriceTierType, label?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null } | null> } | null, shortDescription?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null, quantitySettings?: { __typename?: 'ProductQuantitySettings', enabled?: boolean | null, maxQuantity?: number | null } | null }> } | null>, paymentMetadata?: { __typename?: 'BookerPaymentMetadata', connectedAccountId?: string | null, depositSettings?: { __typename?: 'DepositSettings', enabled: boolean, rate?: number | null, rateType?: EnumDepositSettingsRateType | null, chargeBalanceDaysBeforeCheckIn: number } | null } | null, waivers: Array<{ __typename?: 'AssetFile', _id: string, type?: EnumDKeyAssetType | null, blurhash: string, caption: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } }>, rules: Array<{ __typename?: 'Rule', _id: any, isActive: boolean, type: EnumRuleType, value: any, activePeriod?: { __typename?: 'DateRangeISO', _id: any, end: string, start: string, metadata?: string | null } | null }>, policies: Array<{ __typename?: 'Policy', _id: any, isActive: boolean, storefront: any, content: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } }>, statusNotification?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null, customizations?: { __typename?: 'BookerCustomizations', featuredImage?: { __typename?: 'AssetImage', _id: string, blurhash: string, qualityScore?: ImageQualityRating | null, width: number, height: number, caption: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, detectedObjects?: { __typename?: 'DetectedObjects', hasText?: boolean | null, hasFace?: boolean | null } | null } | null, logo?: { __typename?: 'AssetImage', _id: string, blurhash: string, qualityScore?: ImageQualityRating | null, width: number, height: number, caption: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, detectedObjects?: { __typename?: 'DetectedObjects', hasText?: boolean | null, hasFace?: boolean | null } | null } | null } | null } | null };

export type BookerCartPriceQueryVariables = Exact<{
  bookerId: Scalars['ID']['input'];
  productPurchaseRequests: Array<ProductPurchaseRequest> | ProductPurchaseRequest;
  promoCode?: InputMaybe<Scalars['String']['input']>;
}>;


export type BookerCartPriceQuery = { __typename?: 'Query', bookerCartPrice?: { __typename?: 'CartPrices', depositTotal: number, discountTotal: number, grandTotal: number, subTotal: number, taxTotal: number, discountTotals: Array<{ __typename?: 'DiscountTotalPerDiscount', discountId: string, total: number }>, productPrices: Array<{ __typename?: 'PricePerProduct', price: number, productId: string }> } | null };

export type BookerSendContactUsEmailQueryVariables = Exact<{
  bookerId: Scalars['ID']['input'];
  details: ContactUsEmailDetails;
}>;


export type BookerSendContactUsEmailQuery = { __typename?: 'Query', bookerSendContactUsEmail?: { __typename?: 'EmailResponse', message: string, success: boolean } | null };

export type ChangeLogManyQueryVariables = Exact<{
  filter?: InputMaybe<FilterFindManyChangelogInput>;
  sort?: InputMaybe<SortFindManyChangelogInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ChangeLogManyQuery = { __typename?: 'Query', changeLogMany: Array<{ __typename?: 'Changelog', _id: any, createdDateISO?: any | null, initiatedByUser?: { __typename?: 'UserWithPictureTC', firstName: string } | null, owner: { __typename?: 'Owner', type: EnumOwnerType }, message: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } }> };

export type DiscountByIdsQueryVariables = Exact<{
  ids: Array<Scalars['MongoID']['input']> | Scalars['MongoID']['input'];
}>;


export type DiscountByIdsQuery = { __typename?: 'Query', discountByIds: Array<{ __typename?: 'Discount', _id: any, promoCode?: string | null, unit: EnumDiscountUnit, type: EnumDiscountType, amount: number, excludeUpsells: boolean, name: { __typename?: 'Multilingual', en?: string | null, fr?: string | null, es?: string | null } }> };

export type EventByIdQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type EventByIdQuery = { __typename?: 'Query', eventById?: { __typename?: 'Event', _id: any, createdByEmail: string, locationType: EnumEventLocationType, price?: string | null, ticketUrl?: string | null, type: EnumEventType, startDate: string, endDate?: string | null, updatedDateISO?: any | null, title: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, description: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, tags?: { __typename?: 'EventTags', global: Array<{ __typename?: 'Tag', _id: any, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, tagGroup?: { __typename?: 'TagGroup', _id: any, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } | null }>, organizationSpecific: Array<{ __typename?: 'Tag', _id: any, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, tagGroup?: { __typename?: 'TagGroup', _id: any, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } | null }> } | null, venue?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null, contact?: { __typename?: 'Contact', email?: string | null, phone?: string | null, tollFreePublicPhone?: string | null, address?: { __typename?: 'Address', line1?: string | null, line2?: string | null, city?: string | null, subdivision?: string | null, postalCode?: string | null, country?: string | null, location?: { __typename?: 'AddressLocation', type: EnumAddressLocationType, coordinates: Array<number | null> } | null } | null, links?: { __typename?: 'Links', bookNow?: string | null, facebook?: string | null, googleMyBusiness?: string | null, instagram?: string | null, pinterest?: string | null, tiktok?: string | null, tripAdvisor?: string | null, website?: string | null, x?: string | null, youtube?: string | null } | null } | null, eventLocation: { __typename?: 'EventEventLocation', venue: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, contact?: { __typename?: 'Contact', email?: string | null, phone?: string | null, tollFreePublicPhone?: string | null, address?: { __typename?: 'Address', line1?: string | null, line2?: string | null, city?: string | null, subdivision?: string | null, postalCode?: string | null, country?: string | null, location?: { __typename?: 'AddressLocation', type: EnumAddressLocationType, coordinates: Array<number | null> } | null } | null, links?: { __typename?: 'Links', bookNow?: string | null, facebook?: string | null, googleMyBusiness?: string | null, instagram?: string | null, pinterest?: string | null, tiktok?: string | null, tripAdvisor?: string | null, website?: string | null, x?: string | null, youtube?: string | null } | null } | null, locationInfo?: { __typename?: 'EventEventLocationLocationInfo', _entityId?: any | null, type?: EnumEventEventLocationLocationInfoType | null } | null }, otherLocations: Array<{ __typename?: 'EventEventLocation', venue: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, contact?: { __typename?: 'Contact', email?: string | null, phone?: string | null, tollFreePublicPhone?: string | null, address?: { __typename?: 'Address', line1?: string | null, line2?: string | null, city?: string | null, subdivision?: string | null, postalCode?: string | null, country?: string | null, location?: { __typename?: 'AddressLocation', type: EnumAddressLocationType, coordinates: Array<number | null> } | null } | null, links?: { __typename?: 'Links', bookNow?: string | null, facebook?: string | null, googleMyBusiness?: string | null, instagram?: string | null, pinterest?: string | null, tiktok?: string | null, tripAdvisor?: string | null, website?: string | null, x?: string | null, youtube?: string | null } | null } | null, locationInfo?: { __typename?: 'EventEventLocationLocationInfo', _entityId?: any | null, type?: EnumEventEventLocationLocationInfoType | null } | null } | null>, images: Array<{ __typename?: 'AssetImage', _id: string, blurhash: string, qualityScore?: ImageQualityRating | null, width: number, height: number, caption: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, detectedObjects?: { __typename?: 'DetectedObjects', hasText?: boolean | null, hasFace?: boolean | null } | null }>, schedules: Array<{ __typename?: 'EventSchedules', allDay: boolean, timeSlots?: Array<{ __typename?: 'EventSchedulesTimeSlots', _id?: any | null, from?: string | null, to?: string | null, endsNextDay?: boolean | null, note?: string | null } | null> | null } | null>, recurrencePattern: { __typename?: 'EventRecurrencePattern', frequency: EnumEventRecurrencePatternFrequency, interval?: number | null, daysOfWeek?: Array<EnumEventRecurrencePatternDaysOfWeek | null> | null, dateOfMonth?: number | null, dayOfMonth?: EnumEventRecurrencePatternDayOfMonth | null, dayOfMonthOccurrence?: number | null, monthAndDateOfYear?: string | null, multiDates?: Array<string | null> | null, skipDates?: Array<string | null> | null, endDate?: string | null }, access: { __typename?: 'EventAccess', operator?: { __typename?: 'EventAccessOperator', _entityId: any } | null, organizations: Array<{ __typename?: 'EventAccessOperator', _entityId: any, status?: EnumEventAccessOperatorStatus | null } | null> } } | null };

export type EventLookaheadMonthsQueryVariables = Exact<{
  organizationId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type EventLookaheadMonthsQuery = { __typename?: 'Query', eventLookaheadMonths?: any | null };

export type EventManyQueryVariables = Exact<{
  startDate: Scalars['String']['input'];
  endDate: Scalars['String']['input'];
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  operatorId?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<EventStatus>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  keepEventsWithNoFutureOccurrences?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type EventManyQuery = { __typename?: 'Query', eventMany: Array<{ __typename?: 'EventWithOccurrences', _id: any, type: EnumEventType, startDate: string, endDate?: string | null, occurrences?: Array<string | null> | null, price?: string | null, ticketUrl?: string | null, title: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, description: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, eventLocation: { __typename?: 'EventEventLocation', venue: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, contact?: { __typename?: 'Contact', email?: string | null, phone?: string | null, tollFreePublicPhone?: string | null, address?: { __typename?: 'Address', line1?: string | null, line2?: string | null, city?: string | null, subdivision?: string | null, postalCode?: string | null, country?: string | null, location?: { __typename?: 'AddressLocation', type: EnumAddressLocationType, coordinates: Array<number | null> } | null } | null, links?: { __typename?: 'Links', bookNow?: string | null, facebook?: string | null, googleMyBusiness?: string | null, instagram?: string | null, pinterest?: string | null, tiktok?: string | null, tripAdvisor?: string | null, website?: string | null, x?: string | null, youtube?: string | null } | null } | null, locationInfo?: { __typename?: 'EventEventLocationLocationInfo', _entityId?: any | null, type?: EnumEventEventLocationLocationInfoType | null } | null }, otherLocations: Array<{ __typename?: 'EventEventLocation', venue: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, contact?: { __typename?: 'Contact', email?: string | null, phone?: string | null, tollFreePublicPhone?: string | null, address?: { __typename?: 'Address', line1?: string | null, line2?: string | null, city?: string | null, subdivision?: string | null, postalCode?: string | null, country?: string | null, location?: { __typename?: 'AddressLocation', type: EnumAddressLocationType, coordinates: Array<number | null> } | null } | null, links?: { __typename?: 'Links', bookNow?: string | null, facebook?: string | null, googleMyBusiness?: string | null, instagram?: string | null, pinterest?: string | null, tiktok?: string | null, tripAdvisor?: string | null, website?: string | null, x?: string | null, youtube?: string | null } | null } | null, locationInfo?: { __typename?: 'EventEventLocationLocationInfo', _entityId?: any | null, type?: EnumEventEventLocationLocationInfoType | null } | null } | null>, schedules: Array<{ __typename?: 'EventSchedules', allDay: boolean, timeSlots?: Array<{ __typename?: 'EventSchedulesTimeSlots', from?: string | null, to?: string | null, endsNextDay?: boolean | null, note?: string | null } | null> | null } | null>, recurrencePattern: { __typename?: 'EventRecurrencePattern', frequency: EnumEventRecurrencePatternFrequency, interval?: number | null, multiDates?: Array<string | null> | null, daysOfWeek?: Array<EnumEventRecurrencePatternDaysOfWeek | null> | null, dateOfMonth?: number | null, dayOfMonth?: EnumEventRecurrencePatternDayOfMonth | null, dayOfMonthOccurrence?: number | null, monthAndDateOfYear?: string | null, endDate?: string | null, skipDates?: Array<string | null> | null }, images: Array<{ __typename?: 'AssetImage', _id: string, blurhash: string, qualityScore?: ImageQualityRating | null, width: number, height: number, caption: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, detectedObjects?: { __typename?: 'DetectedObjects', hasText?: boolean | null, hasFace?: boolean | null } | null }>, tags?: { __typename?: 'EventTags', global: Array<{ __typename?: 'Tag', _id: any, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, tagGroup?: { __typename?: 'TagGroup', _id: any, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } | null }>, organizationSpecific: Array<{ __typename?: 'Tag', _id: any, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, tagGroup?: { __typename?: 'TagGroup', _id: any, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } | null }> } | null }> };

export type EventManyAppQueryVariables = Exact<{
  startDate: Scalars['String']['input'];
  endDate: Scalars['String']['input'];
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  operatorId?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<EventStatus>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  skipRecurrences?: InputMaybe<Scalars['Boolean']['input']>;
  keepEventsWithNoFutureOccurrences?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type EventManyAppQuery = { __typename?: 'Query', eventMany: Array<{ __typename?: 'EventWithOccurrences', _id: any, type: EnumEventType, startDate: string, endDate?: string | null, occurrences?: Array<string | null> | null, updatedDateISO?: any | null, title: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, schedules: Array<{ __typename?: 'EventSchedules', allDay: boolean, timeSlots?: Array<{ __typename?: 'EventSchedulesTimeSlots', from?: string | null, to?: string | null, endsNextDay?: boolean | null, note?: string | null } | null> | null } | null>, recurrencePattern: { __typename?: 'EventRecurrencePattern', frequency: EnumEventRecurrencePatternFrequency, interval?: number | null, multiDates?: Array<string | null> | null, daysOfWeek?: Array<EnumEventRecurrencePatternDaysOfWeek | null> | null, dateOfMonth?: number | null, dayOfMonth?: EnumEventRecurrencePatternDayOfMonth | null, dayOfMonthOccurrence?: number | null, monthAndDateOfYear?: string | null, endDate?: string | null, skipDates?: Array<string | null> | null }, images: Array<{ __typename?: 'AssetImage', _id: string, blurhash: string, qualityScore?: ImageQualityRating | null, width: number, height: number, caption: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, detectedObjects?: { __typename?: 'DetectedObjects', hasText?: boolean | null, hasFace?: boolean | null } | null }>, access: { __typename?: 'EventAccess', operator?: { __typename?: 'EventAccessOperator', _entityId: any } | null, organizations: Array<{ __typename?: 'EventAccessOperator', _entityId: any, status?: EnumEventAccessOperatorStatus | null } | null> } }> };

export type InventoryByProductBookedDatesQueryVariables = Exact<{
  productId: Scalars['ID']['input'];
}>;


export type InventoryByProductBookedDatesQuery = { __typename?: 'Query', inventoryDatesByProduct?: { __typename?: 'InventoryBookedDatesSummary', bookedDatesISO: Array<string>, checkOutOnlyDatesISO: Array<string> } | null };

export type ListByIdQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type ListByIdQuery = { __typename?: 'Query', listById: { __typename?: 'ListWithEntities', _id: any, type: EnumListType, selections: any, archived: boolean, favorited: boolean, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, description: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, entities?: Array<{ __typename?: 'OperatorWithStatus', _entityId: any, _versionId: any, status?: PublicationStatusType | null, type: EnumOperatorType, iasc?: number | null, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, images: Array<{ __typename?: 'AssetImage', _id: string, blurhash: string, qualityScore?: ImageQualityRating | null, width: number, height: number, caption: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, detectedObjects?: { __typename?: 'DetectedObjects', hasText?: boolean | null, hasFace?: boolean | null } | null }> }> | null } };

export type ListManyQueryVariables = Exact<{
  filter?: InputMaybe<FilterFindManyListInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyListInput>;
}>;


export type ListManyQuery = { __typename?: 'Query', listMany: Array<{ __typename?: 'List', _id: any, type: EnumListType, updatedDateISO?: any | null, archived: boolean, favorited: boolean, description: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, owner: { __typename?: 'Owner', entityId: any, type: EnumOwnerType }, entityReferences: Array<{ __typename?: 'VersionedEntityReference', _entityId: any, _versionId: any, type: EnumVersionedEntityReferenceType } | null> }> };

export type MaintenanceFindOneQueryVariables = Exact<{ [key: string]: never; }>;


export type MaintenanceFindOneQuery = { __typename?: 'Query', maintenanceFindOne?: { __typename?: 'Maintenance', banner: { __typename?: 'MaintenanceDoorstop', isLive: boolean, message: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } }, doorstop: { __typename?: 'MaintenanceDoorstop', isLive: boolean, message: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } } | null };

export type NoteManyQueryVariables = Exact<{
  filter?: InputMaybe<FilterFindManyNoteInput>;
  sort?: InputMaybe<SortFindManyNoteInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type NoteManyQuery = { __typename?: 'Query', noteMany: Array<{ __typename?: 'Note', _id: any, message: string, updatedDateISO?: any | null, author?: { __typename?: 'UserWithPictureTC', _id: any, firstName: string, lastName: string, email: string } | null, entity: { __typename?: 'EntityReference', _entityId: any, type: EnumEntityReferenceType }, owner: { __typename?: 'Owner', entityId: any, type: EnumOwnerType }, resolvedBy?: { __typename?: 'UserWithPictureTC', _id: any, firstName: string, lastName: string } | null }> };

export type OperatorByIdQueryVariables = Exact<{
  operatorId: Scalars['ID']['input'];
}>;


export type OperatorByIdQuery = { __typename?: 'Query', operatorById: { __typename?: 'OperatorWithStatus', _entityId: any, _versionId: any, updatedDateISO?: any | null, type: EnumOperatorType, operationalStatus: EnumOperatorOperationalStatus, pricing?: EnumOperatorPricing | null, status?: PublicationStatusType | null, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, images: Array<{ __typename?: 'AssetImage', _id: string, blurhash: string, qualityScore?: ImageQualityRating | null, width: number, height: number, caption: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, detectedObjects?: { __typename?: 'DetectedObjects', hasText?: boolean | null, hasFace?: boolean | null } | null }>, tags?: { __typename?: 'OperatorTags', organizationSpecific: Array<{ __typename?: 'Tag', _id: any, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, tagGroup?: { __typename?: 'TagGroup', _id: any, key: EnumTagGroupKey, type: EnumTagGroupType, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } | null }>, global: Array<{ __typename?: 'Tag', _id: any, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, tagGroup?: { __typename?: 'TagGroup', _id: any, key: EnumTagGroupKey, type: EnumTagGroupType, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } | null }>, businessType: Array<{ __typename?: 'Tag', _id: any, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, tagGroup?: { __typename?: 'TagGroup', _id: any, key: EnumTagGroupKey, type: EnumTagGroupType, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } | null }>, amenity: Array<{ __typename?: 'Tag', _id: any, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, tagGroup?: { __typename?: 'TagGroup', _id: any, key: EnumTagGroupKey, type: EnumTagGroupType, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } | null }> } | null, description?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null, shortDescription?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null, contact: { __typename?: 'Contact', email?: string | null, phone?: string | null, tollFreePublicPhone?: string | null, address?: { __typename?: 'Address', line1?: string | null, line2?: string | null, city?: string | null, subdivision?: string | null, postalCode?: string | null, country?: string | null, location?: { __typename?: 'AddressLocation', type: EnumAddressLocationType, coordinates: Array<number | null> } | null } | null, links?: { __typename?: 'Links', bookNow?: string | null, facebook?: string | null, googleMyBusiness?: string | null, instagram?: string | null, pinterest?: string | null, tiktok?: string | null, tripAdvisor?: string | null, website?: string | null, x?: string | null, youtube?: string | null } | null }, seasonality?: { __typename?: 'Seasonality', jan?: SeasonalityEnum | null, feb?: SeasonalityEnum | null, mar?: SeasonalityEnum | null, apr?: SeasonalityEnum | null, may?: SeasonalityEnum | null, jun?: SeasonalityEnum | null, jul?: SeasonalityEnum | null, aug?: SeasonalityEnum | null, sep?: SeasonalityEnum | null, oct?: SeasonalityEnum | null, nov?: SeasonalityEnum | null, dec?: SeasonalityEnum | null } | null, hoursOfOperation?: { __typename?: 'OperatorHoursOfOperation', sun?: { __typename?: 'DateRangeISO', start: string, end: string } | null, mon?: { __typename?: 'DateRangeISO', start: string, end: string } | null, tue?: { __typename?: 'DateRangeISO', start: string, end: string } | null, wed?: { __typename?: 'DateRangeISO', start: string, end: string } | null, thu?: { __typename?: 'DateRangeISO', start: string, end: string } | null, fri?: { __typename?: 'DateRangeISO', start: string, end: string } | null, sat?: { __typename?: 'DateRangeISO', start: string, end: string } | null } | null, enrollments: Array<{ __typename?: 'OperatorEnrollments', organization: any, organizationControlled: boolean, onboardingStatus: EnumOperatorEnrollmentsOnboardingStatus } | null> } };

export type OperatorNameByIdQueryVariables = Exact<{
  operatorEntityId: Scalars['ID']['input'];
}>;


export type OperatorNameByIdQuery = { __typename?: 'Query', operatorById: { __typename?: 'OperatorWithStatus', name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } };

export type OperatorStaffQueryVariables = Exact<{
  operatorId: Scalars['ID']['input'];
}>;


export type OperatorStaffQuery = { __typename?: 'Query', operatorStaff: Array<{ __typename?: 'UserWithPictureTC', email: string, _id: any, firstName: string, lastName: string, picture?: string | null, status: EnumUserStatus, access: { __typename?: 'UserAccess', operators: Array<{ __typename?: 'UserAccessOperators', entityId: any, role: EnumUserAccessOperatorsRole, status: EnumUserAccessOperatorsStatus } | null>, organizations: Array<{ __typename?: 'UserAccessOperators', entityId: any, role: EnumUserAccessOperatorsRole, status: EnumUserAccessOperatorsStatus } | null> }, onboardingMetadata?: { __typename?: 'UserOnboardingMetadata', onboardingOrganization?: any | null, isPostOnboarding?: boolean | null } | null }> };

export type OperatorsByIdsQueryVariables = Exact<{
  operatorEntityIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  status?: InputMaybe<PublicationStatusType>;
}>;


export type OperatorsByIdsQuery = { __typename?: 'Query', operatorsByIds: Array<{ __typename?: 'OperatorWithStatusAndStaff', _entityId: any, _versionId: any, pricing?: EnumOperatorPricing | null, type: EnumOperatorType, status?: PublicationStatusType | null, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, description?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null, staff: Array<{ __typename?: 'User', email: string, firstName: string, lastName: string }>, contact: { __typename?: 'Contact', phone?: string | null, email?: string | null, address?: { __typename?: 'Address', line1?: string | null, line2?: string | null, city?: string | null, subdivision?: string | null, postalCode?: string | null, country?: string | null } | null, links?: { __typename?: 'Links', website?: string | null } | null }, tags?: { __typename?: 'OperatorTags', organizationSpecific: Array<{ __typename?: 'Tag', _id: any, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, tagGroup?: { __typename?: 'TagGroup', _id: any, key: EnumTagGroupKey, type: EnumTagGroupType, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } | null }> } | null } | null> };

export type OperatorsByIdsEventCreationQueryVariables = Exact<{
  operatorEntityIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  status?: InputMaybe<PublicationStatusType>;
}>;


export type OperatorsByIdsEventCreationQuery = { __typename?: 'Query', operatorsByIds: Array<{ __typename?: 'OperatorWithStatusAndStaff', _entityId: any, _versionId: any, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, enrollments: Array<{ __typename?: 'OperatorEnrollments', onboardingStatus: EnumOperatorEnrollmentsOnboardingStatus, organization: any, organizationControlled: boolean } | null>, contact: { __typename?: 'Contact', email?: string | null, phone?: string | null, links?: { __typename?: 'Links', website?: string | null, instagram?: string | null, x?: string | null, bookNow?: string | null, youtube?: string | null, pinterest?: string | null, googleMyBusiness?: string | null, tiktok?: string | null, facebook?: string | null, tripAdvisor?: string | null } | null, address?: { __typename?: 'Address', line1?: string | null, line2?: string | null, city?: string | null, subdivision?: string | null, postalCode?: string | null, country?: string | null, location?: { __typename?: 'AddressLocation', type: EnumAddressLocationType, coordinates: Array<number | null> } | null } | null } } | null> };

export type OperatorsByUserQueryVariables = Exact<{ [key: string]: never; }>;


export type OperatorsByUserQuery = { __typename?: 'Query', operatorsByUser: Array<{ __typename?: 'Operator', _id: any, _entityId: any, _versionId: any, claimed: boolean, contact: { __typename?: 'Contact', address?: { __typename?: 'Address', line1?: string | null, line2?: string | null, city?: string | null, subdivision?: string | null, postalCode?: string | null, country?: string | null, location?: { __typename?: 'AddressLocation', type: EnumAddressLocationType, coordinates: Array<number | null> } | null } | null }, enrollments: Array<{ __typename?: 'OperatorEnrollments', organization: any, organizationControlled: boolean, onboardingStatus: EnumOperatorEnrollmentsOnboardingStatus } | null>, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, images: Array<{ __typename?: 'AssetImage', _id: string, blurhash: string, qualityScore?: ImageQualityRating | null, width: number, height: number, caption: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, detectedObjects?: { __typename?: 'DetectedObjects', hasText?: boolean | null, hasFace?: boolean | null } | null }> }> };

export type OperatorManyQueryVariables = Exact<{
  filter?: InputMaybe<FilterFindManyOperatorInput>;
  avgImageQuality?: InputMaybe<Array<ImageQualityRating> | ImageQualityRating>;
  publicationStatus?: InputMaybe<PublicationStatusType>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useCase?: InputMaybe<OperatorManyUseCaseEnum>;
  imageCount?: InputMaybe<NumberInput>;
  includeInvitedOrAcceptedStaffCounts?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type OperatorManyQuery = { __typename?: 'Query', operatorMany: Array<{ __typename?: 'OperatorWithStatus', _entityId: any, _versionId: any, updatedDateISO?: any | null, claimed: boolean, type: EnumOperatorType, status?: PublicationStatusType | null, iasc?: number | null, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, images: Array<{ __typename?: 'AssetImage', _id: string, blurhash: string, qualityScore?: ImageQualityRating | null, width: number, height: number, caption: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, detectedObjects?: { __typename?: 'DetectedObjects', hasText?: boolean | null, hasFace?: boolean | null } | null }>, enrollments: Array<{ __typename?: 'OperatorEnrollments', onboardingStatus: EnumOperatorEnrollmentsOnboardingStatus, organization: any, organizationControlled: boolean } | null>, contact: { __typename?: 'Contact', email?: string | null, address?: { __typename?: 'Address', line1?: string | null, line2?: string | null, city?: string | null, subdivision?: string | null, postalCode?: string | null, country?: string | null, location?: { __typename?: 'AddressLocation', type: EnumAddressLocationType, coordinates: Array<number | null> } | null } | null } }> };

export type OperatorsManyEventCreationQueryVariables = Exact<{
  filter?: InputMaybe<FilterFindManyOperatorInput>;
  avgImageQuality?: InputMaybe<Array<ImageQualityRating> | ImageQualityRating>;
  publicationStatus?: InputMaybe<PublicationStatusType>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useCase?: InputMaybe<OperatorManyUseCaseEnum>;
  imageCount?: InputMaybe<NumberInput>;
  includeInvitedOrAcceptedStaffCounts?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type OperatorsManyEventCreationQuery = { __typename?: 'Query', operatorMany: Array<{ __typename?: 'OperatorWithStatus', _entityId: any, _versionId: any, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, enrollments: Array<{ __typename?: 'OperatorEnrollments', onboardingStatus: EnumOperatorEnrollmentsOnboardingStatus, organization: any, organizationControlled: boolean } | null>, contact: { __typename?: 'Contact', email?: string | null, phone?: string | null, links?: { __typename?: 'Links', website?: string | null, instagram?: string | null, x?: string | null, bookNow?: string | null, youtube?: string | null, pinterest?: string | null, googleMyBusiness?: string | null, tiktok?: string | null, facebook?: string | null, tripAdvisor?: string | null } | null, address?: { __typename?: 'Address', line1?: string | null, line2?: string | null, city?: string | null, subdivision?: string | null, postalCode?: string | null, country?: string | null, location?: { __typename?: 'AddressLocation', type: EnumAddressLocationType, coordinates: Array<number | null> } | null } | null } }> };

export type OrganizationByIdQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type OrganizationByIdQuery = { __typename?: 'Query', organizationById?: { __typename?: 'Organization', _id: any, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, description: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, shortDescription: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, contact?: { __typename?: 'Contact', email?: string | null, phone?: string | null, tollFreePublicPhone?: string | null, address?: { __typename?: 'Address', line1?: string | null, line2?: string | null, city?: string | null, subdivision?: string | null, postalCode?: string | null, country?: string | null, location?: { __typename?: 'AddressLocation', type: EnumAddressLocationType, coordinates: Array<number | null> } | null } | null, links?: { __typename?: 'Links', bookNow?: string | null, facebook?: string | null, googleMyBusiness?: string | null, instagram?: string | null, pinterest?: string | null, tiktok?: string | null, tripAdvisor?: string | null, website?: string | null, x?: string | null, youtube?: string | null } | null } | null, logo?: { __typename?: 'AssetImage', _id: string, blurhash: string, qualityScore?: ImageQualityRating | null, width: number, height: number, caption: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, detectedObjects?: { __typename?: 'DetectedObjects', hasText?: boolean | null, hasFace?: boolean | null } | null } | null, images: Array<{ __typename?: 'AssetImage', _id: string, blurhash: string, qualityScore?: ImageQualityRating | null, width: number, height: number, caption: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, detectedObjects?: { __typename?: 'DetectedObjects', hasText?: boolean | null, hasFace?: boolean | null } | null }>, onboardingMetadata: { __typename?: 'OrganizationOnboardingMetadata', videoId?: string | null, introMessage?: string | null, allowColdSignup?: boolean | null } } | null };

export type OrganizationLogoByIdQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type OrganizationLogoByIdQuery = { __typename?: 'Query', organizationById?: { __typename?: 'Organization', logo?: { __typename?: 'AssetImage', _id: string, blurhash: string, qualityScore?: ImageQualityRating | null, width: number, height: number, caption: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, detectedObjects?: { __typename?: 'DetectedObjects', hasText?: boolean | null, hasFace?: boolean | null } | null } | null } | null };

export type OrganizationNameByIdQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type OrganizationNameByIdQuery = { __typename?: 'Query', organizationById?: { __typename?: 'Organization', _id: any, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } | null };

export type OrganizationStaffQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
}>;


export type OrganizationStaffQuery = { __typename?: 'Query', organizationStaff: Array<{ __typename?: 'UserWithPictureTC', email: string, _id: any, firstName: string, lastName: string, picture?: string | null, status: EnumUserStatus, access: { __typename?: 'UserAccess', operators: Array<{ __typename?: 'UserAccessOperators', entityId: any, role: EnumUserAccessOperatorsRole, status: EnumUserAccessOperatorsStatus } | null>, organizations: Array<{ __typename?: 'UserAccessOperators', entityId: any, role: EnumUserAccessOperatorsRole, status: EnumUserAccessOperatorsStatus } | null> }, onboardingMetadata?: { __typename?: 'UserOnboardingMetadata', onboardingOrganization?: any | null, isPostOnboarding?: boolean | null } | null }> };

export type OrganizationsByIdsQueryVariables = Exact<{
  ids: Array<Scalars['MongoID']['input']> | Scalars['MongoID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsOrganizationInput>;
}>;


export type OrganizationsByIdsQuery = { __typename?: 'Query', organizationsByIds: Array<{ __typename?: 'Organization', _id: any, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, logo?: { __typename?: 'AssetImage', _id: string, blurhash: string, qualityScore?: ImageQualityRating | null, width: number, height: number, caption: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, detectedObjects?: { __typename?: 'DetectedObjects', hasText?: boolean | null, hasFace?: boolean | null } | null } | null, contact?: { __typename?: 'Contact', email?: string | null, phone?: string | null, links?: { __typename?: 'Links', website?: string | null } | null } | null }> };

export type OrganizationsByUserQueryVariables = Exact<{ [key: string]: never; }>;


export type OrganizationsByUserQuery = { __typename?: 'Query', organizationsByUser: Array<{ __typename?: 'Organization', _id: any, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, logo?: { __typename?: 'AssetImage', _id: string, blurhash: string, qualityScore?: ImageQualityRating | null, width: number, height: number, caption: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, detectedObjects?: { __typename?: 'DetectedObjects', hasText?: boolean | null, hasFace?: boolean | null } | null } | null, contact?: { __typename?: 'Contact', links?: { __typename?: 'Links', website?: string | null } | null } | null, metadata?: { __typename?: 'OrganizationMetadata', inviteWhenAddingStaff?: boolean | null } | null }> };

export type TagGroupOneQueryVariables = Exact<{
  filter?: InputMaybe<FilterFindOneTagGroupInput>;
}>;


export type TagGroupOneQuery = { __typename?: 'Query', tagGroupOne?: { __typename?: 'TagGroup', _id: any, key: EnumTagGroupKey, type: EnumTagGroupType, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } | null };

export type TagGroupByIdsQueryVariables = Exact<{
  ids: Array<Scalars['MongoID']['input']> | Scalars['MongoID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type TagGroupByIdsQuery = { __typename?: 'Query', tagGroupByIds: Array<{ __typename?: 'TagGroup', _id: any, key: EnumTagGroupKey, type: EnumTagGroupType, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } }> };

export type TagManyQueryVariables = Exact<{
  filter?: InputMaybe<FilterFindManyTagInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type TagManyQuery = { __typename?: 'Query', tagMany: Array<{ __typename?: 'Tag', _id: any, entityTypes: Array<EnumTagEntityTypes | null>, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, owner?: { __typename?: 'Owner', entityId: any, type: EnumOwnerType } | null, tagGroup?: { __typename?: 'TagGroup', _id: any, key: EnumTagGroupKey, type: EnumTagGroupType, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } | null }> };

export type TagByIdsQueryVariables = Exact<{
  ids: Array<Scalars['MongoID']['input']> | Scalars['MongoID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type TagByIdsQuery = { __typename?: 'Query', tagByIds: Array<{ __typename?: 'Tag', _id: any, entityTypes: Array<EnumTagEntityTypes | null>, owner?: { __typename?: 'Owner', entityId: any, type: EnumOwnerType } | null, tagGroup?: { __typename?: 'TagGroup', _id: any, key: EnumTagGroupKey, type: EnumTagGroupType, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } | null, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } }> };

export type UserByIdQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type UserByIdQuery = { __typename?: 'Query', userById?: { __typename?: 'UserWithPictureTC', _id: any, firstName: string, lastName: string, email: string, picture?: string | null, status: EnumUserStatus, access: { __typename?: 'UserAccess', operators: Array<{ __typename?: 'UserAccessOperators', entityId: any, role: EnumUserAccessOperatorsRole, status: EnumUserAccessOperatorsStatus } | null>, organizations: Array<{ __typename?: 'UserAccessOperators', entityId: any, role: EnumUserAccessOperatorsRole, status: EnumUserAccessOperatorsStatus } | null> }, onboardingMetadata?: { __typename?: 'UserOnboardingMetadata', onboardingOrganization?: any | null, isPostOnboarding?: boolean | null } | null } | null };

export type UserFindOneQueryVariables = Exact<{
  filter?: InputMaybe<FilterFindOneUserInput>;
}>;


export type UserFindOneQuery = { __typename?: 'Query', userFindOne?: { __typename?: 'UserWithPictureTC', _id: any, firstName: string, lastName: string, email: string, picture?: string | null, status: EnumUserStatus, access: { __typename?: 'UserAccess', operators: Array<{ __typename?: 'UserAccessOperators', entityId: any, role: EnumUserAccessOperatorsRole, status: EnumUserAccessOperatorsStatus } | null>, organizations: Array<{ __typename?: 'UserAccessOperators', entityId: any, role: EnumUserAccessOperatorsRole, status: EnumUserAccessOperatorsStatus } | null> }, onboardingMetadata?: { __typename?: 'UserOnboardingMetadata', onboardingOrganization?: any | null, isPostOnboarding?: boolean | null } | null } | null };

export type UserFindOneByEmailQueryVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type UserFindOneByEmailQuery = { __typename?: 'Query', userFindOneByEmail?: { __typename?: 'UserWithResetPasswordUrlTC', _id: any, email: string, firstName: string, lastName: string, passwordResetUrl?: string | null, status: EnumUserStatus, access: { __typename?: 'UserAccess', operators: Array<{ __typename?: 'UserAccessOperators', entityId: any, status: EnumUserAccessOperatorsStatus } | null>, organizations: Array<{ __typename?: 'UserAccessOperators', entityId: any, status: EnumUserAccessOperatorsStatus } | null> } } | null };

export type UserRequestEmailVerificationQueryVariables = Exact<{ [key: string]: never; }>;


export type UserRequestEmailVerificationQuery = { __typename?: 'Query', userRequestEmailVerification?: string | null };

export type WidgetByIdQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type WidgetByIdQuery = { __typename?: 'Query', widgetById: { __typename?: 'WidgetWithListEntities', _id: any, type: EnumWidgetType, archived: boolean, favorited: boolean, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, description: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, filterableTags: Array<{ __typename?: 'Tag', _id: any, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } }>, list: { __typename?: 'ListWithEntitiesAndOverrides', _id: any, type: EnumListType, selections: any, archived: boolean, favorited: boolean, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, description: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, entities: Array<{ __typename?: 'OperatorWithOverrides', _entityId: any, _versionId: any, status?: PublicationStatusType | null, type: EnumOperatorType, description?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null, shortDescription?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, images: Array<{ __typename?: 'AssetImage', _id: string, blurhash: string, qualityScore?: ImageQualityRating | null, width: number, height: number, caption: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, detectedObjects?: { __typename?: 'DetectedObjects', hasText?: boolean | null, hasFace?: boolean | null } | null }>, tags?: { __typename?: 'OperatorTags', businessType: Array<{ __typename?: 'Tag', _id: any, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, tagGroup?: { __typename?: 'TagGroup', _id: any, key: EnumTagGroupKey, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } | null }>, global: Array<{ __typename?: 'Tag', _id: any, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, tagGroup?: { __typename?: 'TagGroup', _id: any, key: EnumTagGroupKey, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } | null }>, organizationSpecific: Array<{ __typename?: 'Tag', _id: any, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, tagGroup?: { __typename?: 'TagGroup', _id: any, key: EnumTagGroupKey, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } | null }>, amenity: Array<{ __typename?: 'Tag', _id: any, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, tagGroup?: { __typename?: 'TagGroup', _id: any, key: EnumTagGroupKey, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } | null }> } | null, overrides?: { __typename?: 'OverrideDetails', description?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null, shortDescription?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null, images: Array<{ __typename?: 'AssetImage', _id: string, blurhash: string, qualityScore?: ImageQualityRating | null, width: number, height: number, caption: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, detectedObjects?: { __typename?: 'DetectedObjects', hasText?: boolean | null, hasFace?: boolean | null } | null }> } | null }> }, eventSettings?: { __typename?: 'WidgetEventSettings', displayType: EnumWidgetEventSettingsDisplayType, eventTags: Array<any | null>, lookAheadMonths?: number | null } | null, owner: { __typename?: 'Owner', entityId: any } } };

export type WidgetByIdWithEntitiesQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type WidgetByIdWithEntitiesQuery = { __typename?: 'Query', widgetById: { __typename?: 'WidgetWithListEntities', _id: any, type: EnumWidgetType, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, filterableTags: Array<{ __typename?: 'Tag', _id: any, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } }>, list: { __typename?: 'ListWithEntitiesAndOverrides', entities: Array<{ __typename?: 'OperatorWithOverrides', _entityId: any, status?: PublicationStatusType | null, pricing?: EnumOperatorPricing | null, images: Array<{ __typename?: 'AssetImage', _id: string, blurhash: string, qualityScore?: ImageQualityRating | null, width: number, height: number, caption: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, detectedObjects?: { __typename?: 'DetectedObjects', hasText?: boolean | null, hasFace?: boolean | null } | null }>, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, shortDescription?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null, description?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null, contact: { __typename?: 'Contact', phone?: string | null, email?: string | null, links?: { __typename?: 'Links', website?: string | null, bookNow?: string | null } | null, address?: { __typename?: 'Address', line1?: string | null, line2?: string | null, city?: string | null, subdivision?: string | null, postalCode?: string | null, country?: string | null, location?: { __typename?: 'AddressLocation', type: EnumAddressLocationType, coordinates: Array<number | null> } | null } | null }, hoursOfOperation?: { __typename?: 'OperatorHoursOfOperation', mon?: { __typename?: 'DateRangeISO', _id: any, start: string, end: string } | null, tue?: { __typename?: 'DateRangeISO', _id: any, start: string, end: string } | null, wed?: { __typename?: 'DateRangeISO', _id: any, start: string, end: string } | null, thu?: { __typename?: 'DateRangeISO', _id: any, start: string, end: string } | null, fri?: { __typename?: 'DateRangeISO', _id: any, start: string, end: string } | null, sat?: { __typename?: 'DateRangeISO', _id: any, start: string, end: string } | null, sun?: { __typename?: 'DateRangeISO', _id: any, start: string, end: string } | null } | null, tags?: { __typename?: 'OperatorTags', businessType: Array<{ __typename?: 'Tag', _id: any }>, global: Array<{ __typename?: 'Tag', _id: any }>, organizationSpecific: Array<{ __typename?: 'Tag', _id: any }>, amenity: Array<{ __typename?: 'Tag', _id: any }> } | null, overrides?: { __typename?: 'OverrideDetails', description?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null, shortDescription?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null, images: Array<{ __typename?: 'AssetImage', _id: string, blurhash: string, qualityScore?: ImageQualityRating | null, width: number, height: number, caption: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, detectedObjects?: { __typename?: 'DetectedObjects', hasText?: boolean | null, hasFace?: boolean | null } | null }> } | null }> }, eventSettings?: { __typename?: 'WidgetEventSettings', displayType: EnumWidgetEventSettingsDisplayType, eventTags: Array<any | null>, lookAheadMonths?: number | null } | null } };

export type WidgetManyQueryVariables = Exact<{
  filter?: InputMaybe<FilterFindManyWidgetInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyWidgetInput>;
}>;


export type WidgetManyQuery = { __typename?: 'Query', widgetMany: Array<{ __typename?: 'WidgetWithListAndItemCount', _id: any, type: EnumWidgetType, itemCount?: number | null, archived: boolean, favorited: boolean, updatedDateISO?: any | null, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, owner: { __typename?: 'Owner', entityId: any, type: EnumOwnerType }, list?: { __typename?: 'ListWithEntities', _id: any, entityReferences: Array<{ __typename?: 'VersionedEntityReference', _entityId: any, type: EnumVersionedEntityReferenceType } | null>, externallyAvailableEntityReferences: Array<{ __typename?: 'VersionedEntityReference', _entityId: any, type: EnumVersionedEntityReferenceType } | null> } | null, eventSettings?: { __typename?: 'WidgetEventSettings', displayType: EnumWidgetEventSettingsDisplayType, lookAheadMonths?: number | null, eventTags: Array<any | null> } | null }> };

export const MultilingualFragmentFragmentDoc = gql`
    fragment MultilingualFragment on Multilingual {
  en
  es
  fr
}
    `;
export const ContactFragmentFragmentDoc = gql`
    fragment ContactFragment on Contact {
  address {
    line1
    line2
    city
    subdivision
    postalCode
    country
    location {
      type
      coordinates
    }
  }
  email
  links {
    bookNow
    facebook
    googleMyBusiness
    instagram
    pinterest
    tiktok
    tripAdvisor
    website
    x
    youtube
  }
  phone
  tollFreePublicPhone
}
    `;
export const EventLocationFragmentFragmentDoc = gql`
    fragment EventLocationFragment on EventEventLocation {
  venue {
    ...MultilingualFragment
  }
  contact {
    ...ContactFragment
  }
  locationInfo {
    _entityId
    type
  }
}
    ${MultilingualFragmentFragmentDoc}
${ContactFragmentFragmentDoc}`;
export const ImageFragmentFragmentDoc = gql`
    fragment ImageFragment on AssetImage {
  _id
  blurhash
  caption {
    ...MultilingualFragment
  }
  qualityScore
  width
  height
  detectedObjects {
    hasText
    hasFace
  }
}
    ${MultilingualFragmentFragmentDoc}`;
export const EventDetailsFragmentFragmentDoc = gql`
    fragment EventDetailsFragment on Event {
  _id
  createdByEmail
  locationType
  title {
    ...MultilingualFragment
  }
  description {
    ...MultilingualFragment
  }
  price
  ticketUrl
  tags {
    global {
      _id
      name {
        ...MultilingualFragment
      }
      tagGroup {
        _id
        name {
          ...MultilingualFragment
        }
      }
    }
    organizationSpecific {
      _id
      name {
        ...MultilingualFragment
      }
      tagGroup {
        _id
        name {
          ...MultilingualFragment
        }
      }
    }
  }
  venue {
    ...MultilingualFragment
  }
  contact {
    ...ContactFragment
  }
  eventLocation {
    ...EventLocationFragment
  }
  otherLocations {
    ...EventLocationFragment
  }
  images {
    ...ImageFragment
  }
  type
  startDate
  endDate
  schedules {
    allDay
    timeSlots {
      _id
      from
      to
      endsNextDay
      note
    }
  }
  recurrencePattern {
    frequency
    interval
    daysOfWeek
    dateOfMonth
    dayOfMonth
    dayOfMonthOccurrence
    monthAndDateOfYear
    multiDates
    skipDates
    endDate
  }
  access {
    operator {
      _entityId
    }
    organizations {
      _entityId
      status
    }
  }
  createdByEmail
  updatedDateISO
}
    ${MultilingualFragmentFragmentDoc}
${ContactFragmentFragmentDoc}
${EventLocationFragmentFragmentDoc}
${ImageFragmentFragmentDoc}`;
export const NoteFramgmentFragmentDoc = gql`
    fragment NoteFramgment on Note {
  _id
  author {
    _id
    firstName
    lastName
    email
  }
  entity {
    _entityId
    type
  }
  message
  owner {
    entityId
    type
  }
  resolvedBy {
    _id
    firstName
    lastName
  }
  updatedDateISO
}
    `;
export const UserFragmentFragmentDoc = gql`
    fragment UserFragment on UserWithPictureTC {
  _id
  firstName
  lastName
  email
  access {
    operators {
      entityId
      role
      status
    }
    organizations {
      entityId
      role
      status
    }
  }
  picture
  status
  onboardingMetadata {
    onboardingOrganization
    isPostOnboarding
  }
}
    `;
export const OrderCreateDocument = gql`
    mutation OrderCreate($source: OrderSourceInput!, $customer: CustomerInput!, $guests: [OrderGuestsInput]!, $paymentMethodId: String!, $productPurchaseRequests: [ProductPurchaseRequest]!, $promoCode: String) {
  orderCreate(
    source: $source
    customer: $customer
    guests: $guests
    paymentMethodId: $paymentMethodId
    productPurchaseRequests: $productPurchaseRequests
    promoCode: $promoCode
  ) {
    record {
      _id
    }
  }
}
    `;
export type OrderCreateMutationFn = Apollo.MutationFunction<OrderCreateMutation, OrderCreateMutationVariables>;

/**
 * __useOrderCreateMutation__
 *
 * To run a mutation, you first call `useOrderCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrderCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [orderCreateMutation, { data, loading, error }] = useOrderCreateMutation({
 *   variables: {
 *      source: // value for 'source'
 *      customer: // value for 'customer'
 *      guests: // value for 'guests'
 *      paymentMethodId: // value for 'paymentMethodId'
 *      productPurchaseRequests: // value for 'productPurchaseRequests'
 *      promoCode: // value for 'promoCode'
 *   },
 * });
 */
export function useOrderCreateMutation(baseOptions?: Apollo.MutationHookOptions<OrderCreateMutation, OrderCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OrderCreateMutation, OrderCreateMutationVariables>(OrderCreateDocument, options);
      }
export type OrderCreateMutationHookResult = ReturnType<typeof useOrderCreateMutation>;
export type OrderCreateMutationResult = Apollo.MutationResult<OrderCreateMutation>;
export type OrderCreateMutationOptions = Apollo.BaseMutationOptions<OrderCreateMutation, OrderCreateMutationVariables>;
export const CreatePublicationStatusDocument = gql`
    mutation CreatePublicationStatus($record: CreateOnePublicationStatusInput!) {
  createPublicationStatus(record: $record) {
    record {
      _id
      status
      entity {
        _entityId
        _versionId
        type
      }
    }
  }
}
    `;
export type CreatePublicationStatusMutationFn = Apollo.MutationFunction<CreatePublicationStatusMutation, CreatePublicationStatusMutationVariables>;

/**
 * __useCreatePublicationStatusMutation__
 *
 * To run a mutation, you first call `useCreatePublicationStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePublicationStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPublicationStatusMutation, { data, loading, error }] = useCreatePublicationStatusMutation({
 *   variables: {
 *      record: // value for 'record'
 *   },
 * });
 */
export function useCreatePublicationStatusMutation(baseOptions?: Apollo.MutationHookOptions<CreatePublicationStatusMutation, CreatePublicationStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePublicationStatusMutation, CreatePublicationStatusMutationVariables>(CreatePublicationStatusDocument, options);
      }
export type CreatePublicationStatusMutationHookResult = ReturnType<typeof useCreatePublicationStatusMutation>;
export type CreatePublicationStatusMutationResult = Apollo.MutationResult<CreatePublicationStatusMutation>;
export type CreatePublicationStatusMutationOptions = Apollo.BaseMutationOptions<CreatePublicationStatusMutation, CreatePublicationStatusMutationVariables>;
export const DiscountValidatePromocodeDocument = gql`
    mutation DiscountValidatePromocode($promoCode: String!, $storefrontId: ID!) {
  discountValidatePromocode(promoCode: $promoCode, storefrontId: $storefrontId) {
    promoCode
  }
}
    `;
export type DiscountValidatePromocodeMutationFn = Apollo.MutationFunction<DiscountValidatePromocodeMutation, DiscountValidatePromocodeMutationVariables>;

/**
 * __useDiscountValidatePromocodeMutation__
 *
 * To run a mutation, you first call `useDiscountValidatePromocodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDiscountValidatePromocodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [discountValidatePromocodeMutation, { data, loading, error }] = useDiscountValidatePromocodeMutation({
 *   variables: {
 *      promoCode: // value for 'promoCode'
 *      storefrontId: // value for 'storefrontId'
 *   },
 * });
 */
export function useDiscountValidatePromocodeMutation(baseOptions?: Apollo.MutationHookOptions<DiscountValidatePromocodeMutation, DiscountValidatePromocodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DiscountValidatePromocodeMutation, DiscountValidatePromocodeMutationVariables>(DiscountValidatePromocodeDocument, options);
      }
export type DiscountValidatePromocodeMutationHookResult = ReturnType<typeof useDiscountValidatePromocodeMutation>;
export type DiscountValidatePromocodeMutationResult = Apollo.MutationResult<DiscountValidatePromocodeMutation>;
export type DiscountValidatePromocodeMutationOptions = Apollo.BaseMutationOptions<DiscountValidatePromocodeMutation, DiscountValidatePromocodeMutationVariables>;
export const EventCreateDocument = gql`
    mutation EventCreate($record: CreateOneEventInput!, $skipDefaultVenue: Boolean) {
  eventCreate(record: $record, skipDefaultVenue: $skipDefaultVenue) {
    recordId
    record {
      ...EventDetailsFragment
    }
  }
}
    ${EventDetailsFragmentFragmentDoc}`;
export type EventCreateMutationFn = Apollo.MutationFunction<EventCreateMutation, EventCreateMutationVariables>;

/**
 * __useEventCreateMutation__
 *
 * To run a mutation, you first call `useEventCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEventCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [eventCreateMutation, { data, loading, error }] = useEventCreateMutation({
 *   variables: {
 *      record: // value for 'record'
 *      skipDefaultVenue: // value for 'skipDefaultVenue'
 *   },
 * });
 */
export function useEventCreateMutation(baseOptions?: Apollo.MutationHookOptions<EventCreateMutation, EventCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EventCreateMutation, EventCreateMutationVariables>(EventCreateDocument, options);
      }
export type EventCreateMutationHookResult = ReturnType<typeof useEventCreateMutation>;
export type EventCreateMutationResult = Apollo.MutationResult<EventCreateMutation>;
export type EventCreateMutationOptions = Apollo.BaseMutationOptions<EventCreateMutation, EventCreateMutationVariables>;
export const EventDeleteByIdDocument = gql`
    mutation EventDeleteById($id: MongoID!) {
  eventDeleteById(_id: $id) {
    record {
      _id
    }
  }
}
    `;
export type EventDeleteByIdMutationFn = Apollo.MutationFunction<EventDeleteByIdMutation, EventDeleteByIdMutationVariables>;

/**
 * __useEventDeleteByIdMutation__
 *
 * To run a mutation, you first call `useEventDeleteByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEventDeleteByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [eventDeleteByIdMutation, { data, loading, error }] = useEventDeleteByIdMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEventDeleteByIdMutation(baseOptions?: Apollo.MutationHookOptions<EventDeleteByIdMutation, EventDeleteByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EventDeleteByIdMutation, EventDeleteByIdMutationVariables>(EventDeleteByIdDocument, options);
      }
export type EventDeleteByIdMutationHookResult = ReturnType<typeof useEventDeleteByIdMutation>;
export type EventDeleteByIdMutationResult = Apollo.MutationResult<EventDeleteByIdMutation>;
export type EventDeleteByIdMutationOptions = Apollo.BaseMutationOptions<EventDeleteByIdMutation, EventDeleteByIdMutationVariables>;
export const EventUpdateByIdDocument = gql`
    mutation EventUpdateById($id: MongoID!, $record: UpdateByIdEventInput!, $imagesToKeep: [String], $setStatus: EnumEventAccessOperatorStatus, $isSubmitting: Boolean) {
  eventUpdateById(
    _id: $id
    record: $record
    imagesToKeep: $imagesToKeep
    setStatus: $setStatus
    isSubmitting: $isSubmitting
  ) {
    record {
      ...EventDetailsFragment
    }
  }
}
    ${EventDetailsFragmentFragmentDoc}`;
export type EventUpdateByIdMutationFn = Apollo.MutationFunction<EventUpdateByIdMutation, EventUpdateByIdMutationVariables>;

/**
 * __useEventUpdateByIdMutation__
 *
 * To run a mutation, you first call `useEventUpdateByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEventUpdateByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [eventUpdateByIdMutation, { data, loading, error }] = useEventUpdateByIdMutation({
 *   variables: {
 *      id: // value for 'id'
 *      record: // value for 'record'
 *      imagesToKeep: // value for 'imagesToKeep'
 *      setStatus: // value for 'setStatus'
 *      isSubmitting: // value for 'isSubmitting'
 *   },
 * });
 */
export function useEventUpdateByIdMutation(baseOptions?: Apollo.MutationHookOptions<EventUpdateByIdMutation, EventUpdateByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EventUpdateByIdMutation, EventUpdateByIdMutationVariables>(EventUpdateByIdDocument, options);
      }
export type EventUpdateByIdMutationHookResult = ReturnType<typeof useEventUpdateByIdMutation>;
export type EventUpdateByIdMutationResult = Apollo.MutationResult<EventUpdateByIdMutation>;
export type EventUpdateByIdMutationOptions = Apollo.BaseMutationOptions<EventUpdateByIdMutation, EventUpdateByIdMutationVariables>;
export const FileCreateOneDocument = gql`
    mutation FileCreateOne($data: JSON!) {
  fileCreateOne(data: $data) {
    _id
    blurhash
    caption {
      ...MultilingualFragment
    }
  }
}
    ${MultilingualFragmentFragmentDoc}`;
export type FileCreateOneMutationFn = Apollo.MutationFunction<FileCreateOneMutation, FileCreateOneMutationVariables>;

/**
 * __useFileCreateOneMutation__
 *
 * To run a mutation, you first call `useFileCreateOneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFileCreateOneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [fileCreateOneMutation, { data, loading, error }] = useFileCreateOneMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useFileCreateOneMutation(baseOptions?: Apollo.MutationHookOptions<FileCreateOneMutation, FileCreateOneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FileCreateOneMutation, FileCreateOneMutationVariables>(FileCreateOneDocument, options);
      }
export type FileCreateOneMutationHookResult = ReturnType<typeof useFileCreateOneMutation>;
export type FileCreateOneMutationResult = Apollo.MutationResult<FileCreateOneMutation>;
export type FileCreateOneMutationOptions = Apollo.BaseMutationOptions<FileCreateOneMutation, FileCreateOneMutationVariables>;
export const FileDeleteFromCloudinaryOnlyDocument = gql`
    mutation FileDeleteFromCloudinaryOnly($cloudinaryPublicId: String!, $resourceType: String!) {
  fileDeleteFromCloudinaryOnly(
    cloudinaryPublicId: $cloudinaryPublicId
    resourceType: $resourceType
  )
}
    `;
export type FileDeleteFromCloudinaryOnlyMutationFn = Apollo.MutationFunction<FileDeleteFromCloudinaryOnlyMutation, FileDeleteFromCloudinaryOnlyMutationVariables>;

/**
 * __useFileDeleteFromCloudinaryOnlyMutation__
 *
 * To run a mutation, you first call `useFileDeleteFromCloudinaryOnlyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFileDeleteFromCloudinaryOnlyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [fileDeleteFromCloudinaryOnlyMutation, { data, loading, error }] = useFileDeleteFromCloudinaryOnlyMutation({
 *   variables: {
 *      cloudinaryPublicId: // value for 'cloudinaryPublicId'
 *      resourceType: // value for 'resourceType'
 *   },
 * });
 */
export function useFileDeleteFromCloudinaryOnlyMutation(baseOptions?: Apollo.MutationHookOptions<FileDeleteFromCloudinaryOnlyMutation, FileDeleteFromCloudinaryOnlyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FileDeleteFromCloudinaryOnlyMutation, FileDeleteFromCloudinaryOnlyMutationVariables>(FileDeleteFromCloudinaryOnlyDocument, options);
      }
export type FileDeleteFromCloudinaryOnlyMutationHookResult = ReturnType<typeof useFileDeleteFromCloudinaryOnlyMutation>;
export type FileDeleteFromCloudinaryOnlyMutationResult = Apollo.MutationResult<FileDeleteFromCloudinaryOnlyMutation>;
export type FileDeleteFromCloudinaryOnlyMutationOptions = Apollo.BaseMutationOptions<FileDeleteFromCloudinaryOnlyMutation, FileDeleteFromCloudinaryOnlyMutationVariables>;
export const FileUpdateDocument = gql`
    mutation FileUpdate($id: String!, $record: UpdateByIdAssetFileInput!) {
  fileUpdate(_id: $id, record: $record) {
    record {
      _id
      caption {
        ...MultilingualFragment
      }
    }
  }
}
    ${MultilingualFragmentFragmentDoc}`;
export type FileUpdateMutationFn = Apollo.MutationFunction<FileUpdateMutation, FileUpdateMutationVariables>;

/**
 * __useFileUpdateMutation__
 *
 * To run a mutation, you first call `useFileUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFileUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [fileUpdateMutation, { data, loading, error }] = useFileUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      record: // value for 'record'
 *   },
 * });
 */
export function useFileUpdateMutation(baseOptions?: Apollo.MutationHookOptions<FileUpdateMutation, FileUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FileUpdateMutation, FileUpdateMutationVariables>(FileUpdateDocument, options);
      }
export type FileUpdateMutationHookResult = ReturnType<typeof useFileUpdateMutation>;
export type FileUpdateMutationResult = Apollo.MutationResult<FileUpdateMutation>;
export type FileUpdateMutationOptions = Apollo.BaseMutationOptions<FileUpdateMutation, FileUpdateMutationVariables>;
export const ImageCreateOneDocument = gql`
    mutation ImageCreateOne($data: JSON!) {
  imageCreateOne(data: $data) {
    _id
    blurhash
    caption {
      ...MultilingualFragment
    }
    qualityScore
  }
}
    ${MultilingualFragmentFragmentDoc}`;
export type ImageCreateOneMutationFn = Apollo.MutationFunction<ImageCreateOneMutation, ImageCreateOneMutationVariables>;

/**
 * __useImageCreateOneMutation__
 *
 * To run a mutation, you first call `useImageCreateOneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImageCreateOneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [imageCreateOneMutation, { data, loading, error }] = useImageCreateOneMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useImageCreateOneMutation(baseOptions?: Apollo.MutationHookOptions<ImageCreateOneMutation, ImageCreateOneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ImageCreateOneMutation, ImageCreateOneMutationVariables>(ImageCreateOneDocument, options);
      }
export type ImageCreateOneMutationHookResult = ReturnType<typeof useImageCreateOneMutation>;
export type ImageCreateOneMutationResult = Apollo.MutationResult<ImageCreateOneMutation>;
export type ImageCreateOneMutationOptions = Apollo.BaseMutationOptions<ImageCreateOneMutation, ImageCreateOneMutationVariables>;
export const ImageDeleteFromCloudinaryOnlyDocument = gql`
    mutation ImageDeleteFromCloudinaryOnly($cloudinaryPublicId: String!, $resourceType: String!) {
  imageDeleteFromCloudinaryOnly(
    cloudinaryPublicId: $cloudinaryPublicId
    resourceType: $resourceType
  )
}
    `;
export type ImageDeleteFromCloudinaryOnlyMutationFn = Apollo.MutationFunction<ImageDeleteFromCloudinaryOnlyMutation, ImageDeleteFromCloudinaryOnlyMutationVariables>;

/**
 * __useImageDeleteFromCloudinaryOnlyMutation__
 *
 * To run a mutation, you first call `useImageDeleteFromCloudinaryOnlyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImageDeleteFromCloudinaryOnlyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [imageDeleteFromCloudinaryOnlyMutation, { data, loading, error }] = useImageDeleteFromCloudinaryOnlyMutation({
 *   variables: {
 *      cloudinaryPublicId: // value for 'cloudinaryPublicId'
 *      resourceType: // value for 'resourceType'
 *   },
 * });
 */
export function useImageDeleteFromCloudinaryOnlyMutation(baseOptions?: Apollo.MutationHookOptions<ImageDeleteFromCloudinaryOnlyMutation, ImageDeleteFromCloudinaryOnlyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ImageDeleteFromCloudinaryOnlyMutation, ImageDeleteFromCloudinaryOnlyMutationVariables>(ImageDeleteFromCloudinaryOnlyDocument, options);
      }
export type ImageDeleteFromCloudinaryOnlyMutationHookResult = ReturnType<typeof useImageDeleteFromCloudinaryOnlyMutation>;
export type ImageDeleteFromCloudinaryOnlyMutationResult = Apollo.MutationResult<ImageDeleteFromCloudinaryOnlyMutation>;
export type ImageDeleteFromCloudinaryOnlyMutationOptions = Apollo.BaseMutationOptions<ImageDeleteFromCloudinaryOnlyMutation, ImageDeleteFromCloudinaryOnlyMutationVariables>;
export const ImageUpdateDocument = gql`
    mutation ImageUpdate($id: String!, $record: UpdateByIdAssetImageInput!) {
  imageUpdate(_id: $id, record: $record) {
    record {
      _id
      caption {
        ...MultilingualFragment
      }
      qualityScore
    }
  }
}
    ${MultilingualFragmentFragmentDoc}`;
export type ImageUpdateMutationFn = Apollo.MutationFunction<ImageUpdateMutation, ImageUpdateMutationVariables>;

/**
 * __useImageUpdateMutation__
 *
 * To run a mutation, you first call `useImageUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImageUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [imageUpdateMutation, { data, loading, error }] = useImageUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      record: // value for 'record'
 *   },
 * });
 */
export function useImageUpdateMutation(baseOptions?: Apollo.MutationHookOptions<ImageUpdateMutation, ImageUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ImageUpdateMutation, ImageUpdateMutationVariables>(ImageUpdateDocument, options);
      }
export type ImageUpdateMutationHookResult = ReturnType<typeof useImageUpdateMutation>;
export type ImageUpdateMutationResult = Apollo.MutationResult<ImageUpdateMutation>;
export type ImageUpdateMutationOptions = Apollo.BaseMutationOptions<ImageUpdateMutation, ImageUpdateMutationVariables>;
export const ListCreateDocument = gql`
    mutation ListCreate($record: CreateOneListInput!) {
  listCreate(record: $record) {
    record {
      _id
      name {
        ...MultilingualFragment
      }
      owner {
        entityId
        type
      }
      selections
      type
      entityReferences {
        _entityId
        _versionId
        type
      }
    }
  }
}
    ${MultilingualFragmentFragmentDoc}`;
export type ListCreateMutationFn = Apollo.MutationFunction<ListCreateMutation, ListCreateMutationVariables>;

/**
 * __useListCreateMutation__
 *
 * To run a mutation, you first call `useListCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useListCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [listCreateMutation, { data, loading, error }] = useListCreateMutation({
 *   variables: {
 *      record: // value for 'record'
 *   },
 * });
 */
export function useListCreateMutation(baseOptions?: Apollo.MutationHookOptions<ListCreateMutation, ListCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ListCreateMutation, ListCreateMutationVariables>(ListCreateDocument, options);
      }
export type ListCreateMutationHookResult = ReturnType<typeof useListCreateMutation>;
export type ListCreateMutationResult = Apollo.MutationResult<ListCreateMutation>;
export type ListCreateMutationOptions = Apollo.BaseMutationOptions<ListCreateMutation, ListCreateMutationVariables>;
export const ListUpdateByIdDocument = gql`
    mutation ListUpdateById($id: MongoID!, $record: UpdateByIdListInput!) {
  listUpdateById(_id: $id, record: $record) {
    _id
    type
    selections
    name {
      ...MultilingualFragment
    }
    description {
      ...MultilingualFragment
    }
    archived
    favorited
  }
}
    ${MultilingualFragmentFragmentDoc}`;
export type ListUpdateByIdMutationFn = Apollo.MutationFunction<ListUpdateByIdMutation, ListUpdateByIdMutationVariables>;

/**
 * __useListUpdateByIdMutation__
 *
 * To run a mutation, you first call `useListUpdateByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useListUpdateByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [listUpdateByIdMutation, { data, loading, error }] = useListUpdateByIdMutation({
 *   variables: {
 *      id: // value for 'id'
 *      record: // value for 'record'
 *   },
 * });
 */
export function useListUpdateByIdMutation(baseOptions?: Apollo.MutationHookOptions<ListUpdateByIdMutation, ListUpdateByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ListUpdateByIdMutation, ListUpdateByIdMutationVariables>(ListUpdateByIdDocument, options);
      }
export type ListUpdateByIdMutationHookResult = ReturnType<typeof useListUpdateByIdMutation>;
export type ListUpdateByIdMutationResult = Apollo.MutationResult<ListUpdateByIdMutation>;
export type ListUpdateByIdMutationOptions = Apollo.BaseMutationOptions<ListUpdateByIdMutation, ListUpdateByIdMutationVariables>;
export const NoteCreateOneDocument = gql`
    mutation NoteCreateOne($record: CreateOneNoteInput!) {
  noteCreateOne(record: $record) {
    record {
      ...NoteFramgment
    }
  }
}
    ${NoteFramgmentFragmentDoc}`;
export type NoteCreateOneMutationFn = Apollo.MutationFunction<NoteCreateOneMutation, NoteCreateOneMutationVariables>;

/**
 * __useNoteCreateOneMutation__
 *
 * To run a mutation, you first call `useNoteCreateOneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNoteCreateOneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [noteCreateOneMutation, { data, loading, error }] = useNoteCreateOneMutation({
 *   variables: {
 *      record: // value for 'record'
 *   },
 * });
 */
export function useNoteCreateOneMutation(baseOptions?: Apollo.MutationHookOptions<NoteCreateOneMutation, NoteCreateOneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<NoteCreateOneMutation, NoteCreateOneMutationVariables>(NoteCreateOneDocument, options);
      }
export type NoteCreateOneMutationHookResult = ReturnType<typeof useNoteCreateOneMutation>;
export type NoteCreateOneMutationResult = Apollo.MutationResult<NoteCreateOneMutation>;
export type NoteCreateOneMutationOptions = Apollo.BaseMutationOptions<NoteCreateOneMutation, NoteCreateOneMutationVariables>;
export const NoteRemoveByIdDocument = gql`
    mutation NoteRemoveById($id: MongoID!) {
  noteRemoveById(_id: $id) {
    record {
      ...NoteFramgment
    }
  }
}
    ${NoteFramgmentFragmentDoc}`;
export type NoteRemoveByIdMutationFn = Apollo.MutationFunction<NoteRemoveByIdMutation, NoteRemoveByIdMutationVariables>;

/**
 * __useNoteRemoveByIdMutation__
 *
 * To run a mutation, you first call `useNoteRemoveByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNoteRemoveByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [noteRemoveByIdMutation, { data, loading, error }] = useNoteRemoveByIdMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useNoteRemoveByIdMutation(baseOptions?: Apollo.MutationHookOptions<NoteRemoveByIdMutation, NoteRemoveByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<NoteRemoveByIdMutation, NoteRemoveByIdMutationVariables>(NoteRemoveByIdDocument, options);
      }
export type NoteRemoveByIdMutationHookResult = ReturnType<typeof useNoteRemoveByIdMutation>;
export type NoteRemoveByIdMutationResult = Apollo.MutationResult<NoteRemoveByIdMutation>;
export type NoteRemoveByIdMutationOptions = Apollo.BaseMutationOptions<NoteRemoveByIdMutation, NoteRemoveByIdMutationVariables>;
export const NoteUpdateByIdDocument = gql`
    mutation NoteUpdateById($id: MongoID!, $record: UpdateByIdNoteInput!) {
  noteUpdateById(_id: $id, record: $record) {
    record {
      ...NoteFramgment
    }
  }
}
    ${NoteFramgmentFragmentDoc}`;
export type NoteUpdateByIdMutationFn = Apollo.MutationFunction<NoteUpdateByIdMutation, NoteUpdateByIdMutationVariables>;

/**
 * __useNoteUpdateByIdMutation__
 *
 * To run a mutation, you first call `useNoteUpdateByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNoteUpdateByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [noteUpdateByIdMutation, { data, loading, error }] = useNoteUpdateByIdMutation({
 *   variables: {
 *      id: // value for 'id'
 *      record: // value for 'record'
 *   },
 * });
 */
export function useNoteUpdateByIdMutation(baseOptions?: Apollo.MutationHookOptions<NoteUpdateByIdMutation, NoteUpdateByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<NoteUpdateByIdMutation, NoteUpdateByIdMutationVariables>(NoteUpdateByIdDocument, options);
      }
export type NoteUpdateByIdMutationHookResult = ReturnType<typeof useNoteUpdateByIdMutation>;
export type NoteUpdateByIdMutationResult = Apollo.MutationResult<NoteUpdateByIdMutation>;
export type NoteUpdateByIdMutationOptions = Apollo.BaseMutationOptions<NoteUpdateByIdMutation, NoteUpdateByIdMutationVariables>;
export const OperatorCreateDocument = gql`
    mutation OperatorCreate($record: CreateOneOperatorInput!) {
  operatorCreate(record: $record) {
    record {
      _entityId
      name {
        ...MultilingualFragment
      }
    }
  }
}
    ${MultilingualFragmentFragmentDoc}`;
export type OperatorCreateMutationFn = Apollo.MutationFunction<OperatorCreateMutation, OperatorCreateMutationVariables>;

/**
 * __useOperatorCreateMutation__
 *
 * To run a mutation, you first call `useOperatorCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOperatorCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [operatorCreateMutation, { data, loading, error }] = useOperatorCreateMutation({
 *   variables: {
 *      record: // value for 'record'
 *   },
 * });
 */
export function useOperatorCreateMutation(baseOptions?: Apollo.MutationHookOptions<OperatorCreateMutation, OperatorCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OperatorCreateMutation, OperatorCreateMutationVariables>(OperatorCreateDocument, options);
      }
export type OperatorCreateMutationHookResult = ReturnType<typeof useOperatorCreateMutation>;
export type OperatorCreateMutationResult = Apollo.MutationResult<OperatorCreateMutation>;
export type OperatorCreateMutationOptions = Apollo.BaseMutationOptions<OperatorCreateMutation, OperatorCreateMutationVariables>;
export const OperatorDeleteDocument = gql`
    mutation OperatorDelete($entityId: ID!) {
  operatorDelete(_entityId: $entityId) {
    _entityId
    _versionId
    status
    name {
      ...MultilingualFragment
    }
  }
}
    ${MultilingualFragmentFragmentDoc}`;
export type OperatorDeleteMutationFn = Apollo.MutationFunction<OperatorDeleteMutation, OperatorDeleteMutationVariables>;

/**
 * __useOperatorDeleteMutation__
 *
 * To run a mutation, you first call `useOperatorDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOperatorDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [operatorDeleteMutation, { data, loading, error }] = useOperatorDeleteMutation({
 *   variables: {
 *      entityId: // value for 'entityId'
 *   },
 * });
 */
export function useOperatorDeleteMutation(baseOptions?: Apollo.MutationHookOptions<OperatorDeleteMutation, OperatorDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OperatorDeleteMutation, OperatorDeleteMutationVariables>(OperatorDeleteDocument, options);
      }
export type OperatorDeleteMutationHookResult = ReturnType<typeof useOperatorDeleteMutation>;
export type OperatorDeleteMutationResult = Apollo.MutationResult<OperatorDeleteMutation>;
export type OperatorDeleteMutationOptions = Apollo.BaseMutationOptions<OperatorDeleteMutation, OperatorDeleteMutationVariables>;
export const OperatorUpdateDocument = gql`
    mutation OperatorUpdate($record: UpdateByIdOperatorInput!, $entityId: ID!, $isApproving: Boolean) {
  operatorUpdate(record: $record, _entityId: $entityId, isApproving: $isApproving) {
    _entityId
    _versionId
    status
    name {
      ...MultilingualFragment
    }
    enrollments {
      organizationControlled
      organization
      onboardingStatus
    }
    tags {
      organizationSpecific {
        _id
        name {
          ...MultilingualFragment
        }
        tagGroup {
          _id
          key
          name {
            ...MultilingualFragment
          }
          type
        }
      }
      global {
        _id
        name {
          ...MultilingualFragment
        }
        tagGroup {
          _id
          key
          name {
            ...MultilingualFragment
          }
          type
        }
      }
      businessType {
        _id
        name {
          ...MultilingualFragment
        }
        tagGroup {
          _id
          key
          name {
            ...MultilingualFragment
          }
          type
        }
      }
      amenity {
        _id
        name {
          ...MultilingualFragment
        }
        tagGroup {
          _id
          key
          name {
            ...MultilingualFragment
          }
          type
        }
      }
    }
  }
}
    ${MultilingualFragmentFragmentDoc}`;
export type OperatorUpdateMutationFn = Apollo.MutationFunction<OperatorUpdateMutation, OperatorUpdateMutationVariables>;

/**
 * __useOperatorUpdateMutation__
 *
 * To run a mutation, you first call `useOperatorUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOperatorUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [operatorUpdateMutation, { data, loading, error }] = useOperatorUpdateMutation({
 *   variables: {
 *      record: // value for 'record'
 *      entityId: // value for 'entityId'
 *      isApproving: // value for 'isApproving'
 *   },
 * });
 */
export function useOperatorUpdateMutation(baseOptions?: Apollo.MutationHookOptions<OperatorUpdateMutation, OperatorUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OperatorUpdateMutation, OperatorUpdateMutationVariables>(OperatorUpdateDocument, options);
      }
export type OperatorUpdateMutationHookResult = ReturnType<typeof useOperatorUpdateMutation>;
export type OperatorUpdateMutationResult = Apollo.MutationResult<OperatorUpdateMutation>;
export type OperatorUpdateMutationOptions = Apollo.BaseMutationOptions<OperatorUpdateMutation, OperatorUpdateMutationVariables>;
export const OperatorUpdateImagesDocument = gql`
    mutation OperatorUpdateImages($entityId: ID!, $imagesToKeep: [String!], $imagesToDelete: [String!], $isApproving: Boolean) {
  operatorUpdateImages(
    _entityId: $entityId
    imagesToKeep: $imagesToKeep
    imagesToDelete: $imagesToDelete
    isApproving: $isApproving
  ) {
    status
  }
}
    `;
export type OperatorUpdateImagesMutationFn = Apollo.MutationFunction<OperatorUpdateImagesMutation, OperatorUpdateImagesMutationVariables>;

/**
 * __useOperatorUpdateImagesMutation__
 *
 * To run a mutation, you first call `useOperatorUpdateImagesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOperatorUpdateImagesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [operatorUpdateImagesMutation, { data, loading, error }] = useOperatorUpdateImagesMutation({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      imagesToKeep: // value for 'imagesToKeep'
 *      imagesToDelete: // value for 'imagesToDelete'
 *      isApproving: // value for 'isApproving'
 *   },
 * });
 */
export function useOperatorUpdateImagesMutation(baseOptions?: Apollo.MutationHookOptions<OperatorUpdateImagesMutation, OperatorUpdateImagesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OperatorUpdateImagesMutation, OperatorUpdateImagesMutationVariables>(OperatorUpdateImagesDocument, options);
      }
export type OperatorUpdateImagesMutationHookResult = ReturnType<typeof useOperatorUpdateImagesMutation>;
export type OperatorUpdateImagesMutationResult = Apollo.MutationResult<OperatorUpdateImagesMutation>;
export type OperatorUpdateImagesMutationOptions = Apollo.BaseMutationOptions<OperatorUpdateImagesMutation, OperatorUpdateImagesMutationVariables>;
export const OrganizationUpdateDocument = gql`
    mutation OrganizationUpdate($id: MongoID!, $record: UpdateByIdOrganizationInput!) {
  organizationUpdate(_id: $id, record: $record) {
    record {
      _id
      name {
        ...MultilingualFragment
      }
      contact {
        address {
          line1
          line2
          city
          subdivision
          postalCode
          country
          location {
            type
            coordinates
          }
        }
        email
        phone
        tollFreePublicPhone
        links {
          website
          instagram
          x
          bookNow
          youtube
          pinterest
          googleMyBusiness
          tiktok
          tripAdvisor
          facebook
        }
      }
      description {
        ...MultilingualFragment
      }
      shortDescription {
        ...MultilingualFragment
      }
    }
  }
}
    ${MultilingualFragmentFragmentDoc}`;
export type OrganizationUpdateMutationFn = Apollo.MutationFunction<OrganizationUpdateMutation, OrganizationUpdateMutationVariables>;

/**
 * __useOrganizationUpdateMutation__
 *
 * To run a mutation, you first call `useOrganizationUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrganizationUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [organizationUpdateMutation, { data, loading, error }] = useOrganizationUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      record: // value for 'record'
 *   },
 * });
 */
export function useOrganizationUpdateMutation(baseOptions?: Apollo.MutationHookOptions<OrganizationUpdateMutation, OrganizationUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OrganizationUpdateMutation, OrganizationUpdateMutationVariables>(OrganizationUpdateDocument, options);
      }
export type OrganizationUpdateMutationHookResult = ReturnType<typeof useOrganizationUpdateMutation>;
export type OrganizationUpdateMutationResult = Apollo.MutationResult<OrganizationUpdateMutation>;
export type OrganizationUpdateMutationOptions = Apollo.BaseMutationOptions<OrganizationUpdateMutation, OrganizationUpdateMutationVariables>;
export const OrganizationUpdateImagesDocument = gql`
    mutation OrganizationUpdateImages($id: ID!, $imagesToKeep: [String!], $imagesToDelete: [String!], $isLogo: Boolean) {
  organizationUpdateImages(
    id: $id
    imagesToKeep: $imagesToKeep
    imagesToDelete: $imagesToDelete
    isLogo: $isLogo
  ) {
    _id
    logo {
      ...ImageFragment
    }
    images {
      ...ImageFragment
    }
  }
}
    ${ImageFragmentFragmentDoc}`;
export type OrganizationUpdateImagesMutationFn = Apollo.MutationFunction<OrganizationUpdateImagesMutation, OrganizationUpdateImagesMutationVariables>;

/**
 * __useOrganizationUpdateImagesMutation__
 *
 * To run a mutation, you first call `useOrganizationUpdateImagesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrganizationUpdateImagesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [organizationUpdateImagesMutation, { data, loading, error }] = useOrganizationUpdateImagesMutation({
 *   variables: {
 *      id: // value for 'id'
 *      imagesToKeep: // value for 'imagesToKeep'
 *      imagesToDelete: // value for 'imagesToDelete'
 *      isLogo: // value for 'isLogo'
 *   },
 * });
 */
export function useOrganizationUpdateImagesMutation(baseOptions?: Apollo.MutationHookOptions<OrganizationUpdateImagesMutation, OrganizationUpdateImagesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OrganizationUpdateImagesMutation, OrganizationUpdateImagesMutationVariables>(OrganizationUpdateImagesDocument, options);
      }
export type OrganizationUpdateImagesMutationHookResult = ReturnType<typeof useOrganizationUpdateImagesMutation>;
export type OrganizationUpdateImagesMutationResult = Apollo.MutationResult<OrganizationUpdateImagesMutation>;
export type OrganizationUpdateImagesMutationOptions = Apollo.BaseMutationOptions<OrganizationUpdateImagesMutation, OrganizationUpdateImagesMutationVariables>;
export const TagCreateDocument = gql`
    mutation TagCreate($record: CreateOneTagInput!) {
  tagCreate(record: $record) {
    record {
      _id
      name {
        ...MultilingualFragment
      }
    }
  }
}
    ${MultilingualFragmentFragmentDoc}`;
export type TagCreateMutationFn = Apollo.MutationFunction<TagCreateMutation, TagCreateMutationVariables>;

/**
 * __useTagCreateMutation__
 *
 * To run a mutation, you first call `useTagCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTagCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [tagCreateMutation, { data, loading, error }] = useTagCreateMutation({
 *   variables: {
 *      record: // value for 'record'
 *   },
 * });
 */
export function useTagCreateMutation(baseOptions?: Apollo.MutationHookOptions<TagCreateMutation, TagCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TagCreateMutation, TagCreateMutationVariables>(TagCreateDocument, options);
      }
export type TagCreateMutationHookResult = ReturnType<typeof useTagCreateMutation>;
export type TagCreateMutationResult = Apollo.MutationResult<TagCreateMutation>;
export type TagCreateMutationOptions = Apollo.BaseMutationOptions<TagCreateMutation, TagCreateMutationVariables>;
export const TagGroupManyDocument = gql`
    query TagGroupMany($filter: FilterFindManyTagGroupInput) {
  tagGroupMany(filter: $filter) {
    _id
    key
    name {
      ...MultilingualFragment
    }
    type
  }
}
    ${MultilingualFragmentFragmentDoc}`;

/**
 * __useTagGroupManyQuery__
 *
 * To run a query within a React component, call `useTagGroupManyQuery` and pass it any options that fit your needs.
 * When your component renders, `useTagGroupManyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTagGroupManyQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useTagGroupManyQuery(baseOptions?: Apollo.QueryHookOptions<TagGroupManyQuery, TagGroupManyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TagGroupManyQuery, TagGroupManyQueryVariables>(TagGroupManyDocument, options);
      }
export function useTagGroupManyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TagGroupManyQuery, TagGroupManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TagGroupManyQuery, TagGroupManyQueryVariables>(TagGroupManyDocument, options);
        }
export function useTagGroupManySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TagGroupManyQuery, TagGroupManyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TagGroupManyQuery, TagGroupManyQueryVariables>(TagGroupManyDocument, options);
        }
export type TagGroupManyQueryHookResult = ReturnType<typeof useTagGroupManyQuery>;
export type TagGroupManyLazyQueryHookResult = ReturnType<typeof useTagGroupManyLazyQuery>;
export type TagGroupManySuspenseQueryHookResult = ReturnType<typeof useTagGroupManySuspenseQuery>;
export type TagGroupManyQueryResult = Apollo.QueryResult<TagGroupManyQuery, TagGroupManyQueryVariables>;
export const TagUpdateDocument = gql`
    mutation TagUpdate($id: MongoID!, $record: UpdateByIdTagInput!) {
  tagUpdate(_id: $id, record: $record) {
    record {
      _id
      name {
        ...MultilingualFragment
      }
    }
  }
}
    ${MultilingualFragmentFragmentDoc}`;
export type TagUpdateMutationFn = Apollo.MutationFunction<TagUpdateMutation, TagUpdateMutationVariables>;

/**
 * __useTagUpdateMutation__
 *
 * To run a mutation, you first call `useTagUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTagUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [tagUpdateMutation, { data, loading, error }] = useTagUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      record: // value for 'record'
 *   },
 * });
 */
export function useTagUpdateMutation(baseOptions?: Apollo.MutationHookOptions<TagUpdateMutation, TagUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TagUpdateMutation, TagUpdateMutationVariables>(TagUpdateDocument, options);
      }
export type TagUpdateMutationHookResult = ReturnType<typeof useTagUpdateMutation>;
export type TagUpdateMutationResult = Apollo.MutationResult<TagUpdateMutation>;
export type TagUpdateMutationOptions = Apollo.BaseMutationOptions<TagUpdateMutation, TagUpdateMutationVariables>;
export const UserApproveAccessDocument = gql`
    mutation UserApproveAccess($userId: ID!, $entity: EntityReferenceInput!) {
  userApproveAccess(userId: $userId, entity: $entity) {
    _id
  }
}
    `;
export type UserApproveAccessMutationFn = Apollo.MutationFunction<UserApproveAccessMutation, UserApproveAccessMutationVariables>;

/**
 * __useUserApproveAccessMutation__
 *
 * To run a mutation, you first call `useUserApproveAccessMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserApproveAccessMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userApproveAccessMutation, { data, loading, error }] = useUserApproveAccessMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      entity: // value for 'entity'
 *   },
 * });
 */
export function useUserApproveAccessMutation(baseOptions?: Apollo.MutationHookOptions<UserApproveAccessMutation, UserApproveAccessMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserApproveAccessMutation, UserApproveAccessMutationVariables>(UserApproveAccessDocument, options);
      }
export type UserApproveAccessMutationHookResult = ReturnType<typeof useUserApproveAccessMutation>;
export type UserApproveAccessMutationResult = Apollo.MutationResult<UserApproveAccessMutation>;
export type UserApproveAccessMutationOptions = Apollo.BaseMutationOptions<UserApproveAccessMutation, UserApproveAccessMutationVariables>;
export const UserCreateDocument = gql`
    mutation UserCreate($record: CreateOneUserInput!) {
  userCreate(record: $record) {
    passwordResetUrl
  }
}
    `;
export type UserCreateMutationFn = Apollo.MutationFunction<UserCreateMutation, UserCreateMutationVariables>;

/**
 * __useUserCreateMutation__
 *
 * To run a mutation, you first call `useUserCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userCreateMutation, { data, loading, error }] = useUserCreateMutation({
 *   variables: {
 *      record: // value for 'record'
 *   },
 * });
 */
export function useUserCreateMutation(baseOptions?: Apollo.MutationHookOptions<UserCreateMutation, UserCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserCreateMutation, UserCreateMutationVariables>(UserCreateDocument, options);
      }
export type UserCreateMutationHookResult = ReturnType<typeof useUserCreateMutation>;
export type UserCreateMutationResult = Apollo.MutationResult<UserCreateMutation>;
export type UserCreateMutationOptions = Apollo.BaseMutationOptions<UserCreateMutation, UserCreateMutationVariables>;
export const UserCreateConfirmationCodeDocument = gql`
    mutation UserCreateConfirmationCode($id: ID!, $email: String!, $confirmationCodeType: EnumConfirmationCodeType!) {
  userCreateConfirmationCode(
    _id: $id
    email: $email
    confirmationCodeType: $confirmationCodeType
  ) {
    _id
  }
}
    `;
export type UserCreateConfirmationCodeMutationFn = Apollo.MutationFunction<UserCreateConfirmationCodeMutation, UserCreateConfirmationCodeMutationVariables>;

/**
 * __useUserCreateConfirmationCodeMutation__
 *
 * To run a mutation, you first call `useUserCreateConfirmationCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserCreateConfirmationCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userCreateConfirmationCodeMutation, { data, loading, error }] = useUserCreateConfirmationCodeMutation({
 *   variables: {
 *      id: // value for 'id'
 *      email: // value for 'email'
 *      confirmationCodeType: // value for 'confirmationCodeType'
 *   },
 * });
 */
export function useUserCreateConfirmationCodeMutation(baseOptions?: Apollo.MutationHookOptions<UserCreateConfirmationCodeMutation, UserCreateConfirmationCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserCreateConfirmationCodeMutation, UserCreateConfirmationCodeMutationVariables>(UserCreateConfirmationCodeDocument, options);
      }
export type UserCreateConfirmationCodeMutationHookResult = ReturnType<typeof useUserCreateConfirmationCodeMutation>;
export type UserCreateConfirmationCodeMutationResult = Apollo.MutationResult<UserCreateConfirmationCodeMutation>;
export type UserCreateConfirmationCodeMutationOptions = Apollo.BaseMutationOptions<UserCreateConfirmationCodeMutation, UserCreateConfirmationCodeMutationVariables>;
export const UserCreateInviteDocument = gql`
    mutation UserCreateInvite($email: String!, $firstName: String!, $lastName: String!, $sendInvitationEmail: Boolean!, $entity: EntityReferenceInput!, $role: RoleType) {
  userCreateInvite(
    email: $email
    firstName: $firstName
    lastName: $lastName
    sendInvitationEmail: $sendInvitationEmail
    entity: $entity
    role: $role
  ) {
    _id
    email
    firstName
    lastName
  }
}
    `;
export type UserCreateInviteMutationFn = Apollo.MutationFunction<UserCreateInviteMutation, UserCreateInviteMutationVariables>;

/**
 * __useUserCreateInviteMutation__
 *
 * To run a mutation, you first call `useUserCreateInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserCreateInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userCreateInviteMutation, { data, loading, error }] = useUserCreateInviteMutation({
 *   variables: {
 *      email: // value for 'email'
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      sendInvitationEmail: // value for 'sendInvitationEmail'
 *      entity: // value for 'entity'
 *      role: // value for 'role'
 *   },
 * });
 */
export function useUserCreateInviteMutation(baseOptions?: Apollo.MutationHookOptions<UserCreateInviteMutation, UserCreateInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserCreateInviteMutation, UserCreateInviteMutationVariables>(UserCreateInviteDocument, options);
      }
export type UserCreateInviteMutationHookResult = ReturnType<typeof useUserCreateInviteMutation>;
export type UserCreateInviteMutationResult = Apollo.MutationResult<UserCreateInviteMutation>;
export type UserCreateInviteMutationOptions = Apollo.BaseMutationOptions<UserCreateInviteMutation, UserCreateInviteMutationVariables>;
export const UserRequestAccessDocument = gql`
    mutation UserRequestAccess($entity: EntityReferenceInput!) {
  userRequestAccess(entity: $entity) {
    ...UserFragment
  }
}
    ${UserFragmentFragmentDoc}`;
export type UserRequestAccessMutationFn = Apollo.MutationFunction<UserRequestAccessMutation, UserRequestAccessMutationVariables>;

/**
 * __useUserRequestAccessMutation__
 *
 * To run a mutation, you first call `useUserRequestAccessMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserRequestAccessMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userRequestAccessMutation, { data, loading, error }] = useUserRequestAccessMutation({
 *   variables: {
 *      entity: // value for 'entity'
 *   },
 * });
 */
export function useUserRequestAccessMutation(baseOptions?: Apollo.MutationHookOptions<UserRequestAccessMutation, UserRequestAccessMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserRequestAccessMutation, UserRequestAccessMutationVariables>(UserRequestAccessDocument, options);
      }
export type UserRequestAccessMutationHookResult = ReturnType<typeof useUserRequestAccessMutation>;
export type UserRequestAccessMutationResult = Apollo.MutationResult<UserRequestAccessMutation>;
export type UserRequestAccessMutationOptions = Apollo.BaseMutationOptions<UserRequestAccessMutation, UserRequestAccessMutationVariables>;
export const UserResendConfirmationCodeDocument = gql`
    mutation UserResendConfirmationCode($id: ID!, $sentToEmail: String!, $type: EnumConfirmationCodeType!) {
  userResendConfirmationCode(_id: $id, sentToEmail: $sentToEmail, type: $type) {
    _id
  }
}
    `;
export type UserResendConfirmationCodeMutationFn = Apollo.MutationFunction<UserResendConfirmationCodeMutation, UserResendConfirmationCodeMutationVariables>;

/**
 * __useUserResendConfirmationCodeMutation__
 *
 * To run a mutation, you first call `useUserResendConfirmationCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserResendConfirmationCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userResendConfirmationCodeMutation, { data, loading, error }] = useUserResendConfirmationCodeMutation({
 *   variables: {
 *      id: // value for 'id'
 *      sentToEmail: // value for 'sentToEmail'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useUserResendConfirmationCodeMutation(baseOptions?: Apollo.MutationHookOptions<UserResendConfirmationCodeMutation, UserResendConfirmationCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserResendConfirmationCodeMutation, UserResendConfirmationCodeMutationVariables>(UserResendConfirmationCodeDocument, options);
      }
export type UserResendConfirmationCodeMutationHookResult = ReturnType<typeof useUserResendConfirmationCodeMutation>;
export type UserResendConfirmationCodeMutationResult = Apollo.MutationResult<UserResendConfirmationCodeMutation>;
export type UserResendConfirmationCodeMutationOptions = Apollo.BaseMutationOptions<UserResendConfirmationCodeMutation, UserResendConfirmationCodeMutationVariables>;
export const UserRevokeInviteDocument = gql`
    mutation UserRevokeInvite($userId: ID!, $entity: EntityReferenceInput!) {
  userRevokeInvite(userId: $userId, entity: $entity) {
    _id
  }
}
    `;
export type UserRevokeInviteMutationFn = Apollo.MutationFunction<UserRevokeInviteMutation, UserRevokeInviteMutationVariables>;

/**
 * __useUserRevokeInviteMutation__
 *
 * To run a mutation, you first call `useUserRevokeInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserRevokeInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userRevokeInviteMutation, { data, loading, error }] = useUserRevokeInviteMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      entity: // value for 'entity'
 *   },
 * });
 */
export function useUserRevokeInviteMutation(baseOptions?: Apollo.MutationHookOptions<UserRevokeInviteMutation, UserRevokeInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserRevokeInviteMutation, UserRevokeInviteMutationVariables>(UserRevokeInviteDocument, options);
      }
export type UserRevokeInviteMutationHookResult = ReturnType<typeof useUserRevokeInviteMutation>;
export type UserRevokeInviteMutationResult = Apollo.MutationResult<UserRevokeInviteMutation>;
export type UserRevokeInviteMutationOptions = Apollo.BaseMutationOptions<UserRevokeInviteMutation, UserRevokeInviteMutationVariables>;
export const UserUpdateDocument = gql`
    mutation UserUpdate($id: MongoID!, $record: UpdateByIdUserInput!) {
  userUpdate(_id: $id, record: $record) {
    _id
    passwordResetUrl
  }
}
    `;
export type UserUpdateMutationFn = Apollo.MutationFunction<UserUpdateMutation, UserUpdateMutationVariables>;

/**
 * __useUserUpdateMutation__
 *
 * To run a mutation, you first call `useUserUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userUpdateMutation, { data, loading, error }] = useUserUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      record: // value for 'record'
 *   },
 * });
 */
export function useUserUpdateMutation(baseOptions?: Apollo.MutationHookOptions<UserUpdateMutation, UserUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserUpdateMutation, UserUpdateMutationVariables>(UserUpdateDocument, options);
      }
export type UserUpdateMutationHookResult = ReturnType<typeof useUserUpdateMutation>;
export type UserUpdateMutationResult = Apollo.MutationResult<UserUpdateMutation>;
export type UserUpdateMutationOptions = Apollo.BaseMutationOptions<UserUpdateMutation, UserUpdateMutationVariables>;
export const UserValidateConfirmationCodeDocument = gql`
    mutation UserValidateConfirmationCode($id: ID!, $code: String!) {
  userValidateConfirmationCode(_id: $id, code: $code) {
    _id
  }
}
    `;
export type UserValidateConfirmationCodeMutationFn = Apollo.MutationFunction<UserValidateConfirmationCodeMutation, UserValidateConfirmationCodeMutationVariables>;

/**
 * __useUserValidateConfirmationCodeMutation__
 *
 * To run a mutation, you first call `useUserValidateConfirmationCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserValidateConfirmationCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userValidateConfirmationCodeMutation, { data, loading, error }] = useUserValidateConfirmationCodeMutation({
 *   variables: {
 *      id: // value for 'id'
 *      code: // value for 'code'
 *   },
 * });
 */
export function useUserValidateConfirmationCodeMutation(baseOptions?: Apollo.MutationHookOptions<UserValidateConfirmationCodeMutation, UserValidateConfirmationCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserValidateConfirmationCodeMutation, UserValidateConfirmationCodeMutationVariables>(UserValidateConfirmationCodeDocument, options);
      }
export type UserValidateConfirmationCodeMutationHookResult = ReturnType<typeof useUserValidateConfirmationCodeMutation>;
export type UserValidateConfirmationCodeMutationResult = Apollo.MutationResult<UserValidateConfirmationCodeMutation>;
export type UserValidateConfirmationCodeMutationOptions = Apollo.BaseMutationOptions<UserValidateConfirmationCodeMutation, UserValidateConfirmationCodeMutationVariables>;
export const WidgetCreateDocument = gql`
    mutation WidgetCreate($record: CreateOneWidgetInput!) {
  widgetCreate(record: $record) {
    record {
      _id
      name {
        ...MultilingualFragment
      }
    }
  }
}
    ${MultilingualFragmentFragmentDoc}`;
export type WidgetCreateMutationFn = Apollo.MutationFunction<WidgetCreateMutation, WidgetCreateMutationVariables>;

/**
 * __useWidgetCreateMutation__
 *
 * To run a mutation, you first call `useWidgetCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWidgetCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [widgetCreateMutation, { data, loading, error }] = useWidgetCreateMutation({
 *   variables: {
 *      record: // value for 'record'
 *   },
 * });
 */
export function useWidgetCreateMutation(baseOptions?: Apollo.MutationHookOptions<WidgetCreateMutation, WidgetCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<WidgetCreateMutation, WidgetCreateMutationVariables>(WidgetCreateDocument, options);
      }
export type WidgetCreateMutationHookResult = ReturnType<typeof useWidgetCreateMutation>;
export type WidgetCreateMutationResult = Apollo.MutationResult<WidgetCreateMutation>;
export type WidgetCreateMutationOptions = Apollo.BaseMutationOptions<WidgetCreateMutation, WidgetCreateMutationVariables>;
export const WidgetUpdateByIdDocument = gql`
    mutation WidgetUpdateById($id: MongoID!, $record: UpdateByIdWidgetInput!) {
  widgetUpdateById(_id: $id, record: $record) {
    record {
      name {
        ...MultilingualFragment
      }
      description {
        ...MultilingualFragment
      }
      favorited
      archived
      eventSettings {
        displayType
        eventTags
        lookAheadMonths
      }
    }
  }
}
    ${MultilingualFragmentFragmentDoc}`;
export type WidgetUpdateByIdMutationFn = Apollo.MutationFunction<WidgetUpdateByIdMutation, WidgetUpdateByIdMutationVariables>;

/**
 * __useWidgetUpdateByIdMutation__
 *
 * To run a mutation, you first call `useWidgetUpdateByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWidgetUpdateByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [widgetUpdateByIdMutation, { data, loading, error }] = useWidgetUpdateByIdMutation({
 *   variables: {
 *      id: // value for 'id'
 *      record: // value for 'record'
 *   },
 * });
 */
export function useWidgetUpdateByIdMutation(baseOptions?: Apollo.MutationHookOptions<WidgetUpdateByIdMutation, WidgetUpdateByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<WidgetUpdateByIdMutation, WidgetUpdateByIdMutationVariables>(WidgetUpdateByIdDocument, options);
      }
export type WidgetUpdateByIdMutationHookResult = ReturnType<typeof useWidgetUpdateByIdMutation>;
export type WidgetUpdateByIdMutationResult = Apollo.MutationResult<WidgetUpdateByIdMutation>;
export type WidgetUpdateByIdMutationOptions = Apollo.BaseMutationOptions<WidgetUpdateByIdMutation, WidgetUpdateByIdMutationVariables>;
export const BookerByIdDocument = gql`
    query BookerById($id: MongoID!) {
  bookerById(_id: $id) {
    name {
      ...MultilingualFragment
    }
    storefront
    bundles {
      product {
        storefront
        owner {
          type
          entityId
        }
        type
        name {
          ...MultilingualFragment
        }
        description {
          ...MultilingualFragment
        }
        shortDescription {
          ...MultilingualFragment
        }
        images {
          ...ImageFragment
        }
        tags {
          tagGroup {
            _id
            key
            name {
              ...MultilingualFragment
            }
            type
          }
          name {
            ...MultilingualFragment
          }
          entityType
          entityTypes
          _id
        }
        rules {
          type
          value
          activePeriod {
            _id
            start
            end
            metadata
          }
          isActive
          storefront
          _id
        }
        publicationStatus
        pricing {
          tiers {
            label {
              ...MultilingualFragment
            }
            type
            price
            _id
          }
        }
        externalBookingUrl
        contact {
          address {
            line1
            line2
            city
            subdivision
            postalCode
            country
            location {
              type
              coordinates
            }
          }
          useOwnerContact
        }
        isUpsellOnly
        accommodationMetadata {
          guestMetadata {
            minimumNumber
            maximumNumber
            nameEntryAllowed
            nameEntryRequired
          }
          amenities {
            tagGroup {
              _id
              key
              name {
                ...MultilingualFragment
              }
              type
            }
            name {
              ...MultilingualFragment
            }
            entityType
            entityTypes
            _id
          }
          rooms {
            _id
            type
            amenities
          }
          checkIn
          checkOut
        }
        _id
      }
      upsells {
        _id
        isUpsellOnly
        description {
          ...MultilingualFragment
        }
        name {
          ...MultilingualFragment
        }
        pricing {
          tiers {
            _id
            label {
              ...MultilingualFragment
            }
            price
            type
          }
        }
        publicationStatus
        shortDescription {
          ...MultilingualFragment
        }
        type
        quantitySettings {
          enabled
          maxQuantity
        }
      }
      _id
    }
    paymentMetadata {
      connectedAccountId
      depositSettings {
        enabled
        rate
        rateType
        chargeBalanceDaysBeforeCheckIn
      }
    }
    waivers {
      _id
      caption {
        ...MultilingualFragment
      }
      type
      blurhash
    }
    rules {
      _id
      activePeriod {
        _id
        end
        start
        metadata
      }
      isActive
      type
      value
    }
    policies {
      _id
      content {
        ...MultilingualFragment
      }
      isActive
      name {
        ...MultilingualFragment
      }
      storefront
    }
    status
    statusNotification {
      ...MultilingualFragment
    }
    customizations {
      featuredImage {
        ...ImageFragment
      }
      logo {
        ...ImageFragment
      }
    }
    _id
  }
}
    ${MultilingualFragmentFragmentDoc}
${ImageFragmentFragmentDoc}`;

/**
 * __useBookerByIdQuery__
 *
 * To run a query within a React component, call `useBookerByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookerByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookerByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useBookerByIdQuery(baseOptions: Apollo.QueryHookOptions<BookerByIdQuery, BookerByIdQueryVariables> & ({ variables: BookerByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BookerByIdQuery, BookerByIdQueryVariables>(BookerByIdDocument, options);
      }
export function useBookerByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BookerByIdQuery, BookerByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BookerByIdQuery, BookerByIdQueryVariables>(BookerByIdDocument, options);
        }
export function useBookerByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BookerByIdQuery, BookerByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BookerByIdQuery, BookerByIdQueryVariables>(BookerByIdDocument, options);
        }
export type BookerByIdQueryHookResult = ReturnType<typeof useBookerByIdQuery>;
export type BookerByIdLazyQueryHookResult = ReturnType<typeof useBookerByIdLazyQuery>;
export type BookerByIdSuspenseQueryHookResult = ReturnType<typeof useBookerByIdSuspenseQuery>;
export type BookerByIdQueryResult = Apollo.QueryResult<BookerByIdQuery, BookerByIdQueryVariables>;
export const BookerCartPriceDocument = gql`
    query BookerCartPrice($bookerId: ID!, $productPurchaseRequests: [ProductPurchaseRequest!]!, $promoCode: String) {
  bookerCartPrice(
    bookerId: $bookerId
    productPurchaseRequests: $productPurchaseRequests
    promoCode: $promoCode
  ) {
    depositTotal
    discountTotal
    discountTotals {
      discountId
      total
    }
    grandTotal
    subTotal
    taxTotal
    productPrices {
      price
      productId
    }
  }
}
    `;

/**
 * __useBookerCartPriceQuery__
 *
 * To run a query within a React component, call `useBookerCartPriceQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookerCartPriceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookerCartPriceQuery({
 *   variables: {
 *      bookerId: // value for 'bookerId'
 *      productPurchaseRequests: // value for 'productPurchaseRequests'
 *      promoCode: // value for 'promoCode'
 *   },
 * });
 */
export function useBookerCartPriceQuery(baseOptions: Apollo.QueryHookOptions<BookerCartPriceQuery, BookerCartPriceQueryVariables> & ({ variables: BookerCartPriceQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BookerCartPriceQuery, BookerCartPriceQueryVariables>(BookerCartPriceDocument, options);
      }
export function useBookerCartPriceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BookerCartPriceQuery, BookerCartPriceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BookerCartPriceQuery, BookerCartPriceQueryVariables>(BookerCartPriceDocument, options);
        }
export function useBookerCartPriceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BookerCartPriceQuery, BookerCartPriceQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BookerCartPriceQuery, BookerCartPriceQueryVariables>(BookerCartPriceDocument, options);
        }
export type BookerCartPriceQueryHookResult = ReturnType<typeof useBookerCartPriceQuery>;
export type BookerCartPriceLazyQueryHookResult = ReturnType<typeof useBookerCartPriceLazyQuery>;
export type BookerCartPriceSuspenseQueryHookResult = ReturnType<typeof useBookerCartPriceSuspenseQuery>;
export type BookerCartPriceQueryResult = Apollo.QueryResult<BookerCartPriceQuery, BookerCartPriceQueryVariables>;
export const BookerSendContactUsEmailDocument = gql`
    query BookerSendContactUsEmail($bookerId: ID!, $details: ContactUsEmailDetails!) {
  bookerSendContactUsEmail(bookerId: $bookerId, details: $details) {
    message
    success
  }
}
    `;

/**
 * __useBookerSendContactUsEmailQuery__
 *
 * To run a query within a React component, call `useBookerSendContactUsEmailQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookerSendContactUsEmailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookerSendContactUsEmailQuery({
 *   variables: {
 *      bookerId: // value for 'bookerId'
 *      details: // value for 'details'
 *   },
 * });
 */
export function useBookerSendContactUsEmailQuery(baseOptions: Apollo.QueryHookOptions<BookerSendContactUsEmailQuery, BookerSendContactUsEmailQueryVariables> & ({ variables: BookerSendContactUsEmailQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BookerSendContactUsEmailQuery, BookerSendContactUsEmailQueryVariables>(BookerSendContactUsEmailDocument, options);
      }
export function useBookerSendContactUsEmailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BookerSendContactUsEmailQuery, BookerSendContactUsEmailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BookerSendContactUsEmailQuery, BookerSendContactUsEmailQueryVariables>(BookerSendContactUsEmailDocument, options);
        }
export function useBookerSendContactUsEmailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BookerSendContactUsEmailQuery, BookerSendContactUsEmailQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BookerSendContactUsEmailQuery, BookerSendContactUsEmailQueryVariables>(BookerSendContactUsEmailDocument, options);
        }
export type BookerSendContactUsEmailQueryHookResult = ReturnType<typeof useBookerSendContactUsEmailQuery>;
export type BookerSendContactUsEmailLazyQueryHookResult = ReturnType<typeof useBookerSendContactUsEmailLazyQuery>;
export type BookerSendContactUsEmailSuspenseQueryHookResult = ReturnType<typeof useBookerSendContactUsEmailSuspenseQuery>;
export type BookerSendContactUsEmailQueryResult = Apollo.QueryResult<BookerSendContactUsEmailQuery, BookerSendContactUsEmailQueryVariables>;
export const ChangeLogManyDocument = gql`
    query ChangeLogMany($filter: FilterFindManyChangelogInput, $sort: SortFindManyChangelogInput, $limit: Int) {
  changeLogMany(filter: $filter, sort: $sort, limit: $limit) {
    _id
    initiatedByUser {
      firstName
    }
    owner {
      type
    }
    message {
      ...MultilingualFragment
    }
    createdDateISO
  }
}
    ${MultilingualFragmentFragmentDoc}`;

/**
 * __useChangeLogManyQuery__
 *
 * To run a query within a React component, call `useChangeLogManyQuery` and pass it any options that fit your needs.
 * When your component renders, `useChangeLogManyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChangeLogManyQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useChangeLogManyQuery(baseOptions?: Apollo.QueryHookOptions<ChangeLogManyQuery, ChangeLogManyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ChangeLogManyQuery, ChangeLogManyQueryVariables>(ChangeLogManyDocument, options);
      }
export function useChangeLogManyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ChangeLogManyQuery, ChangeLogManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ChangeLogManyQuery, ChangeLogManyQueryVariables>(ChangeLogManyDocument, options);
        }
export function useChangeLogManySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ChangeLogManyQuery, ChangeLogManyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ChangeLogManyQuery, ChangeLogManyQueryVariables>(ChangeLogManyDocument, options);
        }
export type ChangeLogManyQueryHookResult = ReturnType<typeof useChangeLogManyQuery>;
export type ChangeLogManyLazyQueryHookResult = ReturnType<typeof useChangeLogManyLazyQuery>;
export type ChangeLogManySuspenseQueryHookResult = ReturnType<typeof useChangeLogManySuspenseQuery>;
export type ChangeLogManyQueryResult = Apollo.QueryResult<ChangeLogManyQuery, ChangeLogManyQueryVariables>;
export const DiscountByIdsDocument = gql`
    query DiscountByIds($ids: [MongoID!]!) {
  discountByIds(_ids: $ids) {
    _id
    name {
      en
      fr
      es
    }
    promoCode
    unit
    type
    amount
    excludeUpsells
  }
}
    `;

/**
 * __useDiscountByIdsQuery__
 *
 * To run a query within a React component, call `useDiscountByIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDiscountByIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDiscountByIdsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useDiscountByIdsQuery(baseOptions: Apollo.QueryHookOptions<DiscountByIdsQuery, DiscountByIdsQueryVariables> & ({ variables: DiscountByIdsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DiscountByIdsQuery, DiscountByIdsQueryVariables>(DiscountByIdsDocument, options);
      }
export function useDiscountByIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DiscountByIdsQuery, DiscountByIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DiscountByIdsQuery, DiscountByIdsQueryVariables>(DiscountByIdsDocument, options);
        }
export function useDiscountByIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DiscountByIdsQuery, DiscountByIdsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DiscountByIdsQuery, DiscountByIdsQueryVariables>(DiscountByIdsDocument, options);
        }
export type DiscountByIdsQueryHookResult = ReturnType<typeof useDiscountByIdsQuery>;
export type DiscountByIdsLazyQueryHookResult = ReturnType<typeof useDiscountByIdsLazyQuery>;
export type DiscountByIdsSuspenseQueryHookResult = ReturnType<typeof useDiscountByIdsSuspenseQuery>;
export type DiscountByIdsQueryResult = Apollo.QueryResult<DiscountByIdsQuery, DiscountByIdsQueryVariables>;
export const EventByIdDocument = gql`
    query EventById($id: MongoID!) {
  eventById(_id: $id) {
    ...EventDetailsFragment
  }
}
    ${EventDetailsFragmentFragmentDoc}`;

/**
 * __useEventByIdQuery__
 *
 * To run a query within a React component, call `useEventByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEventByIdQuery(baseOptions: Apollo.QueryHookOptions<EventByIdQuery, EventByIdQueryVariables> & ({ variables: EventByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EventByIdQuery, EventByIdQueryVariables>(EventByIdDocument, options);
      }
export function useEventByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EventByIdQuery, EventByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EventByIdQuery, EventByIdQueryVariables>(EventByIdDocument, options);
        }
export function useEventByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EventByIdQuery, EventByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EventByIdQuery, EventByIdQueryVariables>(EventByIdDocument, options);
        }
export type EventByIdQueryHookResult = ReturnType<typeof useEventByIdQuery>;
export type EventByIdLazyQueryHookResult = ReturnType<typeof useEventByIdLazyQuery>;
export type EventByIdSuspenseQueryHookResult = ReturnType<typeof useEventByIdSuspenseQuery>;
export type EventByIdQueryResult = Apollo.QueryResult<EventByIdQuery, EventByIdQueryVariables>;
export const EventLookaheadMonthsDocument = gql`
    query EventLookaheadMonths($organizationId: ID) {
  eventLookaheadMonths(organizationId: $organizationId)
}
    `;

/**
 * __useEventLookaheadMonthsQuery__
 *
 * To run a query within a React component, call `useEventLookaheadMonthsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventLookaheadMonthsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventLookaheadMonthsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useEventLookaheadMonthsQuery(baseOptions?: Apollo.QueryHookOptions<EventLookaheadMonthsQuery, EventLookaheadMonthsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EventLookaheadMonthsQuery, EventLookaheadMonthsQueryVariables>(EventLookaheadMonthsDocument, options);
      }
export function useEventLookaheadMonthsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EventLookaheadMonthsQuery, EventLookaheadMonthsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EventLookaheadMonthsQuery, EventLookaheadMonthsQueryVariables>(EventLookaheadMonthsDocument, options);
        }
export function useEventLookaheadMonthsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EventLookaheadMonthsQuery, EventLookaheadMonthsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EventLookaheadMonthsQuery, EventLookaheadMonthsQueryVariables>(EventLookaheadMonthsDocument, options);
        }
export type EventLookaheadMonthsQueryHookResult = ReturnType<typeof useEventLookaheadMonthsQuery>;
export type EventLookaheadMonthsLazyQueryHookResult = ReturnType<typeof useEventLookaheadMonthsLazyQuery>;
export type EventLookaheadMonthsSuspenseQueryHookResult = ReturnType<typeof useEventLookaheadMonthsSuspenseQuery>;
export type EventLookaheadMonthsQueryResult = Apollo.QueryResult<EventLookaheadMonthsQuery, EventLookaheadMonthsQueryVariables>;
export const EventManyDocument = gql`
    query EventMany($startDate: String!, $endDate: String!, $organizationId: ID, $operatorId: ID, $status: EventStatus, $tags: [ID], $keepEventsWithNoFutureOccurrences: Boolean) {
  eventMany(
    startDate: $startDate
    endDate: $endDate
    organizationId: $organizationId
    operatorId: $operatorId
    status: $status
    tags: $tags
    keepEventsWithNoFutureOccurrences: $keepEventsWithNoFutureOccurrences
  ) {
    _id
    title {
      ...MultilingualFragment
    }
    description {
      ...MultilingualFragment
    }
    eventLocation {
      ...EventLocationFragment
    }
    otherLocations {
      ...EventLocationFragment
    }
    type
    startDate
    endDate
    occurrences
    schedules {
      allDay
      timeSlots {
        from
        to
        endsNextDay
        note
      }
    }
    recurrencePattern {
      frequency
      interval
      multiDates
      daysOfWeek
      dateOfMonth
      dayOfMonth
      dayOfMonthOccurrence
      monthAndDateOfYear
      endDate
      skipDates
    }
    price
    ticketUrl
    images {
      ...ImageFragment
    }
    tags {
      global {
        _id
        name {
          ...MultilingualFragment
        }
        tagGroup {
          _id
          name {
            ...MultilingualFragment
          }
        }
      }
      organizationSpecific {
        _id
        name {
          ...MultilingualFragment
        }
        tagGroup {
          _id
          name {
            ...MultilingualFragment
          }
        }
      }
    }
  }
}
    ${MultilingualFragmentFragmentDoc}
${EventLocationFragmentFragmentDoc}
${ImageFragmentFragmentDoc}`;

/**
 * __useEventManyQuery__
 *
 * To run a query within a React component, call `useEventManyQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventManyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventManyQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      organizationId: // value for 'organizationId'
 *      operatorId: // value for 'operatorId'
 *      status: // value for 'status'
 *      tags: // value for 'tags'
 *      keepEventsWithNoFutureOccurrences: // value for 'keepEventsWithNoFutureOccurrences'
 *   },
 * });
 */
export function useEventManyQuery(baseOptions: Apollo.QueryHookOptions<EventManyQuery, EventManyQueryVariables> & ({ variables: EventManyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EventManyQuery, EventManyQueryVariables>(EventManyDocument, options);
      }
export function useEventManyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EventManyQuery, EventManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EventManyQuery, EventManyQueryVariables>(EventManyDocument, options);
        }
export function useEventManySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EventManyQuery, EventManyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EventManyQuery, EventManyQueryVariables>(EventManyDocument, options);
        }
export type EventManyQueryHookResult = ReturnType<typeof useEventManyQuery>;
export type EventManyLazyQueryHookResult = ReturnType<typeof useEventManyLazyQuery>;
export type EventManySuspenseQueryHookResult = ReturnType<typeof useEventManySuspenseQuery>;
export type EventManyQueryResult = Apollo.QueryResult<EventManyQuery, EventManyQueryVariables>;
export const EventManyAppDocument = gql`
    query EventManyApp($startDate: String!, $endDate: String!, $organizationId: ID, $operatorId: ID, $status: EventStatus, $tags: [ID], $skipRecurrences: Boolean, $keepEventsWithNoFutureOccurrences: Boolean) {
  eventMany(
    startDate: $startDate
    endDate: $endDate
    organizationId: $organizationId
    operatorId: $operatorId
    status: $status
    tags: $tags
    skipRecurrences: $skipRecurrences
    keepEventsWithNoFutureOccurrences: $keepEventsWithNoFutureOccurrences
  ) {
    _id
    title {
      ...MultilingualFragment
    }
    type
    startDate
    endDate
    occurrences
    schedules {
      allDay
      timeSlots {
        from
        to
        endsNextDay
        note
      }
    }
    recurrencePattern {
      frequency
      interval
      multiDates
      daysOfWeek
      dateOfMonth
      dayOfMonth
      dayOfMonthOccurrence
      monthAndDateOfYear
      endDate
      skipDates
    }
    images {
      ...ImageFragment
    }
    access {
      operator {
        _entityId
      }
      organizations {
        _entityId
        status
      }
    }
    updatedDateISO
  }
}
    ${MultilingualFragmentFragmentDoc}
${ImageFragmentFragmentDoc}`;

/**
 * __useEventManyAppQuery__
 *
 * To run a query within a React component, call `useEventManyAppQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventManyAppQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventManyAppQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      organizationId: // value for 'organizationId'
 *      operatorId: // value for 'operatorId'
 *      status: // value for 'status'
 *      tags: // value for 'tags'
 *      skipRecurrences: // value for 'skipRecurrences'
 *      keepEventsWithNoFutureOccurrences: // value for 'keepEventsWithNoFutureOccurrences'
 *   },
 * });
 */
export function useEventManyAppQuery(baseOptions: Apollo.QueryHookOptions<EventManyAppQuery, EventManyAppQueryVariables> & ({ variables: EventManyAppQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EventManyAppQuery, EventManyAppQueryVariables>(EventManyAppDocument, options);
      }
export function useEventManyAppLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EventManyAppQuery, EventManyAppQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EventManyAppQuery, EventManyAppQueryVariables>(EventManyAppDocument, options);
        }
export function useEventManyAppSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EventManyAppQuery, EventManyAppQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EventManyAppQuery, EventManyAppQueryVariables>(EventManyAppDocument, options);
        }
export type EventManyAppQueryHookResult = ReturnType<typeof useEventManyAppQuery>;
export type EventManyAppLazyQueryHookResult = ReturnType<typeof useEventManyAppLazyQuery>;
export type EventManyAppSuspenseQueryHookResult = ReturnType<typeof useEventManyAppSuspenseQuery>;
export type EventManyAppQueryResult = Apollo.QueryResult<EventManyAppQuery, EventManyAppQueryVariables>;
export const InventoryByProductBookedDatesDocument = gql`
    query InventoryByProductBookedDates($productId: ID!) {
  inventoryDatesByProduct(productId: $productId) {
    bookedDatesISO
    checkOutOnlyDatesISO
  }
}
    `;

/**
 * __useInventoryByProductBookedDatesQuery__
 *
 * To run a query within a React component, call `useInventoryByProductBookedDatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useInventoryByProductBookedDatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInventoryByProductBookedDatesQuery({
 *   variables: {
 *      productId: // value for 'productId'
 *   },
 * });
 */
export function useInventoryByProductBookedDatesQuery(baseOptions: Apollo.QueryHookOptions<InventoryByProductBookedDatesQuery, InventoryByProductBookedDatesQueryVariables> & ({ variables: InventoryByProductBookedDatesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InventoryByProductBookedDatesQuery, InventoryByProductBookedDatesQueryVariables>(InventoryByProductBookedDatesDocument, options);
      }
export function useInventoryByProductBookedDatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InventoryByProductBookedDatesQuery, InventoryByProductBookedDatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InventoryByProductBookedDatesQuery, InventoryByProductBookedDatesQueryVariables>(InventoryByProductBookedDatesDocument, options);
        }
export function useInventoryByProductBookedDatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InventoryByProductBookedDatesQuery, InventoryByProductBookedDatesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InventoryByProductBookedDatesQuery, InventoryByProductBookedDatesQueryVariables>(InventoryByProductBookedDatesDocument, options);
        }
export type InventoryByProductBookedDatesQueryHookResult = ReturnType<typeof useInventoryByProductBookedDatesQuery>;
export type InventoryByProductBookedDatesLazyQueryHookResult = ReturnType<typeof useInventoryByProductBookedDatesLazyQuery>;
export type InventoryByProductBookedDatesSuspenseQueryHookResult = ReturnType<typeof useInventoryByProductBookedDatesSuspenseQuery>;
export type InventoryByProductBookedDatesQueryResult = Apollo.QueryResult<InventoryByProductBookedDatesQuery, InventoryByProductBookedDatesQueryVariables>;
export const ListByIdDocument = gql`
    query ListById($id: MongoID!) {
  listById(_id: $id) {
    _id
    type
    name {
      ...MultilingualFragment
    }
    description {
      ...MultilingualFragment
    }
    selections
    archived
    favorited
    entities {
      _entityId
      _versionId
      status
      name {
        ...MultilingualFragment
      }
      type
      images {
        ...ImageFragment
      }
      iasc
    }
  }
}
    ${MultilingualFragmentFragmentDoc}
${ImageFragmentFragmentDoc}`;

/**
 * __useListByIdQuery__
 *
 * To run a query within a React component, call `useListByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useListByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useListByIdQuery(baseOptions: Apollo.QueryHookOptions<ListByIdQuery, ListByIdQueryVariables> & ({ variables: ListByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListByIdQuery, ListByIdQueryVariables>(ListByIdDocument, options);
      }
export function useListByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListByIdQuery, ListByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListByIdQuery, ListByIdQueryVariables>(ListByIdDocument, options);
        }
export function useListByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListByIdQuery, ListByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListByIdQuery, ListByIdQueryVariables>(ListByIdDocument, options);
        }
export type ListByIdQueryHookResult = ReturnType<typeof useListByIdQuery>;
export type ListByIdLazyQueryHookResult = ReturnType<typeof useListByIdLazyQuery>;
export type ListByIdSuspenseQueryHookResult = ReturnType<typeof useListByIdSuspenseQuery>;
export type ListByIdQueryResult = Apollo.QueryResult<ListByIdQuery, ListByIdQueryVariables>;
export const ListManyDocument = gql`
    query ListMany($filter: FilterFindManyListInput, $limit: Int, $sort: SortFindManyListInput) {
  listMany(filter: $filter, limit: $limit, sort: $sort) {
    _id
    description {
      ...MultilingualFragment
    }
    name {
      ...MultilingualFragment
    }
    owner {
      entityId
      type
    }
    type
    entityReferences {
      _entityId
      _versionId
      type
    }
    updatedDateISO
    archived
    favorited
  }
}
    ${MultilingualFragmentFragmentDoc}`;

/**
 * __useListManyQuery__
 *
 * To run a query within a React component, call `useListManyQuery` and pass it any options that fit your needs.
 * When your component renders, `useListManyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListManyQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      limit: // value for 'limit'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useListManyQuery(baseOptions?: Apollo.QueryHookOptions<ListManyQuery, ListManyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListManyQuery, ListManyQueryVariables>(ListManyDocument, options);
      }
export function useListManyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListManyQuery, ListManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListManyQuery, ListManyQueryVariables>(ListManyDocument, options);
        }
export function useListManySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListManyQuery, ListManyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListManyQuery, ListManyQueryVariables>(ListManyDocument, options);
        }
export type ListManyQueryHookResult = ReturnType<typeof useListManyQuery>;
export type ListManyLazyQueryHookResult = ReturnType<typeof useListManyLazyQuery>;
export type ListManySuspenseQueryHookResult = ReturnType<typeof useListManySuspenseQuery>;
export type ListManyQueryResult = Apollo.QueryResult<ListManyQuery, ListManyQueryVariables>;
export const MaintenanceFindOneDocument = gql`
    query MaintenanceFindOne {
  maintenanceFindOne {
    banner {
      isLive
      message {
        ...MultilingualFragment
      }
    }
    doorstop {
      isLive
      message {
        ...MultilingualFragment
      }
    }
  }
}
    ${MultilingualFragmentFragmentDoc}`;

/**
 * __useMaintenanceFindOneQuery__
 *
 * To run a query within a React component, call `useMaintenanceFindOneQuery` and pass it any options that fit your needs.
 * When your component renders, `useMaintenanceFindOneQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMaintenanceFindOneQuery({
 *   variables: {
 *   },
 * });
 */
export function useMaintenanceFindOneQuery(baseOptions?: Apollo.QueryHookOptions<MaintenanceFindOneQuery, MaintenanceFindOneQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MaintenanceFindOneQuery, MaintenanceFindOneQueryVariables>(MaintenanceFindOneDocument, options);
      }
export function useMaintenanceFindOneLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MaintenanceFindOneQuery, MaintenanceFindOneQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MaintenanceFindOneQuery, MaintenanceFindOneQueryVariables>(MaintenanceFindOneDocument, options);
        }
export function useMaintenanceFindOneSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MaintenanceFindOneQuery, MaintenanceFindOneQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MaintenanceFindOneQuery, MaintenanceFindOneQueryVariables>(MaintenanceFindOneDocument, options);
        }
export type MaintenanceFindOneQueryHookResult = ReturnType<typeof useMaintenanceFindOneQuery>;
export type MaintenanceFindOneLazyQueryHookResult = ReturnType<typeof useMaintenanceFindOneLazyQuery>;
export type MaintenanceFindOneSuspenseQueryHookResult = ReturnType<typeof useMaintenanceFindOneSuspenseQuery>;
export type MaintenanceFindOneQueryResult = Apollo.QueryResult<MaintenanceFindOneQuery, MaintenanceFindOneQueryVariables>;
export const NoteManyDocument = gql`
    query NoteMany($filter: FilterFindManyNoteInput, $sort: SortFindManyNoteInput, $limit: Int) {
  noteMany(filter: $filter, sort: $sort, limit: $limit) {
    ...NoteFramgment
  }
}
    ${NoteFramgmentFragmentDoc}`;

/**
 * __useNoteManyQuery__
 *
 * To run a query within a React component, call `useNoteManyQuery` and pass it any options that fit your needs.
 * When your component renders, `useNoteManyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNoteManyQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useNoteManyQuery(baseOptions?: Apollo.QueryHookOptions<NoteManyQuery, NoteManyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NoteManyQuery, NoteManyQueryVariables>(NoteManyDocument, options);
      }
export function useNoteManyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NoteManyQuery, NoteManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NoteManyQuery, NoteManyQueryVariables>(NoteManyDocument, options);
        }
export function useNoteManySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<NoteManyQuery, NoteManyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<NoteManyQuery, NoteManyQueryVariables>(NoteManyDocument, options);
        }
export type NoteManyQueryHookResult = ReturnType<typeof useNoteManyQuery>;
export type NoteManyLazyQueryHookResult = ReturnType<typeof useNoteManyLazyQuery>;
export type NoteManySuspenseQueryHookResult = ReturnType<typeof useNoteManySuspenseQuery>;
export type NoteManyQueryResult = Apollo.QueryResult<NoteManyQuery, NoteManyQueryVariables>;
export const OperatorByIdDocument = gql`
    query OperatorById($operatorId: ID!) {
  operatorById(operatorEntityId: $operatorId) {
    _entityId
    _versionId
    updatedDateISO
    name {
      ...MultilingualFragment
    }
    type
    operationalStatus
    images {
      ...ImageFragment
    }
    tags {
      organizationSpecific {
        _id
        name {
          ...MultilingualFragment
        }
        tagGroup {
          _id
          key
          name {
            ...MultilingualFragment
          }
          type
        }
      }
      global {
        _id
        name {
          ...MultilingualFragment
        }
        tagGroup {
          _id
          key
          name {
            ...MultilingualFragment
          }
          type
        }
      }
      businessType {
        _id
        name {
          ...MultilingualFragment
        }
        tagGroup {
          _id
          key
          name {
            ...MultilingualFragment
          }
          type
        }
      }
      amenity {
        _id
        name {
          ...MultilingualFragment
        }
        tagGroup {
          _id
          key
          name {
            ...MultilingualFragment
          }
          type
        }
      }
    }
    description {
      ...MultilingualFragment
    }
    shortDescription {
      ...MultilingualFragment
    }
    pricing
    contact {
      ...ContactFragment
    }
    seasonality {
      jan
      feb
      mar
      apr
      may
      jun
      jul
      aug
      sep
      oct
      nov
      dec
    }
    hoursOfOperation {
      sun {
        start
        end
      }
      mon {
        start
        end
      }
      tue {
        start
        end
      }
      wed {
        start
        end
      }
      thu {
        start
        end
      }
      fri {
        start
        end
      }
      sat {
        start
        end
      }
    }
    status
    enrollments {
      organization
      organizationControlled
      onboardingStatus
    }
  }
}
    ${MultilingualFragmentFragmentDoc}
${ImageFragmentFragmentDoc}
${ContactFragmentFragmentDoc}`;

/**
 * __useOperatorByIdQuery__
 *
 * To run a query within a React component, call `useOperatorByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useOperatorByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOperatorByIdQuery({
 *   variables: {
 *      operatorId: // value for 'operatorId'
 *   },
 * });
 */
export function useOperatorByIdQuery(baseOptions: Apollo.QueryHookOptions<OperatorByIdQuery, OperatorByIdQueryVariables> & ({ variables: OperatorByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OperatorByIdQuery, OperatorByIdQueryVariables>(OperatorByIdDocument, options);
      }
export function useOperatorByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OperatorByIdQuery, OperatorByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OperatorByIdQuery, OperatorByIdQueryVariables>(OperatorByIdDocument, options);
        }
export function useOperatorByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OperatorByIdQuery, OperatorByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OperatorByIdQuery, OperatorByIdQueryVariables>(OperatorByIdDocument, options);
        }
export type OperatorByIdQueryHookResult = ReturnType<typeof useOperatorByIdQuery>;
export type OperatorByIdLazyQueryHookResult = ReturnType<typeof useOperatorByIdLazyQuery>;
export type OperatorByIdSuspenseQueryHookResult = ReturnType<typeof useOperatorByIdSuspenseQuery>;
export type OperatorByIdQueryResult = Apollo.QueryResult<OperatorByIdQuery, OperatorByIdQueryVariables>;
export const OperatorNameByIdDocument = gql`
    query OperatorNameById($operatorEntityId: ID!) {
  operatorById(operatorEntityId: $operatorEntityId) {
    name {
      ...MultilingualFragment
    }
  }
}
    ${MultilingualFragmentFragmentDoc}`;

/**
 * __useOperatorNameByIdQuery__
 *
 * To run a query within a React component, call `useOperatorNameByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useOperatorNameByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOperatorNameByIdQuery({
 *   variables: {
 *      operatorEntityId: // value for 'operatorEntityId'
 *   },
 * });
 */
export function useOperatorNameByIdQuery(baseOptions: Apollo.QueryHookOptions<OperatorNameByIdQuery, OperatorNameByIdQueryVariables> & ({ variables: OperatorNameByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OperatorNameByIdQuery, OperatorNameByIdQueryVariables>(OperatorNameByIdDocument, options);
      }
export function useOperatorNameByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OperatorNameByIdQuery, OperatorNameByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OperatorNameByIdQuery, OperatorNameByIdQueryVariables>(OperatorNameByIdDocument, options);
        }
export function useOperatorNameByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OperatorNameByIdQuery, OperatorNameByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OperatorNameByIdQuery, OperatorNameByIdQueryVariables>(OperatorNameByIdDocument, options);
        }
export type OperatorNameByIdQueryHookResult = ReturnType<typeof useOperatorNameByIdQuery>;
export type OperatorNameByIdLazyQueryHookResult = ReturnType<typeof useOperatorNameByIdLazyQuery>;
export type OperatorNameByIdSuspenseQueryHookResult = ReturnType<typeof useOperatorNameByIdSuspenseQuery>;
export type OperatorNameByIdQueryResult = Apollo.QueryResult<OperatorNameByIdQuery, OperatorNameByIdQueryVariables>;
export const OperatorStaffDocument = gql`
    query OperatorStaff($operatorId: ID!) {
  operatorStaff(operatorId: $operatorId) {
    ...UserFragment
    email
  }
}
    ${UserFragmentFragmentDoc}`;

/**
 * __useOperatorStaffQuery__
 *
 * To run a query within a React component, call `useOperatorStaffQuery` and pass it any options that fit your needs.
 * When your component renders, `useOperatorStaffQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOperatorStaffQuery({
 *   variables: {
 *      operatorId: // value for 'operatorId'
 *   },
 * });
 */
export function useOperatorStaffQuery(baseOptions: Apollo.QueryHookOptions<OperatorStaffQuery, OperatorStaffQueryVariables> & ({ variables: OperatorStaffQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OperatorStaffQuery, OperatorStaffQueryVariables>(OperatorStaffDocument, options);
      }
export function useOperatorStaffLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OperatorStaffQuery, OperatorStaffQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OperatorStaffQuery, OperatorStaffQueryVariables>(OperatorStaffDocument, options);
        }
export function useOperatorStaffSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OperatorStaffQuery, OperatorStaffQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OperatorStaffQuery, OperatorStaffQueryVariables>(OperatorStaffDocument, options);
        }
export type OperatorStaffQueryHookResult = ReturnType<typeof useOperatorStaffQuery>;
export type OperatorStaffLazyQueryHookResult = ReturnType<typeof useOperatorStaffLazyQuery>;
export type OperatorStaffSuspenseQueryHookResult = ReturnType<typeof useOperatorStaffSuspenseQuery>;
export type OperatorStaffQueryResult = Apollo.QueryResult<OperatorStaffQuery, OperatorStaffQueryVariables>;
export const OperatorsByIdsDocument = gql`
    query OperatorsByIds($operatorEntityIds: [ID!], $status: PublicationStatusType) {
  operatorsByIds(operatorEntityIds: $operatorEntityIds, status: $status) {
    _entityId
    _versionId
    name {
      ...MultilingualFragment
    }
    description {
      ...MultilingualFragment
    }
    pricing
    type
    staff {
      email
      firstName
      lastName
    }
    contact {
      address {
        line1
        line2
        city
        subdivision
        postalCode
        country
      }
      phone
      email
      links {
        website
      }
    }
    status
    tags {
      organizationSpecific {
        _id
        name {
          ...MultilingualFragment
        }
        tagGroup {
          _id
          key
          name {
            ...MultilingualFragment
          }
          type
        }
      }
    }
  }
}
    ${MultilingualFragmentFragmentDoc}`;

/**
 * __useOperatorsByIdsQuery__
 *
 * To run a query within a React component, call `useOperatorsByIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOperatorsByIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOperatorsByIdsQuery({
 *   variables: {
 *      operatorEntityIds: // value for 'operatorEntityIds'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useOperatorsByIdsQuery(baseOptions?: Apollo.QueryHookOptions<OperatorsByIdsQuery, OperatorsByIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OperatorsByIdsQuery, OperatorsByIdsQueryVariables>(OperatorsByIdsDocument, options);
      }
export function useOperatorsByIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OperatorsByIdsQuery, OperatorsByIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OperatorsByIdsQuery, OperatorsByIdsQueryVariables>(OperatorsByIdsDocument, options);
        }
export function useOperatorsByIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OperatorsByIdsQuery, OperatorsByIdsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OperatorsByIdsQuery, OperatorsByIdsQueryVariables>(OperatorsByIdsDocument, options);
        }
export type OperatorsByIdsQueryHookResult = ReturnType<typeof useOperatorsByIdsQuery>;
export type OperatorsByIdsLazyQueryHookResult = ReturnType<typeof useOperatorsByIdsLazyQuery>;
export type OperatorsByIdsSuspenseQueryHookResult = ReturnType<typeof useOperatorsByIdsSuspenseQuery>;
export type OperatorsByIdsQueryResult = Apollo.QueryResult<OperatorsByIdsQuery, OperatorsByIdsQueryVariables>;
export const OperatorsByIdsEventCreationDocument = gql`
    query OperatorsByIdsEventCreation($operatorEntityIds: [ID!], $status: PublicationStatusType) {
  operatorsByIds(operatorEntityIds: $operatorEntityIds, status: $status) {
    _entityId
    _versionId
    name {
      ...MultilingualFragment
    }
    enrollments {
      onboardingStatus
      organization
      organizationControlled
    }
    contact {
      email
      phone
      links {
        website
        instagram
        x
        bookNow
        youtube
        pinterest
        googleMyBusiness
        tiktok
        facebook
        tripAdvisor
      }
      address {
        line1
        line2
        city
        subdivision
        postalCode
        country
        location {
          type
          coordinates
        }
      }
    }
  }
}
    ${MultilingualFragmentFragmentDoc}`;

/**
 * __useOperatorsByIdsEventCreationQuery__
 *
 * To run a query within a React component, call `useOperatorsByIdsEventCreationQuery` and pass it any options that fit your needs.
 * When your component renders, `useOperatorsByIdsEventCreationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOperatorsByIdsEventCreationQuery({
 *   variables: {
 *      operatorEntityIds: // value for 'operatorEntityIds'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useOperatorsByIdsEventCreationQuery(baseOptions?: Apollo.QueryHookOptions<OperatorsByIdsEventCreationQuery, OperatorsByIdsEventCreationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OperatorsByIdsEventCreationQuery, OperatorsByIdsEventCreationQueryVariables>(OperatorsByIdsEventCreationDocument, options);
      }
export function useOperatorsByIdsEventCreationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OperatorsByIdsEventCreationQuery, OperatorsByIdsEventCreationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OperatorsByIdsEventCreationQuery, OperatorsByIdsEventCreationQueryVariables>(OperatorsByIdsEventCreationDocument, options);
        }
export function useOperatorsByIdsEventCreationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OperatorsByIdsEventCreationQuery, OperatorsByIdsEventCreationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OperatorsByIdsEventCreationQuery, OperatorsByIdsEventCreationQueryVariables>(OperatorsByIdsEventCreationDocument, options);
        }
export type OperatorsByIdsEventCreationQueryHookResult = ReturnType<typeof useOperatorsByIdsEventCreationQuery>;
export type OperatorsByIdsEventCreationLazyQueryHookResult = ReturnType<typeof useOperatorsByIdsEventCreationLazyQuery>;
export type OperatorsByIdsEventCreationSuspenseQueryHookResult = ReturnType<typeof useOperatorsByIdsEventCreationSuspenseQuery>;
export type OperatorsByIdsEventCreationQueryResult = Apollo.QueryResult<OperatorsByIdsEventCreationQuery, OperatorsByIdsEventCreationQueryVariables>;
export const OperatorsByUserDocument = gql`
    query OperatorsByUser {
  operatorsByUser {
    _id
    _entityId
    _versionId
    claimed
    contact {
      address {
        line1
        line2
        city
        subdivision
        postalCode
        country
        location {
          type
          coordinates
        }
      }
    }
    enrollments {
      organization
      organizationControlled
      onboardingStatus
    }
    name {
      ...MultilingualFragment
    }
    images {
      ...ImageFragment
    }
  }
}
    ${MultilingualFragmentFragmentDoc}
${ImageFragmentFragmentDoc}`;

/**
 * __useOperatorsByUserQuery__
 *
 * To run a query within a React component, call `useOperatorsByUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useOperatorsByUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOperatorsByUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useOperatorsByUserQuery(baseOptions?: Apollo.QueryHookOptions<OperatorsByUserQuery, OperatorsByUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OperatorsByUserQuery, OperatorsByUserQueryVariables>(OperatorsByUserDocument, options);
      }
export function useOperatorsByUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OperatorsByUserQuery, OperatorsByUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OperatorsByUserQuery, OperatorsByUserQueryVariables>(OperatorsByUserDocument, options);
        }
export function useOperatorsByUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OperatorsByUserQuery, OperatorsByUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OperatorsByUserQuery, OperatorsByUserQueryVariables>(OperatorsByUserDocument, options);
        }
export type OperatorsByUserQueryHookResult = ReturnType<typeof useOperatorsByUserQuery>;
export type OperatorsByUserLazyQueryHookResult = ReturnType<typeof useOperatorsByUserLazyQuery>;
export type OperatorsByUserSuspenseQueryHookResult = ReturnType<typeof useOperatorsByUserSuspenseQuery>;
export type OperatorsByUserQueryResult = Apollo.QueryResult<OperatorsByUserQuery, OperatorsByUserQueryVariables>;
export const OperatorManyDocument = gql`
    query OperatorMany($filter: FilterFindManyOperatorInput, $avgImageQuality: [ImageQualityRating!], $publicationStatus: PublicationStatusType, $limit: Int, $skip: Int, $useCase: OperatorManyUseCaseEnum, $imageCount: NumberInput, $includeInvitedOrAcceptedStaffCounts: Boolean) {
  operatorMany(
    filter: $filter
    avgImageQuality: $avgImageQuality
    publicationStatus: $publicationStatus
    limit: $limit
    skip: $skip
    useCase: $useCase
    imageCount: $imageCount
    includeInvitedOrAcceptedStaffCounts: $includeInvitedOrAcceptedStaffCounts
  ) {
    _entityId
    _versionId
    updatedDateISO
    claimed
    name {
      ...MultilingualFragment
    }
    type
    images {
      ...ImageFragment
    }
    status
    iasc
    enrollments {
      onboardingStatus
      organization
      organizationControlled
    }
    contact {
      email
      address {
        line1
        line2
        city
        subdivision
        postalCode
        country
        location {
          type
          coordinates
        }
      }
    }
  }
}
    ${MultilingualFragmentFragmentDoc}
${ImageFragmentFragmentDoc}`;

/**
 * __useOperatorManyQuery__
 *
 * To run a query within a React component, call `useOperatorManyQuery` and pass it any options that fit your needs.
 * When your component renders, `useOperatorManyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOperatorManyQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      avgImageQuality: // value for 'avgImageQuality'
 *      publicationStatus: // value for 'publicationStatus'
 *      limit: // value for 'limit'
 *      skip: // value for 'skip'
 *      useCase: // value for 'useCase'
 *      imageCount: // value for 'imageCount'
 *      includeInvitedOrAcceptedStaffCounts: // value for 'includeInvitedOrAcceptedStaffCounts'
 *   },
 * });
 */
export function useOperatorManyQuery(baseOptions?: Apollo.QueryHookOptions<OperatorManyQuery, OperatorManyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OperatorManyQuery, OperatorManyQueryVariables>(OperatorManyDocument, options);
      }
export function useOperatorManyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OperatorManyQuery, OperatorManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OperatorManyQuery, OperatorManyQueryVariables>(OperatorManyDocument, options);
        }
export function useOperatorManySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OperatorManyQuery, OperatorManyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OperatorManyQuery, OperatorManyQueryVariables>(OperatorManyDocument, options);
        }
export type OperatorManyQueryHookResult = ReturnType<typeof useOperatorManyQuery>;
export type OperatorManyLazyQueryHookResult = ReturnType<typeof useOperatorManyLazyQuery>;
export type OperatorManySuspenseQueryHookResult = ReturnType<typeof useOperatorManySuspenseQuery>;
export type OperatorManyQueryResult = Apollo.QueryResult<OperatorManyQuery, OperatorManyQueryVariables>;
export const OperatorsManyEventCreationDocument = gql`
    query OperatorsManyEventCreation($filter: FilterFindManyOperatorInput, $avgImageQuality: [ImageQualityRating!], $publicationStatus: PublicationStatusType, $limit: Int, $skip: Int, $useCase: OperatorManyUseCaseEnum, $imageCount: NumberInput, $includeInvitedOrAcceptedStaffCounts: Boolean) {
  operatorMany(
    filter: $filter
    avgImageQuality: $avgImageQuality
    publicationStatus: $publicationStatus
    limit: $limit
    skip: $skip
    useCase: $useCase
    imageCount: $imageCount
    includeInvitedOrAcceptedStaffCounts: $includeInvitedOrAcceptedStaffCounts
  ) {
    _entityId
    _versionId
    name {
      ...MultilingualFragment
    }
    enrollments {
      onboardingStatus
      organization
      organizationControlled
    }
    contact {
      email
      phone
      links {
        website
        instagram
        x
        bookNow
        youtube
        pinterest
        googleMyBusiness
        tiktok
        facebook
        tripAdvisor
      }
      address {
        line1
        line2
        city
        subdivision
        postalCode
        country
        location {
          type
          coordinates
        }
      }
    }
  }
}
    ${MultilingualFragmentFragmentDoc}`;

/**
 * __useOperatorsManyEventCreationQuery__
 *
 * To run a query within a React component, call `useOperatorsManyEventCreationQuery` and pass it any options that fit your needs.
 * When your component renders, `useOperatorsManyEventCreationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOperatorsManyEventCreationQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      avgImageQuality: // value for 'avgImageQuality'
 *      publicationStatus: // value for 'publicationStatus'
 *      limit: // value for 'limit'
 *      skip: // value for 'skip'
 *      useCase: // value for 'useCase'
 *      imageCount: // value for 'imageCount'
 *      includeInvitedOrAcceptedStaffCounts: // value for 'includeInvitedOrAcceptedStaffCounts'
 *   },
 * });
 */
export function useOperatorsManyEventCreationQuery(baseOptions?: Apollo.QueryHookOptions<OperatorsManyEventCreationQuery, OperatorsManyEventCreationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OperatorsManyEventCreationQuery, OperatorsManyEventCreationQueryVariables>(OperatorsManyEventCreationDocument, options);
      }
export function useOperatorsManyEventCreationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OperatorsManyEventCreationQuery, OperatorsManyEventCreationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OperatorsManyEventCreationQuery, OperatorsManyEventCreationQueryVariables>(OperatorsManyEventCreationDocument, options);
        }
export function useOperatorsManyEventCreationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OperatorsManyEventCreationQuery, OperatorsManyEventCreationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OperatorsManyEventCreationQuery, OperatorsManyEventCreationQueryVariables>(OperatorsManyEventCreationDocument, options);
        }
export type OperatorsManyEventCreationQueryHookResult = ReturnType<typeof useOperatorsManyEventCreationQuery>;
export type OperatorsManyEventCreationLazyQueryHookResult = ReturnType<typeof useOperatorsManyEventCreationLazyQuery>;
export type OperatorsManyEventCreationSuspenseQueryHookResult = ReturnType<typeof useOperatorsManyEventCreationSuspenseQuery>;
export type OperatorsManyEventCreationQueryResult = Apollo.QueryResult<OperatorsManyEventCreationQuery, OperatorsManyEventCreationQueryVariables>;
export const OrganizationByIdDocument = gql`
    query OrganizationById($id: MongoID!) {
  organizationById(_id: $id) {
    _id
    name {
      ...MultilingualFragment
    }
    description {
      ...MultilingualFragment
    }
    shortDescription {
      ...MultilingualFragment
    }
    contact {
      ...ContactFragment
    }
    logo {
      ...ImageFragment
    }
    images {
      ...ImageFragment
    }
    onboardingMetadata {
      videoId
      introMessage
      allowColdSignup
    }
  }
}
    ${MultilingualFragmentFragmentDoc}
${ContactFragmentFragmentDoc}
${ImageFragmentFragmentDoc}`;

/**
 * __useOrganizationByIdQuery__
 *
 * To run a query within a React component, call `useOrganizationByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOrganizationByIdQuery(baseOptions: Apollo.QueryHookOptions<OrganizationByIdQuery, OrganizationByIdQueryVariables> & ({ variables: OrganizationByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganizationByIdQuery, OrganizationByIdQueryVariables>(OrganizationByIdDocument, options);
      }
export function useOrganizationByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganizationByIdQuery, OrganizationByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganizationByIdQuery, OrganizationByIdQueryVariables>(OrganizationByIdDocument, options);
        }
export function useOrganizationByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrganizationByIdQuery, OrganizationByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrganizationByIdQuery, OrganizationByIdQueryVariables>(OrganizationByIdDocument, options);
        }
export type OrganizationByIdQueryHookResult = ReturnType<typeof useOrganizationByIdQuery>;
export type OrganizationByIdLazyQueryHookResult = ReturnType<typeof useOrganizationByIdLazyQuery>;
export type OrganizationByIdSuspenseQueryHookResult = ReturnType<typeof useOrganizationByIdSuspenseQuery>;
export type OrganizationByIdQueryResult = Apollo.QueryResult<OrganizationByIdQuery, OrganizationByIdQueryVariables>;
export const OrganizationLogoByIdDocument = gql`
    query OrganizationLogoById($id: MongoID!) {
  organizationById(_id: $id) {
    logo {
      ...ImageFragment
    }
  }
}
    ${ImageFragmentFragmentDoc}`;

/**
 * __useOrganizationLogoByIdQuery__
 *
 * To run a query within a React component, call `useOrganizationLogoByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationLogoByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationLogoByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOrganizationLogoByIdQuery(baseOptions: Apollo.QueryHookOptions<OrganizationLogoByIdQuery, OrganizationLogoByIdQueryVariables> & ({ variables: OrganizationLogoByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganizationLogoByIdQuery, OrganizationLogoByIdQueryVariables>(OrganizationLogoByIdDocument, options);
      }
export function useOrganizationLogoByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganizationLogoByIdQuery, OrganizationLogoByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganizationLogoByIdQuery, OrganizationLogoByIdQueryVariables>(OrganizationLogoByIdDocument, options);
        }
export function useOrganizationLogoByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrganizationLogoByIdQuery, OrganizationLogoByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrganizationLogoByIdQuery, OrganizationLogoByIdQueryVariables>(OrganizationLogoByIdDocument, options);
        }
export type OrganizationLogoByIdQueryHookResult = ReturnType<typeof useOrganizationLogoByIdQuery>;
export type OrganizationLogoByIdLazyQueryHookResult = ReturnType<typeof useOrganizationLogoByIdLazyQuery>;
export type OrganizationLogoByIdSuspenseQueryHookResult = ReturnType<typeof useOrganizationLogoByIdSuspenseQuery>;
export type OrganizationLogoByIdQueryResult = Apollo.QueryResult<OrganizationLogoByIdQuery, OrganizationLogoByIdQueryVariables>;
export const OrganizationNameByIdDocument = gql`
    query OrganizationNameById($id: MongoID!) {
  organizationById(_id: $id) {
    _id
    name {
      ...MultilingualFragment
    }
  }
}
    ${MultilingualFragmentFragmentDoc}`;

/**
 * __useOrganizationNameByIdQuery__
 *
 * To run a query within a React component, call `useOrganizationNameByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationNameByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationNameByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOrganizationNameByIdQuery(baseOptions: Apollo.QueryHookOptions<OrganizationNameByIdQuery, OrganizationNameByIdQueryVariables> & ({ variables: OrganizationNameByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganizationNameByIdQuery, OrganizationNameByIdQueryVariables>(OrganizationNameByIdDocument, options);
      }
export function useOrganizationNameByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganizationNameByIdQuery, OrganizationNameByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganizationNameByIdQuery, OrganizationNameByIdQueryVariables>(OrganizationNameByIdDocument, options);
        }
export function useOrganizationNameByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrganizationNameByIdQuery, OrganizationNameByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrganizationNameByIdQuery, OrganizationNameByIdQueryVariables>(OrganizationNameByIdDocument, options);
        }
export type OrganizationNameByIdQueryHookResult = ReturnType<typeof useOrganizationNameByIdQuery>;
export type OrganizationNameByIdLazyQueryHookResult = ReturnType<typeof useOrganizationNameByIdLazyQuery>;
export type OrganizationNameByIdSuspenseQueryHookResult = ReturnType<typeof useOrganizationNameByIdSuspenseQuery>;
export type OrganizationNameByIdQueryResult = Apollo.QueryResult<OrganizationNameByIdQuery, OrganizationNameByIdQueryVariables>;
export const OrganizationStaffDocument = gql`
    query OrganizationStaff($organizationId: ID!) {
  organizationStaff(organizationId: $organizationId) {
    ...UserFragment
    email
  }
}
    ${UserFragmentFragmentDoc}`;

/**
 * __useOrganizationStaffQuery__
 *
 * To run a query within a React component, call `useOrganizationStaffQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationStaffQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationStaffQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useOrganizationStaffQuery(baseOptions: Apollo.QueryHookOptions<OrganizationStaffQuery, OrganizationStaffQueryVariables> & ({ variables: OrganizationStaffQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganizationStaffQuery, OrganizationStaffQueryVariables>(OrganizationStaffDocument, options);
      }
export function useOrganizationStaffLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganizationStaffQuery, OrganizationStaffQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganizationStaffQuery, OrganizationStaffQueryVariables>(OrganizationStaffDocument, options);
        }
export function useOrganizationStaffSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrganizationStaffQuery, OrganizationStaffQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrganizationStaffQuery, OrganizationStaffQueryVariables>(OrganizationStaffDocument, options);
        }
export type OrganizationStaffQueryHookResult = ReturnType<typeof useOrganizationStaffQuery>;
export type OrganizationStaffLazyQueryHookResult = ReturnType<typeof useOrganizationStaffLazyQuery>;
export type OrganizationStaffSuspenseQueryHookResult = ReturnType<typeof useOrganizationStaffSuspenseQuery>;
export type OrganizationStaffQueryResult = Apollo.QueryResult<OrganizationStaffQuery, OrganizationStaffQueryVariables>;
export const OrganizationsByIdsDocument = gql`
    query OrganizationsByIds($ids: [MongoID!]!, $limit: Int, $sort: SortFindByIdsOrganizationInput) {
  organizationsByIds(_ids: $ids, limit: $limit, sort: $sort) {
    _id
    name {
      ...MultilingualFragment
    }
    logo {
      ...ImageFragment
    }
    contact {
      email
      links {
        website
      }
      phone
    }
  }
}
    ${MultilingualFragmentFragmentDoc}
${ImageFragmentFragmentDoc}`;

/**
 * __useOrganizationsByIdsQuery__
 *
 * To run a query within a React component, call `useOrganizationsByIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationsByIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationsByIdsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *      limit: // value for 'limit'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useOrganizationsByIdsQuery(baseOptions: Apollo.QueryHookOptions<OrganizationsByIdsQuery, OrganizationsByIdsQueryVariables> & ({ variables: OrganizationsByIdsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganizationsByIdsQuery, OrganizationsByIdsQueryVariables>(OrganizationsByIdsDocument, options);
      }
export function useOrganizationsByIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganizationsByIdsQuery, OrganizationsByIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganizationsByIdsQuery, OrganizationsByIdsQueryVariables>(OrganizationsByIdsDocument, options);
        }
export function useOrganizationsByIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrganizationsByIdsQuery, OrganizationsByIdsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrganizationsByIdsQuery, OrganizationsByIdsQueryVariables>(OrganizationsByIdsDocument, options);
        }
export type OrganizationsByIdsQueryHookResult = ReturnType<typeof useOrganizationsByIdsQuery>;
export type OrganizationsByIdsLazyQueryHookResult = ReturnType<typeof useOrganizationsByIdsLazyQuery>;
export type OrganizationsByIdsSuspenseQueryHookResult = ReturnType<typeof useOrganizationsByIdsSuspenseQuery>;
export type OrganizationsByIdsQueryResult = Apollo.QueryResult<OrganizationsByIdsQuery, OrganizationsByIdsQueryVariables>;
export const OrganizationsByUserDocument = gql`
    query OrganizationsByUser {
  organizationsByUser {
    _id
    name {
      ...MultilingualFragment
    }
    logo {
      ...ImageFragment
    }
    contact {
      links {
        website
      }
    }
    metadata {
      inviteWhenAddingStaff
    }
  }
}
    ${MultilingualFragmentFragmentDoc}
${ImageFragmentFragmentDoc}`;

/**
 * __useOrganizationsByUserQuery__
 *
 * To run a query within a React component, call `useOrganizationsByUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationsByUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationsByUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useOrganizationsByUserQuery(baseOptions?: Apollo.QueryHookOptions<OrganizationsByUserQuery, OrganizationsByUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganizationsByUserQuery, OrganizationsByUserQueryVariables>(OrganizationsByUserDocument, options);
      }
export function useOrganizationsByUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganizationsByUserQuery, OrganizationsByUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganizationsByUserQuery, OrganizationsByUserQueryVariables>(OrganizationsByUserDocument, options);
        }
export function useOrganizationsByUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrganizationsByUserQuery, OrganizationsByUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrganizationsByUserQuery, OrganizationsByUserQueryVariables>(OrganizationsByUserDocument, options);
        }
export type OrganizationsByUserQueryHookResult = ReturnType<typeof useOrganizationsByUserQuery>;
export type OrganizationsByUserLazyQueryHookResult = ReturnType<typeof useOrganizationsByUserLazyQuery>;
export type OrganizationsByUserSuspenseQueryHookResult = ReturnType<typeof useOrganizationsByUserSuspenseQuery>;
export type OrganizationsByUserQueryResult = Apollo.QueryResult<OrganizationsByUserQuery, OrganizationsByUserQueryVariables>;
export const TagGroupOneDocument = gql`
    query TagGroupOne($filter: FilterFindOneTagGroupInput) {
  tagGroupOne(filter: $filter) {
    _id
    key
    name {
      ...MultilingualFragment
    }
    type
  }
}
    ${MultilingualFragmentFragmentDoc}`;

/**
 * __useTagGroupOneQuery__
 *
 * To run a query within a React component, call `useTagGroupOneQuery` and pass it any options that fit your needs.
 * When your component renders, `useTagGroupOneQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTagGroupOneQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useTagGroupOneQuery(baseOptions?: Apollo.QueryHookOptions<TagGroupOneQuery, TagGroupOneQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TagGroupOneQuery, TagGroupOneQueryVariables>(TagGroupOneDocument, options);
      }
export function useTagGroupOneLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TagGroupOneQuery, TagGroupOneQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TagGroupOneQuery, TagGroupOneQueryVariables>(TagGroupOneDocument, options);
        }
export function useTagGroupOneSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TagGroupOneQuery, TagGroupOneQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TagGroupOneQuery, TagGroupOneQueryVariables>(TagGroupOneDocument, options);
        }
export type TagGroupOneQueryHookResult = ReturnType<typeof useTagGroupOneQuery>;
export type TagGroupOneLazyQueryHookResult = ReturnType<typeof useTagGroupOneLazyQuery>;
export type TagGroupOneSuspenseQueryHookResult = ReturnType<typeof useTagGroupOneSuspenseQuery>;
export type TagGroupOneQueryResult = Apollo.QueryResult<TagGroupOneQuery, TagGroupOneQueryVariables>;
export const TagGroupByIdsDocument = gql`
    query TagGroupByIds($ids: [MongoID!]!, $limit: Int) {
  tagGroupByIds(_ids: $ids, limit: $limit) {
    _id
    key
    name {
      ...MultilingualFragment
    }
    type
  }
}
    ${MultilingualFragmentFragmentDoc}`;

/**
 * __useTagGroupByIdsQuery__
 *
 * To run a query within a React component, call `useTagGroupByIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTagGroupByIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTagGroupByIdsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useTagGroupByIdsQuery(baseOptions: Apollo.QueryHookOptions<TagGroupByIdsQuery, TagGroupByIdsQueryVariables> & ({ variables: TagGroupByIdsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TagGroupByIdsQuery, TagGroupByIdsQueryVariables>(TagGroupByIdsDocument, options);
      }
export function useTagGroupByIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TagGroupByIdsQuery, TagGroupByIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TagGroupByIdsQuery, TagGroupByIdsQueryVariables>(TagGroupByIdsDocument, options);
        }
export function useTagGroupByIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TagGroupByIdsQuery, TagGroupByIdsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TagGroupByIdsQuery, TagGroupByIdsQueryVariables>(TagGroupByIdsDocument, options);
        }
export type TagGroupByIdsQueryHookResult = ReturnType<typeof useTagGroupByIdsQuery>;
export type TagGroupByIdsLazyQueryHookResult = ReturnType<typeof useTagGroupByIdsLazyQuery>;
export type TagGroupByIdsSuspenseQueryHookResult = ReturnType<typeof useTagGroupByIdsSuspenseQuery>;
export type TagGroupByIdsQueryResult = Apollo.QueryResult<TagGroupByIdsQuery, TagGroupByIdsQueryVariables>;
export const TagManyDocument = gql`
    query TagMany($filter: FilterFindManyTagInput, $limit: Int) {
  tagMany(filter: $filter, limit: $limit) {
    name {
      ...MultilingualFragment
    }
    _id
    entityTypes
    owner {
      entityId
      type
    }
    tagGroup {
      _id
      key
      name {
        ...MultilingualFragment
      }
      type
    }
  }
}
    ${MultilingualFragmentFragmentDoc}`;

/**
 * __useTagManyQuery__
 *
 * To run a query within a React component, call `useTagManyQuery` and pass it any options that fit your needs.
 * When your component renders, `useTagManyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTagManyQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useTagManyQuery(baseOptions?: Apollo.QueryHookOptions<TagManyQuery, TagManyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TagManyQuery, TagManyQueryVariables>(TagManyDocument, options);
      }
export function useTagManyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TagManyQuery, TagManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TagManyQuery, TagManyQueryVariables>(TagManyDocument, options);
        }
export function useTagManySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TagManyQuery, TagManyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TagManyQuery, TagManyQueryVariables>(TagManyDocument, options);
        }
export type TagManyQueryHookResult = ReturnType<typeof useTagManyQuery>;
export type TagManyLazyQueryHookResult = ReturnType<typeof useTagManyLazyQuery>;
export type TagManySuspenseQueryHookResult = ReturnType<typeof useTagManySuspenseQuery>;
export type TagManyQueryResult = Apollo.QueryResult<TagManyQuery, TagManyQueryVariables>;
export const TagByIdsDocument = gql`
    query TagByIds($ids: [MongoID!]!, $limit: Int) {
  tagByIds(_ids: $ids, limit: $limit) {
    _id
    entityTypes
    owner {
      entityId
      type
    }
    tagGroup {
      _id
      key
      type
      name {
        ...MultilingualFragment
      }
    }
    name {
      ...MultilingualFragment
    }
  }
}
    ${MultilingualFragmentFragmentDoc}`;

/**
 * __useTagByIdsQuery__
 *
 * To run a query within a React component, call `useTagByIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTagByIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTagByIdsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useTagByIdsQuery(baseOptions: Apollo.QueryHookOptions<TagByIdsQuery, TagByIdsQueryVariables> & ({ variables: TagByIdsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TagByIdsQuery, TagByIdsQueryVariables>(TagByIdsDocument, options);
      }
export function useTagByIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TagByIdsQuery, TagByIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TagByIdsQuery, TagByIdsQueryVariables>(TagByIdsDocument, options);
        }
export function useTagByIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TagByIdsQuery, TagByIdsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TagByIdsQuery, TagByIdsQueryVariables>(TagByIdsDocument, options);
        }
export type TagByIdsQueryHookResult = ReturnType<typeof useTagByIdsQuery>;
export type TagByIdsLazyQueryHookResult = ReturnType<typeof useTagByIdsLazyQuery>;
export type TagByIdsSuspenseQueryHookResult = ReturnType<typeof useTagByIdsSuspenseQuery>;
export type TagByIdsQueryResult = Apollo.QueryResult<TagByIdsQuery, TagByIdsQueryVariables>;
export const UserByIdDocument = gql`
    query UserById($id: MongoID!) {
  userById(_id: $id) {
    ...UserFragment
  }
}
    ${UserFragmentFragmentDoc}`;

/**
 * __useUserByIdQuery__
 *
 * To run a query within a React component, call `useUserByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUserByIdQuery(baseOptions: Apollo.QueryHookOptions<UserByIdQuery, UserByIdQueryVariables> & ({ variables: UserByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserByIdQuery, UserByIdQueryVariables>(UserByIdDocument, options);
      }
export function useUserByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserByIdQuery, UserByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserByIdQuery, UserByIdQueryVariables>(UserByIdDocument, options);
        }
export function useUserByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserByIdQuery, UserByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserByIdQuery, UserByIdQueryVariables>(UserByIdDocument, options);
        }
export type UserByIdQueryHookResult = ReturnType<typeof useUserByIdQuery>;
export type UserByIdLazyQueryHookResult = ReturnType<typeof useUserByIdLazyQuery>;
export type UserByIdSuspenseQueryHookResult = ReturnType<typeof useUserByIdSuspenseQuery>;
export type UserByIdQueryResult = Apollo.QueryResult<UserByIdQuery, UserByIdQueryVariables>;
export const UserFindOneDocument = gql`
    query UserFindOne($filter: FilterFindOneUserInput) {
  userFindOne(filter: $filter) {
    ...UserFragment
  }
}
    ${UserFragmentFragmentDoc}`;

/**
 * __useUserFindOneQuery__
 *
 * To run a query within a React component, call `useUserFindOneQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserFindOneQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserFindOneQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useUserFindOneQuery(baseOptions?: Apollo.QueryHookOptions<UserFindOneQuery, UserFindOneQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserFindOneQuery, UserFindOneQueryVariables>(UserFindOneDocument, options);
      }
export function useUserFindOneLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserFindOneQuery, UserFindOneQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserFindOneQuery, UserFindOneQueryVariables>(UserFindOneDocument, options);
        }
export function useUserFindOneSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserFindOneQuery, UserFindOneQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserFindOneQuery, UserFindOneQueryVariables>(UserFindOneDocument, options);
        }
export type UserFindOneQueryHookResult = ReturnType<typeof useUserFindOneQuery>;
export type UserFindOneLazyQueryHookResult = ReturnType<typeof useUserFindOneLazyQuery>;
export type UserFindOneSuspenseQueryHookResult = ReturnType<typeof useUserFindOneSuspenseQuery>;
export type UserFindOneQueryResult = Apollo.QueryResult<UserFindOneQuery, UserFindOneQueryVariables>;
export const UserFindOneByEmailDocument = gql`
    query UserFindOneByEmail($email: String!) {
  userFindOneByEmail(email: $email) {
    _id
    email
    firstName
    lastName
    passwordResetUrl
    status
    access {
      operators {
        entityId
        status
      }
      organizations {
        entityId
        status
      }
    }
  }
}
    `;

/**
 * __useUserFindOneByEmailQuery__
 *
 * To run a query within a React component, call `useUserFindOneByEmailQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserFindOneByEmailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserFindOneByEmailQuery({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useUserFindOneByEmailQuery(baseOptions: Apollo.QueryHookOptions<UserFindOneByEmailQuery, UserFindOneByEmailQueryVariables> & ({ variables: UserFindOneByEmailQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserFindOneByEmailQuery, UserFindOneByEmailQueryVariables>(UserFindOneByEmailDocument, options);
      }
export function useUserFindOneByEmailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserFindOneByEmailQuery, UserFindOneByEmailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserFindOneByEmailQuery, UserFindOneByEmailQueryVariables>(UserFindOneByEmailDocument, options);
        }
export function useUserFindOneByEmailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserFindOneByEmailQuery, UserFindOneByEmailQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserFindOneByEmailQuery, UserFindOneByEmailQueryVariables>(UserFindOneByEmailDocument, options);
        }
export type UserFindOneByEmailQueryHookResult = ReturnType<typeof useUserFindOneByEmailQuery>;
export type UserFindOneByEmailLazyQueryHookResult = ReturnType<typeof useUserFindOneByEmailLazyQuery>;
export type UserFindOneByEmailSuspenseQueryHookResult = ReturnType<typeof useUserFindOneByEmailSuspenseQuery>;
export type UserFindOneByEmailQueryResult = Apollo.QueryResult<UserFindOneByEmailQuery, UserFindOneByEmailQueryVariables>;
export const UserRequestEmailVerificationDocument = gql`
    query UserRequestEmailVerification {
  userRequestEmailVerification
}
    `;

/**
 * __useUserRequestEmailVerificationQuery__
 *
 * To run a query within a React component, call `useUserRequestEmailVerificationQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserRequestEmailVerificationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserRequestEmailVerificationQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserRequestEmailVerificationQuery(baseOptions?: Apollo.QueryHookOptions<UserRequestEmailVerificationQuery, UserRequestEmailVerificationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserRequestEmailVerificationQuery, UserRequestEmailVerificationQueryVariables>(UserRequestEmailVerificationDocument, options);
      }
export function useUserRequestEmailVerificationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserRequestEmailVerificationQuery, UserRequestEmailVerificationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserRequestEmailVerificationQuery, UserRequestEmailVerificationQueryVariables>(UserRequestEmailVerificationDocument, options);
        }
export function useUserRequestEmailVerificationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserRequestEmailVerificationQuery, UserRequestEmailVerificationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserRequestEmailVerificationQuery, UserRequestEmailVerificationQueryVariables>(UserRequestEmailVerificationDocument, options);
        }
export type UserRequestEmailVerificationQueryHookResult = ReturnType<typeof useUserRequestEmailVerificationQuery>;
export type UserRequestEmailVerificationLazyQueryHookResult = ReturnType<typeof useUserRequestEmailVerificationLazyQuery>;
export type UserRequestEmailVerificationSuspenseQueryHookResult = ReturnType<typeof useUserRequestEmailVerificationSuspenseQuery>;
export type UserRequestEmailVerificationQueryResult = Apollo.QueryResult<UserRequestEmailVerificationQuery, UserRequestEmailVerificationQueryVariables>;
export const WidgetByIdDocument = gql`
    query WidgetById($id: MongoID!) {
  widgetById(_id: $id) {
    _id
    type
    name {
      ...MultilingualFragment
    }
    description {
      ...MultilingualFragment
    }
    filterableTags {
      _id
      name {
        ...MultilingualFragment
      }
    }
    archived
    favorited
    list {
      _id
      type
      name {
        ...MultilingualFragment
      }
      description {
        ...MultilingualFragment
      }
      selections
      archived
      favorited
      entities {
        _entityId
        _versionId
        status
        type
        description {
          ...MultilingualFragment
        }
        shortDescription {
          ...MultilingualFragment
        }
        name {
          ...MultilingualFragment
        }
        images {
          ...ImageFragment
        }
        tags {
          businessType {
            _id
            name {
              ...MultilingualFragment
            }
            tagGroup {
              _id
              key
              name {
                ...MultilingualFragment
              }
            }
          }
          global {
            _id
            name {
              ...MultilingualFragment
            }
            tagGroup {
              _id
              key
              name {
                ...MultilingualFragment
              }
            }
          }
          organizationSpecific {
            _id
            name {
              ...MultilingualFragment
            }
            tagGroup {
              _id
              key
              name {
                ...MultilingualFragment
              }
            }
          }
          amenity {
            _id
            name {
              ...MultilingualFragment
            }
            tagGroup {
              _id
              key
              name {
                ...MultilingualFragment
              }
            }
          }
        }
        overrides {
          description {
            ...MultilingualFragment
          }
          shortDescription {
            ...MultilingualFragment
          }
          images {
            ...ImageFragment
          }
        }
      }
    }
    eventSettings {
      displayType
      eventTags
      lookAheadMonths
    }
    owner {
      entityId
    }
  }
}
    ${MultilingualFragmentFragmentDoc}
${ImageFragmentFragmentDoc}`;

/**
 * __useWidgetByIdQuery__
 *
 * To run a query within a React component, call `useWidgetByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useWidgetByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWidgetByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useWidgetByIdQuery(baseOptions: Apollo.QueryHookOptions<WidgetByIdQuery, WidgetByIdQueryVariables> & ({ variables: WidgetByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WidgetByIdQuery, WidgetByIdQueryVariables>(WidgetByIdDocument, options);
      }
export function useWidgetByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WidgetByIdQuery, WidgetByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WidgetByIdQuery, WidgetByIdQueryVariables>(WidgetByIdDocument, options);
        }
export function useWidgetByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WidgetByIdQuery, WidgetByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WidgetByIdQuery, WidgetByIdQueryVariables>(WidgetByIdDocument, options);
        }
export type WidgetByIdQueryHookResult = ReturnType<typeof useWidgetByIdQuery>;
export type WidgetByIdLazyQueryHookResult = ReturnType<typeof useWidgetByIdLazyQuery>;
export type WidgetByIdSuspenseQueryHookResult = ReturnType<typeof useWidgetByIdSuspenseQuery>;
export type WidgetByIdQueryResult = Apollo.QueryResult<WidgetByIdQuery, WidgetByIdQueryVariables>;
export const WidgetByIdWithEntitiesDocument = gql`
    query WidgetByIdWithEntities($id: MongoID!) {
  widgetById(_id: $id) {
    _id
    type
    name {
      ...MultilingualFragment
    }
    filterableTags {
      _id
      name {
        ...MultilingualFragment
      }
    }
    list {
      entities {
        _entityId
        status
        images {
          ...ImageFragment
        }
        name {
          ...MultilingualFragment
        }
        shortDescription {
          ...MultilingualFragment
        }
        description {
          ...MultilingualFragment
        }
        contact {
          phone
          email
          links {
            website
            bookNow
          }
          address {
            line1
            line2
            city
            subdivision
            postalCode
            country
            location {
              type
              coordinates
            }
          }
        }
        hoursOfOperation {
          mon {
            _id
            start
            end
          }
          tue {
            _id
            start
            end
          }
          wed {
            _id
            start
            end
          }
          thu {
            _id
            start
            end
          }
          fri {
            _id
            start
            end
          }
          sat {
            _id
            start
            end
          }
          sun {
            _id
            start
            end
          }
        }
        pricing
        tags {
          businessType {
            _id
          }
          global {
            _id
          }
          organizationSpecific {
            _id
          }
          amenity {
            _id
          }
        }
        overrides {
          description {
            ...MultilingualFragment
          }
          shortDescription {
            ...MultilingualFragment
          }
          images {
            ...ImageFragment
          }
        }
      }
    }
    eventSettings {
      displayType
      eventTags
      lookAheadMonths
    }
  }
}
    ${MultilingualFragmentFragmentDoc}
${ImageFragmentFragmentDoc}`;

/**
 * __useWidgetByIdWithEntitiesQuery__
 *
 * To run a query within a React component, call `useWidgetByIdWithEntitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useWidgetByIdWithEntitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWidgetByIdWithEntitiesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useWidgetByIdWithEntitiesQuery(baseOptions: Apollo.QueryHookOptions<WidgetByIdWithEntitiesQuery, WidgetByIdWithEntitiesQueryVariables> & ({ variables: WidgetByIdWithEntitiesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WidgetByIdWithEntitiesQuery, WidgetByIdWithEntitiesQueryVariables>(WidgetByIdWithEntitiesDocument, options);
      }
export function useWidgetByIdWithEntitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WidgetByIdWithEntitiesQuery, WidgetByIdWithEntitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WidgetByIdWithEntitiesQuery, WidgetByIdWithEntitiesQueryVariables>(WidgetByIdWithEntitiesDocument, options);
        }
export function useWidgetByIdWithEntitiesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WidgetByIdWithEntitiesQuery, WidgetByIdWithEntitiesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WidgetByIdWithEntitiesQuery, WidgetByIdWithEntitiesQueryVariables>(WidgetByIdWithEntitiesDocument, options);
        }
export type WidgetByIdWithEntitiesQueryHookResult = ReturnType<typeof useWidgetByIdWithEntitiesQuery>;
export type WidgetByIdWithEntitiesLazyQueryHookResult = ReturnType<typeof useWidgetByIdWithEntitiesLazyQuery>;
export type WidgetByIdWithEntitiesSuspenseQueryHookResult = ReturnType<typeof useWidgetByIdWithEntitiesSuspenseQuery>;
export type WidgetByIdWithEntitiesQueryResult = Apollo.QueryResult<WidgetByIdWithEntitiesQuery, WidgetByIdWithEntitiesQueryVariables>;
export const WidgetManyDocument = gql`
    query WidgetMany($filter: FilterFindManyWidgetInput, $limit: Int, $sort: SortFindManyWidgetInput) {
  widgetMany(filter: $filter, limit: $limit, sort: $sort) {
    _id
    type
    itemCount
    name {
      ...MultilingualFragment
    }
    owner {
      entityId
      type
    }
    list {
      _id
      entityReferences {
        _entityId
        type
      }
      externallyAvailableEntityReferences {
        _entityId
        type
      }
    }
    eventSettings {
      displayType
      lookAheadMonths
      eventTags
    }
    archived
    favorited
    updatedDateISO
  }
}
    ${MultilingualFragmentFragmentDoc}`;

/**
 * __useWidgetManyQuery__
 *
 * To run a query within a React component, call `useWidgetManyQuery` and pass it any options that fit your needs.
 * When your component renders, `useWidgetManyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWidgetManyQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      limit: // value for 'limit'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useWidgetManyQuery(baseOptions?: Apollo.QueryHookOptions<WidgetManyQuery, WidgetManyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WidgetManyQuery, WidgetManyQueryVariables>(WidgetManyDocument, options);
      }
export function useWidgetManyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WidgetManyQuery, WidgetManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WidgetManyQuery, WidgetManyQueryVariables>(WidgetManyDocument, options);
        }
export function useWidgetManySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WidgetManyQuery, WidgetManyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WidgetManyQuery, WidgetManyQueryVariables>(WidgetManyDocument, options);
        }
export type WidgetManyQueryHookResult = ReturnType<typeof useWidgetManyQuery>;
export type WidgetManyLazyQueryHookResult = ReturnType<typeof useWidgetManyLazyQuery>;
export type WidgetManySuspenseQueryHookResult = ReturnType<typeof useWidgetManySuspenseQuery>;
export type WidgetManyQueryResult = Apollo.QueryResult<WidgetManyQuery, WidgetManyQueryVariables>;